(function dartProgram(){function copyProperties(a,b){var t=Object.keys(a)
for(var s=0;s<t.length;s++){var r=t[s]
b[r]=a[r]}}function mixinPropertiesHard(a,b){var t=Object.keys(a)
for(var s=0;s<t.length;s++){var r=t[s]
if(!b.hasOwnProperty(r)){b[r]=a[r]}}}function mixinPropertiesEasy(a,b){Object.assign(b,a)}var z=function(){var t=function(){}
t.prototype={p:{}}
var s=new t()
if(!(Object.getPrototypeOf(s)&&Object.getPrototypeOf(s).p===t.prototype.p))return false
try{if(typeof navigator!="undefined"&&typeof navigator.userAgent=="string"&&navigator.userAgent.indexOf("Chrome/")>=0)return true
if(typeof version=="function"&&version.length==0){var r=version()
if(/^\d+\.\d+\.\d+\.\d+$/.test(r))return true}}catch(q){}return false}()
function inherit(a,b){a.prototype.constructor=a
a.prototype["$i"+a.name]=a
if(b!=null){if(z){Object.setPrototypeOf(a.prototype,b.prototype)
return}var t=Object.create(b.prototype)
copyProperties(a.prototype,t)
a.prototype=t}}function inheritMany(a,b){for(var t=0;t<b.length;t++){inherit(b[t],a)}}function mixinEasy(a,b){mixinPropertiesEasy(b.prototype,a.prototype)
a.prototype.constructor=a}function mixinHard(a,b){mixinPropertiesHard(b.prototype,a.prototype)
a.prototype.constructor=a}function lazy(a,b,c,d){var t=a
a[b]=t
a[c]=function(){if(a[b]===t){a[b]=d()}a[c]=function(){return this[b]}
return a[b]}}function lazyFinal(a,b,c,d){var t=a
a[b]=t
a[c]=function(){if(a[b]===t){var s=d()
if(a[b]!==t){A.mL(b)}a[b]=s}var r=a[b]
a[c]=function(){return r}
return r}}function makeConstList(a,b){if(b!=null)A.q(a,b)
a.$flags=7
return a}function convertToFastObject(a){function t(){}t.prototype=a
new t()
return a}function convertAllToFastObject(a){for(var t=0;t<a.length;++t){convertToFastObject(a[t])}}var y=0
function instanceTearOffGetter(a,b){var t=null
return a?function(c){if(t===null)t=A.h1(b)
return new t(c,this)}:function(){if(t===null)t=A.h1(b)
return new t(this,null)}}function staticTearOffGetter(a){var t=null
return function(){if(t===null)t=A.h1(a).prototype
return t}}var x=0
function tearOffParameters(a,b,c,d,e,f,g,h,i,j){if(typeof h=="number"){h+=x}return{co:a,iS:b,iI:c,rC:d,dV:e,cs:f,fs:g,fT:h,aI:i||0,nDA:j}}function installStaticTearOff(a,b,c,d,e,f,g,h){var t=tearOffParameters(a,true,false,c,d,e,f,g,h,false)
var s=staticTearOffGetter(t)
a[b]=s}function installInstanceTearOff(a,b,c,d,e,f,g,h,i,j){c=!!c
var t=tearOffParameters(a,false,c,d,e,f,g,h,i,!!j)
var s=instanceTearOffGetter(c,t)
a[b]=s}function setOrUpdateInterceptorsByTag(a){var t=v.interceptorsByTag
if(!t){v.interceptorsByTag=a
return}copyProperties(a,t)}function setOrUpdateLeafTags(a){var t=v.leafTags
if(!t){v.leafTags=a
return}copyProperties(a,t)}function updateTypes(a){var t=v.types
var s=t.length
t.push.apply(t,a)
return s}function updateHolder(a,b){copyProperties(b,a)
return a}var hunkHelpers=function(){var t=function(a,b,c,d,e){return function(f,g,h,i){return installInstanceTearOff(f,g,a,b,c,d,[h],i,e,false)}},s=function(a,b,c,d){return function(e,f,g,h){return installStaticTearOff(e,f,a,b,c,[g],h,d)}}
return{inherit:inherit,inheritMany:inheritMany,mixin:mixinEasy,mixinHard:mixinHard,installStaticTearOff:installStaticTearOff,installInstanceTearOff:installInstanceTearOff,_instance_0u:t(0,0,null,["$0"],0),_instance_1u:t(0,1,null,["$1"],0),_instance_2u:t(0,2,null,["$2"],0),_instance_0i:t(1,0,null,["$0"],0),_instance_1i:t(1,1,null,["$1"],0),_instance_2i:t(1,2,null,["$2"],0),_static_0:s(0,null,["$0"],0),_static_1:s(1,null,["$1"],0),_static_2:s(2,null,["$2"],0),makeConstList:makeConstList,lazy:lazy,lazyFinal:lazyFinal,updateHolder:updateHolder,convertToFastObject:convertToFastObject,updateTypes:updateTypes,setOrUpdateInterceptorsByTag:setOrUpdateInterceptorsByTag,setOrUpdateLeafTags:setOrUpdateLeafTags}}()
function initializeDeferredHunk(a){x=v.types.length
a(hunkHelpers,v,w,$)}var J={
h6(a,b,c,d){return{i:a,p:b,e:c,x:d}},
fn(a){var t,s,r,q,p,o=a[v.dispatchPropertyName]
if(o==null)if($.h3==null){A.mv()
o=a[v.dispatchPropertyName]}if(o!=null){t=o.p
if(!1===t)return o.i
if(!0===t)return a
s=Object.getPrototypeOf(a)
if(t===s)return o.i
if(o.e===s)throw A.j(A.i3("Return interceptor for "+A.C(t(a,o))))}r=a.constructor
if(r==null)q=null
else{p=$.f5
if(p==null)p=$.f5=v.getIsolateTag("_$dart_js")
q=r[p]}if(q!=null)return q
q=A.mC(a)
if(q!=null)return q
if(typeof a=="function")return B.aB
t=Object.getPrototypeOf(a)
if(t==null)return B.al
if(t===Object.prototype)return B.al
if(typeof r=="function"){p=$.f5
if(p==null)p=$.f5=v.getIsolateTag("_$dart_js")
Object.defineProperty(r,p,{value:B.S,enumerable:false,writable:true,configurable:true})
return B.S}return B.S},
hL(a,b){if(a<0||a>4294967295)throw A.j(A.a9(a,0,4294967295,"length",null))
return J.kH(new Array(a),b)},
kG(a,b){if(a<0)throw A.j(A.aK("Length must be a non-negative integer: "+a,null))
return A.q(new Array(a),b.p("B<0>"))},
hK(a,b){if(a<0)throw A.j(A.aK("Length must be a non-negative integer: "+a,null))
return A.q(new Array(a),b.p("B<0>"))},
kH(a,b){var t=A.q(a,b.p("B<0>"))
t.$flags=1
return t},
hM(a,b){var t=u.U
return J.j9(t.a(a),t.a(b))},
aI(a){if(typeof a=="number"){if(Math.floor(a)==a)return J.bA.prototype
return J.c6.prototype}if(typeof a=="string")return J.ay.prototype
if(a==null)return J.c5.prototype
if(typeof a=="boolean")return J.d7.prototype
if(Array.isArray(a))return J.B.prototype
if(typeof a!="object"){if(typeof a=="function")return J.ap.prototype
if(typeof a=="symbol")return J.bC.prototype
if(typeof a=="bigint")return J.bB.prototype
return a}if(a instanceof A.x)return a
return J.fn(a)},
N(a){if(typeof a=="string")return J.ay.prototype
if(a==null)return a
if(Array.isArray(a))return J.B.prototype
if(typeof a!="object"){if(typeof a=="function")return J.ap.prototype
if(typeof a=="symbol")return J.bC.prototype
if(typeof a=="bigint")return J.bB.prototype
return a}if(a instanceof A.x)return a
return J.fn(a)},
aJ(a){if(a==null)return a
if(Array.isArray(a))return J.B.prototype
if(typeof a!="object"){if(typeof a=="function")return J.ap.prototype
if(typeof a=="symbol")return J.bC.prototype
if(typeof a=="bigint")return J.bB.prototype
return a}if(a instanceof A.x)return a
return J.fn(a)},
mo(a){if(typeof a=="number"){if(Math.floor(a)==a)return J.bA.prototype
return J.c6.prototype}if(a==null)return a
if(!(a instanceof A.x))return J.as.prototype
return a},
iD(a){if(typeof a=="number")return J.aQ.prototype
if(a==null)return a
if(!(a instanceof A.x))return J.as.prototype
return a},
mp(a){if(typeof a=="number")return J.aQ.prototype
if(typeof a=="string")return J.ay.prototype
if(a==null)return a
if(!(a instanceof A.x))return J.as.prototype
return a},
iE(a){if(typeof a=="string")return J.ay.prototype
if(a==null)return a
if(!(a instanceof A.x))return J.as.prototype
return a},
dF(a){if(a==null)return a
if(typeof a!="object"){if(typeof a=="function")return J.ap.prototype
if(typeof a=="symbol")return J.bC.prototype
if(typeof a=="bigint")return J.bB.prototype
return a}if(a instanceof A.x)return a
return J.fn(a)},
ad(a,b){if(a==null)return b==null
if(typeof a!="object")return b!=null&&a===b
return J.aI(a).O(a,b)},
j5(a){if(typeof a=="number")return-a
return J.mo(a).bP(a)},
he(a,b){if(typeof b==="number")if(Array.isArray(a)||A.mz(a,a[v.dispatchPropertyName]))if(b>>>0===b&&b<a.length)return a[b]
return J.aJ(a).k(a,b)},
j6(a,b,c){return J.dF(a).cf(a,b,c)},
j7(a,b,c){return J.dF(a).cg(a,b,c)},
j8(a){return J.dF(a).ci(a)},
U(a,b,c){return J.dF(a).be(a,b,c)},
j9(a,b){return J.mp(a).bf(a,b)},
hf(a,b){return J.aJ(a).aL(a,b)},
am(a){return J.aI(a).gF(a)},
fv(a){return J.aJ(a).gD(a)},
bc(a){return J.N(a).gn(a)},
ja(a){return J.aI(a).ga6(a)},
jb(a,b){return J.iE(a).dY(a,b)},
hg(a){return J.iD(a).R(a)},
hh(a,b){return J.aJ(a).bw(a,b)},
jc(a,b){return J.iE(a).cC(a,b)},
jd(a,b){return J.aJ(a).co(a,b)},
je(a){return J.iD(a).e3(a)},
cM(a){return J.aI(a).v(a)},
d4:function d4(){},
d7:function d7(){},
c5:function c5(){},
c7:function c7(){},
az:function az(){},
dj:function dj(){},
as:function as(){},
ap:function ap(){},
bB:function bB(){},
bC:function bC(){},
B:function B(a){this.$ti=a},
d6:function d6(){},
ez:function ez(a){this.$ti=a},
bd:function bd(a,b,c){var _=this
_.a=a
_.b=b
_.c=0
_.d=null
_.$ti=c},
aQ:function aQ(){},
bA:function bA(){},
c6:function c6(){},
ay:function ay(){}},A={fM:function fM(){},
eB(a){return new A.bD("Field '"+a+"' has not been initialized.")},
kI(a){return new A.bD("Field '"+a+"' has already been initialized.")},
aq(a,b){a=a+b&536870911
a=a+((a&524287)<<10)&536870911
return a^a>>>6},
eU(a){a=a+((a&67108863)<<3)&536870911
a^=a>>>11
return a+((a&16383)<<15)&536870911},
iy(a,b,c){return a},
h4(a){var t,s
for(t=$.a_.length,s=0;s<t;++s)if(a===$.a_[s])return!0
return!1},
dq(a,b,c,d){A.ct(b,"start")
if(c!=null){A.ct(c,"end")
if(b>c)A.cL(A.a9(b,0,c,"start",null))}return new A.cw(a,b,c,d.p("cw<0>"))},
hI(){return new A.bJ("No element")},
kE(){return new A.bJ("Too few elements")},
bD:function bD(a){this.a=a},
bf:function bf(a){this.a=a},
eS:function eS(){},
bW:function bW(){},
Y:function Y(){},
cw:function cw(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.$ti=d},
bE:function bE(a,b,c){var _=this
_.a=a
_.b=b
_.c=0
_.d=null
_.$ti=c},
bF:function bF(a,b,c){this.a=a
this.b=b
this.$ti=c},
bX:function bX(a){this.$ti=a},
cW:function cW(a){this.$ti=a},
V:function V(){},
aC:function aC(){},
bL:function bL(){},
iI(a){var t=v.mangledGlobalNames[a]
if(t!=null)return t
return"minified:"+a},
mz(a,b){var t
if(b!=null){t=b.x
if(t!=null)return t}return u.J.b(a)},
C(a){var t
if(typeof a=="string")return a
if(typeof a=="number"){if(a!==0)return""+a}else if(!0===a)return"true"
else if(!1===a)return"false"
else if(a==null)return"null"
t=J.cM(a)
return t},
cq(a){var t,s=$.hY
if(s==null)s=$.hY=Symbol("identityHashCode")
t=a[s]
if(t==null){t=Math.random()*0x3fffffff|0
a[s]=t}return t},
kX(a,b){var t,s=/^\s*[+-]?((0x[a-f0-9]+)|(\d+)|([a-z0-9]+))\s*$/i.exec(a)
if(s==null)return null
if(3>=s.length)return A.a(s,3)
t=s[3]
if(t!=null)return parseInt(a,10)
if(s[2]!=null)return parseInt(a,16)
return null},
dl(a){var t,s,r,q
if(a instanceof A.x)return A.Z(A.al(a),null)
t=J.aI(a)
if(t===B.az||t===B.aC||u.A.b(a)){s=B.U(a)
if(s!=="Object"&&s!=="")return s
r=a.constructor
if(typeof r=="function"){q=r.name
if(typeof q=="string"&&q!=="Object"&&q!=="")return q}}return A.Z(A.al(a),null)},
hZ(a){var t,s,r
if(a==null||typeof a=="number"||A.h_(a))return J.cM(a)
if(typeof a=="string")return JSON.stringify(a)
if(a instanceof A.au)return a.v(0)
if(a instanceof A.M)return a.ca(!0)
t=$.j3()
for(s=0;s<1;++s){r=t[s].e6(a)
if(r!=null)return r}return"Instance of '"+A.dl(a)+"'"},
kV(){return Date.now()},
kW(){var t,s
if($.eQ!==0)return
$.eQ=1000
if(typeof window=="undefined")return
t=window
if(t==null)return
if(!!t.dartUseDateNowForTicks)return
s=t.performance
if(s==null)return
if(typeof s.now!="function")return
$.eQ=1e6
$.eR=new A.eP(s)},
hX(a){var t,s,r,q,p=a.length
if(p<=500)return String.fromCharCode.apply(null,a)
for(t="",s=0;s<p;s=r){r=s+500
q=r<p?r:p
t+=String.fromCharCode.apply(null,a.slice(s,q))}return t},
kY(a){var t,s,r,q=A.q([],u.t)
for(t=a.length,s=0;s<a.length;a.length===t||(0,A.a0)(a),++s){r=a[s]
if(!A.fi(r))throw A.j(A.aH(r))
if(r<=65535)B.c.E(q,r)
else if(r<=1114111){B.c.E(q,55296+(B.b.G(r-65536,10)&1023))
B.c.E(q,56320+(r&1023))}else throw A.j(A.aH(r))}return A.hX(q)},
i_(a){var t,s,r
for(t=a.length,s=0;s<t;++s){r=a[s]
if(!A.fi(r))throw A.j(A.aH(r))
if(r<0)throw A.j(A.aH(r))
if(r>65535)return A.kY(a)}return A.hX(a)},
kZ(a,b,c){var t,s,r,q
if(c<=500&&b===0&&c===a.length)return String.fromCharCode.apply(null,a)
for(t=b,s="";t<c;t=r){r=t+500
q=r<c?r:c
s+=String.fromCharCode.apply(null,a.subarray(t,q))}return s},
cr(a){var t
if(a<=65535)return String.fromCharCode(a)
if(a<=1114111){t=a-65536
return String.fromCharCode((B.b.G(t,10)|55296)>>>0,t&1023|56320)}throw A.j(A.a9(a,0,1114111,null,null))},
bS(a){throw A.j(A.aH(a))},
a(a,b){if(a==null)J.bc(a)
throw A.j(A.fl(a,b))},
fl(a,b){var t,s="index"
if(!A.fi(b))return new A.ae(!0,b,s,null)
t=A.p(J.bc(a))
if(b<0||b>=t)return A.fH(b,t,a,s)
return A.l0(b,s)},
mk(a,b,c){if(a<0||a>c)return A.a9(a,0,c,"start",null)
if(b!=null)if(b<a||b>c)return A.a9(b,a,c,"end",null)
return new A.ae(!0,b,"end",null)},
aH(a){return new A.ae(!0,a,null,null)},
j(a){return A.J(a,new Error())},
J(a,b){var t
if(a==null)a=new A.cx()
b.dartException=a
t=A.mM
if("defineProperty" in Object){Object.defineProperty(b,"message",{get:t})
b.name=""}else b.toString=t
return b},
mM(){return J.cM(this.dartException)},
cL(a,b){throw A.J(a,b==null?new Error():b)},
b(a,b,c){var t
if(b==null)b=0
if(c==null)c=0
t=Error()
A.cL(A.lH(a,b,c),t)},
lH(a,b,c){var t,s,r,q,p,o,n,m,l
if(typeof b=="string")t=b
else{s="[]=;add;removeWhere;retainWhere;removeRange;setRange;setInt8;setInt16;setInt32;setUint8;setUint16;setUint32;setFloat32;setFloat64".split(";")
r=s.length
q=b
if(q>r){c=q/r|0
q%=r}t=s[q]}p=typeof c=="string"?c:"modify;remove from;add to".split(";")[c]
o=u.j.b(a)?"list":"ByteData"
n=a.$flags|0
m="a "
if((n&4)!==0)l="constant "
else if((n&2)!==0){l="unmodifiable "
m="an "}else l=(n&1)!==0?"fixed-length ":""
return new A.cy("'"+t+"': Cannot "+p+" "+m+l+o)},
a0(a){throw A.j(A.aM(a))},
ar(a){var t,s,r,q,p,o
a=A.mI(a.replace(String({}),"$receiver$"))
t=a.match(/\\\$[a-zA-Z]+\\\$/g)
if(t==null)t=A.q([],u.s)
s=t.indexOf("\\$arguments\\$")
r=t.indexOf("\\$argumentsExpr\\$")
q=t.indexOf("\\$expr\\$")
p=t.indexOf("\\$method\\$")
o=t.indexOf("\\$receiver\\$")
return new A.eV(a.replace(new RegExp("\\\\\\$arguments\\\\\\$","g"),"((?:x|[^x])*)").replace(new RegExp("\\\\\\$argumentsExpr\\\\\\$","g"),"((?:x|[^x])*)").replace(new RegExp("\\\\\\$expr\\\\\\$","g"),"((?:x|[^x])*)").replace(new RegExp("\\\\\\$method\\\\\\$","g"),"((?:x|[^x])*)").replace(new RegExp("\\\\\\$receiver\\\\\\$","g"),"((?:x|[^x])*)"),s,r,q,p,o)},
eW(a){return function($expr$){var $argumentsExpr$="$arguments$"
try{$expr$.$method$($argumentsExpr$)}catch(t){return t.message}}(a)},
i2(a){return function($expr$){try{$expr$.$method$}catch(t){return t.message}}(a)},
fN(a,b){var t=b==null,s=t?null:b.method
return new A.d8(a,s,t?null:b.receiver)},
mO(a){if(a==null)return new A.eH(a)
if(typeof a!=="object")return a
if("dartException" in a)return A.bb(a,a.dartException)
return A.md(a)},
bb(a,b){if(u.C.b(b))if(b.$thrownJsError==null)b.$thrownJsError=a
return b},
md(a){var t,s,r,q,p,o,n,m,l,k,j,i,h
if(!("message" in a))return a
t=a.message
if("number" in a&&typeof a.number=="number"){s=a.number
r=s&65535
if((B.b.G(s,16)&8191)===10)switch(r){case 438:return A.bb(a,A.fN(A.C(t)+" (Error "+r+")",null))
case 445:case 5007:A.C(t)
return A.bb(a,new A.ci())}}if(a instanceof TypeError){q=$.iM()
p=$.iN()
o=$.iO()
n=$.iP()
m=$.iS()
l=$.iT()
k=$.iR()
$.iQ()
j=$.iV()
i=$.iU()
h=q.aO(t)
if(h!=null)return A.bb(a,A.fN(A.ak(t),h))
else{h=p.aO(t)
if(h!=null){h.method="call"
return A.bb(a,A.fN(A.ak(t),h))}else if(o.aO(t)!=null||n.aO(t)!=null||m.aO(t)!=null||l.aO(t)!=null||k.aO(t)!=null||n.aO(t)!=null||j.aO(t)!=null||i.aO(t)!=null){A.ak(t)
return A.bb(a,new A.ci())}}return A.bb(a,new A.dt(typeof t=="string"?t:""))}if(a instanceof RangeError){if(typeof t=="string"&&t.indexOf("call stack")!==-1)return new A.cv()
t=function(b){try{return String(b)}catch(g){}return null}(a)
return A.bb(a,new A.ae(!1,null,null,typeof t=="string"?t.replace(/^RangeError:\s*/,""):t))}if(typeof InternalError=="function"&&a instanceof InternalError)if(typeof t=="string"&&t==="too much recursion")return new A.cv()
return a},
h7(a){if(a==null)return J.am(a)
if(typeof a=="object")return A.cq(a)
return J.am(a)},
me(a){if(typeof a=="number")return B.a.gF(a)
if(a instanceof A.dB)return A.cq(a)
if(a instanceof A.M)return a.gF(a)
return A.h7(a)},
iC(a,b){var t,s,r,q=a.length
for(t=0;t<q;t=r){s=t+1
r=s+1
b.q(0,a[t],a[s])}return b},
lQ(a,b,c,d,e,f){u.Z.a(a)
switch(A.p(b)){case 0:return a.$0()
case 1:return a.$1(c)
case 2:return a.$2(c,d)
case 3:return a.$3(c,d,e)
case 4:return a.$4(c,d,e,f)}throw A.j(A.ku("Unsupported number of arguments for wrapped closure"))},
mf(a,b){var t=a.$identity
if(!!t)return t
t=A.mg(a,b)
a.$identity=t
return t},
mg(a,b){var t
switch(b){case 0:t=a.$0
break
case 1:t=a.$1
break
case 2:t=a.$2
break
case 3:t=a.$3
break
case 4:t=a.$4
break
default:t=null}if(t!=null)return t.bind(a)
return function(c,d,e){return function(f,g,h,i){return e(c,d,f,g,h,i)}}(a,b,A.lQ)},
jm(a1){var t,s,r,q,p,o,n,m,l,k,j=a1.co,i=a1.iS,h=a1.iI,g=a1.nDA,f=a1.aI,e=a1.fs,d=a1.cs,c=e[0],b=d[0],a=j[c],a0=a1.fT
a0.toString
t=i?Object.create(new A.dp().constructor.prototype):Object.create(new A.be(null,null).constructor.prototype)
t.$initialize=t.constructor
s=i?function static_tear_off(){this.$initialize()}:function tear_off(a2,a3){this.$initialize(a2,a3)}
t.constructor=s
s.prototype=t
t.$_name=c
t.$_target=a
r=!i
if(r)q=A.hm(c,a,h,g)
else{t.$static_name=c
q=a}t.$S=A.ji(a0,i,h)
t[b]=q
for(p=q,o=1;o<e.length;++o){n=e[o]
if(typeof n=="string"){m=j[n]
l=n
n=m}else l=""
k=d[o]
if(k!=null){if(r)n=A.hm(l,n,h,g)
t[k]=n}if(o===f)p=n}t.$C=p
t.$R=a1.rC
t.$D=a1.dV
return s},
ji(a,b,c){if(typeof a=="number")return a
if(typeof a=="string"){if(b)throw A.j("Cannot compute signature for static tearoff.")
return function(d,e){return function(){return e(this,d)}}(a,A.jg)}throw A.j("Error in functionType of tearoff")},
jj(a,b,c,d){var t=A.hl
switch(b?-1:a){case 0:return function(e,f){return function(){return f(this)[e]()}}(c,t)
case 1:return function(e,f){return function(g){return f(this)[e](g)}}(c,t)
case 2:return function(e,f){return function(g,h){return f(this)[e](g,h)}}(c,t)
case 3:return function(e,f){return function(g,h,i){return f(this)[e](g,h,i)}}(c,t)
case 4:return function(e,f){return function(g,h,i,j){return f(this)[e](g,h,i,j)}}(c,t)
case 5:return function(e,f){return function(g,h,i,j,k){return f(this)[e](g,h,i,j,k)}}(c,t)
default:return function(e,f){return function(){return e.apply(f(this),arguments)}}(d,t)}},
hm(a,b,c,d){if(c)return A.jl(a,b,d)
return A.jj(b.length,d,a,b)},
jk(a,b,c,d){var t=A.hl,s=A.jh
switch(b?-1:a){case 0:throw A.j(new A.dn("Intercepted function with no arguments."))
case 1:return function(e,f,g){return function(){return f(this)[e](g(this))}}(c,s,t)
case 2:return function(e,f,g){return function(h){return f(this)[e](g(this),h)}}(c,s,t)
case 3:return function(e,f,g){return function(h,i){return f(this)[e](g(this),h,i)}}(c,s,t)
case 4:return function(e,f,g){return function(h,i,j){return f(this)[e](g(this),h,i,j)}}(c,s,t)
case 5:return function(e,f,g){return function(h,i,j,k){return f(this)[e](g(this),h,i,j,k)}}(c,s,t)
case 6:return function(e,f,g){return function(h,i,j,k,l){return f(this)[e](g(this),h,i,j,k,l)}}(c,s,t)
default:return function(e,f,g){return function(){var r=[g(this)]
Array.prototype.push.apply(r,arguments)
return e.apply(f(this),r)}}(d,s,t)}},
jl(a,b,c){var t,s
if($.hj==null)$.hj=A.hi("interceptor")
if($.hk==null)$.hk=A.hi("receiver")
t=b.length
s=A.jk(t,c,a,b)
return s},
h1(a){return A.jm(a)},
jg(a,b){return A.cJ(v.typeUniverse,A.al(a.a),b)},
hl(a){return a.a},
jh(a){return a.b},
hi(a){var t,s,r,q=new A.be("receiver","interceptor"),p=Object.getOwnPropertyNames(q)
p.$flags=1
t=p
for(p=t.length,s=0;s<p;++s){r=t[s]
if(q[r]===a)return r}throw A.j(A.aK("Field name "+a+" not found.",null))},
mq(a){return v.getIsolateTag(a)},
ni(a,b,c){Object.defineProperty(a,b,{value:c,enumerable:false,writable:true,configurable:true})},
mC(a){var t,s,r,q,p,o=A.ak($.iF.$1(a)),n=$.fm[o]
if(n!=null){Object.defineProperty(a,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
return n.i}t=$.fr[o]
if(t!=null)return t
s=v.interceptorsByTag[o]
if(s==null){r=A.ip($.ix.$2(a,o))
if(r!=null){n=$.fm[r]
if(n!=null){Object.defineProperty(a,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
return n.i}t=$.fr[r]
if(t!=null)return t
s=v.interceptorsByTag[r]
o=r}}if(s==null)return null
t=s.prototype
q=o[0]
if(q==="!"){n=A.fs(t)
$.fm[o]=n
Object.defineProperty(a,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
return n.i}if(q==="~"){$.fr[o]=t
return t}if(q==="-"){p=A.fs(t)
Object.defineProperty(Object.getPrototypeOf(a),v.dispatchPropertyName,{value:p,enumerable:false,writable:true,configurable:true})
return p.i}if(q==="+")return A.iG(a,t)
if(q==="*")throw A.j(A.i3(o))
if(v.leafTags[o]===true){p=A.fs(t)
Object.defineProperty(Object.getPrototypeOf(a),v.dispatchPropertyName,{value:p,enumerable:false,writable:true,configurable:true})
return p.i}else return A.iG(a,t)},
iG(a,b){var t=Object.getPrototypeOf(a)
Object.defineProperty(t,v.dispatchPropertyName,{value:J.h6(b,t,null,null),enumerable:false,writable:true,configurable:true})
return b},
fs(a){return J.h6(a,!1,null,!!a.$ia1)},
mE(a,b,c){var t=b.prototype
if(v.leafTags[a]===true)return A.fs(t)
else return J.h6(t,c,null,null)},
mv(){if(!0===$.h3)return
$.h3=!0
A.mw()},
mw(){var t,s,r,q,p,o,n,m
$.fm=Object.create(null)
$.fr=Object.create(null)
A.mu()
t=v.interceptorsByTag
s=Object.getOwnPropertyNames(t)
if(typeof window!="undefined"){window
r=function(){}
for(q=0;q<s.length;++q){p=s[q]
o=$.iH.$1(p)
if(o!=null){n=A.mE(p,t[p],o)
if(n!=null){Object.defineProperty(o,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
r.prototype=o}}}}for(q=0;q<s.length;++q){p=s[q]
if(/^[A-Za-z_]/.test(p)){m=t[p]
t["!"+p]=m
t["~"+p]=m
t["-"+p]=m
t["+"+p]=m
t["*"+p]=m}}},
mu(){var t,s,r,q,p,o,n=B.an()
n=A.bQ(B.ao,A.bQ(B.ap,A.bQ(B.V,A.bQ(B.V,A.bQ(B.aq,A.bQ(B.ar,A.bQ(B.as(B.U),n)))))))
if(typeof dartNativeDispatchHooksTransformer!="undefined"){t=dartNativeDispatchHooksTransformer
if(typeof t=="function")t=[t]
if(Array.isArray(t))for(s=0;s<t.length;++s){r=t[s]
if(typeof r=="function")n=r(n)||n}}q=n.getTag
p=n.getUnknownTag
o=n.prototypeForTag
$.iF=new A.fo(q)
$.ix=new A.fp(p)
$.iH=new A.fq(o)},
bQ(a,b){return a(b)||b},
ll(a,b){var t,s
for(t=0;t<a.length;++t){s=a[t]
if(!(t<b.length))return A.a(b,t)
if(!J.ad(s,b[t]))return!1}return!0},
mj(a,b){var t=b.length,s=v.rttc[""+t+";"+a]
if(s==null)return null
if(t===0)return s
if(t===s.length)return s.apply(null,b)
return s(b)},
mK(a,b,c){var t=a.indexOf(b,c)
return t>=0},
mI(a){if(/[[\]{}()*+?.\\^$|]/.test(a))return a.replace(/[[\]{}()*+?.\\^$|]/g,"\\$&")
return a},
I:function I(a,b){this.a=a
this.b=b},
ai:function ai(a,b){this.a=a
this.b=b},
r:function r(a,b,c){this.a=a
this.b=b
this.c=c},
cD:function cD(a,b,c){this.a=a
this.b=b
this.c=c},
ab:function ab(a,b,c){this.a=a
this.b=b
this.c=c},
bN:function bN(a){this.a=a},
bO:function bO(a){this.a=a},
cE:function cE(a){this.a=a},
bs:function bs(){},
bV:function bV(a,b,c){this.a=a
this.b=b
this.$ti=c},
bu:function bu(a,b){this.a=a
this.$ti=b},
eP:function eP(a){this.a=a},
cu:function cu(){},
eV:function eV(a,b,c,d,e,f){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e
_.f=f},
ci:function ci(){},
d8:function d8(a,b,c){this.a=a
this.b=b
this.c=c},
dt:function dt(a){this.a=a},
eH:function eH(a){this.a=a},
au:function au(){},
cP:function cP(){},
cQ:function cQ(){},
dr:function dr(){},
dp:function dp(){},
be:function be(a,b){this.a=a
this.b=b},
dn:function dn(a){this.a=a},
a7:function a7(a){var _=this
_.a=0
_.f=_.e=_.d=_.c=_.b=null
_.r=0
_.$ti=a},
eD:function eD(a,b){var _=this
_.a=a
_.b=b
_.d=_.c=null},
aR:function aR(a,b){this.a=a
this.$ti=b},
W:function W(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=null
_.$ti=d},
c8:function c8(a){var _=this
_.a=0
_.f=_.e=_.d=_.c=_.b=null
_.r=0
_.$ti=a},
fo:function fo(a){this.a=a},
fp:function fp(a){this.a=a},
fq:function fq(a){this.a=a},
M:function M(){},
b7:function b7(){},
aD:function aD(){},
aE:function aE(){},
mL(a){throw A.J(new A.bD("Field '"+a+"' has been assigned during initialization."),new Error())},
c(){throw A.J(A.eB(""),new Error())},
h9(){throw A.J(A.kI(""),new Error())},
i4(){var t=new A.f_()
return t.b=t},
f_:function f_(){this.b=null},
cK(a,b,c){},
t(a){var t,s,r
if(u.e.b(a))return a
t=J.N(a)
s=A.aA(t.gn(a),null,!1,u.z)
for(r=0;r<t.gn(a);++r)B.c.q(s,r,t.k(a,r))
return s},
kN(a){return new Float32Array(a)},
kO(a,b,c){A.cK(a,b,c)
c=B.b.V(a.byteLength-b,4)
return new Float32Array(a,b,c)},
kP(a,b,c){A.cK(a,b,c)
c=B.b.V(a.byteLength-b,4)
return new Uint32Array(a,b,c)},
kQ(a){return new Uint8Array(a)},
kR(a,b,c){A.cK(a,b,c)
return c==null?new Uint8Array(a,b):new Uint8Array(a,b,c)},
aG(a,b,c){if(a>>>0!==a||a>=c)throw A.j(A.fl(b,a))},
iq(a,b,c){var t
if(!(a>>>0!==a))if(b==null)t=a>c
else t=b>>>0!==b||a>b||b>c
else t=!0
if(t)throw A.j(A.mk(a,b,c))
if(b==null)return c
return b},
aT:function aT(){},
ce:function ce(){},
fa:function fa(a){this.a=a},
Q:function Q(){},
aB:function aB(){},
a2:function a2(){},
c9:function c9(){},
ca:function ca(){},
cb:function cb(){},
cc:function cc(){},
cd:function cd(){},
cf:function cf(){},
cg:function cg(){},
a8:function a8(){},
cz:function cz(){},
cA:function cA(){},
cB:function cB(){},
cC:function cC(){},
fS(a,b){var t=b.c
return t==null?b.c=A.cH(a,"er",[b.x]):t},
i0(a){var t=a.w
if(t===6||t===7)return A.i0(a.x)
return t===11||t===12},
l1(a){return a.as},
h8(a,b){var t,s=b.length
for(t=0;t<s;++t)if(!a[t].b(b[t]))return!1
return!0},
bR(a){return A.f9(v.typeUniverse,a,!1)},
b8(a0,a1,a2,a3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a=a1.w
switch(a){case 5:case 1:case 2:case 3:case 4:return a1
case 6:t=a1.x
s=A.b8(a0,t,a2,a3)
if(s===t)return a1
return A.ie(a0,s,!0)
case 7:t=a1.x
s=A.b8(a0,t,a2,a3)
if(s===t)return a1
return A.id(a0,s,!0)
case 8:r=a1.y
q=A.bP(a0,r,a2,a3)
if(q===r)return a1
return A.cH(a0,a1.x,q)
case 9:p=a1.x
o=A.b8(a0,p,a2,a3)
n=a1.y
m=A.bP(a0,n,a2,a3)
if(o===p&&m===n)return a1
return A.fX(a0,o,m)
case 10:l=a1.x
k=a1.y
j=A.bP(a0,k,a2,a3)
if(j===k)return a1
return A.ig(a0,l,j)
case 11:i=a1.x
h=A.b8(a0,i,a2,a3)
g=a1.y
f=A.ma(a0,g,a2,a3)
if(h===i&&f===g)return a1
return A.ic(a0,h,f)
case 12:e=a1.y
a3+=e.length
d=A.bP(a0,e,a2,a3)
p=a1.x
o=A.b8(a0,p,a2,a3)
if(d===e&&o===p)return a1
return A.fY(a0,o,d,!0)
case 13:c=a1.x
if(c<a3)return a1
b=a2[c-a3]
if(b==null)return a1
return b
default:throw A.j(A.bU("Attempted to substitute unexpected RTI kind "+a))}},
bP(a,b,c,d){var t,s,r,q,p=b.length,o=A.ff(p)
for(t=!1,s=0;s<p;++s){r=b[s]
q=A.b8(a,r,c,d)
if(q!==r)t=!0
o[s]=q}return t?o:b},
mb(a,b,c,d){var t,s,r,q,p,o,n=b.length,m=A.ff(n)
for(t=!1,s=0;s<n;s+=3){r=b[s]
q=b[s+1]
p=b[s+2]
o=A.b8(a,p,c,d)
if(o!==p)t=!0
m.splice(s,3,r,q,o)}return t?m:b},
ma(a,b,c,d){var t,s=b.a,r=A.bP(a,s,c,d),q=b.b,p=A.bP(a,q,c,d),o=b.c,n=A.mb(a,o,c,d)
if(r===s&&p===q&&n===o)return b
t=new A.dy()
t.a=r
t.b=p
t.c=n
return t},
q(a,b){a[v.arrayRti]=b
return a},
iz(a){var t=a.$S
if(t!=null){if(typeof t=="number")return A.ms(t)
return a.$S()}return null},
mx(a,b){var t
if(A.i0(b))if(a instanceof A.au){t=A.iz(a)
if(t!=null)return t}return A.al(a)},
al(a){if(a instanceof A.x)return A.i(a)
if(Array.isArray(a))return A.aj(a)
return A.fZ(J.aI(a))},
aj(a){var t=a[v.arrayRti],s=u.b
if(t==null)return s
if(t.constructor!==s.constructor)return s
return t},
i(a){var t=a.$ti
return t!=null?t:A.fZ(a)},
fZ(a){var t=a.constructor,s=t.$ccache
if(s!=null)return s
return A.lO(a,t)},
lO(a,b){var t=a instanceof A.au?Object.getPrototypeOf(Object.getPrototypeOf(a)).constructor:b,s=A.lt(v.typeUniverse,t.name)
b.$ccache=s
return s},
ms(a){var t,s=v.types,r=s[a]
if(typeof r=="string"){t=A.f9(v.typeUniverse,r,!1)
s[a]=t
return t}return r},
mr(a){return A.b9(A.i(a))},
h0(a){var t
if(a instanceof A.M)return A.mm(a.$r,a.bm())
t=a instanceof A.au?A.iz(a):null
if(t!=null)return t
if(u.R.b(a))return J.ja(a).a
if(Array.isArray(a))return A.aj(a)
return A.al(a)},
b9(a){var t=a.r
return t==null?a.r=new A.dB(a):t},
mm(a,b){var t,s,r=b,q=r.length
if(q===0)return u.F
if(0>=q)return A.a(r,0)
t=A.cJ(v.typeUniverse,A.h0(r[0]),"@<0>")
for(s=1;s<q;++s){if(!(s<r.length))return A.a(r,s)
t=A.ih(v.typeUniverse,t,A.h0(r[s]))}return A.cJ(v.typeUniverse,t,a)},
at(a){return A.b9(A.f9(v.typeUniverse,a,!1))},
lN(a){var t=this
t.b=A.m9(t)
return t.b(a)},
m9(a){var t,s,r,q,p
if(a===u.K)return A.lW
if(A.ba(a))return A.m_
t=a.w
if(t===6)return A.lL
if(t===1)return A.iv
if(t===7)return A.lR
s=A.m8(a)
if(s!=null)return s
if(t===8){r=a.x
if(a.y.every(A.ba)){a.f="$i"+r
if(r==="u")return A.lU
if(a===u.m)return A.lT
return A.lZ}}else if(t===10){q=A.mj(a.x,a.y)
p=q==null?A.iv:q
return p==null?A.io(p):p}return A.lJ},
m8(a){if(a.w===8){if(a===u.S)return A.fi
if(a===u.i||a===u.H)return A.lV
if(a===u.N)return A.lY
if(a===u.y)return A.h_}return null},
lM(a){var t=this,s=A.lI
if(A.ba(t))s=A.lE
else if(t===u.K)s=A.io
else if(A.bT(t)){s=A.lK
if(t===u.a3)s=A.lB
else if(t===u.x)s=A.ip
else if(t===u.u)s=A.lz
else if(t===u.ae)s=A.im
else if(t===u.dd)s=A.lA
else if(t===u.B)s=A.lD}else if(t===u.S)s=A.p
else if(t===u.N)s=A.ak
else if(t===u.y)s=A.il
else if(t===u.H)s=A.dD
else if(t===u.i)s=A.dC
else if(t===u.m)s=A.lC
t.a=s
return t.a(a)},
lJ(a){var t=this
if(a==null)return A.bT(t)
return A.mB(v.typeUniverse,A.mx(a,t),t)},
lL(a){if(a==null)return!0
return this.x.b(a)},
lZ(a){var t,s=this
if(a==null)return A.bT(s)
t=s.f
if(a instanceof A.x)return!!a[t]
return!!J.aI(a)[t]},
lU(a){var t,s=this
if(a==null)return A.bT(s)
if(typeof a!="object")return!1
if(Array.isArray(a))return!0
t=s.f
if(a instanceof A.x)return!!a[t]
return!!J.aI(a)[t]},
lT(a){var t=this
if(a==null)return!1
if(typeof a=="object"){if(a instanceof A.x)return!!a[t.f]
return!0}if(typeof a=="function")return!0
return!1},
iu(a){if(typeof a=="object"){if(a instanceof A.x)return u.m.b(a)
return!0}if(typeof a=="function")return!0
return!1},
lI(a){var t=this
if(a==null){if(A.bT(t))return a}else if(t.b(a))return a
throw A.J(A.ir(a,t),new Error())},
lK(a){var t=this
if(a==null||t.b(a))return a
throw A.J(A.ir(a,t),new Error())},
ir(a,b){return new A.cF("TypeError: "+A.i5(a,A.Z(b,null)))},
i5(a,b){return A.em(a)+": type '"+A.Z(A.h0(a),null)+"' is not a subtype of type '"+b+"'"},
a5(a,b){return new A.cF("TypeError: "+A.i5(a,b))},
lR(a){var t=this
return t.x.b(a)||A.fS(v.typeUniverse,t).b(a)},
lW(a){return a!=null},
io(a){if(a!=null)return a
throw A.J(A.a5(a,"Object"),new Error())},
m_(a){return!0},
lE(a){return a},
iv(a){return!1},
h_(a){return!0===a||!1===a},
il(a){if(!0===a)return!0
if(!1===a)return!1
throw A.J(A.a5(a,"bool"),new Error())},
lz(a){if(!0===a)return!0
if(!1===a)return!1
if(a==null)return a
throw A.J(A.a5(a,"bool?"),new Error())},
dC(a){if(typeof a=="number")return a
throw A.J(A.a5(a,"double"),new Error())},
lA(a){if(typeof a=="number")return a
if(a==null)return a
throw A.J(A.a5(a,"double?"),new Error())},
fi(a){return typeof a=="number"&&Math.floor(a)===a},
p(a){if(typeof a=="number"&&Math.floor(a)===a)return a
throw A.J(A.a5(a,"int"),new Error())},
lB(a){if(typeof a=="number"&&Math.floor(a)===a)return a
if(a==null)return a
throw A.J(A.a5(a,"int?"),new Error())},
lV(a){return typeof a=="number"},
dD(a){if(typeof a=="number")return a
throw A.J(A.a5(a,"num"),new Error())},
im(a){if(typeof a=="number")return a
if(a==null)return a
throw A.J(A.a5(a,"num?"),new Error())},
lY(a){return typeof a=="string"},
ak(a){if(typeof a=="string")return a
throw A.J(A.a5(a,"String"),new Error())},
ip(a){if(typeof a=="string")return a
if(a==null)return a
throw A.J(A.a5(a,"String?"),new Error())},
lC(a){if(A.iu(a))return a
throw A.J(A.a5(a,"JSObject"),new Error())},
lD(a){if(a==null)return a
if(A.iu(a))return a
throw A.J(A.a5(a,"JSObject?"),new Error())},
iw(a,b){var t,s,r
for(t="",s="",r=0;r<a.length;++r,s=", ")t+=s+A.Z(a[r],b)
return t},
m4(a,b){var t,s,r,q,p,o,n=a.x,m=a.y
if(""===n)return"("+A.iw(m,b)+")"
t=m.length
s=n.split(",")
r=s.length-t
for(q="(",p="",o=0;o<t;++o,p=", "){q+=p
if(r===0)q+="{"
q+=A.Z(m[o],b)
if(r>=0)q+=" "+s[r];++r}return q+"})"},
is(a2,a3,a4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0=", ",a1=null
if(a4!=null){t=a4.length
if(a3==null)a3=A.q([],u.s)
else a1=a3.length
s=a3.length
for(r=t;r>0;--r)B.c.E(a3,"T"+(s+r))
for(q=u.X,p="<",o="",r=0;r<t;++r,o=a0){n=a3.length
m=n-1-r
if(!(m>=0))return A.a(a3,m)
p=p+o+a3[m]
l=a4[r]
k=l.w
if(!(k===2||k===3||k===4||k===5||l===q))p+=" extends "+A.Z(l,a3)}p+=">"}else p=""
q=a2.x
j=a2.y
i=j.a
h=i.length
g=j.b
f=g.length
e=j.c
d=e.length
c=A.Z(q,a3)
for(b="",a="",r=0;r<h;++r,a=a0)b+=a+A.Z(i[r],a3)
if(f>0){b+=a+"["
for(a="",r=0;r<f;++r,a=a0)b+=a+A.Z(g[r],a3)
b+="]"}if(d>0){b+=a+"{"
for(a="",r=0;r<d;r+=3,a=a0){b+=a
if(e[r+1])b+="required "
b+=A.Z(e[r+2],a3)+" "+e[r]}b+="}"}if(a1!=null){a3.toString
a3.length=a1}return p+"("+b+") => "+c},
Z(a,b){var t,s,r,q,p,o,n,m=a.w
if(m===5)return"erased"
if(m===2)return"dynamic"
if(m===3)return"void"
if(m===1)return"Never"
if(m===4)return"any"
if(m===6){t=a.x
s=A.Z(t,b)
r=t.w
return(r===11||r===12?"("+s+")":s)+"?"}if(m===7)return"FutureOr<"+A.Z(a.x,b)+">"
if(m===8){q=A.mc(a.x)
p=a.y
return p.length>0?q+("<"+A.iw(p,b)+">"):q}if(m===10)return A.m4(a,b)
if(m===11)return A.is(a,b,null)
if(m===12)return A.is(a.x,b,a.y)
if(m===13){o=a.x
n=b.length
o=n-1-o
if(!(o>=0&&o<n))return A.a(b,o)
return b[o]}return"?"},
mc(a){var t=v.mangledGlobalNames[a]
if(t!=null)return t
return"minified:"+a},
lu(a,b){var t=a.tR[b]
while(typeof t=="string")t=a.tR[t]
return t},
lt(a,b){var t,s,r,q,p,o=a.eT,n=o[b]
if(n==null)return A.f9(a,b,!1)
else if(typeof n=="number"){t=n
s=A.cI(a,5,"#")
r=A.ff(t)
for(q=0;q<t;++q)r[q]=s
p=A.cH(a,b,r)
o[b]=p
return p}else return n},
ls(a,b){return A.ij(a.tR,b)},
lr(a,b){return A.ij(a.eT,b)},
f9(a,b,c){var t,s=a.eC,r=s.get(b)
if(r!=null)return r
t=A.ia(A.i8(a,null,b,!1))
s.set(b,t)
return t},
cJ(a,b,c){var t,s,r=b.z
if(r==null)r=b.z=new Map()
t=r.get(c)
if(t!=null)return t
s=A.ia(A.i8(a,b,c,!0))
r.set(c,s)
return s},
ih(a,b,c){var t,s,r,q=b.Q
if(q==null)q=b.Q=new Map()
t=c.as
s=q.get(t)
if(s!=null)return s
r=A.fX(a,b,c.w===9?c.y:[c])
q.set(t,r)
return r},
aF(a,b){b.a=A.lM
b.b=A.lN
return b},
cI(a,b,c){var t,s,r=a.eC.get(c)
if(r!=null)return r
t=new A.aa(null,null)
t.w=b
t.as=c
s=A.aF(a,t)
a.eC.set(c,s)
return s},
ie(a,b,c){var t,s=b.as+"?",r=a.eC.get(s)
if(r!=null)return r
t=A.lp(a,b,s,c)
a.eC.set(s,t)
return t},
lp(a,b,c,d){var t,s,r
if(d){t=b.w
s=!0
if(!A.ba(b))if(!(b===u.a||b===u.T))if(t!==6)s=t===7&&A.bT(b.x)
if(s)return b
else if(t===1)return u.a}r=new A.aa(null,null)
r.w=6
r.x=b
r.as=c
return A.aF(a,r)},
id(a,b,c){var t,s=b.as+"/",r=a.eC.get(s)
if(r!=null)return r
t=A.ln(a,b,s,c)
a.eC.set(s,t)
return t},
ln(a,b,c,d){var t,s
if(d){t=b.w
if(A.ba(b)||b===u.K)return b
else if(t===1)return A.cH(a,"er",[b])
else if(b===u.a||b===u.T)return u.f}s=new A.aa(null,null)
s.w=7
s.x=b
s.as=c
return A.aF(a,s)},
lq(a,b){var t,s,r=""+b+"^",q=a.eC.get(r)
if(q!=null)return q
t=new A.aa(null,null)
t.w=13
t.x=b
t.as=r
s=A.aF(a,t)
a.eC.set(r,s)
return s},
cG(a){var t,s,r,q=a.length
for(t="",s="",r=0;r<q;++r,s=",")t+=s+a[r].as
return t},
lm(a){var t,s,r,q,p,o=a.length
for(t="",s="",r=0;r<o;r+=3,s=","){q=a[r]
p=a[r+1]?"!":":"
t+=s+q+p+a[r+2].as}return t},
cH(a,b,c){var t,s,r,q=b
if(c.length>0)q+="<"+A.cG(c)+">"
t=a.eC.get(q)
if(t!=null)return t
s=new A.aa(null,null)
s.w=8
s.x=b
s.y=c
if(c.length>0)s.c=c[0]
s.as=q
r=A.aF(a,s)
a.eC.set(q,r)
return r},
fX(a,b,c){var t,s,r,q,p,o
if(b.w===9){t=b.x
s=b.y.concat(c)}else{s=c
t=b}r=t.as+(";<"+A.cG(s)+">")
q=a.eC.get(r)
if(q!=null)return q
p=new A.aa(null,null)
p.w=9
p.x=t
p.y=s
p.as=r
o=A.aF(a,p)
a.eC.set(r,o)
return o},
ig(a,b,c){var t,s,r="+"+(b+"("+A.cG(c)+")"),q=a.eC.get(r)
if(q!=null)return q
t=new A.aa(null,null)
t.w=10
t.x=b
t.y=c
t.as=r
s=A.aF(a,t)
a.eC.set(r,s)
return s},
ic(a,b,c){var t,s,r,q,p,o=b.as,n=c.a,m=n.length,l=c.b,k=l.length,j=c.c,i=j.length,h="("+A.cG(n)
if(k>0){t=m>0?",":""
h+=t+"["+A.cG(l)+"]"}if(i>0){t=m>0?",":""
h+=t+"{"+A.lm(j)+"}"}s=o+(h+")")
r=a.eC.get(s)
if(r!=null)return r
q=new A.aa(null,null)
q.w=11
q.x=b
q.y=c
q.as=s
p=A.aF(a,q)
a.eC.set(s,p)
return p},
fY(a,b,c,d){var t,s=b.as+("<"+A.cG(c)+">"),r=a.eC.get(s)
if(r!=null)return r
t=A.lo(a,b,c,s,d)
a.eC.set(s,t)
return t},
lo(a,b,c,d,e){var t,s,r,q,p,o,n,m
if(e){t=c.length
s=A.ff(t)
for(r=0,q=0;q<t;++q){p=c[q]
if(p.w===1){s[q]=p;++r}}if(r>0){o=A.b8(a,b,s,0)
n=A.bP(a,c,s,0)
return A.fY(a,o,n,c!==n)}}m=new A.aa(null,null)
m.w=12
m.x=b
m.y=c
m.as=d
return A.aF(a,m)},
i8(a,b,c,d){return{u:a,e:b,r:c,s:[],p:0,n:d}},
ia(a){var t,s,r,q,p,o,n,m=a.r,l=a.s
for(t=m.length,s=0;s<t;){r=m.charCodeAt(s)
if(r>=48&&r<=57)s=A.le(s+1,r,m,l)
else if((((r|32)>>>0)-97&65535)<26||r===95||r===36||r===124)s=A.i9(a,s,m,l,!1)
else if(r===46)s=A.i9(a,s,m,l,!0)
else{++s
switch(r){case 44:break
case 58:l.push(!1)
break
case 33:l.push(!0)
break
case 59:l.push(A.b6(a.u,a.e,l.pop()))
break
case 94:l.push(A.lq(a.u,l.pop()))
break
case 35:l.push(A.cI(a.u,5,"#"))
break
case 64:l.push(A.cI(a.u,2,"@"))
break
case 126:l.push(A.cI(a.u,3,"~"))
break
case 60:l.push(a.p)
a.p=l.length
break
case 62:A.lg(a,l)
break
case 38:A.lf(a,l)
break
case 63:q=a.u
l.push(A.ie(q,A.b6(q,a.e,l.pop()),a.n))
break
case 47:q=a.u
l.push(A.id(q,A.b6(q,a.e,l.pop()),a.n))
break
case 40:l.push(-3)
l.push(a.p)
a.p=l.length
break
case 41:A.ld(a,l)
break
case 91:l.push(a.p)
a.p=l.length
break
case 93:p=l.splice(a.p)
A.ib(a.u,a.e,p)
a.p=l.pop()
l.push(p)
l.push(-1)
break
case 123:l.push(a.p)
a.p=l.length
break
case 125:p=l.splice(a.p)
A.li(a.u,a.e,p)
a.p=l.pop()
l.push(p)
l.push(-2)
break
case 43:o=m.indexOf("(",s)
l.push(m.substring(s,o))
l.push(-4)
l.push(a.p)
a.p=l.length
s=o+1
break
default:throw"Bad character "+r}}}n=l.pop()
return A.b6(a.u,a.e,n)},
le(a,b,c,d){var t,s,r=b-48
for(t=c.length;a<t;++a){s=c.charCodeAt(a)
if(!(s>=48&&s<=57))break
r=r*10+(s-48)}d.push(r)
return a},
i9(a,b,c,d,e){var t,s,r,q,p,o,n=b+1
for(t=c.length;n<t;++n){s=c.charCodeAt(n)
if(s===46){if(e)break
e=!0}else{if(!((((s|32)>>>0)-97&65535)<26||s===95||s===36||s===124))r=s>=48&&s<=57
else r=!0
if(!r)break}}q=c.substring(b,n)
if(e){t=a.u
p=a.e
if(p.w===9)p=p.x
o=A.lu(t,p.x)[q]
if(o==null)A.cL('No "'+q+'" in "'+A.l1(p)+'"')
d.push(A.cJ(t,p,o))}else d.push(q)
return n},
lg(a,b){var t,s=a.u,r=A.i7(a,b),q=b.pop()
if(typeof q=="string")b.push(A.cH(s,q,r))
else{t=A.b6(s,a.e,q)
switch(t.w){case 11:b.push(A.fY(s,t,r,a.n))
break
default:b.push(A.fX(s,t,r))
break}}},
ld(a,b){var t,s,r,q=a.u,p=b.pop(),o=null,n=null
if(typeof p=="number")switch(p){case-1:o=b.pop()
break
case-2:n=b.pop()
break
default:b.push(p)
break}else b.push(p)
t=A.i7(a,b)
p=b.pop()
switch(p){case-3:p=b.pop()
if(o==null)o=q.sEA
if(n==null)n=q.sEA
s=A.b6(q,a.e,p)
r=new A.dy()
r.a=t
r.b=o
r.c=n
b.push(A.ic(q,s,r))
return
case-4:b.push(A.ig(q,b.pop(),t))
return
default:throw A.j(A.bU("Unexpected state under `()`: "+A.C(p)))}},
lf(a,b){var t=b.pop()
if(0===t){b.push(A.cI(a.u,1,"0&"))
return}if(1===t){b.push(A.cI(a.u,4,"1&"))
return}throw A.j(A.bU("Unexpected extended operation "+A.C(t)))},
i7(a,b){var t=b.splice(a.p)
A.ib(a.u,a.e,t)
a.p=b.pop()
return t},
b6(a,b,c){if(typeof c=="string")return A.cH(a,c,a.sEA)
else if(typeof c=="number"){b.toString
return A.lh(a,b,c)}else return c},
ib(a,b,c){var t,s=c.length
for(t=0;t<s;++t)c[t]=A.b6(a,b,c[t])},
li(a,b,c){var t,s=c.length
for(t=2;t<s;t+=3)c[t]=A.b6(a,b,c[t])},
lh(a,b,c){var t,s,r=b.w
if(r===9){if(c===0)return b.x
t=b.y
s=t.length
if(c<=s)return t[c-1]
c-=s
b=b.x
r=b.w}else if(c===0)return b
if(r!==8)throw A.j(A.bU("Indexed base must be an interface type"))
t=b.y
if(c<=t.length)return t[c-1]
throw A.j(A.bU("Bad index "+c+" for "+b.v(0)))},
mB(a,b,c){var t,s=b.d
if(s==null)s=b.d=new Map()
t=s.get(c)
if(t==null){t=A.G(a,b,null,c,null)
s.set(c,t)}return t},
G(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k,j
if(b===d)return!0
if(A.ba(d))return!0
t=b.w
if(t===4)return!0
if(A.ba(b))return!1
if(b.w===1)return!0
s=t===13
if(s)if(A.G(a,c[b.x],c,d,e))return!0
r=d.w
q=u.a
if(b===q||b===u.T){if(r===7)return A.G(a,b,c,d.x,e)
return d===q||d===u.T||r===6}if(d===u.K){if(t===7)return A.G(a,b.x,c,d,e)
return t!==6}if(t===7){if(!A.G(a,b.x,c,d,e))return!1
return A.G(a,A.fS(a,b),c,d,e)}if(t===6)return A.G(a,q,c,d,e)&&A.G(a,b.x,c,d,e)
if(r===7){if(A.G(a,b,c,d.x,e))return!0
return A.G(a,b,c,A.fS(a,d),e)}if(r===6)return A.G(a,b,c,q,e)||A.G(a,b,c,d.x,e)
if(s)return!1
q=t!==11
if((!q||t===12)&&d===u.Z)return!0
p=t===10
if(p&&d===u.O)return!0
if(r===12){if(b===u.M)return!0
if(t!==12)return!1
o=b.y
n=d.y
m=o.length
if(m!==n.length)return!1
c=c==null?o:o.concat(c)
e=e==null?n:n.concat(e)
for(l=0;l<m;++l){k=o[l]
j=n[l]
if(!A.G(a,k,c,j,e)||!A.G(a,j,e,k,c))return!1}return A.it(a,b.x,c,d.x,e)}if(r===11){if(b===u.M)return!0
if(q)return!1
return A.it(a,b,c,d,e)}if(t===8){if(r!==8)return!1
return A.lS(a,b,c,d,e)}if(p&&r===10)return A.lX(a,b,c,d,e)
return!1},
it(a2,a3,a4,a5,a6){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1
if(!A.G(a2,a3.x,a4,a5.x,a6))return!1
t=a3.y
s=a5.y
r=t.a
q=s.a
p=r.length
o=q.length
if(p>o)return!1
n=o-p
m=t.b
l=s.b
k=m.length
j=l.length
if(p+k<o+j)return!1
for(i=0;i<p;++i){h=r[i]
if(!A.G(a2,q[i],a6,h,a4))return!1}for(i=0;i<n;++i){h=m[i]
if(!A.G(a2,q[p+i],a6,h,a4))return!1}for(i=0;i<j;++i){h=m[n+i]
if(!A.G(a2,l[i],a6,h,a4))return!1}g=t.c
f=s.c
e=g.length
d=f.length
for(c=0,b=0;b<d;b+=3){a=f[b]
for(;;){if(c>=e)return!1
a0=g[c]
c+=3
if(a<a0)return!1
a1=g[c-2]
if(a0<a){if(a1)return!1
continue}h=f[b+1]
if(a1&&!h)return!1
h=g[c-1]
if(!A.G(a2,f[b+2],a6,h,a4))return!1
break}}while(c<e){if(g[c+1])return!1
c+=3}return!0},
lS(a,b,c,d,e){var t,s,r,q,p,o=b.x,n=d.x
while(o!==n){t=a.tR[o]
if(t==null)return!1
if(typeof t=="string"){o=t
continue}s=t[n]
if(s==null)return!1
r=s.length
q=r>0?new Array(r):v.typeUniverse.sEA
for(p=0;p<r;++p)q[p]=A.cJ(a,b,s[p])
return A.ik(a,q,null,c,d.y,e)}return A.ik(a,b.y,null,c,d.y,e)},
ik(a,b,c,d,e,f){var t,s=b.length
for(t=0;t<s;++t)if(!A.G(a,b[t],d,e[t],f))return!1
return!0},
lX(a,b,c,d,e){var t,s=b.y,r=d.y,q=s.length
if(q!==r.length)return!1
if(b.x!==d.x)return!1
for(t=0;t<q;++t)if(!A.G(a,s[t],c,r[t],e))return!1
return!0},
bT(a){var t=a.w,s=!0
if(!(a===u.a||a===u.T))if(!A.ba(a))if(t!==6)s=t===7&&A.bT(a.x)
return s},
ba(a){var t=a.w
return t===2||t===3||t===4||t===5||a===u.X},
ij(a,b){var t,s,r=Object.keys(b),q=r.length
for(t=0;t<q;++t){s=r[t]
a[s]=b[s]}},
ff(a){return a>0?new Array(a):v.typeUniverse.sEA},
aa:function aa(a,b){var _=this
_.a=a
_.b=b
_.r=_.f=_.d=_.c=null
_.w=0
_.as=_.Q=_.z=_.y=_.x=null},
dy:function dy(){this.c=this.b=this.a=null},
dB:function dB(a){this.a=a},
dw:function dw(){},
cF:function cF(a){this.a=a},
kJ(a,b){return new A.a7(a.p("@<0>").b7(b).p("a7<1,2>"))},
kK(a,b,c){return b.p("@<0>").b7(c).p("fO<1,2>").a(A.iC(a,new A.a7(b.p("@<0>").b7(c).p("a7<1,2>"))))},
aS(a,b){return new A.a7(a.p("@<0>").b7(b).p("a7<1,2>"))},
da(a,b,c){var t=A.kJ(b,c)
a.aG(0,new A.eE(t,b,c))
return t},
fP(a){var t,s
if(A.h4(a))return"{...}"
t=new A.bK("")
try{s={}
B.c.E($.a_,a)
t.a+="{"
s.a=!0
a.aG(0,new A.eF(s,t))
t.a+="}"}finally{if(0>=$.a_.length)return A.a($.a_,-1)
$.a_.pop()}s=t.a
return s.charCodeAt(0)==0?s:s},
eE:function eE(a,b,c){this.a=a
this.b=b
this.c=c},
w:function w(){},
P:function P(){},
eF:function eF(a,b){this.a=a
this.b=b},
m2(a,b){var t,s,r,q=null
try{q=JSON.parse(a)}catch(s){t=A.mO(s)
r=A.fF(String(t),null,null)
throw A.j(r)}r=A.fh(q)
return r},
fh(a){var t
if(a==null)return null
if(typeof a!="object")return a
if(!Array.isArray(a))return new A.dz(a,Object.create(null))
for(t=0;t<a.length;++t)a[t]=A.fh(a[t])
return a},
lw(a,b,c){var t,s,r,q,p=c-b
if(p<=4096)t=$.j0()
else t=new Uint8Array(p)
for(s=0;s<p;++s){r=b+s
if(!(r<a.length))return A.a(a,r)
q=a[r]
if((q&255)!==q)q=255
t[s]=q}return t},
lv(a,b,c,d){var t=a?$.j_():$.iZ()
if(t==null)return null
if(0===c&&d===b.length)return A.ii(t,b)
return A.ii(t,b.subarray(c,d))},
ii(a,b){var t,s
try{t=a.decode(b)
return t}catch(s){}return null},
lx(a){switch(a){case 65:return"Missing extension byte"
case 67:return"Unexpected extension byte"
case 69:return"Invalid UTF-8 byte"
case 71:return"Overlong encoding"
case 73:return"Out of unicode range"
case 75:return"Encoded surrogate"
case 77:return"Unfinished UTF-8 octet sequence"
default:return""}},
dz:function dz(a,b){this.a=a
this.b=b
this.c=null},
dA:function dA(a){this.a=a},
fd:function fd(){},
fc:function fc(){},
f8:function f8(){},
bg:function bg(){},
cT:function cT(){},
bY:function bY(){},
d9:function d9(){},
eA:function eA(a){this.a=a},
eC:function eC(){},
du:function du(){},
eY:function eY(){},
fe:function fe(a){this.b=0
this.c=a},
dv:function dv(a){this.a=a},
fb:function fb(a){this.a=a
this.b=16
this.c=0},
my(a){var t=A.kX(a,null)
if(t!=null)return t
throw A.j(A.fF(a,null,null))},
aA(a,b,c,d){var t,s=J.hL(a,d)
if(a!==0&&b!=null)for(t=0;t<a;++t)s[t]=b
return s},
kL(a,b,c){var t,s=A.q([],c.p("B<0>"))
for(t=J.fv(a);t.H();)B.c.E(s,c.a(t.gL()))
if(b)return s
s.$flags=1
return s},
k(a,b){var t,s
if(Array.isArray(a))return A.q(a.slice(0),b.p("B<0>"))
t=A.q([],b.p("B<0>"))
for(s=J.fv(a);s.H();)B.c.E(t,s.gL())
return t},
kM(a,b,c){var t,s=J.kG(a,c)
for(t=0;t<a;++t)B.c.q(s,t,b.$1(t))
return s},
l3(a,b,c){var t,s,r,q,p
A.ct(b,"start")
t=c==null
s=!t
if(s){r=c-b
if(r<0)throw A.j(A.a9(c,b,null,"end",null))
if(r===0)return""}if(Array.isArray(a)){q=a
p=q.length
if(t)c=p
return A.i_(b>0||c<p?q.slice(b,c):q)}if(u.Y.b(a))return A.l4(a,b,c)
if(s)a=J.jd(a,c)
if(b>0)a=J.hh(a,b)
t=A.k(a,u.S)
return A.i_(t)},
l4(a,b,c){var t=a.length
if(b>=t)return""
return A.kZ(a,b,c==null||c>t?t:c)},
i1(a,b,c){var t=J.fv(b)
if(!t.H())return a
if(c.length===0){do a+=A.C(t.gL())
while(t.H())}else{a+=A.C(t.gL())
while(t.H())a=a+c+A.C(t.gL())}return a},
em(a){if(typeof a=="number"||A.h_(a)||a==null)return J.cM(a)
if(typeof a=="string")return JSON.stringify(a)
return A.hZ(a)},
bU(a){return new A.cN(a)},
aK(a,b){return new A.ae(!1,null,b,a)},
jf(a,b,c){return new A.ae(!0,a,b,c)},
l0(a,b){return new A.cs(null,null,!0,a,b,"Value not in range")},
a9(a,b,c,d,e){return new A.cs(b,c,!0,a,d,"Invalid value")},
bI(a,b,c){if(0>a||a>c)throw A.j(A.a9(a,0,c,"start",null))
if(b!=null){if(a>b||b>c)throw A.j(A.a9(b,a,c,"end",null))
return b}return c},
ct(a,b){if(a<0)throw A.j(A.a9(a,0,null,b,null))
return a},
fH(a,b,c,d){return new A.d1(b,!0,a,d,"Index out of range")},
ah(a){return new A.cy(a)},
i3(a){return new A.ds(a)},
l2(a){return new A.bJ(a)},
aM(a){return new A.cS(a)},
ku(a){return new A.f2(a)},
fF(a,b,c){return new A.ep(a,b,c)},
kF(a,b,c){var t,s
if(A.h4(a)){if(b==="("&&c===")")return"(...)"
return b+"..."+c}t=A.q([],u.s)
B.c.E($.a_,a)
try{A.m0(a,t)}finally{if(0>=$.a_.length)return A.a($.a_,-1)
$.a_.pop()}s=A.i1(b,u.W.a(t),", ")+c
return s.charCodeAt(0)==0?s:s},
hJ(a,b,c){var t,s
if(A.h4(a))return b+"..."+c
t=new A.bK(b)
B.c.E($.a_,a)
try{s=t
s.a=A.i1(s.a,a,", ")}finally{if(0>=$.a_.length)return A.a($.a_,-1)
$.a_.pop()}t.a+=c
s=t.a
return s.charCodeAt(0)==0?s:s},
m0(a,b){var t,s,r,q,p,o,n,m=a.gD(a),l=0,k=0
for(;;){if(!(l<80||k<3))break
if(!m.H())return
t=A.C(m.gL())
B.c.E(b,t)
l+=t.length+2;++k}if(!m.H()){if(k<=5)return
if(0>=b.length)return A.a(b,-1)
s=b.pop()
if(0>=b.length)return A.a(b,-1)
r=b.pop()}else{q=m.gL();++k
if(!m.H()){if(k<=4){B.c.E(b,A.C(q))
return}s=A.C(q)
if(0>=b.length)return A.a(b,-1)
r=b.pop()
l+=s.length+2}else{p=m.gL();++k
for(;m.H();q=p,p=o){o=m.gL();++k
if(k>100){for(;;){if(!(l>75&&k>3))break
if(0>=b.length)return A.a(b,-1)
l-=b.pop().length+2;--k}B.c.E(b,"...")
return}}r=A.C(q)
s=A.C(p)
l+=s.length+r.length+4}}if(k>b.length+2){l+=5
n="..."}else n=null
for(;;){if(!(l>80&&b.length>3))break
if(0>=b.length)return A.a(b,-1)
l-=b.pop().length+2
if(n==null){l+=5
n="..."}}if(n!=null)B.c.E(b,n)
B.c.E(b,r)
B.c.E(b,s)},
fQ(a,b,c,d){var t
if(B.B===c){t=B.b.gF(a)
b=J.am(b)
return A.eU(A.aq(A.aq($.dH(),t),b))}if(B.B===d){t=B.b.gF(a)
b=J.am(b)
c=J.am(c)
return A.eU(A.aq(A.aq(A.aq($.dH(),t),b),c))}t=B.b.gF(a)
b=J.am(b)
c=J.am(c)
d=J.am(d)
d=A.eU(A.aq(A.aq(A.aq(A.aq($.dH(),t),b),c),d))
return d},
l(a){var t,s,r=$.dH()
for(t=a.length,s=0;s<a.length;a.length===t||(0,A.a0)(a),++s)r=A.aq(r,J.am(a[s]))
return A.eU(r)},
dG(a){A.mH(a)},
f1:function f1(){},
F:function F(){},
cN:function cN(a){this.a=a},
cx:function cx(){},
ae:function ae(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
cs:function cs(a,b,c,d,e,f){var _=this
_.e=a
_.f=b
_.a=c
_.b=d
_.c=e
_.d=f},
d1:function d1(a,b,c,d,e){var _=this
_.f=a
_.a=b
_.b=c
_.c=d
_.d=e},
cy:function cy(a){this.a=a},
ds:function ds(a){this.a=a},
bJ:function bJ(a){this.a=a},
cS:function cS(a){this.a=a},
cv:function cv(){},
f2:function f2(a){this.a=a},
ep:function ep(a,b,c){this.a=a
this.b=b
this.c=c},
d:function d(){},
ch:function ch(){},
x:function x(){},
eT:function eT(){this.b=this.a=0},
bK:function bK(a){this.a=a},
l8(a,b,c){throw A.j(A.ah("File._open"))},
lb(){throw A.j(A.ah("_Namespace"))},
lc(){throw A.j(A.ah("_Namespace"))},
lj(){throw A.j(A.ah("Platform._operatingSystem"))},
lG(a,b,c){var t
if(u.j.b(a)&&!J.ad(J.he(a,0),0)){t=J.aJ(a)
switch(t.k(a,0)){case 1:throw A.j(A.aK(b+": "+c,null))
case 2:throw A.j(A.kw(new A.eI(A.ak(t.k(a,2)),A.p(t.k(a,1))),b,c))
case 3:throw A.j(A.hB("File closed",c,null))
default:throw A.j(A.bU("Unknown error"))}}},
kx(a){var t
$.j2()
t=A.kv(B.aw.b4(a))
return new A.dx(a,t)},
hB(a,b,c){return new A.bt(a,b,c)},
kw(a,b,c){if($.iK())switch(a.b){case 5:case 16:case 19:case 24:case 32:case 33:case 65:case 108:return new A.df(b,c,a)
case 80:case 183:return new A.dg(b,c,a)
case 2:case 3:case 15:case 123:case 18:case 53:case 67:case 161:case 206:return new A.dh(b,c,a)
default:return new A.bt(b,c,a)}else switch(a.b){case 1:case 13:return new A.df(b,c,a)
case 17:return new A.dg(b,c,a)
case 2:return new A.dh(b,c,a)
default:return new A.bt(b,c,a)}},
l7(){return A.lc()},
l6(a,b){B.c.q(b,0,A.l7())},
kv(a){var t,s,r=a.length
if(r!==0){t=r-1
if(!(t>=0))return A.a(a,t)
t=a[t]!==0}else t=!0
if(t){s=new Uint8Array(r+1)
B.e.aD(s,0,r,a)
return s}else return a},
lk(){return A.lj()},
eI:function eI(a,b){this.a=a
this.b=b},
bt:function bt(a,b,c){this.a=a
this.b=b
this.c=c},
df:function df(a,b,c){this.a=a
this.b=b
this.c=c},
dg:function dg(a,b,c){this.a=a
this.b=b
this.c=c},
dh:function dh(a,b,c){this.a=a
this.b=b
this.c=c},
dx:function dx(a,b){this.a=a
this.b=b},
f3:function f3(a){this.a=a},
eo:function eo(){},
eZ:function eZ(){},
fg:function fg(){},
jo(a,b,c,d){var t=A.fV(),s=A.fV(),r=A.fV(),q=new Uint16Array(16),p=new Uint32Array(573),o=new Uint8Array(573)
t=new A.dJ(a,c,t,s,r,q,p,o)
t.d5(b,d)
t.cQ(B.C)
return t},
hn(a,b,c,d){var t,s=b*2,r=a.length
if(!(s>=0&&s<r))return A.a(a,s)
s=a[s]
t=c*2
if(!(t>=0&&t<r))return A.a(a,t)
t=a[t]
if(s>=t)if(s===t){if(!(b>=0&&b<573))return A.a(d,b)
s=d[b]
if(!(c>=0&&c<573))return A.a(d,c)
s=s<=d[c]}else s=!1
else s=!0
return s},
fV(){return new A.f4()},
l9(a,b,c){var t,s,r,q,p,o,n,m=new Uint16Array(16)
for(t=0,s=1;s<=15;++s){t=t+c[s-1]<<1>>>0
if(!(s<16))return A.a(m,s)
m[s]=t}for(r=a.length,q=0;q<=b;++q){p=q*2
o=p+1
if(!(o<r))return A.a(a,o)
n=a[o]
if(n===0)continue
if(!(n<16))return A.a(m,n)
o=m[n]
if(!(n<16))return A.a(m,n)
m[n]=o+1
o=A.la(o,n)
a.$flags&2&&A.b(a)
if(!(p<r))return A.a(a,p)
a[p]=o}},
la(a,b){var t,s=0
do{t=A.X(a,1)
s=(s|a&1)<<1>>>0
if(--b,b>0){a=t
continue}else break}while(!0)
return A.X(s,1)},
i6(a){var t
if(a<256){if(!(a>=0))return A.a(B.H,a)
t=B.H[a]}else{t=256+A.X(a,7)
if(!(t<512))return A.a(B.H,t)
t=B.H[t]}return t},
fW(a,b,c,d,e){return new A.f7(a,b,c,d,e)},
X(a,b){if(a>=0)return B.b.bv(a,b)
else return B.b.bv(a,b)+B.b.c8(2,(~b>>>0)+65536&65535)},
bM:function bM(a,b){this.a=a
this.b=b},
dJ:function dJ(a,b,c,d,e,f,g,h){var _=this
_.a=a
_.b=b
_.c=null
_.e=_.d=0
_.x=_.w=_.r=_.f=$
_.y=2
_.id=_.go=_.fy=_.fx=_.fr=_.dy=_.dx=_.db=_.cy=_.cx=_.CW=_.ch=_.ay=_.ax=_.at=_.as=_.Q=$
_.k1=0
_.p3=_.p2=_.p1=_.ok=_.k4=_.k3=_.k2=$
_.p4=c
_.R8=d
_.RG=e
_.rx=f
_.ry=g
_.x1=_.to=$
_.x2=h
_.a9=_.ah=_.bg=_.bp=_.b5=_.aM=_.bo=_.y2=_.y1=_.xr=$},
a4:function a4(a,b,c,d,e){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e},
f4:function f4(){this.c=this.b=this.a=$},
f7:function f7(a,b,c,d,e){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e},
cO:function cO(a,b){this.a=a
this.b=b},
fI(a,b,c,d){var t,s,r=new A.d2(b)
if(d==null)d=0
if(c==null)c=a.length-d
t=a.length
if(d+c>t)c=t-d
s=u.d.b(a)?a:new Uint8Array(A.t(a))
t=J.U(B.e.gB(s),s.byteOffset+d,c)
r.b=t
r.d=t.length
return r},
d2:function d2(a){var _=this
_.b=null
_.c=0
_.d=$
_.a=a},
d3:function d3(){},
kS(a,b){var t=b==null?32768:b
return new A.dd(new Uint8Array(t),a)},
dd:function dd(a,b){this.b=0
this.c=a
this.a=b},
de:function de(){},
dI:function dI(a,b){this.a=a
this.b=b},
y:function y(a){this.a=-1
this.b=a},
af:function af(a,b){this.a=a
this.b=b},
bh:function bh(a){this.a=a},
bi:function bi(a){this.a=a},
bj:function bj(a){this.a=a},
bk:function bk(a){this.a=a},
bl:function bl(a){this.a=a},
bm:function bm(a){this.a=a},
bn:function bn(a,b){this.a=a
this.b=b},
bo:function bo(a){this.a=a},
bp:function bp(a,b){this.a=a
this.b=b},
bq:function bq(a){this.a=a},
br:function br(a,b){this.a=a
this.b=b},
jn(a,b,c,d){var t=new A.cR(new Uint8Array(4))
t.cF(a,b,c,d)
return t},
aL:function aL(a){this.a=a},
cR:function cR(a){this.a=a},
dE(a,b,c){var t
if(b===c)return a
switch(b.a){case 0:if(a===0)t=0
else{t=B.ag.k(0,c)
t.toString}return t
case 1:switch(c.a){case 0:return a===0?0:1
case 1:return a
case 2:return a*5
case 3:return a*75
case 4:return a*21845
case 5:return a*1431655765
case 6:return a*42
case 7:return a*10922
case 8:return a*715827882
case 9:case 10:case 11:return a/3}break
case 2:switch(c.a){case 0:return a===0?0:1
case 1:return B.b.G(A.p(a),1)
case 2:return a
case 3:return a*17
case 4:return a*4369
case 5:return a*286331153
case 6:return a*8
case 7:return a*2184
case 8:return a*143165576
case 9:case 10:case 11:return a/3}break
case 3:switch(c.a){case 0:return a===0?0:1
case 1:return B.b.G(A.p(a),6)
case 2:return B.b.G(A.p(a),4)
case 3:return a
case 4:return a*257
case 5:return a*16843009
case 6:return B.b.G(A.p(a),1)
case 7:return a*128
case 8:return a*8421504
case 9:case 10:case 11:return a/255}break
case 4:switch(c.a){case 0:return a===0?0:1
case 1:return B.b.G(A.p(a),14)
case 2:return B.b.G(A.p(a),12)
case 3:return B.b.G(A.p(a),8)
case 4:return a
case 5:return A.p(a)<<8>>>0
case 6:return B.b.G(A.p(a),9)
case 7:return B.b.G(A.p(a),1)
case 8:return a*524296
case 9:case 10:case 11:return a/65535}break
case 5:switch(c.a){case 0:return a===0?0:1
case 1:return B.b.G(A.p(a),30)
case 2:return B.b.G(A.p(a),28)
case 3:return B.b.G(A.p(a),24)
case 4:return B.b.G(A.p(a),16)
case 5:return a
case 6:return B.b.G(A.p(a),25)
case 7:return B.b.G(A.p(a),17)
case 8:return B.b.G(A.p(a),1)
case 9:case 10:case 11:return a/4294967295}break
case 6:switch(c.a){case 0:return a===0?0:1
case 1:return a<=0?0:B.b.G(A.p(a),5)
case 2:return a<=0?0:B.b.G(A.p(a),3)
case 3:return a<=0?0:A.p(a)<<1>>>0
case 4:return a<=0?0:A.p(a)*516
case 5:return a<=0?0:A.p(a)*33818640
case 6:return a
case 7:return a*258
case 8:return a*16909320
case 9:case 10:case 11:return a/127}break
case 7:switch(c.a){case 0:return a===0?0:1
case 1:return a<=0?0:B.b.G(A.p(a),15)
case 2:return a<=0?0:B.b.G(A.p(a),11)
case 3:return a<=0?0:B.b.G(A.p(a),7)
case 4:return a<=0?0:A.p(a)<<1>>>0
case 5:return a<=0?0:A.p(a)*131076
case 6:return B.b.G(A.p(a),8)
case 7:return a
case 8:return A.p(a)*65538
case 9:case 10:case 11:return a/32767}break
case 8:switch(c.a){case 0:return a===0?0:1
case 1:return a<=0?0:B.b.G(A.p(a),29)
case 2:return a<=0?0:B.b.G(A.p(a),27)
case 3:return a<=0?0:B.b.G(A.p(a),23)
case 4:return a<=0?0:B.b.G(A.p(a),16)
case 5:return a<=0?0:A.p(a)<<1>>>0
case 6:return B.b.G(A.p(a),24)
case 7:return B.b.G(A.p(a),16)
case 8:return a
case 9:case 10:case 11:return a/2147483647}break
case 9:case 10:case 11:switch(c.a){case 0:return a===0?0:1
case 1:return B.a.h(B.a.i(a,0,1)*3)
case 2:return B.a.h(B.a.i(a,0,1)*15)
case 3:return B.a.h(B.a.i(a,0,1)*255)
case 4:return B.a.h(B.a.i(a,0,1)*65535)
case 5:return B.a.h(B.a.i(a,0,1)*4294967295)
case 6:return B.a.h(a<0?B.a.i(a,-1,1)*128:B.a.i(a,-1,1)*127)
case 7:return B.a.h(a<0?B.a.i(a,-1,1)*32768:B.a.i(a,-1,1)*32767)
case 8:return B.a.h(a<0?B.a.i(a,-1,1)*2147483648:B.a.i(a,-1,1)*2147483647)
case 9:case 10:case 11:return a}break}},
T:function T(a,b){this.a=a
this.b=b},
en(a){var t,s=new A.cX(A.aS(u.N,u.P))
s.cG(a)
t=a.b
if(t!=null)s.b=new Uint8Array(A.t(t))
return s},
cX:function cX(a){this.b=null
this.a=a},
e(a,b,c){return new A.cY(a,b)},
cY:function cY(a,b){this.a=a
this.b=b},
bv:function bv(a){this.a=a},
et:function et(a){this.a=a},
hE(a){var t=new A.aO(A.aS(u.S,u.r),new A.bv(A.aS(u.N,u.P)))
t.dt(a)
return t},
aO:function aO(a,b){this.a=a
this.b=b},
eu:function eu(a){this.a=a},
ev:function ev(a){this.a=a},
aw:function aw(a,b){this.a=a
this.b=b},
el:function el(){},
dk:function dk(a,b){this.a=a
this.b=b},
eO:function eO(a,b,c){var _=this
_.a=null
_.b=a
_.c=0
_.d=b
_.e=$
_.f=0
_.r=!1
_.w=null
_.z=c},
hD(a){return new A.cZ(a.a,a.b,B.e.cA(a.c,0))},
es:function es(a,b){this.a=a
this.b=b},
cZ:function cZ(a,b,c){this.a=a
this.b=b
this.c=c},
fG(a,b,c,d,e,f,g,h,i,j,k,l,m){var t=new A.ax(null,null,null,a,h,e,d,0)
B.c.E(t.gZ(),t)
t.c_(l,f,b,c,g,i,j,k,m)
return t},
d_(a,b,c,d){var t,s,r,q=null,p=a.e
p=p==null?q:A.en(p)
t=a.c
t=t==null?q:A.hD(t)
s=a.w
r=a.r
p=new A.ax(q,t,p,q,r,s,a.y,a.z)
p.cJ(a,b,c,d)
return p},
aP(a,b,c){var t,s,r,q,p=null,o=a.a
o=o==null?p:o.aw(c)
t=a.e
t=t==null?p:A.en(t)
s=a.c
s=s==null?p:A.hD(s)
r=a.w
q=a.r
o=new A.ax(o,s,t,p,q,r,a.y,a.z)
o.cH(a,b,c)
return o},
hG(a,b,c,d,e,f){var t=null,s=new A.ax(t,t,t,t,0,B.F,0,0)
s.cI(t,a,b,t,B.h,0,0,B.F,c,t,0,d,e,t,B.h,t,t,f,!1)
return s},
eq:function eq(a,b){this.a=a
this.b=b},
ax:function ax(a,b,c,d,e,f,g,h){var _=this
_.a=a
_.b=null
_.c=b
_.d=null
_.e=c
_.f=d
_.r=e
_.w=f
_.x=$
_.y=g
_.z=h},
ey:function ey(a,b){this.a=a
this.b=b},
ex:function ex(){},
L:function L(){},
kA(a,b,c){return new A.bZ(new Uint16Array(a*b*c),a,b,c)},
bZ:function bZ(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
kB(a,b,c){return new A.c_(new Float32Array(a*b*c),a,b,c)},
c_:function c_(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
c0:function c0(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
c1:function c1(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
c2:function c2(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
c3:function c3(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
bw:function bw(a,b,c,d,e,f){var _=this
_.d=a
_.e=b
_.f=c
_.r=null
_.a=d
_.b=e
_.c=f},
bx:function bx(a,b,c,d,e){var _=this
_.d=a
_.e=b
_.a=c
_.b=d
_.c=e},
by:function by(a,b,c,d,e,f){var _=this
_.d=a
_.e=b
_.f=c
_.r=null
_.a=d
_.b=e
_.c=f},
kC(a,b,c){return new A.c4(new Uint32Array(a*b*c),a,b,c)},
c4:function c4(a,b,c,d){var _=this
_.d=a
_.a=b
_.b=c
_.c=d},
bz:function bz(a,b,c,d,e,f){var _=this
_.d=a
_.e=b
_.f=c
_.r=null
_.a=d
_.b=e
_.c=f},
hH(a,b,c){return new A.ao(new Uint8Array(a*b*c),null,a,b,c)},
ao:function ao(a,b,c,d,e){var _=this
_.d=a
_.e=b
_.a=c
_.b=d
_.c=e},
d5:function d5(a,b){this.a=a
this.b=b},
a3:function a3(){},
cj:function cj(a,b,c){this.c=a
this.a=b
this.b=c},
ck:function ck(a,b,c){this.c=a
this.a=b
this.b=c},
cl:function cl(a,b,c){this.c=a
this.a=b
this.b=c},
cm:function cm(a,b,c){this.c=a
this.a=b
this.b=c},
cn:function cn(a,b,c){this.c=a
this.a=b
this.b=c},
co:function co(a,b,c){this.c=a
this.a=b
this.b=c},
cp:function cp(a,b,c){this.c=a
this.a=b
this.b=c},
bG:function bG(a,b,c){this.c=a
this.a=b
this.b=c},
kT(a){return new A.bH(new Uint8Array(A.t(a.c)),a.a,a.b)},
bH:function bH(a,b,c){this.c=a
this.a=b
this.b=c},
hO(a){return new A.aV(-1,0,-a.c,a)},
aV:function aV(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
hP(a){return new A.aW(-1,0,-a.c,a)},
aW:function aW(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
hQ(a){return new A.aX(-1,0,-a.c,a)},
aX:function aX(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
hR(a){return new A.aY(-1,0,-a.c,a)},
aY:function aY(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
hS(a){return new A.aZ(-1,0,-a.c,a)},
aZ:function aZ(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
hT(a){return new A.b_(-1,0,-a.c,a)},
b_:function b_(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
eL(a){return new A.b0(-1,0,0,-1,0,a)},
b0:function b0(a,b,c,d,e,f){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e
_.f=f},
hU(a){return new A.b1(-1,0,-a.c,a)},
b1:function b1(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
eM(a){return new A.b2(-1,0,0,-2,0,a)},
b2:function b2(a,b,c,d,e,f){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e
_.f=f},
hV(a){return new A.b3(-1,0,-a.c,a)},
b3:function b3(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
eN(a){return new A.b4(-1,0,0,-(a.c<<2>>>0),a)},
b4:function b4(a,b,c,d,e){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e},
hW(a){return new A.b5(-1,0,-a.c,a)},
b5:function b5(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
A:function A(){},
kD(a){return new A.ew(a)},
ew:function ew(a){this.a=a},
db:function db(a){var _=this
_.a=$
_.b=10
_.c=16
_.d=3
_.f=_.e=$
_.r=null
_.Q=_.z=_.y=_.x=_.w=$
_.as=a
_.ax=_.at=$},
aU(a,b){return new A.dc(a,new Uint8Array(b))},
dc:function dc(a,b){this.a=0
this.b=a
this.c=b},
dm:function dm(){},
fw(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5,c6,c7,c8){return new A.dK(a,c0,a0,a1,b3,c1,m,g,b6,i,h,b5,t,o,c4,d,c8,c7,c6,c5,s,r,f,b,c,!0,b9,a8,q,a6,a5,n,b4,a4,c2,e,b8,a7,p,!1,!0,a3,b0,b1,a9,c3,j,l,k)},
jO(a){var t,s,r=J.hK(6,u.o)
for(t=u.i,s=0;s<6;++s)r[s]=A.kM(3,new A.e6(a,s),t)
return r},
hA(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k,j=a.length,i=b*c
if(j!==i)throw A.j(A.aK("skin plane is "+j+" bytes, "+b+"x"+c+" needs "+i,null))
i=d*e
t=new Uint8Array(i)
if(b===d&&c===e){for(s=0;s<i;++s){if(!(s<j))return A.a(a,s)
r=a[s]
if(!(s<i))return A.a(t,s)
t[s]=r}return t}for(r=A.mi(b,c,d,e).a,q=0;q<e;++q){p=B.a.aF(r[3]+(q+0.5)*r[0]/e)
o=r[3]
n=B.b.i(p,o,o+r[0]-1)*b
for(p=q*d,m=0;m<d;++m){o=B.a.aF(r[2]+(m+0.5)*r[1]/d)
l=r[2]
k=p+m
l=n+B.b.i(o,l,l+r[1]-1)
if(!(l>=0&&l<j))return A.a(a,l)
l=a[l]
if(!(k>=0&&k<i))return A.a(t,k)
t[k]=l}}return t},
jQ(a,b,c,d,e,f,g,h){if(b!=null)return b
return null},
fC(a,b,c,d){var t=0.299*a+0.587*b+0.114*c
return new A.r(B.a.i(t+(a-t)*d,0,255),B.a.i(t+(b-t)*d,0,255),B.a.i(t+(c-t)*d,0,255))},
k8(a5,a6,a7){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0=null,a1=a5.gu(),a2=a5.gC(),a3=a1*a2,a4=a6.length
if(a4!==a3||a7.length!==a3)return new A.ab(a7,a0,a6)
for(t=a7.length,s=0,r=0,q=0;q<a3;++q){if(!(q<t))return A.a(a7,q)
if(a7[q]!==0)++s
if(!(q<a4))return A.a(a6,q)
if(a6[q]===1)++r}if(s<64||r<64)return new A.ab(a7,a0,a6)
p=s/(s+r)
if(p>0.2)return new A.ab(a7,a0,a6)
o=u.n
n=A.q([],o)
m=A.q([],o)
for(l=0;l<a2;l+=3)for(k=l*a1,j=0;j<a1;j+=3){i=k+j
if(!(i>=0&&i<a4))return A.a(a6,i)
if(a6[i]!==1)continue
i=a5.a
h=i==null?a0:i.S(j,l,a0)
if(h==null)h=new A.A()
g=A.cU(h.gj(),h.gm(),h.gl())
B.c.E(n,g.b)
B.c.E(m,g.c)}if(n.length===0)return new A.ab(a7,a0,a6)
B.c.aY(n)
B.c.aY(m)
a4=n.length
k=a4/2|0
if(!(k<a4))return A.a(n,k)
f=n[k]
k=m.length
a4=k/2|0
if(!(a4<k))return A.a(m,a4)
e=m[a4]
d=A.q([],o)
for(l=0;l<a2;l+=2)for(a4=l*a1,j=0;j<a1;j+=2){o=a4+j
if(!(o>=0&&o<t))return A.a(a7,o)
if(a7[o]===0)continue
o=a5.a
h=o==null?a0:o.S(j,l,a0)
if(h==null)h=new A.A()
g=A.cU(h.gj(),h.gm(),h.gl())
B.c.E(d,Math.sqrt(Math.pow(g.b-f,2)+Math.pow(g.c-e,2)))}if(d.length===0)return new A.ab(a7,a0,a6)
B.c.aY(d)
a4=d.length
o=a4/2|0
if(!(o<a4))return A.a(d,o)
c=d[o]
b="hair "+B.a.bt(100*p,1)+"% of the person, chroma "+B.a.bt(c,3)+" from the face"
if(c>0.016)return new A.ab(a7,"hair kept: "+b,a6)
a=new Uint8Array(A.t(a6))
for(a4=a.length,o=a.$flags|0,q=0;q<a3;++q){if(!(q<t))return A.a(a7,q)
if(a7[q]!==0){if(!(q<a4))return A.a(a,q)
k=a[q]===0}else k=!1
if(k){o&2&&A.b(a)
if(!(q<a4))return A.a(a,q)
a[q]=1}}return new A.ab(a0,"scalp fuzz folded into skin: "+b,a)},
k7(b1,b2){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6=null,a7=b1.gu(),a8=b1.gC(),a9=a7*a8,b0=b2.length
if(b0!==a9)return new A.ai(a6,b2)
for(t=0,s=0,r=0;r<a9;++r){if(!(r<b0))return A.a(b2,r)
q=b2[r]
if(q===3)++t
if(q===1)++s}if(t<64||s<64)return new A.ai(a6,b2)
q=u.n
p=A.q([],q)
o=A.q([],q)
for(n=0;n<a8;n+=3)for(q=n*a7,m=0;m<a7;m+=3){l=q+m
if(!(l>=0&&l<b0))return A.a(b2,l)
if(b2[l]!==1)continue
l=b1.a
k=l==null?a6:l.S(m,n,a6)
if(k==null)k=new A.A()
j=A.cU(k.gj(),k.gm(),k.gl())
B.c.E(p,j.b)
B.c.E(o,j.c)}if(p.length===0)return new A.ai(a6,b2)
B.c.aY(p)
B.c.aY(o)
q=p.length
l=q/2|0
if(!(l<q))return A.a(p,l)
i=p[l]
l=o.length
q=l/2|0
if(!(q<l))return A.a(o,q)
h=o[q]
g=Math.sqrt(i*i+h*h)
if(g<0.01)return new A.ai("clothes kept: the face has no hue to match (chroma "+B.a.bt(g,3)+")",b2)
f=Math.atan2(h,i)*180/3.141592653589793
e=new Uint8Array(A.t(b2))
for(d=0,n=0;n<a8;++n)for(q=n*a7,m=0;m<a7;++m){r=q+m
if(!(r>=0&&r<b0))return A.a(b2,r)
if(b2[r]!==3)continue
l=b1.a
k=l==null?a6:l.S(m,n,a6)
if(k==null)k=new A.A()
c=A.cU(k.gj(),k.gm(),k.gl())
b=c.a
a=a6
a0=a6
a1=c.b
a2=c.c
a0=a2
a=a1
a3=b
if(typeof a3!=="number")return a3.cv()
if(a3<0.5)continue
if(typeof a!=="number")return a.aP()
if(typeof a0!=="number")return a0.aP()
a4=Math.sqrt(a*a+a0*a0)/g
if(a4<0.35||a4>1.5)continue
a5=Math.atan2(a0,a)*180/3.141592653589793-f
if(a5>180)a5-=360
if(Math.abs(a5<-180?a5+360:a5)>16)continue
e.$flags&2&&A.b(e)
if(!(r<e.length))return A.a(e,r)
e[r]=1;++d}b0=B.a.bt(100*d/t,1)
if(d===0)return new A.ai(a6,b2)
return new A.ai("bare skin folded into skin: "+(b0+"% of the clothes plane ("+d+" px) in the face's own colour"),e)},
k3(a,b,c){return B.a.i((30-(Math.max(a,Math.max(b,c))-Math.min(a,Math.min(b,c))))/5,0,1)},
ki(a,b,c){var t,s=A.k3(a,b,c)
if(s<=0)return 0
t=B.a.i((0.299*a+0.587*b+0.114*c-110)/40,0,1)
if(t<=0)return 0
return s*t*B.a.i((c/Math.max(a,1)-0.86)/0.06000000000000005,0,1)},
kh(a6,a7,a8,a9,b0,b1){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1=a7*a8,a2=new Uint8Array(a1),a3=new Uint8Array(a1),a4=u.t,a5=A.q([],a4)
for(t=a6.length,s=0;s<a1;++s){if(!(s<t))return A.a(a6,s)
if(a6[s]!==2)continue
B.c.E(a5,s)
r=a9.$1(s)
q=b0.$1(s)
p=b1.$1(s)
o=0.299*r+0.587*q+0.114*p
if(o<80)a3[s]=3
else if(o<110)a3[s]=2
else{a3[s]=1
a2[s]=B.a.R(A.ki(r,q,p)*255)}}n=new Uint8Array(a1)
if(a5.length===0)return n
m=new Int32Array(a1)
l=A.q([0],a4)
k=A.q([],a4)
j=new A.ek(a7,a1)
for(t=a5.length,i=0;i<a5.length;a5.length===t||(0,A.a0)(a5),++i){h=a5[i]
if(!(h<a1))return A.a(m,h)
if(m[h]!==0)continue
g=l.length
B.c.E(l,0)
m[h]=g
B.c.E(k,h)
while(f=k.length,f!==0){if(0>=f)return A.a(k,-1)
s=k.pop()
if(!(g<l.length))return A.a(l,g)
B.c.q(l,g,l[g]+1)
j.$2(s,new A.eh(a3,m,g,k))}}e=new Uint8Array(a1)
d=new Uint8Array(a1)
c=A.q([],a4)
for(a4=a5.length,i=0;t=a5.length,i<t;a5.length===a4||(0,A.a0)(a5),++i){h=a5[i]
if(!(h<a1))return A.a(a3,h)
if(a3[h]===3){if(!(h<a1))return A.a(d,h)
t=d[h]!==0}else t=!0
if(t)continue
B.c.cm(c)
if(!(h<a1))return A.a(d,h)
d[h]=1
B.c.E(k,h)
while(t=k.length,t!==0){if(0>=t)return A.a(k,-1)
s=k.pop()
B.c.E(c,s)
j.$2(s,new A.ei(a3,d,k))}if(!(h<a1))return A.a(m,h)
t=m[h]
if(!(t>=0&&t<l.length))return A.a(l,t)
b=Math.max(2,B.b.V(l[t],64))
t=c.length
if(t<b)continue
for(a=0;a<t;++a){s=c[a]
if(!(s>=0&&s<a1))return A.a(e,s)
e[s]=1}}a0=new Uint8Array(a1)
for(i=0;a4=a5.length,i<a4;a5.length===t||(0,A.a0)(a5),++i){h=a5[i]
if(!(h<a1))return A.a(e,h)
if(e[h]!==0){if(!(h<a1))return A.a(a0,h)
a4=a0[h]!==0}else a4=!0
if(a4)continue
if(!(h<a1))return A.a(a0,h)
a0[h]=1
B.c.E(k,h)
while(a4=k.length,a4!==0){if(0>=a4)return A.a(k,-1)
j.$2(k.pop(),new A.ej(a0,e,a3,a2,k))}}for(i=0;i<a4;++i){s=a5[i]
if(!(s<a1))return A.a(a0,s)
if(a0[s]!==0){if(!(s<a1))return A.a(a2,s)
t=a2[s]
if(!(s<a1))return A.a(n,s)
n[s]=t}}return n},
cV(a,b,c){var t,s
if(a<b||a<c)return!1
t=Math.max(a,Math.max(b,c))
s=Math.min(a,Math.min(b,c))
if(t<=1)return!1
if((t-s)/t<0.14)return!1
return 0.299*a+0.587*b+0.114*c>=85},
k5(a,b,c){return new A.eb().$1((45-(Math.max(a,Math.max(b,c))-Math.min(a,Math.min(b,c))))/20)},
k4(a,b,c,d,e){var t,s,r,q
if(d<=0)return new A.r(a,b,c)
t=0.299*a+0.587*b+0.114*c
s=new A.ea()
r=t+(255-t)*e*d*s.$1((t-110)/40)-t*e*d*s.$1((100-t)/30)
q=1-d
return new A.r(B.a.i(r+(a-t)*q,0,255),B.a.i(r+(b-t)*q,0,255),B.a.i(r+(c-t)*q,0,255))},
kg(a7,a8,a9,b0,b1,b2){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6
if(b2!=null){if(b2<=0)return new A.r(a7,a8,a9)
t=0.299*a7+0.587*a8+0.114*a9
if(t<=45)s=0
else s=t>=85?1:(t-45)/40
if(t<=235)r=1
else r=t>=250?0:(250-t)/15
q=a7>=a8&&a7>=a9
p=Math.max(a7,Math.max(a8,a9))
o=Math.min(a7,Math.min(a8,a9))
n=p<=1?0:(p-o)/p
if(n<=0.14)m=0
else m=n>=0.22?1:(n-0.14)/0.08
l=q?b0*s*r*m:0}else l=b0*A.kk(a7,a8,a9)
if(l<=0)return new A.r(a7,a8,a9)
if(b1){k=u.V
j=A.k(new A.bF(B.a4,u.q.a(new A.ee()),k),k.p("Y.E"))}else j=$.hb()[1]
if(b1){k=u.V
i=A.k(new A.bF(B.a3,u.q.a(new A.ef()),k),k.p("Y.E"))}else i=$.hb()[3]
k=new A.eg()
h=k.$3(a7,a8,a9)
g=j.length
if(0>=g)return A.a(j,0)
f=j[0]
if(1>=g)return A.a(j,1)
e=j[1]
if(2>=g)return A.a(j,2)
d=k.$3(f,e,j[2])
e=i.length
if(0>=e)return A.a(i,0)
f=i[0]
if(1>=e)return A.a(i,1)
g=i[1]
if(2>=e)return A.a(i,2)
c=k.$3(f,g,i[2])
b=d===c?0:B.a.i((d-h)/(d-c),0,1)
g=j.length
if(0>=g)return A.a(j,0)
f=j[0]
e=1-b
a=i.length
if(0>=a)return A.a(i,0)
a0=f*e+i[0]*b
if(1>=g)return A.a(j,1)
f=j[1]
if(1>=a)return A.a(i,1)
a1=f*e+i[1]*b
if(2>=g)return A.a(j,2)
g=j[2]
if(2>=a)return A.a(i,2)
a2=g*e+i[2]*b
if(h<c&&c>0){a3=h/c
a0*=a3
a1*=a3
a2*=a3}a4=Math.max(a7,Math.max(a8,a9))-Math.min(a7,Math.min(a8,a9))
a5=Math.max(a0,Math.max(a1,a2))-Math.min(a0,Math.min(a1,a2))
if(a5>a4&&a5>0){a6=k.$3(a0,a1,a2)
a3=a4/a5
a0=a6+(a0-a6)*a3
a1=a6+(a1-a6)*a3
a2=a6+(a2-a6)*a3}return new A.r(a7+(a0-a7)*l,a8+(a1-a8)*l,a9+(a2-a9)*l)},
cU(a,b,c){var t,s,r,q=new A.ed(),p=q.$1(a),o=q.$1(b),n=q.$1(c)
q=new A.ec()
t=q.$1(0.4122214708*p+0.5363325363*o+0.0514459929*n)
s=q.$1(0.2119034982*p+0.6806995451*o+0.1073969566*n)
r=q.$1(0.0883024619*p+0.2817188376*o+0.6299787005*n)
return new A.r(0.2104542553*t+0.793617785*s-0.0040720468*r,1.9779984951*t-2.428592205*s+0.4505937099*r,0.0259040371*t+0.7827717662*s-0.808675766*r)},
hy(a){return new Uint8Array(A.t(A.ml(A.jN(a))))},
jN(g0){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5,c6,c7,c8,c9,d0,d1,d2,d3,d4,d5,d6,d7,d8,d9,e0,e1,e2,e3,e4,e5,e6,e7,e8,e9,f0,f1,f2,f3,f4,f5,f6=null,f7={},f8=Date.now(),f9=new A.eT()
$.hc()
f9.cz()
t=new A.bK("")
s=new A.e5(t,f9)
r=A.ht()
f7.a=null
q=A.jM(g0)
q.gu()
q.gC()
s.$1("decode+crop")
p=[null,null,0,0,null,0,0,null]
f7.a=q
o=p[4]
n=o==null?f6:A.hA(o,p[6],p[5],q.gu(),q.gC())
o=p[1]
m=o==null?f6:A.hA(o,p[3],p[2],q.gu(),q.gC())
s.$1("resize")
if(n!=null&&m!=null){l=A.k8(q,n,m)
n=l.c
m=l.a
p=l.b
if(p!=null)A.dG("[EinkCore] "+p)}if(n!=null){k=A.k7(q,n)
n=k.b
p=k.a
if(p!=null)A.dG("[EinkCore] "+p)}j=f7.a=A.js(q,"off")
i=A.jK(j,f6)
h=g0.RG?A.jp(i):B.a2
s.$1("fuzz+analyze")
g=g0.x
f=Math.abs(g-1)>0.05||Math.abs(g0.r-1)>0.05||Math.abs(g0.y-1)>0.02||Math.abs(g0.Q)>0.01
e=g0.r
d=g0.y
c=g0.Q
if(!f){g*=h.r
e*=h.w
d+=h.y
p=h.x
b=c*p
c=h.c&&Math.abs(c)<0.01?0.2*p:b}a=g0.db
a0=g0.dy
if(g0.a){a1=A.k2(i)
a*=a1.a
a0*=a1.b}if(Math.abs(a-1)>0.01||Math.abs(g0.dx-1)>0.01||Math.abs(a0-1)>0.01){j=A.ju(j,a,g0.dx,a0)
f7.a=j
p=j}else p=j
o=g0.fr
if(Math.abs(o-1)>0.01){a2=p.gu()
a3=p.gC()
j=A.jr(p,o,1.2,n!=null&&o-1.2>0.005?A.kd(n,a2,a3):f6)
f7.a=j
p=j}if(Math.abs(c)>0.01){j=A.jq(g0.ay<=0.01?f7.a=A.ho(p,0.3,f6,0):p,c,n)
f7.a=j}else j=p
p=g0.dN
if(p)a4=!g0.k2
else a4=!1
a5=j.gu()*j.gC()
if(a4)a6=new Uint8Array(a5)
else a6=f6
if(a4)a7=new Uint8Array(a5)
else a7=f6
if(a4)a8=new Uint8Array(a5)
else a8=f6
s.$1("wb+gamma+denoise+clarity")
a2=g0.w
a3=g0.z
a9=g0.ch
b0=g0.cx
b1=g0.cy
b2=g0.as
b3=g0.at
b4=g0.ax
b5=g0.ry
b6=g0.xr
b7=g0.y1
b8=g0.dF
b9=g0.dG
c0=g0.dH
c1=g0.dI
c2=g0.dO
c3=g0.dP
c4=g0.dQ
c5=A.jC(j,b0,b9,d,b2,c2,c4,c3,g,b6,1,f6,b4,a8,a7,a6,c1,b5,m,n,e,b7,0,b3,a3,0,0,0,0,f6,c0,a2,b8,p,a9,b1)
j=A.R(j)!=null?j:j.aT(B.h,3)
A.jB(j,0,j.gC(),c5,b0,b9,d,b2,c2,c4,c3,g,b6,1,f6,j.gC(),b4,a8,a7,a6,c1,b5,m,n,e,b7,0,b3,a3,0,0,0,0,f6,c0,a2,b8,p,a9,b1,0)
if(A.hz(a3)>0)j=A.jt(j,A.hz(a3))
f7.a=j
s.$1("enhance")
a2=g0.dJ
a3=a2>0
if(a3)a9=n!=null||m!=null
else a9=!1
if(a9)A.jA(j,n,m,a2)
c6=A.jJ(j.gu(),j.gC(),f6)
a9=c6!=null
if(a9){c7=f6.geh()
c8=c7.a
c9=c7.b
d0=c7.c
for(b0=c6.length,d1=0;d1<b0;++d1)if(c6[d1]===0){b1=f7.a.a
b2=b1.a
b2=B.b.K(d1,b2)
b3=b1.a
b3=B.b.X(d1,b3)
b1.a5(b2,b3,c8,c9,d0)}}b0=g0.f
d2=f6
if(b0){if(a6!=null){a7.toString
a8.toString
b1=f7.a
d3=A.e7(a6,a7,a8,b1.gu(),b1.gC())
a6=d3.a
a7=d3.b
a8=d3.c}if(a9){a9=f7.a
c6=A.e7(c6,c6,c6,a9.gu(),a9.gC()).a}if(n!=null){a9=f7.a
n=A.e7(n,n,n,a9.gu(),a9.gC()).a}if(m!=null){a9=f7.a
m=A.e7(m,m,m,a9.gu(),a9.gC()).a}f7.a=A.iB(f7.a,-90)}if(a3){a3=f7.a
d4=A.k1(n,m,a3.gu()*a3.gC())}else d4=f6
a3=g0.ay
if(a3>0.01||d4!=null)f7.a=A.ho(f7.a,a3,d4,a2)
a3=g0.k2
if(a3)f7.a=A.jS(f7.a,g0.k3,1.4)
a9=a6!=null
if(a9&&p){a7.toString
a8.toString
b1=f7.a
d5=A.jZ(a6,a7,a8,b1.gu()*b1.gC())}else d5=f6
d6=f6
if(a9){a7.toString
a8.toString
a9=f7.a
d7=A.k0(a6,a7,a8,a9.gu(),a9.gC())
if(d7!=null){d6=d7.a[0]
a9=f7.a
d8=a9.gu()*a9.gC()
d9=new Uint8Array(d8)
e0=new Uint8Array(d8)
e1=new Uint8Array(d8)
for(a9=a9.a,a9=a9.gD(a9),d1=0;a9.H();){e2=a9.gL()
b1=B.a.h(e2.gj())
if(!(d1<d8))return A.a(d9,d1)
d9[d1]=b1
e0[d1]=B.a.h(e2.gm())
e1[d1]=B.a.h(e2.gl());++d1}A.jV(d9,e0,e1,a6,a7,a8,d7,d8)
for(a9=f7.a.a,a9=a9.gD(a9),d1=0;a9.H();){e2=a9.gL()
if(!(d1<d8))return A.a(d9,d1)
e2.sj(d9[d1])
e2.sm(e0[d1])
e2.sl(e1[d1]);++d1}}}a9=f7.a
e3=A.jQ(g0,n,f6,a9.gu(),a9.gC(),new A.e2(f7),new A.e3(f7),new A.e4(f7))
s.$1("finalDenoise+lift+gate")
a9=f7.a
b1=g0.go
b2=b1?B.aP:B.b5
b3=b1?B.aG:B.bc
b1=b1?B.bd:B.b9
e4=A.jG(a9,d5,a3,g0.id,d2,b6,a2,g0.to,0,e3,0,m,1,0,b2,b3,b1,!1,2,!1,o,1,g0.a9,g0.x2,g0.x1,!1,d6,0,1,p)
s.$1("dither")
if(c6!=null){null.toString
A.jR(e4,c6,null)}p=f7.a
o=p.gu()
e5=A.fG(f6,f6,B.h,0,B.F,p.gC(),f6,0,3,f6,B.h,o,!1)
if(g0.c)e6=B.a7
else e6=B.z
e7=A.R(e5)
e8=e7.a
e9=e7.b
f0=e7.c
for(p=e4.length,o=e6.length,d1=0;d1<p;++d1){a2=e4[d1]
if(!(a2>=0&&a2<o))return A.a(e6,a2)
f1=e6[a2]
a2=f7.a.a
a3=a2==null
a9=a3?f6:a2.a
f2=B.b.K(d1,a9==null?0:a9)
a2=a3?f6:a2.a
f3=B.b.X(d1,a2==null?0:a2)*f0+f2*e9
B.e.q(e8,f3,f1[0])
B.e.q(e8,f3+1,f1[1])
B.e.q(e8,f3+2,f1[2])}s.$1("paint")
f4=b0?A.iB(e5,90):e5
f5=B.b.V(1000*(Date.now()-f8),1000)
s.$1("rotate")
f8=t.v(0)
p=f7.a
A.dG("[EinkCore] \u26a1 Preview complete in "+f5+"ms \xb7 stages: "+f8+p.gu()+"x"+p.gC()+" \xb7 core "+r+"\u2192"+A.ht())
return f4},
jM(a){var t=a.dK,s=a.dL,r=a.dM,q=t.length,p=s*r,o=q===p*3?3:4
if(q!==p*o)throw A.j(A.aK("preDecodedRgba: "+q+" bytes is neither "+s+"x"+r+" RGB nor RGBA",null))
q=B.e.gB(t)
p=t.byteOffset
return A.hG(q,p,r,o,o===3?B.E:B.D,s)},
jK(a,b){var t,s,r
if(b==null)return a
t=b.c
if(t<1||b.d<1)return a
s=b.a
if(s===0&&b.b===0&&t===a.gu()&&b.d===a.gC())return a
r=b.b
return A.mh(a,b.d,t,s,r)},
jJ(a,b,c){var t,s,r,q,p,o,n,m,l
if(c==null)return null
t=a*b
s=new Uint8Array(t)
r=c.a
q=B.b.i(r+c.c,0,a)
p=c.b
o=B.b.i(p+c.d,0,b)
for(n=B.b.i(p,0,b);n<o;++n){m=n*a
for(l=B.b.i(r,0,a);l<q;++l){p=m+l
if(!(p>=0&&p<t))return A.a(s,p)
s[p]=1}}return s},
kc(a){var t
switch(a.a){case 1:t=0
break
case 0:t=1
break
case 3:t=2
break
case 2:t=3
break
case 4:t=4
break
case 5:t=5
break
default:t=null}return t},
jR(a,b,c){var t,s,r,q=A.kc(c)
for(t=b.length,s=J.aJ(a),r=0;r<t;++r)if(b[r]===0)s.q(a,r,q)},
jp(a1){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c=null,b=a1.gu(),a=a1.gC(),a0=Math.max(1,B.b.V(b*a,1e4))
for(t=0,s=0,r=0,q=0;q<a;++q)for(p=0;p<b;++p,r=o){o=r+1
if(B.b.K(r,a0)!==0)continue
n=a1.a
m=n==null?c:n.S(p,q,c)
if(m==null)m=new A.A()
t+=0.299*m.gj()+0.587*m.gm()+0.114*m.gl();++s}if(s===0)return B.a2
l=t/s
for(r=0,k=0,q=0;q<a;++q)for(p=0;p<b;++p,r=o){o=r+1
if(B.b.K(r,a0)!==0)continue
n=a1.a
m=n==null?c:n.S(p,q,c)
if(m==null)m=new A.A()
j=0.299*m.gj()+0.587*m.gm()+0.114*m.gl()-l
k+=j*j}i=Math.sqrt(k/s)
h=i<40
if(h){g=1.15
f=1.4
e=1.1}else if(i>80){g=0.85
f=0.6
e=0.95}else{g=1
f=1
e=1}if(l>180){g*=1.1
d=-0.08}else if(l<70){f*=1.2
d=0.12}else d=0
return new A.d0(h,g,e,f,d)},
jA(a,b,a0,a1){var t,s,r,q,p,o,n,m,l,k,j,i,h,g=a.gu(),f=g*a.gC(),e=new A.dP(a,g),d=b==null?-1:A.hx(f,new A.dN(b),e),c=a0==null?-1:A.hx(f,new A.dO(a0),e)
if(d<0&&c<0)return
A.dG("[EinkCore] depixel "+B.b.R(a1*100)+"%: skin median "+d+", hair median "+c)
for(t=a1*15,s=d>=0,r=0;r<f;++r){q=B.b.K(r,g)
p=B.b.X(r,g)
o=a.a
n=o==null?null:o.S(q,p,null)
if(n==null)n=new A.A()
m=n.gj()
l=n.gm()
k=n.gl()
o=!1
if(s){if(!(r<b.length))return A.a(b,r)
j=b[r]
if(j!==1){i=j===2
if(i||j===4)if(A.cV(m,l,k))o=!(i&&0.299*m+0.587*l+0.114*k<110)}else o=!0}if((o?d:-1)<0)continue
if(t===0)continue
o=B.b.i(B.a.R(m+t),0,255)
j=B.b.i(B.a.R(l+t),0,255)
i=B.b.i(B.a.R(k+t),0,255)
h=a.a
if(h!=null)h.a5(q,p,o,j,i)}},
ho(b6,b7,b8,b9){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4=b8==null,b5=b4?0:B.a.i(b9*0.5,0,1)
if(b7<0.01&&b5<=0)return b6
t=b6.gu()
s=b6.gC()
r=B.a.i(b7*0.5,0,1)
q=t*s
p=new Uint8Array(q)
o=new Uint8Array(q)
n=new Uint8Array(q)
m=new Float32Array(q)
A.fA(b6,p,o,n)
for(l=0;l<q;++l){k=p[l]
j=o[l]
i=n[l]
if(!(l<q))return A.a(m,l)
m[l]=0.299*k+0.587*j+0.114*i}h=A.aP(A.R(b6)!=null?b6:b6.aT(B.h,3),!1,!1)
g=A.R(h)
f=g.a
e=g.b
d=g.c
for(k=s-1,j=t-1,b4=!b4,c=1;c<k;++c){b=c*t
for(i=c*d,a=1;a<j;++a){a0=b+a
if(!(a0>=0&&a0<q))return A.a(m,a0)
a1=m[a0]
for(a2=a1,a3=1,a4=-1;a4<=1;++a4)for(a5=(c+a4)*t+a,a6=a4===0,a7=-1;a7<=1;++a7){if(a7===0&&a6)continue
a8=a5+a7
if(!(a8>=0&&a8<q))return A.a(m,a8)
a9=m[a8]
if(Math.abs(a9-a1)<30){a2+=a9;++a3}}if(b4){if(!(a0<b8.length))return A.a(b8,a0)
a5=b8[a0]!==0}else a5=!1
b0=a5?Math.max(r,b5):r
b1=a1>0?(a1+(a2/a3-a1)*b0)/a1:1
b2=i+a*e
a5=B.a.h(B.a.i(p[a0]*b1,0,255))
f.$flags&2&&A.b(f)
a6=f.length
if(!(b2>=0&&b2<a6))return A.a(f,b2)
f[b2]=a5
a5=b2+1
b3=B.a.h(B.a.i(o[a0]*b1,0,255))
f.$flags&2&&A.b(f)
if(!(a5<a6))return A.a(f,a5)
f[a5]=b3
b3=b2+2
a5=B.a.h(B.a.i(n[a0]*b1,0,255))
f.$flags&2&&A.b(f)
if(!(b3<a6))return A.a(f,b3)
f[b3]=a5}}return h},
fx(a,b){var t=a/255-0.5
return Math.max(0,Math.min(255,(0.5+t*(1+(b-1)*(1-Math.min(0.8,Math.abs(t)*1.5))))*255))},
jC(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8){var t=j>0||a4!==1||a5!==0?A.hu(a2,a1,a.gu(),a.gC()):null,s=b0>0&&a2!=null?b0*A.km(a2,a.gu()*a.gC(),new A.dW(a)):0,r=a9!==0?A.k6(l,a.gu(),a.gC()):null
return new A.f0(t,s,r,a8>0&&a2!=null?A.kn(a2,a.gu()*a.gC(),new A.dX(a),new A.dY(a),new A.dZ(a)):null)},
jB(m5,m6,m7,m8,m9,n0,n1,n2,n3,n4,n5,n6,n7,n8,n9,o0,o1,o2,o3,o4,o5,o6,o7,o8,o9,p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,q0,q1,q2,q3,q4,q5){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5,c6,c7,c8,c9,d0,d1,d2,d3,d4,d5,d6,d7,d8,d9,e0,e1,e2,e3,e4,e5,e6,e7,e8,e9,f0,f1,f2,f3,f4,f5,f6,f7,f8,f9,g0,g1,g2,g3,g4,g5,g6,g7,g8,g9,h0,h1,h2,h3,h4,h5,h6,h7,h8,h9,i0,i1,i2,i3,i4,i5,i6,i7,i8,i9,j0,j1,j2,j3,j4,j5,j6,j7,j8,j9,k0,k1,k2,k3,k4,k5,k6,k7,k8,k9,l0,l1,l2,l3,l4=null,l5=(n1-1)*128,l6=q0===0,l7=q3!==0,l8=m9!==0,l9=m8.a,m0=q4!==0,m1=Math.abs(n2)>0.01,m2=Math.abs(p2)>0.01,m3=Math.abs(o1)>0.01,m4=o6>0.01
if(n3!=null){t=!0
if(!B.c.bM(n3,new A.dQ())){n5.toString
if(!B.c.bM(n5,new A.dR())){n4.toString
s=B.c.bM(n4,new A.dS())}else s=t
t=s}}else t=!1
r=m8.b
q=m8.c
p=m8.d
o=A.R(m5)
n=o.a
m=o.b
l=o.c
k=new Float64Array(3)
for(s=o5>0,j=p9>0,i=n0>0,h=q1>0,g=o4!=null,f=p7>0,e=p!=null,d=p5!==0,c=r>0,b=!m2,a=p0!==1,a0=n8!==1,a1=n7>0,a2=n.length,a3=l9!=null,a4=o8==null,a5=o7!=null,a6=o9*p0,a7=p1!==0,a8=q3>0,a9=q3*60,b0=!a4,b1=q!=null,b2=p8!=null,b3=0.4*o5,b4=b3*1.4,b5=0.5*q1,b6=n.$flags|0,b7=a9*0.8,b8=m6;b8<m7;++b8){b9=b8*l
c0=b8+q5
c1=(c0+0.5)/16-0.5
c2=0
for(;;){c3=m5.a
c4=c3==null
c5=c4?l4:c3.a
if(!(c2<(c5==null?0:c5)))break
if(!(b9>=0&&b9<a2))return A.a(n,b9)
c6=n[b9]
c5=b9+1
if(!(c5<a2))return A.a(n,c5)
c7=n[c5]
c8=b9+2
if(!(c8<a2))return A.a(n,c8)
c9=n[c8]
if(a1){if(a3){d0=c4?l4:c3.a
d0=b8*(d0==null?0:d0)+c2
if(!(d0>=0&&d0<l9.length))return A.a(l9,d0)
d0=l9[d0]!==0}else d0=!1
d0=!d0}else d0=!1
if(d0){d1=m8.e
if(d1==null){d0=c4?l4:c3.a
if(d0==null)d0=0
c3=c4?l4:c3.b
if(c3==null)c3=0
d1=m8.e=A.k_(d0,c3,new A.dT(m5),new A.dU(m5),new A.dV(m5))}c3=d1.a
c4=d1.b
d2=(c2+0.5)/16-0.5
d0=c4-1
d3=B.b.i(B.a.aF(d2),0,d0)
d4=d1.c-1
m6=B.b.i(B.a.aF(c1),0,d4)
d5=B.b.i(d3+1,0,d0)
d6=B.b.i(m6+1,0,d4)
d7=B.a.i(d2-d3,0,1)
d8=B.a.i(c1-m6,0,1)
d4=m6*c4
d0=d4+d3
d9=c3.length
if(!(d0>=0&&d0<d9))return A.a(c3,d0)
d0=c3[d0]
e0=1-d7
d4+=d5
if(!(d4>=0&&d4<d9))return A.a(c3,d4)
d4=c3[d4]
c4=d6*c4
e1=c4+d3
if(!(e1>=0&&e1<d9))return A.a(c3,e1)
e1=c3[e1]
c4+=d5
if(!(c4>=0&&c4<d9))return A.a(c3,c4)
e2=A.jy(c6,c7,c9,n7*((d0*e0+d4*d7)*(1-d8)+(e1*e0+c3[c4]*d7)*d8))
e3=e2.a
e4=e2.b
e5=e2.c
c9=e5
c7=e4
c6=e3}if(a0){c6=B.a.i(c6*n8,0,255)
c7=B.a.i(c7*n8,0,255)
c9=B.a.i(c9*n8,0,255)}if(t){n5.toString
n4.toString
e6=A.jw(c6,c7,c9,n3,n5,n4)
e7=e6.a
e8=e6.b
e9=e6.c
c9=e9
c7=e8
c6=e7}f0=Math.max(c6,Math.max(c7,c9))
f1=Math.min(c6,Math.min(c7,c9))
f2=(c6+c7+c9)/3
if(a)c3=!a4||a5
else c3=!1
if(c3){c3=m5.a
c3=c3==null?l4:c3.a
f3=b8*(c3==null?0:c3)+c2
if(a3){if(!(f3>=0&&f3<l9.length))return A.a(l9,f3)
f4=l9[f3]!==0}else f4=!1
f5=!f4?a6:o9}else f5=o9
if(f0!==f1&&f5!==1){f6=(f0-f1)/255
c3=f0/255
c4=f1/255
f7=(f0+f1)/2/255>0.5?f6/(2-c3-c4):f6/(c3+c4)
f8=Math.min(1,f7*f5)
f9=f7>0.001?f8/f7:1
c6=Math.max(0,Math.min(255,f2+(c6-f2)*f9))
c7=Math.max(0,Math.min(255,f2+(c7-f2)*f9))
c9=Math.max(0,Math.min(255,f2+(c9-f2)*f9))}if(!l6||a7){g0=Math.max(c6,Math.max(c7,c9))
g1=Math.min(c6,Math.min(c7,c9))
g2=g0>0?(g0-g1)/g0:0
g3=c6>c7&&c7>c9&&c6-c7<80&&c6>60&&c7>40&&c9>20&&c6/(c7+1)<1.8&&c7/(c9+1)<2
g4=!a4||a5
f4=!1
if(g4)if(a3){c3=m5.a
c3=c3==null?l4:c3.a
c3=b8*(c3==null?0:c3)+c2
if(!(c3>=0&&c3<l9.length))return A.a(l9,c3)
c3=l9[c3]!==0
f4=c3}g5=g4&&!f4&&a7
g6=(q0+(g5?p1:0))*(1-g2)
if(g3&&!g5)g6*=0.4
g7=0.299*c6+0.587*c7+0.114*c9
c6=Math.max(0,Math.min(255,c6+(c6-g7)*g6))
c7=Math.max(0,Math.min(255,c7+(c7-g7)*g6))
c9=Math.max(0,Math.min(255,c9+(c9-g7)*g6))}c3=A.fx(c6,n6)
c4=A.fx(c7,n6)
d0=A.fx(c9,n6)
c6=B.a.i(c3+l5,0,255)
c7=B.a.i(c4+l5,0,255)
c9=B.a.i(d0+l5,0,255)
if(l7){c6=B.a.i(c6+a9,0,255)
c7=B.a.i(c7+a9*(a8?0.3:0.1),0,255)
c9=B.a.i(c9-b7,0,255)}if(l8){if(b0){c3=m5.a
c4=c3==null
d0=c4?l4:c3.a
d0=b8*(d0==null?0:d0)+c2
d4=o8.length
if(!(d0>=0&&d0<d4))return A.a(o8,d0)
d0=o8[d0]
if(!(d0===2||d0===4||d0===5)){c3=c4?l4:c3.a
c3=b8*(c3==null?0:c3)+c2
if(!(c3>=0&&c3<d4))return A.a(o8,c3)
c3=o8[c3]===1}else c3=!0}else c3=!1
c3=!c3}else c3=!1
if(c3){g8=0.299*c6+0.587*c7+0.114*c9
if(g8<96){g9=(96-g8)/96
h0=m9*g9*g9*96
c6=B.a.i(c6-h0,0,255)
c7=B.a.i(c7-h0,0,255)
c9=B.a.i(c9-h0,0,255)}}if(m0){g8=0.299*c6+0.587*c7+0.114*c9
if(g8>160){g9=(g8-160)/95
h0=q4*g9*g9*95
c6=B.a.i(c6+h0,0,255)
c7=B.a.i(c7+h0,0,255)
c9=B.a.i(c9+h0,0,255)}}if(m1){c3=(0.299*c6+0.587*c7+0.114*c9)/255
h1=1-c3
h0=h1*h1*n2*0.5*255-c3*n2*0.2*255
c6=B.a.i(c6+h0,0,255)
c7=B.a.i(c7+h0,0,255)
c9=B.a.i(c9+h0,0,255)}if(!b||m3){g8=0.299*c6+0.587*c7+0.114*c9
if(m2&&g8<128){g9=1-g8/128
h0=g9*g9*p2*128
c6=B.a.i(c6+h0,0,255)
c7=B.a.i(c7+h0,0,255)
c9=B.a.i(c9+h0,0,255)}if(m3&&g8>128){g9=(g8-128)/127
h0=g9*g9*o1*128
c6=B.a.i(c6+h0,0,255)
c7=B.a.i(c7+h0,0,255)
c9=B.a.i(c9+h0,0,255)}}c3=!1
if(c){o8.toString
c4=m5.a
c4=c4==null?l4:c4.a
c4=b8*(c4==null?0:c4)+c2
if(!(c4>=0&&c4<o8.length))return A.a(o8,c4)
c4=o8[c4]
if(c4!==1){d0=c4===2
if(d0||c4===4)if(A.cV(c6,c7,c9))c3=!(d0&&0.299*c6+0.587*c7+0.114*c9<110)}else c3=!0}if(c3){g8=0.299*c6+0.587*c7+0.114*c9
if(g8<128){g9=1-g8/128
h0=g9*g9*r*128
c6=B.a.i(c6+h0,0,255)
c7=B.a.i(c7+h0,0,255)
c9=B.a.i(c9+h0,0,255)}}c3=!1
if(d)if(b0){c4=m5.a
d0=c4==null
d4=d0?l4:c4.a
d4=b8*(d4==null?0:d4)+c2
if(!(d4>=0&&d4<o8.length))return A.a(o8,d4)
d4=o8[d4]
if(d4!==1){d9=d4===2
e0=!1
if(d9||d4===4)if(A.cV(c6,c7,c9))d4=!(d9&&0.299*c6+0.587*c7+0.114*c9<110)
else d4=e0
else d4=e0}else d4=!0
if(d4)if(b1){c3=d0?l4:c4.a
c3=b8*(c3==null?0:c3)+c2
if(!(c3>=0&&c3<q.length))return A.a(q,c3)
c3=q[c3]!==0}else c3=!0}if(c3){h0=A.kl(0.299*c6+0.587*c7+0.114*c9,p5)
c6=B.a.i(c6+h0,0,255)
c7=B.a.i(c7+h0,0,255)
c9=B.a.i(c9+h0,0,255)}if(e){o8.toString
c3=m5.a
c3=c3==null?l4:c3.a
c3=b8*(c3==null?0:c3)+c2
if(!(c3>=0&&c3<o8.length))return A.a(o8,c3)
c3=o8[c3]===1}else c3=!1
if(c3){h2=A.kj(c6,c7,c9,p,p4)
h3=h2.a
c7=l4
c9=l4
h4=h2.b
h5=h2.c
h6=h5
h7=h4
c9=h6
c7=h7
c6=h3}if(f&&b2){c3=m5.a
c3=c3==null?l4:c3.a
g9=A.kp(c2,c0,p8,c3==null?0:c3,o0,p7)
if(g9<1){c6*=g9
c7*=g9
c9*=g9}}if(g){c3=m5.a
c3=c3==null?l4:c3.a
h8=b8*(c3==null?0:c3)+c2
c3=B.b.i(B.a.R(c6),0,255)
o4.$flags&2&&A.b(o4)
if(!(h8>=0&&h8<o4.length))return A.a(o4,h8)
o4[h8]=c3
o3.toString
c3=B.b.i(B.a.R(c7),0,255)
o3.$flags&2&&A.b(o3)
if(!(h8<o3.length))return A.a(o3,h8)
o3[h8]=c3
o2.toString
c3=B.b.i(B.a.R(c9),0,255)
o2.$flags&2&&A.b(o2)
if(!(h8<o2.length))return A.a(o2,h8)
o2[h8]=c3}h9=h?A.kt(c6,c7,c9):0
c3=h9>0
i0=c3?A.ks(c6,c7,c9):1
if(i)if(b0){c4=m5.a
c4=c4==null?l4:c4.a
c4=b8*(c4==null?0:c4)+c2
if(!(c4>=0&&c4<o8.length))return A.a(o8,c4)
c4=o8[c4]!==2}else c4=!0
else c4=!1
if(c4){i1=A.jW(c6,c7,c9,n0)
if(i1<1){c6*=i1
c7*=i1
c9*=i1}}if(j)if(b0){c4=m5.a
c4=c4==null?l4:c4.a
c4=b8*(c4==null?0:c4)+c2
if(!(c4>=0&&c4<o8.length))return A.a(o8,c4)
c4=o8[c4]!==2}else c4=!0
else c4=!1
if(c4){c4=n[b9]
d0=n[c5]
i2=A.kq(c6,c7,c9,p9,n[c8],d0,c4)
i3=i2.a
i4=l4
i5=i2.b
i4=i5
if(typeof i3!=="number")return i3.cv()
if(i3<1){c6*=i3
if(typeof i4!=="number")return A.bS(i4)
c7*=i4
c9*=i4}}c4=!1
if(s){d0=!0
if(b0){d4=m5.a
d9=d4==null
e0=d9?l4:d4.a
e0=b8*(e0==null?0:e0)+c2
e1=o8.length
if(!(e0>=0&&e0<e1))return A.a(o8,e0)
if(o8[e0]!==0){d0=d9?l4:d4.a
d0=b8*(d0==null?0:d0)+c2
if(!(d0>=0&&d0<e1))return A.a(o8,d0)
d0=o8[d0]===3}}if(d0)if(a5){c4=m5.a
c4=c4==null?l4:c4.a
c4=b8*(c4==null?0:c4)+c2
if(!(c4>=0&&c4<o7.length))return A.a(o7,c4)
c4=o7[c4]===0}else c4=!0}if(c4){if(b0){c4=m5.a
c4=c4==null?l4:c4.a
c4=b8*(c4==null?0:c4)+c2
if(!(c4>=0&&c4<o8.length))return A.a(o8,c4)
i6=o8[c4]===3}else i6=!1
i1=B.a.i(1-b3*A.hw(c6,c7,c9,!1),0.1,1)
i4=i6?Math.min(i1,B.a.i(1-b4*A.hw(c6,c7,c9,!0),0.1,1)):i1
if(i4<1){c6*=i1
c7*=i4
c9*=i4}}if(m4){i7=Math.max(c6,Math.max(c7,c9))
i8=Math.min(c6,Math.min(c7,c9))
i9=i7-i8
if(i9>=20){c4=i7+i8
j0=c4/2
if(j0<40)j1=j0/40
else j1=j0>215?(255-j0)/40:1
if(j1>=0.05){if(i7===c6)j2=60*B.a.K((c7-c9)/i9,6)
else j2=i7===c7?60*((c9-c6)/i9+2):60*((c6-c7)/i9+4)
if(j2<0)j2+=360
j3=i9/(i7<=0?1:i7)
if(q2)j4=j2>=5&&j2<42?B.a.i((j3-0.32)/0.15999999999999998,0,1):0
else j4=j2>=15&&j2<47?B.a.i((j3-0.55)/0.1499999999999999,0,1)*(1-B.a.i((j2-42)/5,0,1)):0
d0=A.ko(j2)
d4=Math.max(j4,A.jY(j2,i9))
for(d9=j2>=5,e0=j2>=70,e1=j2<=100,j5=j2,j6=360,j7=0;j7<4;++j7){j8=B.b1[j7]
if(j8===60){if(d9)j9=j2<=(q2?42:55)
else j9=!1
if(!j9)j9=e0&&e1
else j9=!0}else j9=!1
if(j9)continue
k0=Math.abs(j2-j8)
if(k0>180)k0=360-k0
if(k0<j6){j5=j8
j6=k0}}if(d9)k1=j2<=(q2?42:55)
else k1=!1
k2=(k1?0:j5)-j2
if(k2>180)k2-=360
if(k2<-180)k2+=360
d9=k1?B.a.i((55-j2)/13,0,1):1
k3=B.a.K(j2+k2*(d0*o6*j1*(1-d4))*d9,360)
k4=j0>127.5?i9/(510-i7-i8):i9/c4
k5=(1-Math.abs(2*j0/255-1))*k4*255
k6=k3/60
k7=k5*(1-Math.abs(B.a.K(k6,2)-1))
k8=0
if(k6<1){k9=k7
l0=k5}else if(k6<2){k9=k5
l0=k7}else{l0=0
if(k6<3){k8=k7
k9=k5}else if(k6<4){k8=k5
k9=k7}else{if(k6<5){k8=k5
l0=k7}else{k8=k7
l0=k5}k9=0}}l1=j0-k5/2
c6=B.a.i(l0+l1,0,255)
c7=B.a.i(k9+l1,0,255)
c9=B.a.i(k8+l1,0,255)}}}if(q2){l2=A.jH(c6,c7,c9)
l3=A.jz(l2.a,l2.b,l2.c)
e3=l3.a
e4=l3.b
e5=l3.c
c9=e5
c7=e4
c6=e3}A.jD(c6,c7,c9,k)
c6=k[0]
c7=k[1]
c9=k[2]
c4=B.a.h(c3&&c9>c6?B.a.i(c6+(c9-c6)*B.a.i(b5*h9*i0,0,1),0,255):c6)
b6&2&&A.b(n)
n[b9]=c4
n[c5]=B.a.h(c7)
n[c8]=B.a.h(c9);++c2
b9+=m}}},
ht(){var t,s,r,q
try{r=A.kx("/proc/thread-self/stat")
t=r.dl(r.e0(),B.av)
s=A.q(J.jc(t,J.jb(t,")")+2).split(" "),u.s)
r=A.my(J.he(s,36))
return r}catch(q){return-1}},
R(a){var t,s,r=a.a
if(r instanceof A.ao&&r.c>=3){t=r.d
s=r.c
return new A.cD(t,s,r.a*s)}return null},
fA(a,b,a0,a1){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e=a.gu(),d=a.gC(),c=a.a
if(c instanceof A.ao&&c.c>=3){t=c.d
s=c.c
r=c.a*s
for(q=t.length,p=b.$flags|0,o=a0.$flags|0,n=a1.$flags|0,m=0;m<d;++m){l=m*r
k=m*e
for(j=0;j<e;++j){if(!(l>=0&&l<q))return A.a(t,l)
i=t[l]
p&2&&A.b(b)
if(!(k>=0&&k<b.length))return A.a(b,k)
b[k]=i
i=l+1
if(!(i<q))return A.a(t,i)
i=t[i]
o&2&&A.b(a0)
if(!(k<a0.length))return A.a(a0,k)
a0[k]=i
i=l+2
if(!(i<q))return A.a(t,i)
i=t[i]
n&2&&A.b(a1)
if(!(k<a1.length))return A.a(a1,k)
a1[k]=i
l+=s;++k}}return}for(m=0;m<d;++m){h=m*e
for(j=0;j<e;++j){q=a.a
g=q==null?null:q.S(j,m,null)
if(g==null)g=new A.A()
f=h+j
q=B.a.h(g.gj())
b.$flags&2&&A.b(b)
if(!(f>=0&&f<b.length))return A.a(b,f)
b[f]=q
q=B.a.h(g.gm())
a0.$flags&2&&A.b(a0)
if(!(f<a0.length))return A.a(a0,f)
a0[f]=q
q=B.a.h(g.gl())
a1.$flags&2&&A.b(a1)
if(!(f<a1.length))return A.a(a1,f)
a1[f]=q}}},
jq(a1,a2,a3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0
if(Math.abs(a2)<0.01)return a1
t=a1.gu()
s=a1.gC()
r=t*s
q=new Uint8Array(r)
p=new Uint8Array(r)
o=new Uint8Array(r)
A.fA(a1,q,p,o)
A.jv(q,p,o,t,s,a2,a3)
n=A.aP(a1,!1,!1)
m=n.a
if(m instanceof A.ao&&m.c>=3){l=m.d
k=m.c
j=m.a*k
for(i=l.$flags|0,h=0;h<s;++h){g=h*j
f=h*t
for(e=0;e<t;++e){if(!(f>=0&&f<r))return A.a(q,f)
d=q[f]
i&2&&A.b(l)
c=l.length
if(!(g>=0&&g<c))return A.a(l,g)
l[g]=d
d=g+1
b=p[f]
if(!(d<c))return A.a(l,d)
l[d]=b
b=g+2
d=o[f]
if(!(b<c))return A.a(l,b)
l[b]=d
g+=k;++f}}return n}for(h=0;h<s;++h){a=h*t
for(e=0;e<t;++e){a0=a+e
if(!(a0>=0&&a0<r))return A.a(q,a0)
i=q[a0]
d=p[a0]
c=o[a0]
b=n.a
if(b!=null)b.a5(e,h,i,d,c)}}return n},
k2(a3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f=null,e=Math.max(1,B.b.V(a3.gu(),200)),d=Math.max(1,B.b.V(a3.gC(),200)),c=0,b=0,a=0,a0=0,a1=0,a2=0
for(;;){t=a3.a
t=t==null?f:t.b
if(!(a2<(t==null?0:t)))break
s=0
for(;;){t=a3.a
r=t==null
q=r?f:t.a
if(!(s<(q==null?0:q)))break
p=r?f:t.S(s,a2,f)
if(p==null)p=new A.A();++a1
if(0.299*p.gj()+0.587*p.gm()+0.114*p.gl()>110){c+=p.gj()
b+=p.gm()
a+=p.gl();++a0}s+=e}a2+=d}if(a0<100||a0<a1*0.02)return B.A
o=c/a0
n=b/a0
m=a/a0
if(o<1||n<1||m<1)return B.A
l=n/o
k=n/m
if(l<0.65||l>1.5||k<0.65||k>1.5)return B.A
t=l-1
r=k-1
j=l>1&&k>1
i=t*r<0||j?0.35:0.75
h=1+i*t
g=1+i*r
if(Math.abs(h-1)<0.03&&Math.abs(g-1)<0.03)return B.A
return new A.I(B.a.i(h,0.85,1.2),B.a.i(g,0.85,1.2))},
js(a,b){var t
if(B.af.k(0,b)==null)return a
a=A.R(a)!=null?a:a.aT(B.h,3)
t=A.R(a)
A.l_(t.a,a.gu(),a.gC(),t.b,t.c,b)
return a},
ju(a,b,c,d){var t,s,r,q,p,o,n,m,l,k
a=A.R(a)!=null?a:a.aT(B.h,3)
t=A.R(a)
s=t.a
r=t.b
q=t.c
p=s.length
o=0
for(;;){n=a.a
n=n==null?null:n.b
if(!(o<(n==null?0:n)))break
m=o*q
l=0
for(;;){n=a.a
n=n==null?null:n.a
if(!(l<(n==null?0:n)))break
if(!(m>=0&&m<p))return A.a(s,m)
n=B.a.h(B.a.i(s[m]*b,0,255))
s.$flags&2&&A.b(s)
s[m]=n
n=m+1
if(!(n<p))return A.a(s,n)
k=B.a.h(B.a.i(s[n]*c,0,255))
s.$flags&2&&A.b(s)
s[n]=k
k=m+2
if(!(k<p))return A.a(s,k)
n=B.a.h(B.a.i(s[k]*d,0,255))
s.$flags&2&&A.b(s)
s[k]=n;++l
m+=r}++o}return a},
jr(a3,a4,a5,a6){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0=null,a1=1/a4,a2=1/Math.min(a4,a5)
a3=A.R(a3)!=null?a3:a3.aT(B.h,3)
t=A.R(a3)
s=t.a
r=t.b
q=t.c
if(a6!=null&&a6.length!==a3.gu()*a3.gC())a6=a0
p=a6==null
o=s.length
n=0
for(;;){m=a3.a
m=m==null?a0:m.b
if(!(n<(m==null?0:m)))break
l=n*q
k=0
for(;;){m=a3.a
j=m==null
i=j?a0:m.a
if(!(k<(i==null?0:i)))break
if(!(l>=0&&l<o))return A.a(s,l)
h=s[l]
i=l+1
if(!(i<o))return A.a(s,i)
g=s[i]
f=l+2
if(!(f<o))return A.a(s,f)
e=s[f]
d=0.299*h+0.587*g+0.114*e
if(p)c=Math.pow(d/255,a1)*255
else{m=j?a0:m.a
m=n*(m==null?0:m)+k
if(!(m>=0&&m<a6.length))return A.a(a6,m)
c=A.ka(d,a1,a2,a6[m])}if(d<1){b=B.a.h(B.a.i(c,0,255))
s.$flags&2&&A.b(s)
s[l]=b
s[i]=b
s[f]=b}else{a=c/d
m=B.a.h(B.a.i(h*a,0,255))
s.$flags&2&&A.b(s)
s[l]=m
m=B.a.h(B.a.i(g*a,0,255))
s.$flags&2&&A.b(s)
s[i]=m
m=B.a.h(B.a.i(e*a,0,255))
s.$flags&2&&A.b(s)
s[f]=m}++k
l+=r}++n}return a3},
hz(a){var t
if(a>1)return a
t=a-0.05
return t>0.01?1+t:0},
jt(b4,b5){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7=(b5-1)*0.5,a8=b4.gu(),a9=b4.gC(),b0=a8*a9,b1=new Uint8Array(b0),b2=new Uint8Array(b0),b3=new Uint8Array(b0)
A.fA(b4,b1,b2,b3)
t=A.aP(A.R(b4)!=null?b4:b4.aT(B.h,3),!1,!1)
s=A.R(t)
r=s.a
q=s.b
p=s.c
for(o=a9-1,n=a8-1,m=1;m<o;++m)for(l=m*p,k=m*a8,j=1;j<n;++j){i=k+j
if(!(i>=0&&i<b0))return A.a(b1,i)
h=b1[i]
g=b2[i]
f=b3[i]
for(e=0,d=0,c=0,b=-1;b<=1;++b)for(a=(m+b)*a8,a0=b===0,a1=-1;a1<=1;++a1){if(a1===0&&a0)continue
a2=a+(j+a1)
if(!(a2>=0&&a2<b0))return A.a(b1,a2)
e+=b1[a2]
d+=b2[a2]
c+=b3[a2]}a3=B.a.h(B.a.i(h+a7*(h-e/8),0,255))
a4=B.a.h(B.a.i(g+a7*(g-d/8),0,255))
a5=B.a.h(B.a.i(f+a7*(f-c/8),0,255))
a6=l+j*q
r.$flags&2&&A.b(r)
a=r.length
if(!(a6>=0&&a6<a))return A.a(r,a6)
r[a6]=a3
a0=a6+1
if(!(a0<a))return A.a(r,a0)
r[a0]=a4
a0=a6+2
if(!(a0<a))return A.a(r,a0)
r[a0]=a5}return t},
jI(a,b){var t,s=Math.abs(a-b)
if(s>180)s=360-s
if(s>=30)return 0
t=Math.cos(s/30*3.141592653589793/2)
return t*t},
jP(a,b,c){var t,s,r,q=a/255,p=b/255,o=c/255,n=Math.max(q,Math.max(p,o)),m=Math.min(q,Math.min(p,o)),l=n+m,k=l/2
if(n===m)return new A.r(0,0,k)
t=n-m
s=k>0.5?t/(2-n-m):t/l
if(n===q){l=p<o?6:0
r=((p-o)/t+l)*60}else r=n===p?((o-q)/t+2)*60:((q-p)/t+4)*60
return new A.r(r,s,k)},
fy(a,b,c){if(c<0)++c
if(c>1)--c
if(c<0.16666666666666666)return a+(b-a)*6*c
if(c<0.5)return b
if(c<0.6666666666666666)return a+(b-a)*(0.6666666666666666-c)*6
return a},
jE(a,b,c){var t,s,r,q
if(b<=0){t=B.a.i(c*255,0,255)
return new A.r(t,t,t)}s=c<0.5?c*(1+b):c+b-c*b
r=2*c-s
q=a/360
return new A.r(A.fy(r,s,q+0.3333333333333333)*255,A.fy(r,s,q)*255,A.fy(r,s,q-0.3333333333333333)*255)},
jw(a,b,c,d,e,f){var t,s,r,q,p,o,n,m
if(Math.max(a,Math.max(b,c))===Math.min(a,Math.min(b,c)))return new A.r(a,b,c)
t=A.jP(a,b,c)
s=t.a
for(r=0,q=0,p=0,o=0;o<8;++o){if(d[o]===0&&e[o]===0&&f[o]===0)continue
n=A.jI(s,B.b8[o])
if(n<=0)continue
r+=n*d[o]
q+=n*e[o]
p+=n*f[o]}if(r===0&&q===0&&p===0)return new A.r(a,b,c)
m=A.jE(B.a.K(B.a.K(s+r*30,360)+360,360),B.a.i(t.b+q*0.5,0,1),B.a.i(t.c+p*0.25,0,1))
return new A.r(B.a.i(m.a,0,255),B.a.i(m.b,0,255),B.a.i(m.c,0,255))},
hr(a,b,c,d,e){var t
if(d!==a||d-e<8)return!1
t=60*((b-c)/(d-e))
if(t<0)t+=360
return t>295&&t<355},
jz(a,b,c){var t,s,r,q=Math.max(a,Math.max(b,c)),p=Math.min(a,Math.min(b,c)),o=q>1?(q-p)/q:0,n=0.299*a+0.587*b+0.114*c
if(n>=120&&o<0.15){t=0.7*Math.min(1,Math.min((0.15-o)/0.04,(n-120)/20))
return new A.r(B.a.i(a+(n-a)*t,0,255),B.a.i(b+(n-b)*t,0,255),B.a.i(c+(n-c)*t,0,255))}s=A.hr(a,b,c,q,p)?95:120
if(n>=s||o>=0.28)return new A.r(a,b,c)
r=s<120?10:25
t=0.85*Math.min(1,Math.min((0.28-o)/0.06,(s-n)/r))
return new A.r(B.a.i(a+(n-a)*t,0,255),B.a.i(b+(n-b)*t,0,255),B.a.i(c+(n-c)*t,0,255))},
jH(a,b,c){var t,s,r,q,p,o,n=Math.max(a,Math.max(b,c)),m=n-Math.min(a,Math.min(b,c))
if(m<15||n!==a)return new A.r(a,b,c)
t=60*((b-c)/m)
if(t<0)t+=360
if(t<=300||t>350)return new A.r(a,b,c)
s=0.299*a+0.587*b+0.114*c
r=m/Math.max(n,1)
q=B.a.i((t-300)/5,0,1)*B.a.i((350-t)/15,0,1)*B.a.i((r-0.12)/0.13,0,1)*B.a.i((0.75-r)/0.15,0,1)*B.a.i((s-50)/50,0,1)*B.a.i((220-s)/40,0,1)
if(q<=0)return new A.r(a,b,c)
p=s+(255-s)*0.5
o=0.7*q
return new A.r(a+(p-a)*o,b+(p-b)*o,c+(p-c)*o)},
jD(a,b,c,d){var t,s,r,q=a-b+c,p=b+c-a
if(q<=255&&p<=255){d.$flags&2&&A.b(d)
d[0]=a
d[1]=b
d[2]=c
return}t=0.299*a+0.587*b+0.114*c
s=t+(255-t)*0.3
r=q>255&&q-s>0.001?(q-255)/(q-s):0
if(p>255&&p-s>0.001)r=Math.max(r,(p-255)/(p-s))
if(r<=0){d.$flags&2&&A.b(d)
d[0]=a
d[1]=b
d[2]=c
return}if(r>1)r=1
d.$flags&2&&A.b(d)
d[0]=a+(s-a)*r
d[1]=b+(s-b)*r
d[2]=c+(s-c)*r},
jF(a,b,c,d){var t=new Float64Array(4)
A.hq(a,b,c,t,d)
return new A.bN([t[0],t[1],t[2],t[3]])},
hq(a4,a5,a6,a7,a8){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1=Math.max(a4,Math.max(a5,a6)),a2=Math.min(a4,Math.min(a5,a6)),a3=a1-a2
if(a8){t=0.299*a4+0.587*a5+0.114*a6
s=a1>1?a3/a1:0
r=A.hr(a4,a5,a6,a1,a2)?95:160
q=t<r&&s<0.28?8e4*Math.sqrt(1-s/0.28)*Math.sqrt(B.a.i(1-t/r,0,1)):0}else q=0
if(a3<15){a7.$flags&2&&A.b(a7)
a7[0]=0
a7[1]=0
a7[2]=0
a7[3]=q
return}p=a3/Math.max(a1,1)
if(a1===a4){o=60*((a5-a6)/a3)
if(o<0)o+=360}else o=a1===a5?60*((a6-a4)/a3+2):60*((a4-a5)/a3+4)
if(a8&&o>=5&&o<=58){n=B.a.i(1-Math.abs((o-30)/25),0,1)
m=B.a.i(1-(p-0.55)/0.1499999999999999,0,1)
l=B.a.i((p-0.32)/0.15999999999999998,0,1)
k=B.a.i((0.299*a4+0.587*a5+0.114*a6-170)/40,0,1)
j=o>=42?B.a.i((o-42)/5,0,1)*B.a.i((58-o)/11,0,1):0
i=45e3*Math.sqrt(p)*n*Math.max(m*(1-0.55*l*(1-k)),j)}else if(o>=5&&o<=55){if(p<0.55)h=1
else{g=B.a.i(1-(p-0.55)/0.1499999999999999,0,1)
h=g+(1-g)*B.a.i((o-42)/5,0,1)}i=45e3*Math.sqrt(p)*h*B.a.i(1-Math.abs((o-30)/25),0,1)}else i=0
if(o>=30&&o<=70&&p<0.35)i=Math.max(i,4e4*(1-p/0.35)*B.a.i(1-Math.abs((o-50)/20),0,1))
f=o>=300&&o<=355&&p<0.72?38e3*(1-p/0.72)*B.a.i(1-Math.abs((o-330)/25),0,1):0
if(a8&&o>300&&o<=350){e=B.a.i((0.299*a4+0.587*a5+0.114*a6-50)/50,0,1)
d=B.a.i((o-300)/5,0,1)
c=B.a.i((350-o)/15,0,1)
b=B.a.i((0.75-p)/0.15,0,1)
a=e*Math.min(d,c)*B.a.i(p/0.25,0,1)*b
a0=3e4*a
f*=1-0.7*a}else a0=0
a7.$flags&2&&A.b(a7)
a7[0]=i
a7[1]=f
a7[2]=a0
a7[3]=q},
jL(a,b,c,d){var t,s,r,q,p=Math.max(a,Math.max(b,c)),o=p-Math.min(a,Math.min(b,c))
if(o<10||p!==a)return 0
t=60*((b-c)/o)
if(t<0)t+=360
if(t<300)return 0
s=o/Math.max(p,1)
r=0.299*a+0.587*b+0.114*c
if(r<60)return 0
q=B.a.i(1-Math.abs((t-330)/30),0,1)*B.a.i(s/0.6,0,1)*0.7
return d&&t<=350?Math.max(q,0.65*B.a.i((0.75-s)/0.15,0,1)*B.a.i((r-50)/50,0,1)):q},
k9(a,b,c){var t,s,r,q,p=Math.max(a,Math.max(b,c))
if(p<1)return 0
t=(a-c)/p
if(t<=0.08)s=0
else s=t>=0.2?1:(t-0.08)/0.12
r=0.299*a+0.587*b+0.114*c
if(r<=60)q=0
else q=r>=120?1:(r-60)/60
return s*q},
kk(a,b,c){var t,s
if(a<b||b<c)return 0
t=a>1?(a-c)/a:0
if(t<=0.12||t>=0.7||a-b<10)return 0
s=a===c?0:60*(b-c)/(a-c)
if(s<2||s>40)return 0
return B.a.i(Math.min(Math.min((s-2)/4,(40-s)/8),Math.min((t-0.12)/0.05,(0.6-t)/0.1)),0,1)},
jx(a,b,c){var t=Math.max(a,Math.max(b,c)),s=Math.min(a,Math.min(b,c)),r=t>1?(t-s)/t:0,q=new A.dM(),p=q.$1((150-(0.299*a+0.587*b+0.114*c))/50)
q=q.$1((0.32-r)/0.1)
if(typeof p!=="number")return p.aP()
if(typeof q!=="number")return A.bS(q)
return p*q},
k_(a6,a7,a8,a9,b0){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a=B.b.V(a6+16-1,16),a0=B.b.V(a7+16-1,16),a1=a*a0,a2=new Float64Array(a1),a3=new Float64Array(a1),a4=new Float64Array(a1),a5=new Int32Array(a1)
for(t=0;t<a7;++t)for(s=B.b.V(t,16)*a,r=t*a6,q=0;q<a6;++q){p=s+B.b.V(q,16)
o=r+q
if(!(p>=0&&p<a1))return A.a(a2,p)
n=a2[p]
m=a8.$1(o)
if(typeof m!=="number")return A.bS(m)
if(!(p<a1))return A.a(a2,p)
a2[p]=n+m
if(!(p<a1))return A.a(a3,p)
m=a3[p]
n=a9.$1(o)
if(typeof n!=="number")return A.bS(n)
if(!(p<a1))return A.a(a3,p)
a3[p]=m+n
if(!(p<a1))return A.a(a4,p)
n=a4[p]
m=b0.$1(o)
if(typeof m!=="number")return A.bS(m)
if(!(p<a1))return A.a(a4,p)
a4[p]=n+m
if(!(p<a1))return A.a(a5,p)
m=a5[p]
if(!(p<a1))return A.a(a5,p)
a5[p]=m+1}l=new Float32Array(a1)
for(p=0;p<a1;++p){s=a5[p]
if(s>0){s=A.jx(a2[p]/s,a3[p]/s,a4[p]/s)
if(!(p<a1))return A.a(l,p)
l[p]=s}}for(k=0;k<2;++k,l=j){j=new Float32Array(a1)
for(s=l.length,i=0;i<a0;++i)for(r=i*a,h=0;h<a;++h){for(g=0,f=0,e=-1;e<=1;++e)for(d=i+e,n=d<a0,c=-1;c<=1;++c){b=h+c
if(d<0||!n||b<0||b>=a)continue
m=d*a+b
if(!(m>=0&&m<s))return A.a(l,m)
g+=l[m];++f}n=r+h
if(!(n>=0&&n<a1))return A.a(j,n)
j[n]=g/f}}return new A.r(l,a,a0)},
jy(a,b,c,d){var t,s
if(d<=0)return new A.r(a,b,c)
t=d*0.5
s=0.299*a+0.587*b+0.114*c
return new A.r(a+(s-a)*t,b+(s-b)*t,c+(s-c)*t)},
hu(a,b,c,d){var t,s,r,q,p,o,n,m
if(a==null&&b==null)return null
t=B.a.R(0.025*Math.max(c,d))
s=c*d
r=A.hp(A.jT(a,b,s),c,d,t)
q=new Uint8Array(s)
for(p=r.length,o=0;o<s;++o){if(!(o<p))return A.a(r,o)
n=r[o]===0?1:0
if(!(o<s))return A.a(q,o)
q[o]=n}m=A.hp(q,c,d,t)
for(p=m.length,o=0;o<s;++o){if(!(o<p))return A.a(m,o)
n=m[o]===0?1:0
if(!(o<s))return A.a(q,o)
q[o]=n}return q},
jT(a,b,c){var t,s,r,q,p=new Uint8Array(c)
for(t=a!=null,s=b!=null,r=0;r<c;++r){if(t){if(!(r<a.length))return A.a(a,r)
q=a[r]!==0}else q=!1
if(!q)if(s){if(!(r<b.length))return A.a(b,r)
q=b[r]!==0}else q=!1
else q=!0
q=q?1:0
if(!(r<c))return A.a(p,r)
p[r]=q}return p},
hp(a,b,c,d){var t,s,r,q,p,o,n,m,l,k=b*c,j=new Uint8Array(k),i=b+c,h=new Int32Array(b)
for(t=b-1,s=a.length,r=0;r<c;++r){q=r*b
for(p=i,o=0;o<b;++o){n=q+o
if(!(n>=0&&n<s))return A.a(a,n)
p=a[n]!==0?0:p+1
if(!(o<b))return A.a(h,o)
h[o]=p}for(o=t,p=i;o>=0;--o){n=q+o
if(!(n>=0&&n<s))return A.a(a,n)
p=a[n]!==0?0:p+1
if(p<h[o]){if(!(o<b))return A.a(h,o)
h[o]=p}if(h[o]<=d){if(!(n<k))return A.a(j,n)
j[n]=1}}}m=new Int32Array(c)
for(r=c-1,t=0;t<b;++t){for(p=i,l=0;l<c;++l){s=l*b+t
if(!(s>=0&&s<k))return A.a(j,s)
p=j[s]!==0?0:p+1
if(!(l<c))return A.a(m,l)
m[l]=p}for(l=r,p=i;l>=0;--l){s=l*b+t
if(!(s>=0&&s<k))return A.a(j,s)
p=j[s]!==0?0:p+1
if(p<m[l]){if(!(l<c))return A.a(m,l)
m[l]=p}}for(l=0;l<c;++l)if(m[l]<=d){s=l*b+t
if(!(s>=0&&s<k))return A.a(j,s)
j[s]=1}}return j},
hv(a,b,c){var t=Math.max(a,Math.max(b,c)),s=Math.min(a,Math.min(b,c)),r=new A.e9(),q=r.$1((150-(0.299*a+0.587*b+0.114*c))/70)
s=r.$1((32-(t-s))/17)
if(typeof q!=="number")return q.aP()
if(typeof s!=="number")return A.bS(s)
return q*s},
jU(a,b,c){var t,s,r=Math.max(a,Math.max(b,c)),q=r-Math.min(a,Math.min(b,c))
if(q<10)return 0
t=0.299*a+0.587*b+0.114*c
if(t<80)return 0
if(r===a){s=60*((b-c)/q)
if(s<0)s+=360}else s=r===b?60*((c-a)/q+2):60*((a-b)/q+4)
if(s<5||s>55)return 0
return B.a.i(1-Math.abs((s-30)/25),0,1)*B.a.i((t-80)/120,0,1)*0.65*(1-0.6*B.a.i((q/Math.max(r,1)-0.3)/0.2,0,1))},
jZ(a,b,c,d){var t,s,r,q,p,o,n,m,l,k,j,i=new Float32Array(d),h=new Float32Array(d),g=new Float32Array(d),f=new Float32Array(d)
for(t=a.length,s=b.length,r=c.length,q=0;q<d;++q){if(!(q<t))return A.a(a,q)
p=a[q]
if(!(q<s))return A.a(b,q)
o=b[q]
if(!(q<r))return A.a(c,q)
n=A.jF(p,o,c[q],!0).a
m=n[0]
l=n[1]
k=n[2]
j=n[3]
if(!(q<d))return A.a(i,q)
i[q]=m
if(!(q<d))return A.a(h,q)
h[q]=l
if(!(q<d))return A.a(g,q)
g[q]=k
if(!(q<d))return A.a(f,q)
f[q]=j}return new A.bN([i,h,g,f])},
fz(a,b,c){var t,s,r,q=Math.max(a,Math.max(b,c)),p=q-Math.min(a,Math.min(b,c))
if(q!==a||p<8)return!1
t=p/Math.max(q,1)
if(t<0.12||t>0.65)return!1
s=0.299*a+0.587*b+0.114*c
if(s<35||s>235)return!1
r=60*((b-c)/p)
if(r<0)r+=360
if(r>=300)return t<=0.5
return r<=50},
k0(e0,e1,e2,e3,e4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5,c6,c7,c8,c9,d0,d1,d2,d3,d4,d5={},d6=B.b.V(e3+8-1,8),d7=B.b.V(e4+8-1,8),d8=d6*d7,d9=new Uint8Array(d8)
for(t=e0.length,s=e1.length,r=e2.length,q=0;q<d7;++q)for(p=q*8,o=q*d6,n=0;n<d6;++n){m=n*8
for(l=Math.min(p+8,e4),k=m+8,j=p,i=0,h=0;j<l;j+=2){g=j*e3
for(f=Math.min(k,e3),e=m;e<f;e+=2){d=g+e
if(!(d>=0&&d<t))return A.a(e0,d)
c=e0[d]
if(!(d<s))return A.a(e1,d)
b=e1[d]
if(!(d<r))return A.a(e2,d)
if(A.fz(c,b,e2[d]))++i;++h}}if(h>0&&i/h>0.45){l=o+n
if(!(l>=0&&l<d8))return A.a(d9,l)
d9[l]=1}}a=Math.max(24,B.a.R(d8*0.005))
a0=new Int32Array(d8)
a1=new Uint8Array(d8)
o=u.t
a2=A.q([],o)
for(a3=!1,a4=0,a5=0;a5<d8;++a5){if(d9[a5]===0||a0[a5]!==0)continue;++a4
B.c.cm(a2)
B.c.E(a2,a5)
if(!(a5<d8))return A.a(a0,a5)
a0[a5]=a4
a6=A.q([a5],o)
while(l=a2.length,l!==0){if(0>=l)return A.a(a2,-1)
a7=a2.pop()
n=B.b.K(a7,d6)
q=B.b.X(a7,d6)
for(l=[new A.I(n-1,q),new A.I(n+1,q),new A.I(n,q-1),new A.I(n,q+1)],a8=0;a8<4;++a8){k=l[a8]
a9=k.a
b0=k.b
if(a9<0||a9>=d6||b0<0||b0>=d7)continue
b1=b0*d6+a9
if(!(b1>=0&&b1<d8))return A.a(d9,b1)
if(d9[b1]===1){if(!(b1<d8))return A.a(a0,b1)
k=a0[b1]===0}else k=!1
if(k){if(!(b1<d8))return A.a(a0,b1)
a0[b1]=a4
B.c.E(a2,b1)
B.c.E(a6,b1)}}}l=a6.length
if(l>=a){for(a8=0;a8<l;++a8){a7=a6[a8]
if(!(a7>=0&&a7<d8))return A.a(a1,a7)
a1[a7]=1}a3=!0}}if(!a3)return null
b2=new Uint8Array(A.t(a1))
for(o=b2.$flags|0,q=0;q<d7;q=b3)for(l=q-1,b3=q+1,k=q*d6,n=0;n<d6;++n){f=k+n
if(!(f>=0&&f<d8))return A.a(a1,f)
if(a1[f]===0)continue
for(f=[new A.I(n-1,q),new A.I(n+1,q),new A.I(n,l),new A.I(n,b3)],a8=0;a8<4;++a8){c=f[a8]
a9=c.a
b0=c.b
if(a9>=0&&a9<d6&&b0>=0&&b0<d7){c=b0*d6+a9
o&2&&A.b(b2)
if(!(c>=0&&c<b2.length))return A.a(b2,c)
b2[c]=1}}}b4=new Int32Array(d8)
d5.a=0
o=u.S
b5=A.aS(o,o)
for(a7=0;a7<d8;++a7)if(a1[a7]===1&&a0[a7]!==0){b5.e_(a0[a7],new A.e8(d5))
o=b5.k(0,a0[a7])
o.toString
if(!(a7<d8))return A.a(b4,a7)
b4[a7]=o}for(o=b2.length,a7=0;a7<d8;++a7){if(!(a7<o))return A.a(b2,a7)
if(b2[a7]===1&&b4[a7]===0){n=B.b.K(a7,d6)
q=B.b.X(a7,d6)
for(l=[new A.I(n-1,q),new A.I(n+1,q),new A.I(n,q-1),new A.I(n,q+1)],a8=0;a8<4;++a8){k=l[a8]
a9=k.a
b0=k.b
if(a9<0||a9>=d6||b0<0||b0>=d7)continue
k=b0*d6+a9
if(!(k>=0&&k<d8))return A.a(b4,k)
b6=b4[k]
if(b6!==0){b4[a7]=b6
break}}if(b4[a7]===0){if(!(a7<d8))return A.a(b4,a7)
b4[a7]=1}}}l=d5.a
if(l>254)l=d5.a=254
k=e3*e4
b7=new Uint8Array(k)
b8=new Uint8Array(k);++l
b9=new Float64Array(l)
c0=new Float64Array(l)
c1=new Float64Array(l)
c2=new Float64Array(l)
for(j=0;j<e4;++j){c3=B.b.V(j,8)*d6
g=j*e3
for(e=0;e<e3;++e){d=g+e
f=c3+B.b.V(e,8)
if(!(f>=0&&f<o))return A.a(b2,f)
if(b2[f]===0)continue
if(!(f<d8))return A.a(b4,f)
B.e.q(b8,d,Math.min(b4[f],254))
if(!(d>=0&&d<t))return A.a(e0,d)
f=e0[d]
if(!(d<s))return A.a(e1,d)
c=e1[d]
if(!(d<r))return A.a(e2,d)
if(A.fz(f,c,e2[d])){if(!(d<k))return A.a(b8,d)
c4=b8[d]
if(!(c4<l))return A.a(b9,c4)
c=b9[c4]
if(!(c4<l))return A.a(b9,c4)
b9[c4]=c+f
f=c0[c4]
c=e1[d]
if(!(c4<l))return A.a(c0,c4)
c0[c4]=f+c
c=c1[c4]
f=e2[d]
if(!(c4<l))return A.a(c1,c4)
c1[c4]=c+f
f=c2[c4]
if(!(c4<l))return A.a(c2,c4)
c2[c4]=f+1}c5=e0[d]
c6=e1[d]
b6=e2[d]
if(0.299*c5+0.587*c6+0.114*b6<90){if(!(d<k))return A.a(b7,d)
b7[d]=2}else{c7=Math.max(c5,Math.max(c6,b6))
c8=c7-Math.min(c5,Math.min(c6,b6))
c9=c7>1?c8/c7:0
d0=c8>0.5?60*((c6-b6)/c8):0
if(d0<0)d0+=360
if(c9>0.4)f=d0<20||d0>340
else f=!1
f=f?3:1
if(!(d<k))return A.a(b7,d)
b7[d]=f}}}d8=d5.a
o=d8+1
d1=new Float64Array(o)
d2=new Float64Array(o)
d3=new Float64Array(o)
for(b6=1;b6<=d8;++b6){if(!(b6<l))return A.a(c2,b6)
f=c2[b6]
if(f>0){c=b9[b6]
if(!(b6<o))return A.a(d1,b6)
d1[b6]=c/f
f=c0[b6]
c=c2[b6]
if(!(b6<o))return A.a(d2,b6)
d2[b6]=f/c
c=c1[b6]
f=c2[b6]
if(!(b6<o))return A.a(d3,b6)
d3[b6]=c/f}}for(d=0;d<k;++d){if(b7[d]===0)continue
b6=b8[d]
if(b6!==0){if(!(b6<l))return A.a(c2,b6)
d8=c2[b6]===0}else d8=!0
if(d8)continue
if(!(b6<o))return A.a(d1,b6)
d8=d1[b6]
if(!(b6<o))return A.a(d2,b6)
f=d2[b6]
if(!(b6<o))return A.a(d3,b6)
c=d3[b6]
if(!(d<t))return A.a(e0,d)
b=e0[d]
if(!(d<s))return A.a(e1,d)
d4=e1[d]
if(!(d<r))return A.a(e2,d)
if(Math.abs(0.299*b+0.587*d4+0.114*e2[d]-(0.299*d8+0.587*f+0.114*c))>50){if(!(d<k))return A.a(b7,d)
b7[d]=0}}return new A.cE([b7,b8,d1,d2,d3])},
jV(b7,b8,b9,c0,c1,c2,c3,c4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1=c3.a,b2=b1[0],b3=b1[1],b4=b1[2],b5=b1[3],b6=b1[4]
for(b1=b2.length,t=b3.length,s=b7.length,r=b8.length,q=b9.length,p=c0.length,o=c1.length,n=c2.length,m=b4.length,l=b5.length,k=b6.length,j=0;j<c4;++j){if(!(j<b1))return A.a(b2,j)
i=b2[j]
if(i===0)continue
if(!(j<p))return A.a(c0,j)
h=c0[j]
if(!(j<o))return A.a(c1,j)
g=c1[j]
if(!(j<n))return A.a(c2,j)
f=c2[j]
if(!A.fz(h,g,f)){e=Math.max(h,Math.max(g,f))
d=e-Math.min(h,Math.min(g,f))
c=e>1?d/e:0
b=d>0.5&&e===h?60*((g-f)/d):999
if(b<0)b+=360
if(!(b<=50))a=b>=300&&b<=360
else a=!0
if(!(a&&c>0.65&&c<=0.8))continue
a0=1-(c-0.65)/0.15}else a0=0
if(!(j<s))return A.a(b7,j)
a1=b7[j]
if(!(j<r))return A.a(b8,j)
a2=b8[j]
if(!(j<q))return A.a(b9,j)
a3=b9[j]
a4=0.299*a1+0.587*a2+0.114*a3
if(i===2)continue
if(!(j<t))return A.a(b3,j)
a5=b3[j]
if(a5!==0){if(!(a5>=0&&a5<m))return A.a(b4,a5)
i=b4[a5]>0}else i=!1
if(i){if(!(a5>=0&&a5<m))return A.a(b4,a5)
i=b4[a5]
if(!(a5<l))return A.a(b5,a5)
h=b5[a5]
if(!(a5<k))return A.a(b6,a5)
a6=0.299*i+0.587*h+0.114*b6[a5]
a7=1-B.a.i(Math.abs(a4-a6)/55,0,1)
a8=0.45*a7
if(a0>0)a8=0.45*(0.6+0.4*a0)*a7
i=1-a8
h=b4[a5]
g=b5[a5]
f=b6[a5]
a1=B.a.i(a4+((a1-a4)*i+(h-a6)*a8),0,255)
a2=B.a.i(a4+((a2-a4)*i+(g-a6)*a8),0,255)
a3=B.a.i(a4+((a3-a4)*i+(f-a6)*a8),0,255)
a4=0.299*a1+0.587*a2+0.114*a3}if(b2[j]===3){i=B.b.i(B.a.R(a1+(a4-a1)*0.5),0,255)
b7.$flags&2&&A.b(b7)
b7[j]=i
i=B.b.i(B.a.R(a2+(a4-a2)*0.5),0,255)
b8.$flags&2&&A.b(b8)
b8[j]=i
i=B.b.i(B.a.R(a3+(a4-a3)*0.5),0,255)
b9.$flags&2&&A.b(b9)
b9[j]=i
continue}a9=0.18*B.a.i((a4-90)/50,0,1)
b0=a4+(255-a4)*0.3
i=B.b.i(B.a.R(a1+(b0-a1)*a9),0,255)
b7.$flags&2&&A.b(b7)
b7[j]=i
i=B.b.i(B.a.R(a2+(b0-a2)*a9),0,255)
b8.$flags&2&&A.b(b8)
b8[j]=i
i=B.b.i(B.a.R(a3+(b0-a3)*a9),0,255)
b9.$flags&2&&A.b(b9)
b9[j]=i}},
km(a,b,c){var t,s,r,q,p,o,n,m,l=A.aA(256,0,!1,u.S)
for(t=a.length,s=0,r=0;r<b;++r){if(!(r<t))return A.a(a,r)
if(a[r]!==1)continue
q=B.b.i(J.hg(c.$1(r)),0,255)
if(!(q>=0&&q<256))return A.a(l,q)
B.c.q(l,q,l[q]+1);++s}if(s===0)return 0
o=0
n=0
for(;;){if(!(n<256)){p=0
break}o+=l[n]
if(o*2>=s){p=n
break}++n}m=B.a.i(1-(p-120)/35,0,1)*B.a.i((p-80)/20,0,1)
A.dG("[EinkCore] skin shadow lift gate: skin median lum "+p+" over "+s+" px \u2192 "+B.a.R(m*100)+"%")
return m},
hx(a,b,c){var t,s,r,q,p,o=A.aA(256,0,!1,u.S)
for(t=0,s=0;s<a;++s){if(!b.$1(s))continue
r=B.b.i(J.hg(c.$1(s)),0,255)
if(!(r>=0&&r<256))return A.a(o,r)
B.c.q(o,r,o[r]+1);++t}if(t===0)return-1
for(q=0,p=0;p<256;++p){q+=o[p]
if(q*2>=t)return p}return 255},
k1(a,b,c){var t,s,r,q,p=a==null
if(p&&b==null)return null
t=new Uint8Array(c)
for(p=!p,s=b!=null,r=0;r<c;++r){if(p){if(!(r<a.length))return A.a(a,r)
q=a[r]===1}else q=!1
if(!q)if(s){if(!(r<b.length))return A.a(b,r)
q=b[r]!==0}else q=!1
else q=!0
if(q){if(!(r<c))return A.a(t,r)
t[r]=1}}return t},
ks(a,b,c){var t
if(c<=a||c<=b)return 1
t=c-Math.min(a,b)
if(t<12)return 1
return 1+0.33333333333333326*B.a.i((60*((a-b)/t+4)-246)/8,0,1)},
jX(a,b,c){var t,s,r,q
if(c<=a||c<=b)return 0
t=c-Math.min(a,b)
if(c<24||t<12)return 0
s=B.a.i((t/c-0.35)/0.2,0,1)
if(s===0)return 0
r=60*((a-b)/t+4)
if(r<235)q=B.a.i((r-220)/15,0,1)
else q=r>246?B.a.i((254-r)/8,0,1):1
if(q===0)return 0
return s*q*B.a.i((100-(0.299*a+0.587*b+0.114*c))/45,0,1)},
hw(a,b,c,d){var t,s,r,q,p,o
if(a<=b||b<c)return 0
t=a-c
if(a<24||t<12)return 0
s=d?0.5:0.68
r=d?0.65:0.8
q=B.a.i((t/a-s)/(r-s),0,1)
if(q===0)return 0
p=60*((b-c)/t)
if(p<20)o=B.a.i((p-12)/8,0,1)
else o=p>46?B.a.i((54-p)/8,0,1):1
if(o===0)return 0
if(d)return q*o
return q*o*B.a.i((0.299*a+0.587*b+0.114*c-80)/40,0,1)},
jW(a,b,c,d){var t
if(d<=0)return 1
t=A.jX(a,b,c)
if(t<=0)return 1
return 1-B.a.i(0.5*d*t,0,0.9)},
kr(a,b,c){var t,s,r,q,p,o,n=Math.max(a,Math.max(b,c)),m=Math.min(a,Math.min(b,c)),l=n-m
if(n<24||l<12||a>=n)return 0
t=B.a.i((l/n-0.15)/0.2,0,1)
if(t===0)return 0
s=n===b?60*((c-a)/l+2):60*((a-b)/l+4)
if(s<150)r=0
else if(s<165){q=(s-150)/15
r=q}else{if(s<=188)q=1
else q=s<200?(200-s)/12:0
r=q}if(r===0)return 0
p=(n+m)/2
if(p<180)o=0
else o=p<200?(p-180)/20:1
return t*r*o},
kq(a,b,c,d,e,f,g){var t
if(d<=0)return B.A
t=A.kr(a,b,c)
if(t>0)t*=1-A.kf(g,f,e)
if(t<=0)return B.A
return new A.I(1-B.a.i(0.9*d*t,0,0.9),1-B.a.i(0.4*d*t,0,0.9))},
kt(a,b,c){var t,s,r,q
if(c<=a||c<=b)return 0
t=c-Math.min(a,b)
if(c<24||t<12)return 0
s=B.a.i((t/c-0.3)/0.2,0,1)
if(s===0)return 0
r=60*((a-b)/t+4)
if(r<240)q=B.a.i((r-232)/8,0,1)
else q=r>295?B.a.i((305-r)/10,0,1):1
return s*q},
kp(a,b,c,d,e,f){var t,s,r=J.aJ(c),q=r.k(c,0),p=r.k(c,2),o=r.k(c,1),n=r.k(c,3),m=0.6*Math.min(r.k(c,2),r.k(c,3))
r=Math.sqrt(d*d+e*e)
p=a-(q+p/2)
n=b-(o+n/2)
t=Math.sqrt(p*p+n*n)
if(t<=m)return 1
s=B.a.i((t-m)/(m+0.5*r-m),0,1)
return 1-f*0.25*(s*s*(3-2*s))},
kn(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k,j,i
for(t=a.length,s=0,r=0,q=0,p=0,o=0;o<b;++o){if(!(o<t))return A.a(a,o)
if(a[o]!==1)continue
n=c.$1(o)
m=d.$1(o)
l=e.$1(o)
k=Math.max(n,Math.max(m,l))
j=Math.min(n,Math.min(m,l))
if(k<20||(k-j)/k<0.2)continue
i=0.299*n+0.587*m+0.114*l
s+=(n-i)/i
r+=(m-i)/i
q+=(l-i)/i;++p}if(p<400)return null
return new A.r(s/p,r/p,q/p)},
kj(a,b,c,d,e){var t,s,r,q=Math.max(a,Math.max(b,c)),p=Math.min(a,Math.min(b,c))
if(q<20)return new A.r(a,b,c)
t=(q-p)/q
if(t>=0.2)return new A.r(a,b,c)
s=0.299*a+0.587*b+0.114*c
r=e*(1-t/0.2)
return new A.r(B.a.i(a+r*d.a*s,0,255),B.a.i(b+r*d.b*s,0,255),B.a.i(c+r*d.c*s,0,255))},
k6(a,b,c){var t,s,r,q,p,o,n,m,l,k,j,i,h,g
if(a==null||a.length===0)return null
t=new Uint8Array(b*c)
for(s=a.length,r=0;r<a.length;a.length===s||(0,A.a0)(a),++r){q=a[r]
p=J.aJ(q)
o=p.k(q,0)+p.k(q,2)/2
n=p.k(q,1)+p.k(q,3)/2
m=p.k(q,2)*1.3/2
l=p.k(q,3)*1.3/2
k=B.b.i(B.a.aF(o-m),0,b)
j=B.b.i(B.a.av(o+m),0,b)
i=B.b.i(B.a.aF(n-l),0,c)
h=B.b.i(B.a.av(n+l),0,c)
for(g=i;g<h;++g){p=g*b
B.e.bh(t,p+k,p+j,1)}}return t},
kl(a,b){if(b>0)return b*25*B.a.i((255-a)/170,0,1)
return b*25},
hs(a){return 0.299*a[0]+0.587*a[1]+0.114*a[2]},
kb(a,b){var t,s,r
if(b<=0||a<2){if(!(a<6))return A.a(B.z,a)
return B.z[a]}if(!(a<6))return A.a(B.ac,a)
t=(A.hs(B.ac[a])-A.hs(B.z[a]))*b
s=A.q([],u.h)
for(r=0;r<3;++r)s.push(B.z[a][r]+t)
return s},
jY(a,b){var t,s
if(a<5||a>55)return 0
t=Math.min(B.a.i((a-31)/4,0,1),B.a.i((42-a)/3,0,1))
s=a<39?B.a.i(1-(b-30)/25,0,1):0
return Math.max(t,s)},
ko(a){if(a>=150&&a<=210)return 0
if(a>=250&&a<300)return 0
if(a>210&&a<216)return(a-210)/6
return 1},
ke(a,b,c,d){var t
if(a<b*b)return 0
if(c<=0||d>1)return 1
t=Math.sqrt(a)
return t>=b+c?1:(t-b)/c},
jG(n5,n6,n7,n8,n9,o0,o1,o2,o3,o4,o5,o6,o7,o8,o9,p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,q0,q1,q2,q3,q4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5,c6,c7,c8,c9,d0,d1,d2,d3,d4,d5,d6,d7,d8,d9,e0,e1,e2,e3,e4,e5,e6,e7,e8,e9,f0,f1,f2,f3,f4,f5,f6,f7,f8,f9,g0,g1,g2,g3,g4,g5,g6,g7,g8,g9,h0,h1,h2,h3,h4,h5,h6,h7,h8,h9,i0,i1,i2,i3,i4,i5,i6,i7,i8,i9,j0,j1,j2,j3,j4,j5,j6,j7,j8,j9,k0,k1,k2,k3,k4,k5,k6,k7,k8,k9,l0,l1,l2,l3,l4,l5,l6,l7,l8,l9,m0,m1,m2,m3,m4,m5,m6,m7,m8,m9,n0,n1,n2,n3=null,n4=o5>0
if(n4&&o6!=null){for(t=o6.length,s=0,r=0,q=0,p=0,o=0;o<t;++o){if(o6[o]===0)continue
n=n5.a
m=n==null
l=m?n3:n.a
l=B.b.K(o,l==null?0:l)
k=m?n3:n.a
k=B.b.X(o,k==null?0:k)
j=m?n3:n.S(l,k,n3)
if(j==null)j=new A.A()
s+=j.gj()
r+=j.gm()
q+=j.gl();++p}i=p>0?o5*A.k9(s/p,r/p,q/p):0}else i=0
h=n7?2:6
g=new Float64Array(6)
f=new Float64Array(6)
e=new Float64Array(6)
d=new Float64Array(6)
c=new Float64Array(6)
b=new Float64Array(6)
a=new Float64Array(6)
a0=new Float64Array(6)
a1=new Float64Array(6)
for(o=0;o<6;++o){t=B.b6[o]
g[o]=t[0]
f[o]=t[1]
e[o]=t[2]
a2=o<2?t:A.kb(o,p7)
t=a2.length
if(0>=t)return A.a(a2,0)
d[o]=a2[0]
if(1>=t)return A.a(a2,1)
c[o]=a2[1]
if(2>=t)return A.a(a2,2)
b[o]=a2[2]
t=B.z[o]
a[o]=t[0]
a0[o]=t[1]
a1[o]=t[2]}t=o0>0
a3=t?A.hu(o4,o6,n5.gu(),n5.gC()):n3
a4=n5.gu()
a5=n5.gC()
n=a4*a5
a6=new Float64Array(n)
a7=new Float64Array(n)
a8=new Float64Array(n)
if(o3>0&&o4!=null)a9=new Uint8Array(n)
else a9=n3
m=a9==null
if(m)b0=n3
else{o4.toString
b0=A.kh(o4,a4,a5,new A.e_(n5,a4),new A.e0(n5,a4),new A.e1(n5,a4))}b1=A.R(n5)
if(b1==null){l=A.R(A.R(n5)!=null?n5:n5.aT(B.h,3))
l.toString
b1=l}b2=b1.a
b3=b1.b
b4=b1.c
for(l=o7!==1,m=!m,k=p6!==1,b5=q3!==1,b6=q2>0,b7=o4==null,b8=!b7,b9=b2.length,c0=o6!=null,c1=1-o7,c2=0;c2<a5;++c2){c3=c2*b4
for(c4=c2*a4,c5=c2*668265263,c6=0;c6<a4;++c6,c3+=b3){if(!(c3>=0&&c3<b9))return A.a(b2,c3)
c7=b2[c3]
c8=c3+1
if(!(c8<b9))return A.a(b2,c8)
c9=b2[c8]
c8=c3+2
if(!(c8<b9))return A.a(b2,c8)
d0=b2[c8]
d1=c6*374761393+c5&2147483647
d2=B.a.i(c7+((d1>>>8&65535)/32767.5-1)*3,0,255)
d3=B.a.i(c9+((d1>>>16&32767)/16383.5-1)*3,0,255)
d4=B.a.i(d0+(((d1^d1>>>10)&1023)/511.5-1)*3,0,255)
if(b8){c8=c4+c6
if(!(c8>=0&&c8<o4.length))return A.a(o4,c8)
d5=o4[c8]===2&&0.299*d2+0.587*d3+0.114*d4<110}else d5=!1
if(b6)c8=b8
else c8=!1
if(c8){d6=n3
d7=n3
if(b7)c8=n3
else{c8=c4+c6
if(!(c8>=0&&c8<o4.length))return A.a(o4,c8)
c8=o4[c8]
if(c8===1||c8===2||c8===4){d8=!(c8===2&&0.299*d2+0.587*d3+0.114*d4<110)
c8=d8}else c8=!1
c8=c8?1:0}d9=A.kg(d2,d3,d4,q2,!0,c8)
e0=d9.a
e1=d9.b
e2=d9.c
d0=e2
c9=e1
d7=d0
d6=c9
e3=e0}else{d7=d4
d6=d3
e3=d2}c8=!1
if(b5)if(b8)if(!d5){d8=c4+c6
if(!(d8>=0&&d8<o4.length))return A.a(o4,d8)
d8=o4[d8]
if(d8!==1){e4=d8===2
if(e4||d8===4)if(A.cV(e3,d6,d7))c8=!(e4&&0.299*e3+0.587*d6+0.114*d7<110)}else c8=!0}if(c8){e5=A.fC(e3,d6,d7,q3)
e6=e5.a
d6=n3
d7=n3
e7=e5.b
e8=e5.c
e9=e8
f0=e7
d7=e9
d6=f0
e3=e6}c8=!1
if(k)if(b8){c8=c4+c6
if(!(c8>=0&&c8<o4.length))return A.a(o4,c8)
c8=o4[c8]===4}if(c8){f1=A.fC(e3,d6,d7,p6)
f2=f1.a
d6=n3
d7=n3
f3=f1.b
f4=f1.c
f5=f4
f6=f3
d7=f5
d6=f6
e3=f2}if(m){c8=c4+c6
if(!(c8>=0&&c8<o4.length))return A.a(o4,c8)
c8=o4[c8]
c8=c8===2||c8===5||c8===4}else c8=!1
if(c8){c8=c4+c6
if(!(c8>=0&&c8<o4.length))return A.a(o4,c8)
f7=o4[c8]===2
f8=n3
f9=n3
if(f7){if(!(c8<b0.length))return A.a(b0,c8)
d8=b0[c8]
e4=Math.max(d2,Math.max(d3,d4))
g0=Math.min(d2,Math.min(d3,d4))
g0=Math.max(d8/255,B.a.i((70-(0.299*d2+0.587*d3+0.114*d4))/20,0,1)*B.a.i((50-(e4-g0))/20,0,1))
d8=g0}else d8=A.k5(d2,d3,d4)
g1=o3*d8
if(g1>0){d8=B.a.R(g1*255)
a9.$flags&2&&A.b(a9)
if(!(c8<a9.length))return A.a(a9,c8)
a9[c8]=d8
if(f7)c8=0.3
else{c8=o4[c8]
c8=c8===4||c8===5?0:0.3*B.a.i((30-(Math.max(d2,Math.max(d3,d4))-Math.min(d2,Math.min(d3,d4))))/5,0,1)}g2=A.k4(e3,d6,d7,g1,c8)
g3=g2.a
g4=g2.b
g5=g2.c
g6=g5
g7=g4
d4=g6
d3=g7
d2=g3}else{d4=d7
d3=d6
d2=e3}}else{d4=d7
d3=d6
d2=e3}c8=!1
if(l)if(c0){c8=c4+c6
if(!(c8>=0&&c8<o6.length))return A.a(o6,c8)
c8=o6[c8]!==0}if(c8){g8=A.fC(d2,d3,d4,1-c1*B.a.i((0.299*d2+0.587*d3+0.114*d4-60)/80,0,1))
g9=g8.a
d3=n3
d4=n3
h0=g8.b
h1=g8.c
q=h1
r=h0
d4=q
d3=r
d2=g9}h2=c4+c6
if(!(h2>=0&&h2<n))return A.a(a6,h2)
a6[h2]=d2
a7[h2]=d3
a8[h2]=d4}}h3=new Int32Array(n)
h4=new Float64Array(4)
for(l=o9.length,k=p0.length,b5=p1.length,b6=1-0.6*o1,b7=p7>0,b9=o8>0,c1=3e4*o1,c4=o1>0,c5=a3!=null,c8=n6!=null,d8=q1==null,e4=!d8,g0=n8>0,h5=a4-1,c2=0;c2<a5;++c2){h6=(c2&1)===0
h7=h6?0:h5
h8=h6?a4:-1
h9=h6?1:-1
for(i0=c2*a4,i1=c2*668265263,i2=(c2&63)*64,c6=h7;c6!==h8;c6+=h9){h2=i0+c6
if(!(h2>=0&&h2<n))return A.a(a6,h2)
i3=a6[h2]
i4=a7[h2]
i5=a8[h2]
if(g0){i6=i2+(c6&63)
if(!(i6<4096))return A.a(B.a8,i6)
i7=B.a8[i6]*n8}else i7=((c6*374761393+i1>>>10&1023)/511.5-1)*5
i8=B.a.i(i3+i7,0,255)
i9=B.a.i(i4+i7,0,255)
j0=B.a.i(i5+i7,0,255)
if(e4){if(!(h2<q1.length))return A.a(q1,h2)
j1=q1[h2]!==0}else j1=!1
A.hq(i3,i4,i5,h4,q4)
j2=h4[0]
j3=h4[1]
j4=h4[2]
j5=h4[3]
if(e4){if(!(h2<q1.length))return A.a(q1,h2)
i6=q1[h2]
j6=i6===1||i6===3}else j6=!1
if(c8){i6=n6.a[0]
if(!(h2<i6.length))return A.a(i6,h2)
i6=i6[h2]}else i6=j2
j7=j6?11e3:0
if(d8)j8=0
else{if(!(h2<q1.length))return A.a(q1,h2)
j8=q1[h2]
if(j8===1)j8=9000
else j8=j8===3?18e3:0}j9=Math.min(j3,6000)
if(b8){if(!(h2<o4.length))return A.a(o4,h2)
k0=o4[h2]===2}else k0=!1
if(k0)k1=0
else if(c8){k0=n6.a[3]
if(!(h2<k0.length))return A.a(k0,h2)
k0=Math.max(k0[h2],j5)
k1=k0}else k1=j5
k0=!1
if(n4)if(c0){if(!(h2<o6.length))return A.a(o6,h2)
k0=o6[h2]!==0}k2=k0?i:0
if(c5){if(!(h2<a3.length))return A.a(a3,h2)
k3=a3[h2]!==0}else k3=!1
k4=t&&!k3?o0*A.hv(i3,i4,i5)*2e5:0
if(m){if(!(h2<a9.length))return A.a(a9,h2)
k5=a9[h2]/255*2e5}else k5=0
k6=!1
if(c4)if(b8){if(!(h2<o4.length))return A.a(o4,h2)
k0=o4[h2]
if(k0!==1){k7=k0===2
if(k7||k0===4)if(A.cV(i3,i4,i5))k0=!(k7&&0.299*i3+0.587*i4+0.114*i5<110)
else k0=k6
else k0=k6}else k0=!0
k6=k0}k8=!1
if(c4)if(!k6){if(c0){if(!(h2<o6.length))return A.a(o6,h2)
k0=o6[h2]!==0}else k0=k8
k8=k0}k9=k6||k8
for(i6=i6+j7+0-k2*2e4,j9=j3+j8-0*j9+k2*1e5,j8=(150-(0.299*i3+0.587*i4+0.114*i5))/30,l0=0,l1=1/0,o=0;o<h;++o){l2=i8-g[o]
l3=i9-f[o]
l4=j0-e[o]
l5=2*l2*l2+4*l3*l3+3*l4*l4
j7=!1
if(b9)if(c0){if(!(h2<o6.length))return A.a(o6,h2)
j7=o6[h2]!==0}l6=j7?o8:0
j7=o===2
if(j7)l5+=i6+l6
if(o===5)l5+=l6
if(o===3)l5+=j9
k0=o===4
if(k0)l5+=j4
k7=o>=2
if(k7)l5+=k1
if(k7&&!k0)l5+=k4
if(k7)l5+=k5
if(k6&&j7)l5+=c1*B.a.i(j8,0,1)
if(l5<l1){l1=l5
l0=o}}h3[h2]=l0
if(!(l0>=0&&l0<6))return A.a(d,l0)
l7=i3-d[l0]
l8=i4-c[l0]
l9=i5-b[l0]
if(b7)i6=l0>=2
else i6=!1
if(i6){if(l7*(i3-a[l0])<0)l7=0
if(l8*(i4-a0[l0])<0)l8=0
if(l9*(i5-a1[l0])<0)l9=0}m0=0
if(!j1){i6=A.jU(i3,i4,i5)
j7=k3?0:o0*A.hv(i3,i4,i5)
j7=Math.max(i6,j7)
m0=j7}m1=k5>0?Math.max(m0,k5/2e5):m0
if(m1>0){i6=1-m1
j7=(l7+l8+l9)/3*m1
m2=l7*i6+j7
m3=l8*i6+j7
m4=l9*i6+j7}else{m4=l9
m3=l8
m2=l7}if(l0===3){m5=A.jL(i3,i4,i5,q4)
if(m5>0){i6=1-m5
j7=m2*m5
m3=m3*i6+j7
m4=m4*i6+j7}}m6=j1?1:A.ke(l1,p9,p8,l0)
m7=h6?1:-1
for(m8=0;m8<l;++m8){m9=c6+o9[m8]*m7
if(!(m8<k))return A.a(p0,m8)
n0=c2+p0[m8]
i6=!1
if(m9>=0)if(m9<a4)i6=n0<a5
if(i6){if(!(m8<b5))return A.a(p1,m8)
i6=p1[m8]
j7=k9?b6:1
n1=i6/1*m6*o2*j7
n2=n0*a4+m9
if(!(n2>=0&&n2<n))return A.a(a6,n2)
a6[n2]=B.a.i(a6[n2]+m2*n1,0,255)
a7[n2]=B.a.i(a7[n2]+m3*n1,0,255)
a8[n2]=B.a.i(a8[n2]+m4*n1,0,255)}}}}return h3},
ka(a,b,c,d){var t=a/255,s=Math.pow(t,b)*255
if(d===0)return s
return s+(Math.pow(t,c)*255-s)*(d/255)},
kd(b9,c0,c1){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8
if(c0<1||c1<1||b9.length!==c0*c1)return null
t=c0*c1
s=new Int32Array(t)
r=u.t
q=A.q([],r)
p=A.q([],r)
o=A.q([],r)
n=A.q([],r)
for(m=c1-1,l=c0-1,r=b9.length,k=null,j=0,i=0;i<t;++i){if(s[i]===0){if(!(i<r))return A.a(b9,i)
h=b9[i]
h=!(h===4||h===5)}else h=!0
if(h)continue
if(k==null)k=new Int32Array(t);++j
g=B.b.K(i,c0)
f=B.b.X(i,c0)
k.$flags&2&&A.b(k)
h=k.length
if(0>=h)return A.a(k,0)
k[0]=i
if(!(i<t))return A.a(s,i)
s[i]=j
for(e=f,d=g,c=1;c>0;){--c
if(!(c<h))return A.a(k,c)
b=k[c]
a=B.b.K(b,c0)
a0=B.b.X(b,c0)
if(a<g)g=a
if(a>d)d=a
if(a0<f)f=a0
if(a0>e)e=a0
a1=!1
if(a>0){a2=b-1
if(!(a2>=0&&a2<t))return A.a(s,a2)
if(s[a2]===0){if(!(a2<r))return A.a(b9,a2)
a1=b9[a2]
a1=a1===4||a1===5}}if(a1){a1=b-1
if(!(a1>=0&&a1<t))return A.a(s,a1)
s[a1]=j
a3=c+1
k[c]=a1
c=a3}a1=!1
if(a<l){a2=b+1
if(!(a2>=0&&a2<t))return A.a(s,a2)
if(s[a2]===0){if(!(a2<r))return A.a(b9,a2)
a1=b9[a2]
a1=a1===4||a1===5}}if(a1){a1=b+1
if(!(a1>=0&&a1<t))return A.a(s,a1)
s[a1]=j
a3=c+1
if(!(c<h))return A.a(k,c)
k[c]=a1
c=a3}a1=!1
if(a0>0){a2=b-c0
if(!(a2>=0&&a2<t))return A.a(s,a2)
if(s[a2]===0){if(!(a2<r))return A.a(b9,a2)
a1=b9[a2]
a1=a1===4||a1===5}}if(a1){a1=b-c0
if(!(a1>=0&&a1<t))return A.a(s,a1)
s[a1]=j
a3=c+1
if(!(c<h))return A.a(k,c)
k[c]=a1
c=a3}a1=!1
if(a0<m){a2=b+c0
if(!(a2>=0&&a2<t))return A.a(s,a2)
if(s[a2]===0){if(!(a2<r))return A.a(b9,a2)
a1=b9[a2]
a1=a1===4||a1===5}}if(a1){a1=b+c0
if(!(a1>=0&&a1<t))return A.a(s,a1)
s[a1]=j
a3=c+1
if(!(c<h))return A.a(k,c)
k[c]=a1
c=a3}}B.c.E(q,g)
B.c.E(p,d)
B.c.E(o,f)
B.c.E(n,e)}if(j===0)return null
a4=new Int32Array(t)
for(a5=0;a5<t;++a5)if(s[a5]===0){if(!(a5<t))return A.a(a4,a5)
a4[a5]=536870912}for(f=0;f<c1;++f)for(r=f>0,h=f*c0,g=0;g<c0;++g){a5=h+g
if(!(a5>=0&&a5<t))return A.a(a4,a5)
a6=a4[a5]
a7=s[a5]
a1=g>0
if(a1){a2=a5-1
if(!(a2>=0))return A.a(a4,a2)
a2=a4[a2]+3<a6}else a2=!1
if(a2){a2=a5-1
if(!(a2>=0))return A.a(a4,a2)
a6=a4[a2]+3
a7=s[a2]}if(r){a2=a5-c0
if(!(a2>=0))return A.a(a4,a2)
a8=a4[a2]+3
if(a8<a6){a7=s[a2]
a6=a8}if(a1){a1=a2-1
if(!(a1>=0))return A.a(a4,a1)
a1=a4[a1]+4<a6}else a1=!1
if(a1){a1=a2-1
if(!(a1>=0))return A.a(a4,a1)
a6=a4[a1]+4
a7=s[a1]}if(g<l&&a4[a2+1]+4<a6){a1=a2+1
a6=a4[a1]+4
a7=s[a1]}}if(!(a5<t))return A.a(a4,a5)
a4[a5]=a6
if(!(a5<t))return A.a(s,a5)
s[a5]=a7}for(f=m;f>=0;--f)for(r=f<m,h=f*c0,g=l;g>=0;--g){a5=h+g
if(!(a5>=0&&a5<t))return A.a(a4,a5)
a6=a4[a5]
a7=s[a5]
a1=g<l
if(a1){a2=a5+1
if(!(a2<t))return A.a(a4,a2)
a2=a4[a2]+3<a6}else a2=!1
if(a2){a2=a5+1
if(!(a2<t))return A.a(a4,a2)
a6=a4[a2]+3
a7=s[a2]}if(r){a2=a5+c0
if(!(a2>=0&&a2<t))return A.a(a4,a2)
a8=a4[a2]+3
if(a8<a6){a7=s[a2]
a6=a8}if(a1){a1=a2+1
if(!(a1<t))return A.a(a4,a1)
a1=a4[a1]+4<a6}else a1=!1
if(a1){a1=a2+1
if(!(a1<t))return A.a(a4,a1)
a6=a4[a1]+4
a7=s[a1]}if(g>0){a1=a2-1
if(!(a1>=0))return A.a(a4,a1)
a1=a4[a1]+4<a6}else a1=!1
if(a1){a1=a2-1
if(!(a1>=0))return A.a(a4,a1)
a6=a4[a1]+4
a7=s[a1]}}if(!(a5<t))return A.a(a4,a5)
a4[a5]=a6
if(!(a5<t))return A.a(s,a5)
s[a5]=a7}a9=new Float64Array(j)
b0=new Float64Array(j)
for(r=p.length,h=q.length,a1=n.length,a2=o.length,b1=0;b1<j;++b1){if(!(b1<r))return A.a(p,b1)
b2=p[b1]
if(!(b1<h))return A.a(q,b1)
b3=q[b1]
if(!(b1<a1))return A.a(n,b1)
b4=n[b1]
if(!(b1<a2))return A.a(o,b1)
b5=Math.max(b2-b3+1,b4-o[b1]+1)/2
if(!(b1<j))return A.a(a9,b1)
a9[b1]=0.4*b5*3
if(!(b1<j))return A.a(b0,b1)
b0[b1]=0.8*b5*3}b6=new Uint8Array(t)
for(a5=0;a5<t;++a5){a7=s[a5]
if(a7===0)continue
a6=a4[a5]
r=a7-1
if(!(r>=0&&r<j))return A.a(a9,r)
b7=a9[r]
if(!(r<j))return A.a(b0,r)
b8=b0[r]
if(a6<=b7){if(!(a5<t))return A.a(b6,a5)
b6[a5]=255}else if(a6<b8){r=B.a.R(255*(b8-a6)/(b8-b7))
if(!(a5<t))return A.a(b6,a5)
b6[a5]=r}}return b6},
fB(a,b,c){var t
if(!c)return a*b
t=a/32
return a*b*Math.exp(-t*t)},
jv(b7,b8,b9,c0,c1,c2,c3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6=c3!=null&&c3.length===c0*c1?c3:null
if(Math.abs(c2)<0.01)return
t=Math.max(3,B.a.R(c0/150))
s=c2*2.5
r=c1-t
if(r<=t||c0-t<=t)return
q=t+1
p=(t&1)===0
o=p?1:0
n=1/(q*q-o)
o=2*t
m=o+1
l=m*c0
k=new Int32Array(l)
j=new Int32Array(l)
i=new Int32Array(l)
h=new A.dL(c0,m,t,b7,b8,b9,k,j,i)
g=new Uint8Array(A.t(b7))
f=new Uint8Array(A.t(b8))
e=new Uint8Array(A.t(b9))
for(d=Math.min(o,c1-1),c=0;c<=d;++c)h.$1(c)
for(d=c0-t,b=b6!=null,a=b7.length,a0=b8.length,a1=b9.length,a2=-t,c=t;c<r;++c){a3=c+t
if(a3>o)h.$1(a3)
a4=c*c0
for(a5=t;a5<d;++a5){a6=a4+a5
for(a7=a2,a8=0,a9=0,b0=0;a7<=t;a7+=2){b1=B.b.K(c+a7,m)*c0+a5
if(!(b1>=0&&b1<l))return A.a(k,b1)
a8+=k[b1]
a9+=j[b1]
b0+=i[b1]}if(!(a6>=0&&a6<a))return A.a(b7,a6)
b2=b7[a6]
if(!(a6<a0))return A.a(b8,a6)
b3=b8[a6]
if(!(a6<a1))return A.a(b9,a6)
b4=b9[a6]
if(p){a8-=b2
a9-=b3
b0-=b4}if(b){if(!(a6<b6.length))return A.a(b6,a6)
b5=b6[a6]!==2}else b5=!0
a3=B.a.h(B.a.i(b2+A.fB(b2-a8*n,s,b5),0,255))
g.$flags&2&&A.b(g)
if(!(a6<g.length))return A.a(g,a6)
g[a6]=a3
a3=B.a.h(B.a.i(b3+A.fB(b3-a9*n,s,b5),0,255))
f.$flags&2&&A.b(f)
if(!(a6<f.length))return A.a(f,a6)
f[a6]=a3
a3=B.a.h(B.a.i(b4+A.fB(b4-b0*n,s,b5),0,255))
e.$flags&2&&A.b(e)
if(!(a6<e.length))return A.a(e,a6)
e[a6]=a3}}B.e.bu(b7,0,g)
B.e.bu(b8,0,f)
B.e.bu(b9,0,e)},
e7(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k=e*d,j=new Uint8Array(k),i=new Uint8Array(k),h=new Uint8Array(k),g=d-1
for(t=a.length,s=b.length,r=c.length,q=0;q<e;++q){p=q*d
for(o=0;o<d;++o){n=p+o
m=(g-o)*e+q
if(!(n>=0&&n<t))return A.a(a,n)
l=a[n]
if(!(m>=0&&m<k))return A.a(j,m)
j[m]=l
if(!(n<s))return A.a(b,n)
l=b[n]
if(!(m<k))return A.a(i,m)
i[m]=l
if(!(n<r))return A.a(c,n)
l=c[n]
if(!(m<k))return A.a(h,m)
h[m]=l}}return new A.r(j,i,h)},
jS(a0,a1,a2){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c=a0.gu(),b=a0.gC(),a=c*b
if(a===0)return A.mt(a0)
t=new Uint8Array(a)
s=A.aA(256,0,!1,u.S)
for(r=0;r<b;++r)for(q=r*c,p=0;p<c;++p){o=a0.a
n=o==null?null:o.S(p,r,null)
if(n==null)n=new A.A()
m=B.b.i(B.a.R(0.299*n.gj()+0.587*n.gm()+0.114*n.gl()),0,255)
o=q+p
if(!(o>=0&&o<a))return A.a(t,o)
t[o]=m
if(!(m>=0&&m<256))return A.a(s,m)
B.c.q(s,m,s[m]+1)}l=B.a.R(a*0.02)
j=0
m=0
for(;;){if(!(m<256)){k=0
break}j+=s[m]
if(j>l){k=m
break}++m}j=0
m=255
for(;;){if(!(m>=0)){i=255
break}j+=s[m]
if(j>l){i=m
break}--m}h=(i<=k?B.b.i(k+1,1,255):i)-k
g=a1?0.55:0
for(q=!a1,o=a2!==1,r=0;r<b;++r)for(f=r*c,p=0;p<c;++p){e=f+p
if(!(e>=0&&e<a))return A.a(t,e)
d=B.a.i((t[e]-k)/h,0,1)
d+=g*(d*d*(3-2*d)-d)
m=B.b.i(B.a.R((q&&o?Math.pow(d,a2):d)*255),0,255)
e=a0.a
if(e!=null)e.a5(p,r,m,m,m)}return a0},
kf(a,b,c){var t=A.cU(a,b,c),s=null,r=null,q=t.b,p=t.c
r=p
s=q
if(typeof s!=="number")return s.aP()
if(typeof r!=="number")return r.aP()
return B.a.i(1-(Math.sqrt(s*s+r*r)-0.04)/0.019999999999999997,0,1)},
dK:function dK(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5,c6,c7,c8){var _=this
_.a=a
_.c=b
_.e=c
_.f=d
_.r=e
_.w=f
_.x=g
_.y=h
_.z=i
_.Q=j
_.as=k
_.at=l
_.ax=m
_.ay=n
_.ch=o
_.cx=p
_.cy=q
_.db=r
_.dx=s
_.dy=t
_.fr=a0
_.go=a1
_.id=a2
_.k2=a3
_.k3=a4
_.p4=a5
_.RG=a6
_.ry=a7
_.to=a8
_.x1=a9
_.x2=b0
_.xr=b1
_.y1=b2
_.a9=b3
_.dF=b4
_.dG=b5
_.dH=b6
_.dI=b7
_.dJ=b8
_.ee=b9
_.ef=c0
_.eg=c1
_.dK=c2
_.dL=c3
_.dM=c4
_.dN=c5
_.dO=c6
_.dP=c7
_.dQ=c8},
d0:function d0(a,b,c,d,e){var _=this
_.c=a
_.r=b
_.w=c
_.x=d
_.y=e},
e6:function e6(a,b){this.a=a
this.b=b},
ek:function ek(a,b){this.a=a
this.b=b},
eh:function eh(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
ei:function ei(a,b,c){this.a=a
this.b=b
this.c=c},
ej:function ej(a,b,c,d,e){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e},
eb:function eb(){},
ea:function ea(){},
ee:function ee(){},
ef:function ef(){},
eg:function eg(){},
ed:function ed(){},
ec:function ec(){},
e5:function e5(a,b){this.a=a
this.b=b},
e2:function e2(a){this.a=a},
e3:function e3(a){this.a=a},
e4:function e4(a){this.a=a},
dP:function dP(a,b){this.a=a
this.b=b},
dN:function dN(a){this.a=a},
dO:function dO(a){this.a=a},
dW:function dW(a){this.a=a},
dX:function dX(a){this.a=a},
dY:function dY(a){this.a=a},
dZ:function dZ(a){this.a=a},
dQ:function dQ(){},
dR:function dR(){},
dS:function dS(){},
dT:function dT(a){this.a=a},
dU:function dU(a){this.a=a},
dV:function dV(a){this.a=a},
dM:function dM(){},
e9:function e9(){},
e8:function e8(a){this.a=a},
e_:function e_(a,b){this.a=a
this.b=b},
e0:function e0(a,b){this.a=a
this.b=b},
e1:function e1(a,b){this.a=a
this.b=b},
dL:function dL(a,b,c,d,e,f,g,h,i){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e
_.f=f
_.r=g
_.w=h
_.x=i},
f0:function f0(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=null},
mF(c9,d0,d1,d2){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4=c9.gu(),c5=c9.gC(),c6=Math.max(1,B.a.R(Math.sqrt(c4*c5/12e3))),c7=A.q([],u.t),c8=B.b.V(c5,3)
for(t=0,s=0,r=0,q=0,p=0,o=0,n=0,m=0,l=0,k=0,j=0,i=0,h=0,g=0,f=0,e=0,d=0,c=0,b=0;b<c5;b+=c6)for(a=b<c8,a0=0;a0<c4;a0+=c6){a1=c9.a
a2=a1==null?null:a1.S(a0,b,null)
if(a2==null)a2=new A.A()
a3=a2.gj()
a4=a2.gm()
a5=a2.gl()
a6=0.299*a3+0.587*a4+0.114*a5
B.c.E(c7,B.b.i(B.a.R(a6),0,255))
t+=a3
s+=a4
r+=a5
a7=Math.max(a3,Math.max(a4,a5))
a8=Math.min(a3,Math.min(a4,a5))
a9=a7<=0?0:(a7-a8)/a7
q+=a9
if(a7-a8>24&&a6>20&&a6<245)++c
if(a){++e
if(a5>=a3+15&&a5>=a4+6&&a6>110&&a9>0.1)++f}if(a4>=a3+8&&a4>=a5+8&&a6>35&&a9>0.15)++d
if(a6>100&&a6<245&&!A.mA(a3,a4,a5,a9)){p+=a3
o+=a4
n+=a5;++m}if(a9<0.12&&a6>=40&&a6<=235){l+=a3
k+=a4
j+=a5;++i}if(a6<=5)++h
if(a6>=250)++g}b0=c7.length
if(b0===0)return B.bg
B.c.aY(c7)
b1=new A.fu(c7,b0)
b2=B.c.dS(c7,0,new A.ft(),u.S)/b0
for(a=c7.length,b3=0,b4=0;b4<a;++b4){a1=c7[b4]-b2
b3+=a1*a1}a=b1.$1(0.01)
a1=b1.$1(0.05)
b5=b1.$1(0.5)
b6=b1.$1(0.95)
b1.$1(0.99)
Math.sqrt(b3/b0)
b7=m===0
b8=b7?0:p/m
b9=b7?0:o/m
b7=b7?0:n/m
c0=e===0?0:f/e
c1=i===0
c2=c1?0:l/i
c3=c1?0:k/i
c1=c1?0:j/i
return new A.di(a,a1,b5,b6,c0,d/b0,h/b0,g/b0,t/b0,s/b0,r/b0,q/b0,b0,b8,b9,b7,m/b0,c2,c3,c1,i/b0,0,0,0,0/b0)},
mA(a,b,c,d){var t
if(a<b||b<c)return!1
if(d<=0.15||d>=0.65||a-b<12)return!1
t=a===c?0:60*(b-c)/(a-c)
return t>=3&&t<=32},
mG(a,b,c){var t,s,r,q,p,o,n=0,m=0,l=null
if(b<1||c<1)return null
r=a.length
q=b*c
t=r===q*3?3:4
p=t
if(typeof p!=="number")return A.bS(p)
if(r!==q*p)return null
try{r=B.e.gB(a)
q=a.byteOffset
p=J.ad(t,3)?B.E:B.D
s=A.hG(r,q,c,t,p,b)
p=A.mF(s,n,m,l)
return p}catch(o){return null}},
mN(b4,b5){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1=u.s,b2=A.q([],b1),b3=A.q([],b1)
b1=b4.c
t=(118-b1)/118*60
if(b1<80)B.c.E(b3,"Dark")
if(b1>165)B.c.E(b3,"Bright")
if(Math.abs(t)>=5)B.c.E(b2,b1<118?"Lifted a dark exposure":"Eased a bright exposure")
b1=b4.d-b4.b
s=(190-b1)/190*50
if(b1<120)B.c.E(b3,"Flat")
if(b1>225)B.c.E(b3,"Punchy")
if(s>=5)B.c.E(b2,"Opened up a flat range")
if(s<=-5)B.c.E(b2,"Softened a harsh range")
b1=b4.Q
r=b1>0.02?-Math.min(40,b1*800):0
b1=b4.z
q=b1>0.02?Math.min(40,b1*800):0
if(r<0)B.c.E(b2,"Pulled blown highlights back")
if(q>0)B.c.E(b2,"Opened blocked shadows")
switch(null){case"backlit":q=Math.max(q,25)
r=Math.min(r,-15)
B.c.E(b2,"Backlit: brought the subject forward")
break
case"harsh_shadows":q=Math.max(q,20)
s=Math.min(s,-5)
B.c.E(b2,"Harsh shadows softened")
break
case"overexposed":r=Math.min(r,-20)
break}p=B.a.i((0.35-b4.ay)/0.35*60,-20,40)
if(p>=10)B.c.E(b2,"A little more colour for the panel")
o=b4.gb2()?(b4.CW-b4.cy)/b4.cx:b4.gcl(0)
n=b4.gb2()?b4.CW:b4.as
m=b4.gb2()?b4.cx:b4.at
l=b4.gb2()?b4.cy:b4.ax
k=o<-0.06
j="".toLowerCase()
i=B.M.bN(j,"sunset")||B.M.bN(j,"sunrise")||B.M.bN(j,"golden")
b1=!1
if(Math.abs(o)>0.15)if(!i)b1=b4.gb2()
h=1
g=1
if(b1){f=B.a.i(m/n,0.9,1.1)
e=B.a.i(m/l,0.9,1.1)
B.c.E(b2,k?"Warmed a blue cast":"Cooled a yellow cast")
B.c.E(b2,"strong cast, corrected without the model")
if(b4.fx>=0.1&&b4.dy>0&&b4.dx>0&&b4.fr>0){b1=b4.dx
d=b4.fr
c=b4.dy
if(Math.abs((b1-d)/c)<0.05)B.c.E(b2,"white balance held: the greys are already grey")
else{b=c/b1
a=c/d
a0=k?Math.min(f,Math.max(1,b)):Math.max(f,Math.min(1,b))
a1=k?Math.max(e,Math.min(1,a)):Math.min(e,Math.max(1,a))
if(a0!==f||a1!==e){B.c.E(b2,"white balance held at the greys")
g=a1
h=a0}else{g=e
h=f}}}else{g=e
h=f}}if(b4.gb2()&&o>0.1&&o<0.5&&!i){b1=b4.cx
a2=B.a.i(b1/b4.CW,0.85,1.15)
a3=B.a.i(b1/b4.cy,0.85,1.15)
if(b4.k1>=0.005&&b4.go>0&&b4.id>0&&b4.fy>0){b1=b4.fy
d=b4.go
a4=b1/d
c=b4.id
a5=c/d
a6=B.a.i((0.84-a5)/0.08999999999999997,0,1)
a7=B.a.i((a4-1.42)/0.22999999999999998,0,1)
a3=1+(a3-1)*a6
a2=1+(a2-1)*a7
if(a6===0&&a7===0)B.c.E(b2,"face already in the skin locus \u2014 the warm lights are a colour, not a cast")
else if(a6<1||a7<1)B.c.E(b2,"face white balance scaled to the face's own warmth")
a8=Math.min(1,(a4>1.65?1.65:1.15)*d/b1)
a9=Math.max(1,(a5<0.75?0.75:0.92)*d/c)
b0=a3>a9||a2<a8
a3=Math.min(a3,a9)
a2=Math.max(a2,a8)
if(b0)B.c.E(b2,"face white balance held at the skin")}}else{a2=1
a3=1}B.b.i(B.a.R(t),-30,40)
B.b.i(B.a.R(s),-20,30)
B.a.R(p)
B.b.i(B.a.R(r),-40,0)
B.b.i(B.a.R(q),0,40)
if(b3.length!==0)B.c.dW(b3,", ")
return new A.eG(0,h,1,g,a2,a3)},
di:function di(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,a0,a1,a2,a3,a4){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.f=e
_.r=f
_.z=g
_.Q=h
_.as=i
_.at=j
_.ax=k
_.ay=l
_.ch=m
_.CW=n
_.cx=o
_.cy=p
_.db=q
_.dx=r
_.dy=s
_.fr=t
_.fx=a0
_.fy=a1
_.go=a2
_.id=a3
_.k1=a4},
fu:function fu(a,b){this.a=a
this.b=b},
ft:function ft(){},
eJ:function eJ(){},
eG:function eG(a,b,c,d,e,f){var _=this
_.w=a
_.y=b
_.z=c
_.Q=d
_.as=e
_.at=f},
fR(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3){return new A.eK(a8,b7,i,f,b1,h,g,b0,r,k,b9,d,c3,c2,c1,c0,a7,m,a4,a3,j,b3,a9,q,p,b2,b5,b8,e,b6,a6,t,b4,n,s,l,a0,a2,a1,o,a,b,a5)},
kU(a,b,c,d,e,f){var t,s,r,q,p,o,n,m,l=null
if(e)return A.fR(!0,!1,1.4,0,0.7,1,0,0.18,1.1,1,0.8,0,0.9,0,!1,1,0,0,1,1,l,l,l,40,26,"line art: defaults, no push, snap pulled in so greys dither, Black and White only",0.5,0.3,1.1,1,0,0.05,0,0,1,0,1,0.1,1.5,0,1,1,1,0)
if(d){t=b<-0.06
s=f==null
r=s?l:f.w
if(r==null)r=0
q=s?l:f.y
if(q==null)q=1
p=s?l:f.z
if(p==null)p=1
s=s?l:f.Q
if(s==null)s=1
o=t?l:B.ad
n=t?l:B.ae
m=t?l:B.a9
return A.fR(!1,!0,1.4,0.09,0.7,1,0,0.18,1.175,1,0.8,0,0.9,0,!1,1,0,0.09,1,1,o,m,n,0,64.8,"landscape: half the photographer recipe, no clarity, skies kept smooth",0.5,0.3,1.2200000000000002,1,0,0.05,0,0,1,0,1,0.16,1.5,-0.075+r/100*0.5,s,p,q,0.06)}t=b<-0.06
s=f==null
r=s?l:f.w
if(r==null)r=0
q=s?l:f.y
if(q==null)q=1
p=s?l:f.z
if(p==null)p=1
s=s?l:f.Q
if(s==null)s=1
o=t?l:B.ad
n=t?l:B.ae
m=t?l:B.a9
return A.fR(!1,!0,1.4,0.15,0.7,1,0,0.32999999999999996,1.3,1,0.8,0,0.9,0,!1,1,0,0.18,1,1,o,m,n,60,64.8,"photographer recipe (no black lift) + muted dark fields",0.5,0.6,1.3,1,0,0.05,0,0,1,0,1,0.16,1.5,-0.075+r/100*0.5,s,p,q,0.09)},
eK:function eK(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e
_.f=f
_.r=g
_.w=h
_.x=i
_.y=j
_.z=k
_.Q=l
_.as=m
_.at=n
_.ax=o
_.ay=p
_.ch=q
_.CW=r
_.cx=s
_.cy=t
_.db=a0
_.dx=a1
_.dy=a2
_.fr=a3
_.fx=a4
_.fy=a5
_.go=a6
_.id=a7
_.k1=a8
_.k2=a9
_.k3=b0
_.k4=b1
_.ok=b2
_.p1=b3
_.p2=b4
_.p3=b5
_.p4=b6
_.R8=b7
_.RG=b8
_.rx=b9
_.ry=c0
_.to=c1
_.x2=c2},
ly(a,b,c,d,e,f,g){var t,s,r,q,p,o,n,m=null,l=A.mG(a,b,c)
if(l!=null){t=A.mN(l,B.au)
s=l.gcl(0)
r=l.f>=0.25||l.r>=0.3
q=l.ch>0&&l.ay<=0.06&&l.c>=215&&l.a<=80}else{t=m
s=0
r=!1
q=!1}p=A.kU(!1,s,!1,r,q,f?t:m)
if(!d)return A.fw(!1,!1,!0,0,0,24,1,0,0.18,m,m,m,1.1,0,0.8,0,0.9,!0,1.2,0,new Uint8Array(0),b>c,!0,!1,0,0,64.8,0,0.3,c,a,b,!0,1.1*e,1,0,0.05,!1,1,!1,!1,0.1,0,!1,0+-0.075*g,p.ay,p.ax,p.at,0)
o=new Uint8Array(0)
n=p.z
n=q?n:n- -0.075*(1-g)
return A.fw(!1,p.ry,p.to,p.Q,p.k1,24,p.d,p.r,p.f,p.p4,p.RG,p.R8,p.c,p.db,p.y,p.p3,p.CW,!0,1.2,p.x,o,b>c,!0,!1,p.k4,p.cy,p.cx,p.k3,p.ch,c,a,b,!0,p.a*e,p.dy,p.w,p.e,!1,p.k2,!1,!1,p.b,p.id,!1,n,p.ay,p.ax,p.at,p.as)},
m3(a0,a1,a2,a3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a=null
u.Y.a(a0)
A.p(a1)
A.p(a2)
A.ak(a3)
t=a3.length===0?A.aS(u.N,u.z):u.c.a(B.at.dw(a3,a))
s=t.k(0,"app")
r=J.aI(s)
if(r.O(s,"plain")||r.O(s,"boost")){r=r.O(s,"boost")
q=t.k(0,"saturationScale")
q=A.dD(q==null?1:q)
p=J.ad(t.k(0,"whiteBalance"),!1)
o=t.k(0,"cool")
return A.hy(A.ly(a0,a1,a2,r,q,!p,A.dD(o==null?1:o)))}r=new A.fk(t)
q=new A.fj(t)
p=new Uint8Array(0)
o=r.$2("saturation",1.1)
n=r.$2("vibrance",0.1)
m=r.$2("contrast",1.1)
l=r.$2("brightness",1)
k=r.$2("warmth",0)
j=r.$2("gamma",1.2)
i=r.$2("whiteBalanceR",1)
h=r.$2("whiteBalanceG",1)
g=r.$2("whiteBalanceB",1)
f=r.$2("paletteMapping",0.3)
r=r.$2("errorDiffusion",0.9)
e=q.$2("useAdaptiveEnhancement",!1)
d=q.$2("warmToneV2",!1)
c=q.$2("autoWhiteBalance",!1)
b=q.$2("useSpectra6Palette",!1)
return A.hy(A.fw(c,!1,!0,0,0,0,l,0,0.18,a,a,a,m,0,0.8,0,r,!1,j,0,p,a1>a2,!0,q.$2("isWideGamut",!1),0,0,64.8,0,f,a2,a0,a1,!0,o,1,0,0.05,!1,0,e,b,n,0,d,k,g,h,i,0))},
mD(){if(typeof A.h5()=="function")A.cL(A.aK("Attempting to rewrap a JS function.",null))
var t=function(a,b){return function(c,d,e,f){return a(b,c,d,e,f,arguments.length)}}(A.lF,A.h5())
t[$.ha()]=A.h5()
v.G.wallieProcess=t},
fk:function fk(a){this.a=a},
fj:function fj(a){this.a=a},
l5(a,b){return J.j7(a,b,null)},
mH(a){if(typeof dartPrint=="function"){dartPrint(a)
return}if(typeof console=="object"&&typeof console.log!="undefined"){console.log(a)
return}if(typeof print=="function"){print(a)
return}throw"Unable to print message: "+String(a)},
lF(a,b,c,d,e,f){u.Z.a(a)
A.p(f)
if(f>=4)return a.$4(b,c,d,e)
if(f===3)return a.$3(b,c,d)
if(f===2)return a.$2(b,c)
if(f===1)return a.$1(b)
return a.$0()},
mn(a){var t,s,r,q,p,o=a.gn(0)
for(t=1,s=0;o>0;){r=3800>o?o:3800
o-=r
while(--r,r>=0){q=a.b
q.toString
p=a.c++
if(!(p>=0&&p<q.length))return A.a(q,p)
t+=q[p]
s+=t}t=B.b.K(t,65521)
s=B.b.K(s,65521)}return(s<<16|t)>>>0},
h2(a,b){var t,s,r=J.N(a),q=r.gn(a)
b^=4294967295
for(t=0;q>=8;){s=t+1
b=B.m[(b^r.k(a,t))&255]^b>>>8
t=s+1
b=B.m[(b^r.k(a,s))&255]^b>>>8
s=t+1
b=B.m[(b^r.k(a,t))&255]^b>>>8
t=s+1
b=B.m[(b^r.k(a,s))&255]^b>>>8
s=t+1
b=B.m[(b^r.k(a,t))&255]^b>>>8
t=s+1
b=B.m[(b^r.k(a,s))&255]^b>>>8
s=t+1
b=B.m[(b^r.k(a,t))&255]^b>>>8
t=s+1
b=B.m[(b^r.k(a,s))&255]^b>>>8
q-=8}if(q>0)do{s=t+1
b=B.m[(b^r.k(a,t))&255]^b>>>8
if(--q,q>0){t=s
continue}else break}while(!0)
return(b^4294967295)>>>0},
mt(a){var t,s,r,q,p,o,n,m,l
if(a.gaN())a=a.ds(a.gaH())
for(t=a.gZ(),s=t.length,r=0;r<t.length;t.length===s||(0,A.a0)(t),++r){q=t[r]
p=q.a
if((p==null?null:p.gJ())!=null){p=q.a
o=p==null?null:p.gJ()
n=o.a
for(m=0;m<n;++m){l=0.299*o.an(m)+0.587*o.am(m)+0.114*o.al(m)
o.aS(m,l)
o.aR(m,l)
o.aQ(m,l)}}else for(p=q.a,p=p.gD(p);p.H();){o=p.gL()
l=0.299*o.gj()+0.587*o.gm()+0.114*o.gl()
o.sj(l)
o.sm(l)
o.sl(l)}}return a},
ml(a){return new A.eO(B.bi,6,null).dD(a,!1)},
mh(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k,j,i,h=null
d=B.b.h(B.b.i(d,0,a.gu()-1))
e=B.b.h(B.b.i(e,0,a.gC()-1))
if(d+c>a.gu())c=a.gu()-d
if(e+b>a.gC())b=a.gC()-e
t=a.gZ().length
for(s=u.g,r=h,q=0;q<t;++q){p=a.x
if(p===$)p=a.x=A.q([],s)
if(!(q<p.length))return A.a(p,q)
o=p[q]
n=r==null
m=n?h:r.bd()
if(m==null)m=A.d_(o,b,!0,c)
if(n)r=m
for(n=m.a,n=n.gD(n);n.H();){l=n.gL()
k=l.gac()
j=l.gad()
i=o.a
k=i==null?h:i.S(d+k,e+j,h)
l.W(k==null?new A.A():k)}}r.toString
return r},
iB(a8,a9){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6=null,a7=B.b.K(a9,360)
a8.gaN()
if(B.b.K(a7,90)===0)switch(B.b.V(a7,90)){case 1:return A.m7(a8)
case 2:return A.m5(a8)
case 3:return A.m6(a8)
default:return A.aP(a8,!1,!1)}t=a7*3.141592653589793/180
s=Math.cos(t)
r=Math.sin(t)
q=a8.gu()
p=a8.gu()
o=a8.gC()
n=a8.gC()
m=0.5*a8.gu()
l=0.5*a8.gC()
o=Math.abs(q*s)+Math.abs(o*r)
k=0.5*o
n=Math.abs(p*r)+Math.abs(n*s)
j=0.5*n
i=a8.gZ().length
for(q=u.g,h=a6,g=0;g<i;++g){f=a8.x
if(f===$)f=a8.x=A.q([],q)
if(!(g<f.length))return A.a(f,g)
e=f[g]
p=h==null
d=p?a6:h.bd()
if(d==null){c=B.a.h(o)
d=A.d_(a8,B.a.h(n),!0,c)}if(p)h=d
for(p=d.a,p=p.gD(p);p.H();){b=p.gL()
a=b.gac()
a0=b.gad()
c=a-k
a1=a0-j
a2=m+c*s+a1*r
a3=l-c*r+a1*s
c=!1
if(a2>=0)if(a3>=0){a1=e.a
a4=a1==null
a5=a4?a6:a1.a
if(a2<(a5==null?0:a5)){c=a4?a6:a1.b
c=a3<(c==null?0:c)}}if(c)d.bk(a,a0,e.ct(a2,a3,B.aA))}}h.toString
return h},
m7(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g=null
for(t=a.gZ(),s=t.length,r=g,q=0;q<t.length;t.length===s||(0,A.a0)(t),++q){p=t[q]
o=r==null
n=o?g:r.bd()
if(n==null){m=p.a
l=m==null
k=l?g:m.b
if(k==null)k=0
m=l?g:m.a
n=A.d_(p,m==null?0:m,!0,k)}if(o)r=n
o=p.a
o=o==null?g:o.b
j=(o==null?0:o)-1
i=0
for(;;){o=n.a
o=o==null?g:o.b
if(!(i<(o==null?0:o)))break
h=0
for(;;){o=n.a
o=o==null?g:o.a
if(!(h<(o==null?0:o)))break
o=p.a
o=o==null?g:o.S(i,j-h,g)
n.bk(h,i,o==null?new A.A():o);++h}++i}}r.toString
return r},
m5(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g=null
for(t=a.gZ(),s=t.length,r=g,q=0;q<t.length;t.length===s||(0,A.a0)(t),++q){p=t[q]
o=p.a
n=o==null
m=n?g:o.a
l=(m==null?0:m)-1
o=n?g:o.b
k=(o==null?0:o)-1
o=r==null
j=o?g:r.bd()
if(j==null)j=A.aP(p,!0,!0)
if(o)r=j
i=0
for(;;){o=j.a
o=o==null?g:o.b
if(!(i<(o==null?0:o)))break
o=k-i
h=0
for(;;){n=j.a
n=n==null?g:n.a
if(!(h<(n==null?0:n)))break
n=p.a
n=n==null?g:n.S(l-h,o,g)
j.bk(h,i,n==null?new A.A():n);++h}++i}}r.toString
return r},
m6(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g=null
for(t=a.gZ(),s=t.length,r=g,q=0;q<t.length;t.length===s||(0,A.a0)(t),++q){p=t[q]
o=a.a
o=o==null?g:o.a
n=(o==null?0:o)-1
o=r==null
m=o?g:r.bd()
if(m==null){l=p.a
k=l==null
j=k?g:l.b
if(j==null)j=0
l=k?g:l.a
m=A.d_(p,l==null?0:l,!0,j)}if(o)r=m
i=0
for(;;){o=m.a
o=o==null?g:o.b
if(!(i<(o==null?0:o)))break
o=n-i
h=0
for(;;){l=m.a
l=l==null?g:l.a
if(!(h<(l==null?0:l)))break
l=p.a
l=l==null?g:l.S(o,h,g)
m.bk(h,i,l==null?new A.A():l);++h}++i}}r.toString
return r},
mJ(a,b,c,d){return(B.b.i(a,0,255)|B.b.i(b,0,255)<<8|B.b.i(c,0,255)<<16|B.b.i(d,0,255)<<24)>>>0},
ac(a,b,c){var t,s,r,q,p=b.gn(b),o=b.gA(),n=a.gJ(),m=n==null?null:n.gA()
if(m==null)m=a.gA()
t=a.gn(a)
if(p===1)b.q(0,0,A.dE(B.a.aF(a.gn(a)>2?a.gY():a.k(0,0)),m,o))
else if(p<=t)for(s=0;s<p;++s)b.q(0,s,A.dE(a.k(0,s),m,o))
else if(t===2){r=A.dE(a.k(0,0),m,o)
if(p===3){b.q(0,0,r)
b.q(0,1,r)
b.q(0,2,r)}else{c=A.dE(a.k(0,1),m,o)
b.q(0,0,r)
b.q(0,1,r)
b.q(0,2,r)
b.q(0,3,c)}}else{for(s=0;s<t;++s)b.q(0,s,A.dE(a.k(0,s),m,o))
q=t===1?b.k(0,0):0
for(s=t;s<p;++s)b.q(0,s,s===3?c:q)}return b},
iA(a,b,c,d,e){var t,s,r=a.gJ(),q=r==null?null:r.gA()
if(q==null)q=a.gA()
r=e==null
t=r?null:e.gA()
c=t==null?c:t
if(c==null)c=a.gA()
t=r?null:e.gn(e)
d=t==null?d:t
if(d==null)d=a.gn(a)
if(b==null)b=0
if(c===q&&d===a.gn(a)){if(r)return a.M()
e.W(a)
return e}switch(c.a){case 3:if(r)s=new A.aL(new Uint8Array(d))
else s=e
return A.ac(a,s,b)
case 0:return A.ac(a,r?new A.bn(d,0):e,b)
case 1:return A.ac(a,r?new A.bp(d,0):e,b)
case 2:if(r){r=d<3?1:2
s=new A.br(d,new Uint8Array(r))}else s=e
return A.ac(a,s,b)
case 4:if(r)s=new A.bo(new Uint16Array(d))
else s=e
return A.ac(a,s,b)
case 5:if(r)s=new A.bq(new Uint32Array(d))
else s=e
return A.ac(a,s,b)
case 6:if(r)s=new A.bm(new Int8Array(d))
else s=e
return A.ac(a,s,b)
case 7:if(r)s=new A.bk(new Int16Array(d))
else s=e
return A.ac(a,s,b)
case 8:if(r)s=new A.bl(new Int32Array(d))
else s=e
return A.ac(a,s,b)
case 9:if(r)s=new A.bh(new Uint16Array(d))
else s=e
return A.ac(a,s,b)
case 10:if(r)s=new A.bi(new Float32Array(d))
else s=e
return A.ac(a,s,b)
case 11:if(r)s=new A.bj(new Float64Array(d))
else s=e
return A.ac(a,s,b)}},
E(a){return 0.299*a.gj()+0.587*a.gm()+0.114*a.gl()},
D(a){var t,s,r,q=$.hd()
q.$flags&2&&A.b(q)
q[0]=a
q=$.j1()
if(0>=q.length)return A.a(q,0)
t=q[0]
if(a===0)return t>>>16
if($.K==null)A.S()
s=t>>>23&511
q=$.hC.bb()
if(!(s<q.length))return A.a(q,s)
s=q[s]
if(s!==0){r=t&8388607
return s+(r+4095+(r>>>13&1)>>>13)}return A.ky(t)},
ky(a){var t,s,r=a>>>16&32768,q=(a>>>23&255)-112,p=a&8388607
if(q<=0){if(q<-10)return r
p|=8388608
t=14-q
return(r|B.b.bv(p+(B.b.a8(1,t-1)-1)+(B.b.aV(p,t)&1),t))>>>0}else if(q===143)if(p===0)return r|31744
else{p=p>>>13
s=p===0?1:0
return r|p|s|31744}else{p=p+4095+(p>>>13&1)
if((p&8388608)!==0){++q
p=0}if(q>30)return r|31744
return(r|q<<10|p>>>13)>>>0}},
S(){var t,s,r,q,p,o=$.K
if(o!=null)return o
t=new Uint32Array(65536)
$.K=J.j6(B.R.gB(t),0,null)
o=new Uint16Array(512)
$.hC.b=o
for(s=0;s<256;++s){r=(s&255)-112
if(r<=0||r>=30){o[s]=0
q=(s|256)>>>0
if(!(q<512))return A.a(o,q)
o[q]=0}else{q=r<<10>>>0
o[s]=q
p=(s|256)>>>0
if(!(p<512))return A.a(o,p)
o[p]=(q|32768)>>>0}}for(s=0;s<65536;++s)t[s]=A.kz(s)
o=$.K
o.toString
return o},
kz(a){var t,s=a>>>15&1,r=a>>>10&31,q=a&1023
if(r===0)if(q===0)return s<<31>>>0
else{while((q&1024)===0){q=q<<1;--r}++r
q&=4294966271}else if(r===31){t=s<<31
if(q===0)return(t|2139095040)>>>0
else return(t|q<<13|2139095040)>>>0}return(s<<31|r+112<<23|q<<13)>>>0},
mi(a,b,c,d){var t,s,r=c/d
if(a/b>r){t=B.a.R(b*r)
return new A.bO([b,t,B.b.V(a-t,2),0])}s=B.a.R(a/r)
return new A.bO([s,a,0,B.b.V(b-s,2)])},
l_(a,b,c,d,a0,a1){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e=B.af.k(0,a1)
if(e==null)return
for(t=a.length,s=0;s<c;++s){r=s*a0
for(q=0;q<b;++q,r+=d){if(!(r>=0&&r<t))return A.a(a,r)
p=a[r]
o=r+1
if(!(o<t))return A.a(a,o)
n=a[o]
m=r+2
if(!(m<t))return A.a(a,m)
l=a[m]
k=0.299*p+0.587*n+0.114*l
if(k<1)continue
j=B.a.R(k)
if(!(j>=0&&j<256))return A.a(e,j)
i=e[j].e9(0,k)
h=B.b.aP(p,i)
g=B.b.aP(n,i)
f=B.b.aP(l,i)
j=h>=255?255:B.a.h(h)
a.$flags&2&&A.b(a)
a[r]=j
a[o]=g>=255?255:B.a.h(g)
a[m]=f>=255?255:B.a.h(f)}}}},B={}
var w=[A,J,B]
var $={}
A.fM.prototype={}
J.d4.prototype={
O(a,b){return a===b},
gF(a){return A.cq(a)},
v(a){return"Instance of '"+A.dl(a)+"'"},
ga6(a){return A.b9(A.fZ(this))}}
J.d7.prototype={
v(a){return String(a)},
gF(a){return a?519018:218159},
ga6(a){return A.b9(u.y)},
$iz:1,
$ia6:1}
J.c5.prototype={
O(a,b){return null==b},
v(a){return"null"},
gF(a){return 0},
$iz:1}
J.c7.prototype={$iH:1}
J.az.prototype={
gF(a){return 0},
v(a){return String(a)}}
J.dj.prototype={}
J.as.prototype={}
J.ap.prototype={
v(a){var t=a[$.ha()]
if(t==null)return this.cE(a)
return"JavaScript function for "+J.cM(t)},
$iaN:1}
J.bB.prototype={
gF(a){return 0},
v(a){return String(a)}}
J.bC.prototype={
gF(a){return 0},
v(a){return String(a)}}
J.B.prototype={
E(a,b){A.aj(a).c.a(b)
a.$flags&1&&A.b(a,29)
a.push(b)},
cm(a){a.$flags&1&&A.b(a,"clear","clear")
a.length=0},
dW(a,b){var t,s=A.aA(a.length,"",!1,u.N)
for(t=0;t<a.length;++t)this.q(s,t,A.C(a[t]))
return s.join(b)},
co(a,b){return A.dq(a,0,A.iy(b,"count",u.S),A.aj(a).c)},
bw(a,b){return A.dq(a,b,null,A.aj(a).c)},
dS(a,b,c,d){var t,s,r
d.a(b)
A.aj(a).b7(d).p("1(1,2)").a(c)
t=a.length
for(s=b,r=0;r<t;++r){s=c.$2(s,a[r])
if(a.length!==t)throw A.j(A.aM(a))}return s},
aL(a,b){if(!(b>=0&&b<a.length))return A.a(a,b)
return a[b]},
gdX(a){var t=a.length
if(t>0)return a[t-1]
throw A.j(A.hI())},
bM(a,b){var t,s
A.aj(a).p("a6(1)").a(b)
t=a.length
for(s=0;s<t;++s){if(b.$1(a[s]))return!0
if(a.length!==t)throw A.j(A.aM(a))}return!1},
aY(a){var t,s,r,q,p,o
a.$flags&2&&A.b(a,"sort")
t=a.length
if(t<2)return
if(t===2){s=a[0]
r=a[1]
q=J.hM(s,r)
if(typeof q!=="number")return q.ea()
if(q>0){a[0]=r
a[1]=s}return}p=0
if(A.aj(a).c.b(null))for(o=0;o<a.length;++o)if(a[o]===void 0){a[o]=null;++p}a.sort(A.mf(J.lP(),2))
if(p>0)this.dh(a,p)},
dh(a,b){var t,s=a.length
for(;t=s-1,s>0;s=t)if(a[t]===null){a[t]=void 0;--b
if(b===0)break}},
v(a){return A.hJ(a,"[","]")},
gD(a){return new J.bd(a,a.length,A.aj(a).p("bd<1>"))},
gF(a){return A.cq(a)},
gn(a){return a.length},
k(a,b){if(!(b>=0&&b<a.length))throw A.j(A.fl(a,b))
return a[b]},
q(a,b,c){A.aj(a).c.a(c)
a.$flags&2&&A.b(a)
if(!(b>=0&&b<a.length))throw A.j(A.fl(a,b))
a[b]=c},
$iO:1,
$id:1,
$iu:1}
J.d6.prototype={
e6(a){var t,s,r
if(!Array.isArray(a))return null
t=a.$flags|0
if((t&4)!==0)s="const, "
else if((t&2)!==0)s="unmodifiable, "
else s=(t&1)!==0?"fixed, ":""
r="Instance of '"+A.dl(a)+"'"
if(s==="")return r
return r+" ("+s+"length: "+a.length+")"}}
J.ez.prototype={}
J.bd.prototype={
gL(){var t=this.d
return t==null?this.$ti.c.a(t):t},
H(){var t,s=this,r=s.a,q=r.length
if(s.b!==q){r=A.a0(r)
throw A.j(r)}t=s.c
if(t>=q){s.d=null
return!1}s.d=r[t]
s.c=t+1
return!0}}
J.aQ.prototype={
bf(a,b){var t
A.dD(b)
if(a<b)return-1
else if(a>b)return 1
else if(a===b){if(a===0){t=this.gbs(b)
if(this.gbs(a)===t)return 0
if(this.gbs(a))return-1
return 1}return 0}else if(isNaN(a)){if(isNaN(b))return 0
return 1}else return-1},
gbs(a){return a===0?1/a<0:a<0},
h(a){var t
if(a>=-2147483648&&a<=2147483647)return a|0
if(isFinite(a)){t=a<0?Math.ceil(a):Math.floor(a)
return t+0}throw A.j(A.ah(""+a+".toInt()"))},
av(a){var t,s
if(a>=0){if(a<=2147483647){t=a|0
return a===t?t:t+1}}else if(a>=-2147483648)return a|0
s=Math.ceil(a)
if(isFinite(s))return s
throw A.j(A.ah(""+a+".ceil()"))},
aF(a){var t,s
if(a>=0){if(a<=2147483647)return a|0}else if(a>=-2147483648){t=a|0
return a===t?t:t-1}s=Math.floor(a)
if(isFinite(s))return s
throw A.j(A.ah(""+a+".floor()"))},
R(a){if(a>0){if(a!==1/0)return Math.round(a)}else if(a>-1/0)return 0-Math.round(0-a)
throw A.j(A.ah(""+a+".round()"))},
i(a,b,c){if(this.bf(b,c)>0)throw A.j(A.aH(b))
if(this.bf(a,b)<0)return b
if(this.bf(a,c)>0)return c
return a},
e3(a){return a},
bt(a,b){var t
if(b>20)throw A.j(A.a9(b,0,20,"fractionDigits",null))
t=a.toFixed(b)
if(a===0&&this.gbs(a))return"-"+t
return t},
v(a){if(a===0&&1/a<0)return"-0.0"
else return""+a},
gF(a){var t,s,r,q,p=a|0
if(a===p)return p&536870911
t=Math.abs(a)
s=Math.log(t)/0.6931471805599453|0
r=Math.pow(2,s)
q=t<1?t/r:r/t
return((q*9007199254740992|0)+(q*3542243181176521|0))*599197+s*1259&536870911},
bP(a){return-a},
aP(a,b){return a*b},
K(a,b){var t=a%b
if(t===0)return 0
if(t>0)return t
if(b<0)return t-b
else return t+b},
X(a,b){A.dD(b)
if((a|0)===a)if(b>=1||b<-1)return a/b|0
return this.c9(a,b)},
V(a,b){return(a|0)===a?a/b|0:this.c9(a,b)},
c9(a,b){var t=a/b
if(t>=-2147483648&&t<=2147483647)return t|0
if(t>0){if(t!==1/0)return Math.floor(t)}else if(t>-1/0)return Math.ceil(t)
throw A.j(A.ah("Result of truncating division is "+A.C(t)+": "+A.C(a)+" ~/ "+b))},
a8(a,b){if(b<0)throw A.j(A.aH(b))
return b>31?0:a<<b>>>0},
c8(a,b){return b>31?0:a<<b>>>0},
bv(a,b){var t
if(b<0)throw A.j(A.aH(b))
if(a>0)t=this.bK(a,b)
else{t=b>31?31:b
t=a>>t>>>0}return t},
G(a,b){var t
if(a>0)t=this.bK(a,b)
else{t=b>31?31:b
t=a>>t>>>0}return t},
aV(a,b){if(0>b)throw A.j(A.aH(b))
return this.bK(a,b)},
bK(a,b){return b>31?0:a>>>b},
ga6(a){return A.b9(u.H)},
$ian:1,
$im:1,
$ih:1}
J.bA.prototype={
bP(a){return-a},
ga6(a){return A.b9(u.S)},
$iz:1,
$if:1}
J.c6.prototype={
ga6(a){return A.b9(u.i)},
$iz:1}
J.ay.prototype={
cD(a,b,c){return a.substring(b,A.bI(b,c,a.length))},
cC(a,b){return this.cD(a,b,null)},
dY(a,b){var t=a.length,s=b.length
if(t+s>t)t-=s
return a.lastIndexOf(b,t)},
bN(a,b){return A.mK(a,b,0)},
bf(a,b){var t
A.ak(b)
if(a===b)t=0
else t=a<b?-1:1
return t},
v(a){return a},
gF(a){var t,s,r
for(t=a.length,s=0,r=0;r<t;++r){s=s+a.charCodeAt(r)&536870911
s=s+((s&524287)<<10)&536870911
s^=s>>6}s=s+((s&67108863)<<3)&536870911
s^=s>>11
return s+((s&16383)<<15)&536870911},
ga6(a){return A.b9(u.N)},
gn(a){return a.length},
$iO:1,
$iz:1,
$ian:1,
$ihN:1,
$iv:1}
A.bD.prototype={
v(a){return"LateInitializationError: "+this.a}}
A.bf.prototype={
gn(a){return this.a.length},
k(a,b){var t=this.a
if(!(b>=0&&b<t.length))return A.a(t,b)
return t.charCodeAt(b)}}
A.eS.prototype={}
A.bW.prototype={}
A.Y.prototype={
gD(a){var t=this
return new A.bE(t,t.gn(t),A.i(t).p("bE<Y.E>"))}}
A.cw.prototype={
gcU(){var t=J.bc(this.a),s=this.c
if(s==null||s>t)return t
return s},
gdk(){var t=J.bc(this.a),s=this.b
if(s>t)return t
return s},
gn(a){var t,s=J.bc(this.a),r=this.b
if(r>=s)return 0
t=this.c
if(t==null||t>=s)return s-r
return t-r},
aL(a,b){var t=this,s=t.gdk()+b
if(b<0||s>=t.gcU())throw A.j(A.fH(b,t.gn(0),t,"index"))
return J.hf(t.a,s)},
bw(a,b){var t,s,r=this
A.ct(b,"count")
t=r.b+b
s=r.c
if(s!=null&&t>=s)return new A.bX(r.$ti.p("bX<1>"))
return A.dq(r.a,t,s,r.$ti.c)},
e4(a,b){var t,s,r,q=this,p=q.b,o=q.a,n=J.N(o),m=n.gn(o),l=q.c
if(l!=null&&l<m)m=l
t=m-p
if(t<=0){o=J.hL(0,q.$ti.c)
return o}s=A.aA(t,n.aL(o,p),!1,q.$ti.c)
for(r=1;r<t;++r){B.c.q(s,r,n.aL(o,p+r))
if(n.gn(o)<m)throw A.j(A.aM(q))}return s}}
A.bE.prototype={
gL(){var t=this.d
return t==null?this.$ti.c.a(t):t},
H(){var t,s=this,r=s.a,q=J.N(r),p=q.gn(r)
if(s.b!==p)throw A.j(A.aM(r))
t=s.c
if(t>=p){s.d=null
return!1}s.d=q.aL(r,t);++s.c
return!0}}
A.bF.prototype={
gn(a){return J.bc(this.a)},
aL(a,b){return this.b.$1(J.hf(this.a,b))}}
A.bX.prototype={
gD(a){return B.am},
gn(a){return 0}}
A.cW.prototype={
H(){return!1},
gL(){throw A.j(A.hI())}}
A.V.prototype={}
A.aC.prototype={
q(a,b,c){A.i(this).p("aC.E").a(c)
throw A.j(A.ah("Cannot modify an unmodifiable list"))},
aI(a,b,c,d,e){A.i(this).p("d<aC.E>").a(d)
throw A.j(A.ah("Cannot modify an unmodifiable list"))},
aD(a,b,c,d){return this.aI(0,b,c,d,0)}}
A.bL.prototype={}
A.I.prototype={$r:"+(1,2)",$s:1}
A.ai.prototype={$r:"+note,skin(1,2)",$s:2}
A.r.prototype={$r:"+(1,2,3)",$s:3}
A.cD.prototype={$r:"+data,nc,stride(1,2,3)",$s:4}
A.ab.prototype={$r:"+hair,note,skin(1,2,3)",$s:6}
A.bN.prototype={$r:"+(1,2,3,4)",$s:9}
A.bO.prototype={$r:"+h,w,x,y(1,2,3,4)",$s:10}
A.cE.prototype={$r:"+(1,2,3,4,5)",$s:11}
A.bs.prototype={
v(a){return A.fP(this)},
$iag:1}
A.bV.prototype={
gn(a){return this.b.length},
gd9(){var t=this.$keys
if(t==null){t=Object.keys(this.a)
this.$keys=t}return t},
b3(a){if(typeof a!="string")return!1
if("__proto__"===a)return!1
return this.a.hasOwnProperty(a)},
k(a,b){if(!this.b3(b))return null
return this.b[this.a[b]]},
aG(a,b){var t,s,r,q
this.$ti.p("~(1,2)").a(b)
t=this.gd9()
s=this.b
for(r=t.length,q=0;q<r;++q)b.$2(t[q],s[q])}}
A.bu.prototype={
bE(){var t=this,s=t.$map
if(s==null){s=new A.c8(t.$ti.p("c8<1,2>"))
A.iC(t.a,s)
t.$map=s}return s},
k(a,b){return this.bE().k(0,b)},
aG(a,b){this.$ti.p("~(1,2)").a(b)
this.bE().aG(0,b)},
gn(a){return this.bE().a}}
A.eP.prototype={
$0(){return B.a.aF(1000*this.a.now())},
$S:4}
A.cu.prototype={}
A.eV.prototype={
aO(a){var t,s,r=this,q=new RegExp(r.a).exec(a)
if(q==null)return null
t=Object.create(null)
s=r.b
if(s!==-1)t.arguments=q[s+1]
s=r.c
if(s!==-1)t.argumentsExpr=q[s+1]
s=r.d
if(s!==-1)t.expr=q[s+1]
s=r.e
if(s!==-1)t.method=q[s+1]
s=r.f
if(s!==-1)t.receiver=q[s+1]
return t}}
A.ci.prototype={
v(a){return"Null check operator used on a null value"}}
A.d8.prototype={
v(a){var t,s=this,r="NoSuchMethodError: method not found: '",q=s.b
if(q==null)return"NoSuchMethodError: "+s.a
t=s.c
if(t==null)return r+q+"' ("+s.a+")"
return r+q+"' on '"+t+"' ("+s.a+")"}}
A.dt.prototype={
v(a){var t=this.a
return t.length===0?"Error":"Error: "+t}}
A.eH.prototype={
v(a){return"Throw of null ('"+(this.a===null?"null":"undefined")+"' from JavaScript)"}}
A.au.prototype={
v(a){var t=this.constructor,s=t==null?null:t.name
return"Closure '"+A.iI(s==null?"unknown":s)+"'"},
$iaN:1,
ge8(){return this},
$C:"$1",
$R:1,
$D:null}
A.cP.prototype={$C:"$0",$R:0}
A.cQ.prototype={$C:"$2",$R:2}
A.dr.prototype={}
A.dp.prototype={
v(a){var t=this.$static_name
if(t==null)return"Closure of unknown static method"
return"Closure '"+A.iI(t)+"'"}}
A.be.prototype={
O(a,b){if(b==null)return!1
if(this===b)return!0
if(!(b instanceof A.be))return!1
return this.$_target===b.$_target&&this.a===b.a},
gF(a){return(A.h7(this.a)^A.cq(this.$_target))>>>0},
v(a){return"Closure '"+this.$_name+"' of "+("Instance of '"+A.dl(this.a)+"'")}}
A.dn.prototype={
v(a){return"RuntimeError: "+this.a}}
A.a7.prototype={
gn(a){return this.a},
gbi(){return new A.aR(this,A.i(this).p("aR<1>"))},
b3(a){var t,s
if(typeof a=="string"){t=this.b
if(t==null)return!1
return t[a]!=null}else if(typeof a=="number"&&(a&0x3fffffff)===a){s=this.c
if(s==null)return!1
return s[a]!=null}else return this.dT(a)},
dT(a){var t=this.d
if(t==null)return!1
return this.br(t[this.bq(a)],a)>=0},
k(a,b){var t,s,r,q,p=null
if(typeof b=="string"){t=this.b
if(t==null)return p
s=t[b]
r=s==null?p:s.b
return r}else if(typeof b=="number"&&(b&0x3fffffff)===b){q=this.c
if(q==null)return p
s=q[b]
r=s==null?p:s.b
return r}else return this.dU(b)},
dU(a){var t,s,r=this.d
if(r==null)return null
t=r[this.bq(a)]
s=this.br(t,a)
if(s<0)return null
return t[s].b},
q(a,b,c){var t,s,r=this,q=A.i(r)
q.c.a(b)
q.y[1].a(c)
if(typeof b=="string"){t=r.b
r.bS(t==null?r.b=r.bF():t,b,c)}else if(typeof b=="number"&&(b&0x3fffffff)===b){s=r.c
r.bS(s==null?r.c=r.bF():s,b,c)}else r.dV(b,c)},
dV(a,b){var t,s,r,q,p=this,o=A.i(p)
o.c.a(a)
o.y[1].a(b)
t=p.d
if(t==null)t=p.d=p.bF()
s=p.bq(a)
r=t[s]
if(r==null)t[s]=[p.bG(a,b)]
else{q=p.br(r,a)
if(q>=0)r[q].b=b
else r.push(p.bG(a,b))}},
e_(a,b){var t,s,r=this,q=A.i(r)
q.c.a(a)
q.p("2()").a(b)
if(r.b3(a)){t=r.k(0,a)
return t==null?q.y[1].a(t):t}s=b.$0()
r.q(0,a,s)
return s},
aG(a,b){var t,s,r=this
A.i(r).p("~(1,2)").a(b)
t=r.e
s=r.r
while(t!=null){b.$2(t.a,t.b)
if(s!==r.r)throw A.j(A.aM(r))
t=t.c}},
bS(a,b,c){var t,s=A.i(this)
s.c.a(b)
s.y[1].a(c)
t=a[b]
if(t==null)a[b]=this.bG(b,c)
else t.b=c},
da(){this.r=this.r+1&1073741823},
bG(a,b){var t=this,s=A.i(t),r=new A.eD(s.c.a(a),s.y[1].a(b))
if(t.e==null)t.e=t.f=r
else{s=t.f
s.toString
r.d=s
t.f=s.c=r}++t.a
t.da()
return r},
bq(a){return J.am(a)&1073741823},
br(a,b){var t,s
if(a==null)return-1
t=a.length
for(s=0;s<t;++s)if(J.ad(a[s].a,b))return s
return-1},
v(a){return A.fP(this)},
bF(){var t=Object.create(null)
t["<non-identifier-key>"]=t
delete t["<non-identifier-key>"]
return t},
$ifO:1}
A.eD.prototype={}
A.aR.prototype={
gn(a){return this.a.a},
gD(a){var t=this.a
return new A.W(t,t.r,t.e,this.$ti.p("W<1>"))}}
A.W.prototype={
gL(){return this.d},
H(){var t,s=this,r=s.a
if(s.b!==r.r)throw A.j(A.aM(r))
t=s.c
if(t==null){s.d=null
return!1}else{s.d=t.a
s.c=t.c
return!0}}}
A.c8.prototype={
bq(a){return A.me(a)&1073741823},
br(a,b){var t,s
if(a==null)return-1
t=a.length
for(s=0;s<t;++s)if(J.ad(a[s].a,b))return s
return-1}}
A.fo.prototype={
$1(a){return this.a(a)},
$S:9}
A.fp.prototype={
$2(a,b){return this.a(a,b)},
$S:10}
A.fq.prototype={
$1(a){return this.a(A.ak(a))},
$S:11}
A.M.prototype={
v(a){return this.ca(!1)},
ca(a){var t,s,r,q,p,o=this.cW(),n=this.bm(),m=(a?"Record ":"")+"("
for(t=o.length,s="",r=0;r<t;++r,s=", "){m+=s
q=o[r]
if(typeof q=="string")m=m+q+": "
if(!(r<n.length))return A.a(n,r)
p=n[r]
m=a?m+A.hZ(p):m+A.C(p)}m+=")"
return m.charCodeAt(0)==0?m:m},
cW(){var t,s=this.$s
while($.f6.length<=s)B.c.E($.f6,null)
t=$.f6[s]
if(t==null){t=this.cM()
B.c.q($.f6,s,t)}return t},
cM(){var t,s,r,q=this.$r,p=q.indexOf("("),o=q.substring(1,p),n=q.substring(p),m=n==="()"?0:n.replace(/[^,]/g,"").length+1,l=u.K,k=J.hK(m,l)
for(t=0;t<m;++t)k[t]=t
if(o!==""){s=o.split(",")
t=s.length
for(r=m;t>0;){--r;--t
B.c.q(k,r,s[t])}}k=A.kL(k,!1,l)
k.$flags=3
return k}}
A.b7.prototype={
bm(){return[this.a,this.b]},
O(a,b){if(b==null)return!1
return b instanceof A.b7&&this.$s===b.$s&&J.ad(this.a,b.a)&&J.ad(this.b,b.b)},
gF(a){return A.fQ(this.$s,this.a,this.b,B.B)}}
A.aD.prototype={
bm(){return[this.a,this.b,this.c]},
O(a,b){var t=this
if(b==null)return!1
return b instanceof A.aD&&t.$s===b.$s&&J.ad(t.a,b.a)&&J.ad(t.b,b.b)&&J.ad(t.c,b.c)},
gF(a){var t=this
return A.fQ(t.$s,t.a,t.b,t.c)}}
A.aE.prototype={
bm(){return this.a},
O(a,b){if(b==null)return!1
return b instanceof A.aE&&this.$s===b.$s&&A.ll(this.a,b.a)},
gF(a){return A.fQ(this.$s,A.l(this.a),B.B,B.B)}}
A.f_.prototype={
bb(){var t=this.b
if(t===this)throw A.j(A.eB(""))
return t}}
A.aT.prototype={
ga6(a){return B.bj},
be(a,b,c){A.cK(a,b,c)
return c==null?new Uint8Array(a,b):new Uint8Array(a,b,c)},
ci(a){return this.be(a,0,null)},
cg(a,b,c){A.cK(a,b,c)
c=B.b.V(a.byteLength-b,4)
return new Uint32Array(a,b,c)},
cf(a,b,c){A.cK(a,b,c)
c=B.b.V(a.byteLength-b,4)
return new Float32Array(a,b,c)},
$iz:1,
$iaT:1}
A.ce.prototype={
gB(a){if(((a.$flags|0)&2)!==0)return new A.fa(a.buffer)
else return a.buffer},
d7(a,b,c,d){var t=A.a9(b,0,c,d,null)
throw A.j(t)},
bU(a,b,c,d){if(b>>>0!==b||b>c)this.d7(a,b,c,d)}}
A.fa.prototype={
be(a,b,c){var t=A.kR(this.a,b,c)
t.$flags=3
return t},
ci(a){return this.be(0,0,null)},
cg(a,b,c){var t=A.kP(this.a,b,c)
t.$flags=3
return t},
cf(a,b,c){var t=A.kO(this.a,b,c)
t.$flags=3
return t}}
A.Q.prototype={
gn(a){return a.length},
c7(a,b,c,d,e){var t,s,r=a.length
this.bU(a,b,r,"start")
this.bU(a,c,r,"end")
if(b>c)throw A.j(A.a9(b,0,c,null,null))
t=c-b
if(e<0)throw A.j(A.aK(e,null))
s=d.length
if(s-e<t)throw A.j(A.l2("Not enough elements"))
if(e!==0||s!==t)d=d.subarray(e,e+t)
a.set(d,b)},
$iO:1,
$ia1:1}
A.aB.prototype={
k(a,b){A.aG(b,a,a.length)
return a[b]},
q(a,b,c){A.dC(c)
a.$flags&2&&A.b(a)
A.aG(b,a,a.length)
a[b]=c},
aI(a,b,c,d,e){u.l.a(d)
a.$flags&2&&A.b(a,5)
if(u.Q.b(d)){this.c7(a,b,c,d,e)
return}this.bR(a,b,c,d,e)},
aD(a,b,c,d){return this.aI(a,b,c,d,0)},
$id:1,
$iu:1}
A.a2.prototype={
q(a,b,c){A.p(c)
a.$flags&2&&A.b(a)
A.aG(b,a,a.length)
a[b]=c},
aI(a,b,c,d,e){u._.a(d)
a.$flags&2&&A.b(a,5)
if(u.E.b(d)){this.c7(a,b,c,d,e)
return}this.bR(a,b,c,d,e)},
aD(a,b,c,d){return this.aI(a,b,c,d,0)},
$id:1,
$iu:1}
A.c9.prototype={
ga6(a){return B.bk},
$iz:1,
$ifD:1}
A.ca.prototype={
ga6(a){return B.bl},
$iz:1,
$ifE:1}
A.cb.prototype={
ga6(a){return B.bm},
k(a,b){A.aG(b,a,a.length)
return a[b]},
$iz:1,
$ifJ:1}
A.cc.prototype={
ga6(a){return B.bn},
k(a,b){A.aG(b,a,a.length)
return a[b]},
$iz:1,
$ifK:1}
A.cd.prototype={
ga6(a){return B.bo},
k(a,b){A.aG(b,a,a.length)
return a[b]},
$iz:1,
$ifL:1}
A.cf.prototype={
ga6(a){return B.bq},
k(a,b){A.aG(b,a,a.length)
return a[b]},
$iz:1,
$ifT:1}
A.cg.prototype={
ga6(a){return B.br},
k(a,b){A.aG(b,a,a.length)
return a[b]},
$iz:1,
$ifU:1}
A.a8.prototype={
ga6(a){return B.bs},
gn(a){return a.length},
k(a,b){A.aG(b,a,a.length)
return a[b]},
bQ(a,b,c){return new Uint8Array(a.subarray(b,A.iq(b,c,a.length)))},
cA(a,b){return this.bQ(a,b,null)},
$iz:1,
$ia8:1,
$ieX:1}
A.cz.prototype={}
A.cA.prototype={}
A.cB.prototype={}
A.cC.prototype={}
A.aa.prototype={
p(a){return A.cJ(v.typeUniverse,this,a)},
b7(a){return A.ih(v.typeUniverse,this,a)}}
A.dy.prototype={}
A.dB.prototype={
v(a){return A.Z(this.a,null)}}
A.dw.prototype={
v(a){return this.a}}
A.cF.prototype={}
A.eE.prototype={
$2(a,b){this.a.q(0,this.b.a(a),this.c.a(b))},
$S:12}
A.w.prototype={
gD(a){return new A.bE(a,this.gn(a),A.al(a).p("bE<w.E>"))},
aL(a,b){return this.k(a,b)},
bw(a,b){return A.dq(a,b,null,A.al(a).p("w.E"))},
co(a,b){return A.dq(a,0,A.iy(b,"count",u.S),A.al(a).p("w.E"))},
bh(a,b,c,d){var t
A.al(a).p("w.E?").a(d)
A.bI(b,c,this.gn(a))
for(t=b;t<c;++t)this.q(a,t,d)},
aI(a,b,c,d,e){var t,s,r,q,p
A.al(a).p("d<w.E>").a(d)
A.bI(b,c,this.gn(a))
t=c-b
if(t===0)return
A.ct(e,"skipCount")
if(u.j.b(d)){s=e
r=d}else{r=J.hh(d,e).e4(0,!1)
s=0}q=J.N(r)
if(s+t>q.gn(r))throw A.j(A.kE())
if(s<b)for(p=t-1;p>=0;--p)this.q(a,b+p,q.k(r,s+p))
else for(p=0;p<t;++p)this.q(a,b+p,q.k(r,s+p))},
aD(a,b,c,d){return this.aI(a,b,c,d,0)},
bu(a,b,c){A.al(a).p("d<w.E>").a(c)
this.aD(a,b,b+c.length,c)},
v(a){return A.hJ(a,"[","]")},
$id:1,
$iu:1}
A.P.prototype={
aG(a,b){var t,s,r,q=A.i(this)
q.p("~(P.K,P.V)").a(b)
for(t=this.gbi(),t=t.gD(t),q=q.p("P.V");t.H();){s=t.gL()
r=this.k(0,s)
b.$2(s,r==null?q.a(r):r)}},
gn(a){var t=this.gbi()
return t.gn(t)},
v(a){return A.fP(this)},
$iag:1}
A.eF.prototype={
$2(a,b){var t,s=this.a
if(!s.a)this.b.a+=", "
s.a=!1
s=this.b
t=A.C(a)
s.a=(s.a+=t)+": "
t=A.C(b)
s.a+=t},
$S:13}
A.dz.prototype={
k(a,b){var t,s=this.b
if(s==null)return this.c.k(0,b)
else if(typeof b!="string")return null
else{t=s[b]
return typeof t=="undefined"?this.de(b):t}},
gn(a){return this.b==null?this.c.a:this.bl().length},
gbi(){if(this.b==null){var t=this.c
return new A.aR(t,A.i(t).p("aR<1>"))}return new A.dA(this)},
aG(a,b){var t,s,r,q,p=this
u.cQ.a(b)
if(p.b==null)return p.c.aG(0,b)
t=p.bl()
for(s=0;s<t.length;++s){r=t[s]
q=p.b[r]
if(typeof q=="undefined"){q=A.fh(p.a[r])
p.b[r]=q}b.$2(r,q)
if(t!==p.c)throw A.j(A.aM(p))}},
bl(){var t=u.v.a(this.c)
if(t==null)t=this.c=A.q(Object.keys(this.a),u.s)
return t},
de(a){var t
if(!Object.prototype.hasOwnProperty.call(this.a,a))return null
t=A.fh(this.a[a])
return this.b[a]=t}}
A.dA.prototype={
gn(a){return this.a.gn(0)},
aL(a,b){var t=this.a
if(t.b==null)t=t.gbi().aL(0,b)
else{t=t.bl()
if(!(b>=0&&b<t.length))return A.a(t,b)
t=t[b]}return t},
gD(a){var t=this.a
if(t.b==null){t=t.gbi()
t=t.gD(t)}else{t=t.bl()
t=new J.bd(t,t.length,A.aj(t).p("bd<1>"))}return t}}
A.fd.prototype={
$0(){var t,s
try{t=new TextDecoder("utf-8",{fatal:true})
return t}catch(s){}return null},
$S:6}
A.fc.prototype={
$0(){var t,s
try{t=new TextDecoder("utf-8",{fatal:false})
return t}catch(s){}return null},
$S:6}
A.f8.prototype={
b4(a){var t,s,r=a.length,q=A.bI(0,null,r),p=new Uint8Array(q)
for(t=0;t<q;++t){if(!(t<r))return A.a(a,t)
s=a.charCodeAt(t)
if((s&4294967040)!==0)throw A.j(A.jf(a,"string","Contains invalid characters."))
if(!(t<q))return A.a(p,t)
p[t]=s}return p}}
A.bg.prototype={}
A.cT.prototype={}
A.bY.prototype={}
A.d9.prototype={
dw(a,b){var t=A.m2(a,this.gdA().a)
return t},
gdA(){return B.aD}}
A.eA.prototype={}
A.eC.prototype={}
A.du.prototype={
dv(a,b){u.L.a(a)
return(b===!0?B.bu:B.bt).b4(a)},
du(a){return this.dv(a,null)}}
A.eY.prototype={
b4(a){var t,s,r,q=a.length,p=A.bI(0,null,q)
if(p===0)return new Uint8Array(0)
t=new Uint8Array(p*3)
s=new A.fe(t)
if(s.cX(a,0,p)!==p){r=p-1
if(!(r>=0&&r<q))return A.a(a,r)
s.bL()}return B.e.bQ(t,0,s.b)}}
A.fe.prototype={
bL(){var t,s=this,r=s.c,q=s.b,p=s.b=q+1
r.$flags&2&&A.b(r)
t=r.length
if(!(q<t))return A.a(r,q)
r[q]=239
q=s.b=p+1
if(!(p<t))return A.a(r,p)
r[p]=191
s.b=q+1
if(!(q<t))return A.a(r,q)
r[q]=189},
dm(a,b){var t,s,r,q,p,o=this
if((b&64512)===56320){t=65536+((a&1023)<<10)|b&1023
s=o.c
r=o.b
q=o.b=r+1
s.$flags&2&&A.b(s)
p=s.length
if(!(r<p))return A.a(s,r)
s[r]=t>>>18|240
r=o.b=q+1
if(!(q<p))return A.a(s,q)
s[q]=t>>>12&63|128
q=o.b=r+1
if(!(r<p))return A.a(s,r)
s[r]=t>>>6&63|128
o.b=q+1
if(!(q<p))return A.a(s,q)
s[q]=t&63|128
return!0}else{o.bL()
return!1}},
cX(a,b,c){var t,s,r,q,p,o,n,m,l=this
if(b!==c){t=c-1
if(!(t>=0&&t<a.length))return A.a(a,t)
t=(a.charCodeAt(t)&64512)===55296}else t=!1
if(t)--c
for(t=l.c,s=t.$flags|0,r=t.length,q=a.length,p=b;p<c;++p){if(!(p<q))return A.a(a,p)
o=a.charCodeAt(p)
if(o<=127){n=l.b
if(n>=r)break
l.b=n+1
s&2&&A.b(t)
t[n]=o}else{n=o&64512
if(n===55296){if(l.b+4>r)break
n=p+1
if(!(n<q))return A.a(a,n)
if(l.dm(o,a.charCodeAt(n)))p=n}else if(n===56320){if(l.b+3>r)break
l.bL()}else if(o<=2047){n=l.b
m=n+1
if(m>=r)break
l.b=m
s&2&&A.b(t)
if(!(n<r))return A.a(t,n)
t[n]=o>>>6|192
l.b=m+1
t[m]=o&63|128}else{n=l.b
if(n+2>=r)break
m=l.b=n+1
s&2&&A.b(t)
if(!(n<r))return A.a(t,n)
t[n]=o>>>12|224
n=l.b=m+1
if(!(m<r))return A.a(t,m)
t[m]=o>>>6&63|128
l.b=n+1
if(!(n<r))return A.a(t,n)
t[n]=o&63|128}}}return p}}
A.dv.prototype={
b4(a){return new A.fb(this.a).cO(u.L.a(a),0,null,!0)}}
A.fb.prototype={
cO(a,b,c,d){var t,s,r,q,p,o,n,m=this
u.L.a(a)
t=A.bI(b,c,a.length)
if(b===t)return""
if(a instanceof Uint8Array){s=a
r=s
q=0}else{r=A.lw(a,b,t)
t-=b
q=b
b=0}if(t-b>=15){p=m.a
o=A.lv(p,r,b,t)
if(o!=null){if(!p)return o
if(o.indexOf("\ufffd")<0)return o}}o=m.by(r,b,t,!0)
p=m.b
if((p&1)!==0){n=A.lx(p)
m.b=0
throw A.j(A.fF(n,a,q+m.c))}return o},
by(a,b,c,d){var t,s,r=this
if(c-b>1000){t=B.b.V(b+c,2)
s=r.by(a,b,t,!1)
if((r.b&1)!==0)return s
return s+r.by(a,t,c,d)}return r.dz(a,b,c,d)},
dz(a,b,c,a0){var t,s,r,q,p,o,n,m,l=this,k="AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFFFFFFFFFFFFFFFFGGGGGGGGGGGGGGGGHHHHHHHHHHHHHHHHHHHHHHHHHHHIHHHJEEBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBKCCCCCCCCCCCCDCLONNNMEEEEEEEEEEE",j=" \x000:XECCCCCN:lDb \x000:XECCCCCNvlDb \x000:XECCCCCN:lDb AAAAA\x00\x00\x00\x00\x00AAAAA00000AAAAA:::::AAAAAGG000AAAAA00KKKAAAAAG::::AAAAA:IIIIAAAAA000\x800AAAAA\x00\x00\x00\x00 AAAAA",i=65533,h=l.b,g=l.c,f=new A.bK(""),e=b+1,d=a.length
if(!(b>=0&&b<d))return A.a(a,b)
t=a[b]
A:for(s=l.a;;){for(;;e=p){if(!(t>=0&&t<256))return A.a(k,t)
r=k.charCodeAt(t)&31
g=h<=32?t&61694>>>r:(t&63|g<<6)>>>0
q=h+r
if(!(q>=0&&q<144))return A.a(j,q)
h=j.charCodeAt(q)
if(h===0){q=A.cr(g)
f.a+=q
if(e===c)break A
break}else if((h&1)!==0){if(s)switch(h){case 69:case 67:q=A.cr(i)
f.a+=q
break
case 65:q=A.cr(i)
f.a+=q;--e
break
default:q=A.cr(i)
f.a=(f.a+=q)+q
break}else{l.b=h
l.c=e-1
return""}h=0}if(e===c)break A
p=e+1
if(!(e>=0&&e<d))return A.a(a,e)
t=a[e]}p=e+1
if(!(e>=0&&e<d))return A.a(a,e)
t=a[e]
if(t<128){for(;;){if(!(p<c)){o=c
break}n=p+1
if(!(p>=0&&p<d))return A.a(a,p)
t=a[p]
if(t>=128){o=n-1
p=n
break}p=n}if(o-e<20)for(m=e;m<o;++m){if(!(m<d))return A.a(a,m)
q=A.cr(a[m])
f.a+=q}else{q=A.l3(a,e,o)
f.a+=q}if(o===c)break A
e=p}else e=p}if(a0&&h>32)if(s){d=A.cr(i)
f.a+=d}else{l.b=77
l.c=c
return""}l.b=h
l.c=g
d=f.a
return d.charCodeAt(0)==0?d:d}}
A.f1.prototype={
v(a){return this.aK()}}
A.F.prototype={}
A.cN.prototype={
v(a){var t=this.a
if(t!=null)return"Assertion failed: "+A.em(t)
return"Assertion failed"}}
A.cx.prototype={}
A.ae.prototype={
gbA(){return"Invalid argument"+(!this.a?"(s)":"")},
gbz(){return""},
v(a){var t=this,s=t.c,r=s==null?"":" ("+s+")",q=t.d,p=q==null?"":": "+A.C(q),o=t.gbA()+r+p
if(!t.a)return o
return o+t.gbz()+": "+A.em(t.gbO())},
gbO(){return this.b}}
A.cs.prototype={
gbO(){return A.im(this.b)},
gbA(){return"RangeError"},
gbz(){var t,s=this.e,r=this.f
if(s==null)t=r!=null?": Not less than or equal to "+A.C(r):""
else if(r==null)t=": Not greater than or equal to "+A.C(s)
else if(r>s)t=": Not in inclusive range "+A.C(s)+".."+A.C(r)
else t=r<s?": Valid value range is empty":": Only valid value is "+A.C(s)
return t}}
A.d1.prototype={
gbO(){return A.p(this.b)},
gbA(){return"RangeError"},
gbz(){if(A.p(this.b)<0)return": index must not be negative"
var t=this.f
if(t===0)return": no indices are valid"
return": index should be less than "+t},
gn(a){return this.f}}
A.cy.prototype={
v(a){return"Unsupported operation: "+this.a}}
A.ds.prototype={
v(a){return"UnimplementedError: "+this.a}}
A.bJ.prototype={
v(a){return"Bad state: "+this.a}}
A.cS.prototype={
v(a){var t=this.a
if(t==null)return"Concurrent modification during iteration."
return"Concurrent modification during iteration: "+A.em(t)+"."}}
A.cv.prototype={
v(a){return"Stack Overflow"},
$iF:1}
A.f2.prototype={
v(a){return"Exception: "+this.a}}
A.ep.prototype={
v(a){var t=this.a,s=""!==t?"FormatException: "+t:"FormatException",r=this.c
return r!=null?s+(" (at offset "+A.C(r)+")"):s}}
A.d.prototype={
gn(a){var t,s=this.gD(this)
for(t=0;s.H();)++t
return t},
aL(a,b){var t,s
A.ct(b,"index")
t=this.gD(this)
for(s=b;t.H();){if(s===0)return t.gL();--s}throw A.j(A.fH(b,b-s,this,"index"))},
v(a){return A.kF(this,"(",")")}}
A.ch.prototype={
gF(a){return A.x.prototype.gF.call(this,0)},
v(a){return"null"}}
A.x.prototype={$ix:1,
O(a,b){return this===b},
gF(a){return A.cq(this)},
v(a){return"Instance of '"+A.dl(this)+"'"},
ga6(a){return A.mr(this)},
toString(){return this.v(this)}}
A.eT.prototype={
gdB(){var t=this.gdC()
if($.hc()===1000)return t
return B.b.V(t,1000)},
cz(){var t=this,s=t.b
if(s!=null){t.a=t.a+($.eR.$0()-s)
t.b=null}},
gdC(){var t=this.b
if(t==null)t=$.eR.$0()
return t-this.a}}
A.bK.prototype={
gn(a){return this.a.length},
v(a){var t=this.a
return t.charCodeAt(0)==0?t:t}}
A.eI.prototype={
v(a){var t,s=this.a
if(s.length!==0){s="OS Error: "+s
t=this.b
if(t!==-1)s=s+", errno = "+B.b.v(t)}else{s=this.b
s=s!==-1?"OS Error: errno = "+B.b.v(s):"OS Error"}return s.charCodeAt(0)==0?s:s}}
A.bt.prototype={
bn(a){var t,s=this,r=s.a
if(r.length!==0){r=a+(": "+r)+(", path = '"+s.b+"'")
t=s.c
if(t!=null)r+=" ("+t.v(0)+")"}else{r=s.c
if(r!=null)r=a+(": "+r.v(0))+(", path = '"+s.b+"'")
else r=a+(": "+s.b)}return r.charCodeAt(0)==0?r:r},
v(a){return this.bn("FileSystemException")}}
A.df.prototype={
v(a){return this.bn("PathAccessException")}}
A.dg.prototype={
v(a){return this.bn("PathExistsException")}}
A.dh.prototype={
v(a){return this.bn("PathNotFoundException")}}
A.dx.prototype={
dZ(a){return A.l6(12,[null,this.b]).ei(new A.f3(this),u.S)},
e0(){A.l8(A.lb(),this.b,0)
var t=null},
dl(a,b){var t,s
u.L.a(a)
try{t=b.du(a)
return t}catch(s){t=A.hB("Failed to decode data using encoding 'utf-8'",this.a,null)
throw A.j(t)}},
v(a){return"File: '"+this.a+"'"}}
A.f3.prototype={
$1(a){A.lG(a,"Cannot retrieve length of file",this.a.a)
return a},
$S:15}
A.eo.prototype={}
A.eZ.prototype={}
A.fg.prototype={
cn(a,b){var t
u.L.a(a)
t=A.kS(B.L,32768)
this.dE(A.fI(a,B.T,null,null),t,b,!1,null)
return t.cq()},
dE(a,b,c,d,e){var t,s,r,q,p,o,n,m,l
b.a=B.L
t=(B.b.i(15,0,15)-8<<4|8)>>>0
b.N(t)
s=t*256
for(r=0;q=(r|0)>>>0,B.b.K(s+q,31)!==0;)++r
b.N(q)
p=a.c
o=A.mn(a)
a.c=p
q=c==null?6:c
A.jo(a,q,b,15)
q=o&255
n=o>>>24&255
m=o>>>16&255
l=o>>>8&255
if(b.a===B.L){b.N(n)
b.N(m)
b.N(l)
b.N(q)}else{b.N(q)
b.N(l)
b.N(m)
b.N(n)}}}
A.bM.prototype={
aK(){return"_DeflateFlushMode."+this.b}}
A.dJ.prototype={
d5(a,b){var t,s,r,q,p=this,o=!0
if(b>=9)if(b<=15)o=a>9
if(o)return!1
t=p.d4(a)
if(t==null)return!1
$.av.b=t
o=new Uint16Array(1146)
p.p1=o
s=new Uint16Array(122)
p.p2=s
r=new Uint16Array(78)
p.p3=r
p.as=b
q=p.Q=B.b.c8(1,b)
p.at=q-1
p.db=15
p.cy=32768
p.dx=32767
p.dy=5
p.ax=new Uint8Array(q*2)
p.ch=new Uint16Array(q)
p.CW=new Uint16Array(32768)
p.y1=16384
p.f=new Uint8Array(65536)
p.r=65536
p.bo=16384
p.xr=49152
p.k4=a
p.w=p.x=p.ok=0
p.c=113
p.d=0
q=p.p4
q.a=o
q.c=$.iY()
q=p.R8
q.a=s
q.c=$.iX()
q=p.RG
q.a=r
q.c=$.iW()
p.a9=p.ah=0
p.bg=8
p.c0()
p.ay=2*p.Q
B.n.bh(p.CW,0,p.cy,0)
p.k2=p.fr=p.id=0
p.fx=p.k3=2
p.cx=p.go=0
return!0},
cQ(a){var t,s,r,q,p=this,o=p.x
o===$&&A.c()
if(o!==0)p.bC()
o=p.a
t=o.c
o=o.d
o===$&&A.c()
s=!0
if(t>=o){o=p.k2
o===$&&A.c()
if(o===0)o=a!==B.K&&p.c!==666
else o=s}else o=s
if(o){switch($.av.bb().e){case 0:r=p.cT(a)
break
case 1:r=p.cR(a)
break
case 2:r=p.cS(a)
break
default:r=-1
break}o=r===2
if(o||r===3)p.c=666
if(r===0||o)return 0
if(r===1){if(a===B.bv){p.a0(2,3)
p.b1(256,B.J)
p.cj()
o=p.bg
o===$&&A.c()
t=p.a9
t===$&&A.c()
if(1+o+10-t<9){p.a0(2,3)
p.b1(256,B.J)
p.cj()}p.bg=7}else{p.cb(0,0,!1)
if(a===B.bw){o=p.cy
o===$&&A.c()
t=p.CW
q=0
for(;q<o;++q){t===$&&A.c()
t.$flags&2&&A.b(t)
if(!(q<t.length))return A.a(t,q)
t[q]=0}}}p.bC()}}if(a!==B.C)return 0
return 1},
c0(){var t=this,s=t.p1
s===$&&A.c()
B.n.bh(s,0,572,0)
s=t.p2
s===$&&A.c()
B.n.bh(s,0,60,0)
s=t.p3
s===$&&A.c()
B.n.bh(s,0,38,0)
s=t.p1
s.$flags&2&&A.b(s)
s[512]=1
t.y2=t.bp=t.aM=t.b5=0},
bJ(a,b){var t,s,r,q,p,o,n=this.ry
if(!(b>=0&&b<573))return A.a(n,b)
t=n[b]
s=b<<1>>>0
r=n.$flags|0
q=this.x2
for(;;){p=this.to
p===$&&A.c()
if(!(s<=p))break
if(s<p){p=s+1
if(!(p>=0&&p<573))return A.a(n,p)
p=n[p]
if(!(s>=0&&s<573))return A.a(n,s)
p=A.hn(a,p,n[s],q)}else p=!1
if(p)++s
if(!(s>=0&&s<573))return A.a(n,s)
if(A.hn(a,t,n[s],q))break
p=n[s]
r&2&&A.b(n)
if(!(b>=0&&b<573))return A.a(n,b)
n[b]=p
o=s<<1>>>0
b=s
s=o}r&2&&A.b(n)
if(!(b>=0&&b<573))return A.a(n,b)
n[b]=t},
c5(a,b){var t,s,r,q,p,o,n,m,l,k,j,i=a.length
if(1>=i)return A.a(a,1)
t=a[1]
if(t===0){s=138
r=3}else{s=7
r=4}q=(b+1)*2+1
a.$flags&2&&A.b(a)
if(!(q>=0&&q<i))return A.a(a,q)
a[q]=65535
for(q=this.p3,p=0,o=-1,n=0;p<=b;t=l){++p
m=p*2+1
if(!(m<i))return A.a(a,m)
l=a[m];++n
if(n<s&&t===l)continue
else{k=3
if(n<r){q===$&&A.c()
m=t*2
if(!(m<78))return A.a(q,m)
j=q[m]
q.$flags&2&&A.b(q)
q[m]=j+n}else if(t!==0){if(t!==o){q===$&&A.c()
m=t*2
if(!(m<78))return A.a(q,m)
j=q[m]
q.$flags&2&&A.b(q)
q[m]=j+1}q===$&&A.c()
m=q[32]
q.$flags&2&&A.b(q)
q[32]=m+1}else if(n<=10){q===$&&A.c()
m=q[34]
q.$flags&2&&A.b(q)
q[34]=m+1}else{q===$&&A.c()
m=q[36]
q.$flags&2&&A.b(q)
q[36]=m+1}}if(l===0){r=k
s=138}else if(t===l){r=k
s=6}else{s=7
r=4}o=t
n=0}},
cL(){var t,s,r=this,q=r.p1
q===$&&A.c()
t=r.p4.b
t===$&&A.c()
r.c5(q,t)
t=r.p2
t===$&&A.c()
q=r.R8.b
q===$&&A.c()
r.c5(t,q)
r.RG.bx(r)
for(q=r.p3,s=18;s>=3;--s){q===$&&A.c()
t=B.P[s]*2+1
if(!(t<78))return A.a(q,t)
if(q[t]!==0)break}q=r.aM
q===$&&A.c()
r.aM=q+(3*(s+1)+5+5+4)
return s},
di(a,b,c){var t,s,r,q,p=this
p.a0(a-257,5)
t=b-1
p.a0(t,5)
p.a0(c-4,4)
for(s=0;s<c;++s){r=p.p3
r===$&&A.c()
if(!(s<19))return A.a(B.P,s)
q=B.P[s]*2+1
if(!(q<78))return A.a(r,q)
p.a0(r[q],3)}r=p.p1
r===$&&A.c()
p.c6(r,a-1)
r=p.p2
r===$&&A.c()
p.c6(r,t)},
c6(a,b){var t,s,r,q,p,o,n,m,l,k,j,i,h,g=this,f=a.length
if(1>=f)return A.a(a,1)
t=a[1]
if(t===0){s=138
r=3}else{s=7
r=4}for(q=u.L,p=0,o=-1,n=0;p<=b;t=l){++p
m=p*2+1
if(!(m<f))return A.a(a,m)
l=a[m];++n
if(n<s&&t===l)continue
else{k=3
if(n<r){m=t*2
j=m+1
do{i=g.p3
i===$&&A.c()
q.a(i)
if(!(m<78))return A.a(i,m)
h=i[m]
if(!(j<78))return A.a(i,j)
g.a0(h&65535,i[j]&65535)}while(--n,n!==0)}else if(t!==0){if(t!==o){m=g.p3
m===$&&A.c()
q.a(m)
j=t*2
if(!(j<78))return A.a(m,j)
i=m[j];++j
if(!(j<78))return A.a(m,j)
g.a0(i&65535,m[j]&65535);--n}m=g.p3
m===$&&A.c()
q.a(m)
g.a0(m[32]&65535,m[33]&65535)
g.a0(n-3,2)}else{m=g.p3
if(n<=10){m===$&&A.c()
q.a(m)
g.a0(m[34]&65535,m[35]&65535)
g.a0(n-3,3)}else{m===$&&A.c()
q.a(m)
g.a0(m[36]&65535,m[37]&65535)
g.a0(n-11,7)}}}if(l===0){r=k
s=138}else if(t===l){r=k
s=6}else{s=7
r=4}o=t
n=0}},
df(a,b,c){var t,s,r=this
if(c===0)return
t=r.f
t===$&&A.c()
s=r.x
s===$&&A.c()
B.e.aI(t,s,s+c,a,b)
r.x=r.x+c},
au(a){var t,s=this.f
s===$&&A.c()
t=this.x
t===$&&A.c()
this.x=t+1
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a},
b1(a,b){var t,s,r
u.L.a(b)
t=a*2
s=b.length
if(!(t<s))return A.a(b,t)
r=b[t];++t
if(!(t<s))return A.a(b,t)
this.a0(r&65535,b[t]&65535)},
a0(a,b){var t,s=this,r=s.a9
r===$&&A.c()
t=s.ah
if(r>16-b){t===$&&A.c()
r=s.ah=(t|B.b.a8(a,r)&65535)>>>0
s.au(r)
s.au(A.X(r,8))
s.ah=A.X(a,16-s.a9)
s.a9=s.a9+(b-16)}else{t===$&&A.c()
s.ah=(t|B.b.a8(a,r)&65535)>>>0
s.a9=r+b}},
bc(a,b){var t,s,r,q,p,o=this,n=o.f
n===$&&A.c()
t=o.bo
t===$&&A.c()
s=o.y2
s===$&&A.c()
s=t+s*2
t=A.X(a,8)
n.$flags&2&&A.b(n)
if(!(s<n.length))return A.a(n,s)
n[s]=t
t=o.f
s=o.bo
n=o.y2
s=s+n*2+1
t.$flags&2&&A.b(t)
r=t.length
if(!(s<r))return A.a(t,s)
t[s]=a
s=o.xr
s===$&&A.c()
s+=n
if(!(s<r))return A.a(t,s)
t[s]=b
o.y2=n+1
if(a===0){n=o.p1
n===$&&A.c()
t=b*2
if(!(t>=0&&t<1146))return A.a(n,t)
s=n[t]
n.$flags&2&&A.b(n)
n[t]=s+1}else{n=o.bp
n===$&&A.c()
o.bp=n+1
n=o.p1
n===$&&A.c()
if(!(b>=0&&b<256))return A.a(B.O,b)
t=(B.O[b]+256+1)*2
if(!(t<1146))return A.a(n,t)
s=n[t]
n.$flags&2&&A.b(n)
n[t]=s+1
s=o.p2
s===$&&A.c()
t=A.i6(a-1)*2
if(!(t<122))return A.a(s,t)
n=s[t]
s.$flags&2&&A.b(s)
s[t]=n+1}n=o.y2
if((n&8191)===0){t=o.k4
t===$&&A.c()
t=t>2}else t=!1
if(t){q=n*8
n=o.id
n===$&&A.c()
t=o.fr
t===$&&A.c()
for(s=o.p2,p=0;p<30;++p){s===$&&A.c()
r=p*2
if(!(r<122))return A.a(s,r)
q+=s[r]*(5+B.I[p])}q=A.X(q,3)
s=o.bp
s===$&&A.c()
r=o.y2
if(s<r/2&&q<(n-t)/2)return!0
n=r}t=o.y1
t===$&&A.c()
return n===t-1},
bV(a,b){var t,s,r,q,p,o,n,m,l=this,k=u.L
k.a(a)
k.a(b)
k=l.y2
k===$&&A.c()
if(k!==0){t=0
do{k=l.f
k===$&&A.c()
s=l.bo
s===$&&A.c()
s+=t*2
r=k.length
if(!(s<r))return A.a(k,s)
q=k[s];++s
if(!(s<r))return A.a(k,s)
p=q<<8&65280|k[s]&255
s=l.xr
s===$&&A.c()
s+=t
if(!(s<r))return A.a(k,s)
o=k[s]&255;++t
if(p===0)l.b1(o,a)
else{n=B.O[o]
l.b1(n+256+1,a)
if(!(n<29))return A.a(B.N,n)
m=B.N[n]
if(m!==0)l.a0(o-B.aV[n],m);--p
n=A.i6(p)
l.b1(n,b)
if(!(n<30))return A.a(B.I,n)
m=B.I[n]
if(m!==0)l.a0(p-B.b3[n],m)}}while(t<l.y2)}l.b1(256,a)
if(513>=a.length)return A.a(a,513)
l.bg=a[513]},
cw(){var t,s,r,q,p
for(t=this.p1,s=0,r=0;s<7;){t===$&&A.c()
q=s*2
if(!(q<1146))return A.a(t,q)
r+=t[q];++s}for(p=0;s<128;){t===$&&A.c()
q=s*2
if(!(q<1146))return A.a(t,q)
p+=t[q];++s}while(s<256){t===$&&A.c()
q=s*2
if(!(q<1146))return A.a(t,q)
r+=t[q];++s}this.y=r>A.X(p,2)?0:1},
cj(){var t=this,s=t.a9
s===$&&A.c()
if(s===16){s=t.ah
s===$&&A.c()
t.au(s)
t.au(A.X(s,8))
t.a9=t.ah=0}else if(s>=8){s=t.ah
s===$&&A.c()
t.au(s)
t.ah=A.X(t.ah,8)
t.a9=t.a9-8}},
bT(){var t=this,s=t.a9
s===$&&A.c()
if(s>8){s=t.ah
s===$&&A.c()
t.au(s)
t.au(A.X(s,8))}else if(s>0){s=t.ah
s===$&&A.c()
t.au(s)}t.a9=t.ah=0},
aU(a){var t,s,r,q,p,o=this,n=o.fr
n===$&&A.c()
if(n>=0)t=n
else t=-1
s=o.id
s===$&&A.c()
n=s-n
s=o.k4
s===$&&A.c()
if(s>0){if(o.y===2)o.cw()
o.p4.bx(o)
o.R8.bx(o)
r=o.cL()
s=o.aM
s===$&&A.c()
q=A.X(s+3+7,3)
s=o.b5
s===$&&A.c()
p=A.X(s+3+7,3)
if(p<=q)q=p}else{p=n+5
q=p
r=0}if(n+4<=q&&t!==-1)o.cb(t,n,a)
else if(p===q){o.a0(2+(a?1:0),3)
o.bV(B.J,B.ab)}else{o.a0(4+(a?1:0),3)
n=o.p4.b
n===$&&A.c()
t=o.R8.b
t===$&&A.c()
o.di(n+1,t+1,r+1)
t=o.p1
t===$&&A.c()
n=o.p2
n===$&&A.c()
o.bV(t,n)}o.c0()
if(a)o.bT()
o.fr=o.id
o.bC()},
cT(a){var t,s,r,q,p,o=this,n=o.r
n===$&&A.c()
t=n-5
t=65535>t?t:65535
for(n=a===B.K;;){s=o.k2
s===$&&A.c()
if(s<=1){o.bB()
s=o.k2
r=s===0
if(r&&n)return 0
if(r)break}r=o.id
r===$&&A.c()
s=o.id=r+s
o.k2=0
r=o.fr
r===$&&A.c()
q=r+t
if(s>=q){o.k2=s-q
o.id=q
o.aU(!1)}s=o.id
r=o.fr
p=o.Q
p===$&&A.c()
if(s-r>=p-262)o.aU(!1)}n=a===B.C
o.aU(n)
return n?3:1},
cb(a,b,c){var t,s=this
s.a0(c?1:0,3)
s.bT()
s.bg=8
s.au(b)
s.au(A.X(b,8))
t=(~b>>>0)+65536&65535
s.au(t)
s.au(A.X(t,8))
t=s.ax
t===$&&A.c()
s.df(t,a,b)},
bB(){var t,s,r,q,p,o,n,m,l,k,j,i=this,h=i.a
do{t=i.ay
t===$&&A.c()
s=i.k2
s===$&&A.c()
r=i.id
r===$&&A.c()
q=t-s-r
if(q===0&&r===0&&s===0){t=i.Q
t===$&&A.c()
q=t}else{t=i.Q
t===$&&A.c()
if(r>=t+t-262){s=i.ax
s===$&&A.c()
B.e.aI(s,0,t,s,t)
t=i.k1
p=i.Q
i.k1=t-p
i.id=i.id-p
t=i.fr
t===$&&A.c()
i.fr=t-p
t=i.cy
t===$&&A.c()
s=i.CW
s===$&&A.c()
r=s.length
o=s.$flags|0
n=t
m=n
do{--n
if(!(n>=0&&n<r))return A.a(s,n)
l=s[n]&65535
t=l>=p?l-p:0
o&2&&A.b(s)
s[n]=t}while(--m,m!==0)
t=i.ch
t===$&&A.c()
s=t.length
r=t.$flags|0
n=p
m=n
do{--n
if(!(n>=0&&n<s))return A.a(t,n)
l=t[n]&65535
o=l>=p?l-p:0
r&2&&A.b(t)
t[n]=o}while(--m,m!==0)
q+=p}}t=h.c
s=h.d
s===$&&A.c()
if(t>=s)return
t=i.ax
t===$&&A.c()
m=i.dg(t,i.id+i.k2,q)
t=i.k2=i.k2+m
if(t>=3){s=i.ax
r=i.id
o=s.length
if(r>>>0!==r||r>=o)return A.a(s,r)
k=s[r]&255
i.cx=k
j=i.dy
j===$&&A.c()
j=B.b.a8(k,j);++r
if(!(r<o))return A.a(s,r)
r=s[r]
s=i.dx
s===$&&A.c()
i.cx=((j^r&255)&s)>>>0}}while(t<262&&!(h.c>=h.d))},
cR(a){var t,s,r,q,p,o,n,m,l,k,j=this
for(t=a===B.K,s=0;;){r=j.k2
r===$&&A.c()
if(r<262){j.bB()
r=j.k2
if(r<262&&t)return 0
if(r===0)break}if(r>=3){r=j.cx
r===$&&A.c()
q=j.dy
q===$&&A.c()
q=B.b.a8(r,q)
r=j.ax
r===$&&A.c()
p=j.id
p===$&&A.c()
o=p+2
if(!(o>=0&&o<r.length))return A.a(r,o)
o=r[o]
r=j.dx
r===$&&A.c()
r=((q^o&255)&r)>>>0
j.cx=r
o=j.CW
o===$&&A.c()
if(!(r<o.length))return A.a(o,r)
q=o[r]
s=q&65535
n=j.ch
n===$&&A.c()
m=j.at
m===$&&A.c()
m=(p&m)>>>0
n.$flags&2&&A.b(n)
if(!(m>=0&&m<n.length))return A.a(n,m)
n[m]=q
o.$flags&2&&A.b(o)
o[r]=p}if(s!==0){r=j.id
r===$&&A.c()
q=j.Q
q===$&&A.c()
q=(r-s&65535)<=q-262
r=q}else r=!1
if(r){r=j.ok
r===$&&A.c()
if(r!==2)j.fx=j.c3(s)}r=j.fx
r===$&&A.c()
q=j.id
if(r>=3){q===$&&A.c()
l=j.bc(q-j.k1,r-3)
r=j.k2
q=j.fx
r-=q
j.k2=r
p=$.av.b
if(p===$.av)A.cL(A.eB(""))
if(q<=p.b&&r>=3){r=j.fx=q-1
do{q=j.id=j.id+1
p=j.cx
p===$&&A.c()
o=j.dy
o===$&&A.c()
o=B.b.a8(p,o)
p=j.ax
p===$&&A.c()
n=q+2
if(!(n>=0&&n<p.length))return A.a(p,n)
n=p[n]
p=j.dx
p===$&&A.c()
p=((o^n&255)&p)>>>0
j.cx=p
n=j.CW
n===$&&A.c()
if(!(p<n.length))return A.a(n,p)
o=n[p]
s=o&65535
m=j.ch
m===$&&A.c()
k=j.at
k===$&&A.c()
k=(q&k)>>>0
m.$flags&2&&A.b(m)
if(!(k>=0&&k<m.length))return A.a(m,k)
m[k]=o
n.$flags&2&&A.b(n)
n[p]=q}while(r=j.fx=r-1,r!==0)
j.id=q+1}else{r=j.id=j.id+q
j.fx=0
q=j.ax
q===$&&A.c()
p=q.length
if(!(r>=0&&r<p))return A.a(q,r)
o=q[r]&255
j.cx=o
n=j.dy
n===$&&A.c()
n=B.b.a8(o,n);++r
if(!(r<p))return A.a(q,r)
r=q[r]
q=j.dx
q===$&&A.c()
j.cx=((n^r&255)&q)>>>0}}else{r=j.ax
r===$&&A.c()
q===$&&A.c()
if(!(q>=0&&q<r.length))return A.a(r,q)
l=j.bc(0,r[q]&255)
j.k2=j.k2-1
j.id=j.id+1}if(l)j.aU(!1)}t=a===B.C
j.aU(t)
return t?3:1},
cS(a){var t,s,r,q,p,o,n,m,l,k,j,i=this
for(t=a===B.K,s=0;;){r=i.k2
r===$&&A.c()
if(r<262){i.bB()
r=i.k2
if(r<262&&t)return 0
if(r===0)break}if(r>=3){r=i.cx
r===$&&A.c()
q=i.dy
q===$&&A.c()
q=B.b.a8(r,q)
r=i.ax
r===$&&A.c()
p=i.id
p===$&&A.c()
o=p+2
if(!(o>=0&&o<r.length))return A.a(r,o)
o=r[o]
r=i.dx
r===$&&A.c()
r=((q^o&255)&r)>>>0
i.cx=r
o=i.CW
o===$&&A.c()
if(!(r<o.length))return A.a(o,r)
q=o[r]
s=q&65535
n=i.ch
n===$&&A.c()
m=i.at
m===$&&A.c()
m=(p&m)>>>0
n.$flags&2&&A.b(n)
if(!(m>=0&&m<n.length))return A.a(n,m)
n[m]=q
o.$flags&2&&A.b(o)
o[r]=p}r=i.fx
r===$&&A.c()
i.k3=r
i.fy=i.k1
i.fx=2
q=!1
if(s!==0){p=$.av.b
if(p===$.av)A.cL(A.eB(""))
if(r<p.b){r=i.id
r===$&&A.c()
q=i.Q
q===$&&A.c()
q=(r-s&65535)<=q-262
r=q}else r=q}else r=q
q=2
if(r){r=i.ok
r===$&&A.c()
if(r!==2){r=i.c3(s)
i.fx=r}else r=q
p=!1
if(r<=5)if(i.ok!==1){if(r===3){p=i.id
p===$&&A.c()
p=p-i.k1>4096}}else p=!0
if(p){i.fx=2
r=q}}else r=q
q=i.k3
if(q>=3&&r<=q){r=i.id
r===$&&A.c()
l=r+i.k2-3
k=i.bc(r-1-i.fy,q-3)
q=i.k2
r=i.k3
i.k2=q-(r-1)
r=i.k3=r-2
do{q=i.id=i.id+1
if(q<=l){p=i.cx
p===$&&A.c()
o=i.dy
o===$&&A.c()
o=B.b.a8(p,o)
p=i.ax
p===$&&A.c()
n=q+2
if(!(n>=0&&n<p.length))return A.a(p,n)
n=p[n]
p=i.dx
p===$&&A.c()
p=((o^n&255)&p)>>>0
i.cx=p
n=i.CW
n===$&&A.c()
if(!(p<n.length))return A.a(n,p)
o=n[p]
s=o&65535
m=i.ch
m===$&&A.c()
j=i.at
j===$&&A.c()
j=(q&j)>>>0
m.$flags&2&&A.b(m)
if(!(j>=0&&j<m.length))return A.a(m,j)
m[j]=o
n.$flags&2&&A.b(n)
n[p]=q}}while(r=i.k3=r-1,r!==0)
i.go=0
i.fx=2
i.id=q+1
if(k)i.aU(!1)}else{r=i.go
r===$&&A.c()
if(r!==0){r=i.ax
r===$&&A.c()
q=i.id
q===$&&A.c();--q
if(!(q>=0&&q<r.length))return A.a(r,q)
if(i.bc(0,r[q]&255))i.aU(!1)
i.id=i.id+1
i.k2=i.k2-1}else{i.go=1
r=i.id
r===$&&A.c()
i.id=r+1
i.k2=i.k2-1}}}t=i.go
t===$&&A.c()
if(t!==0){t=i.ax
t===$&&A.c()
r=i.id
r===$&&A.c();--r
if(!(r>=0&&r<t.length))return A.a(t,r)
i.bc(0,t[r]&255)
i.go=0}t=a===B.C
i.aU(t)
return t?3:1},
c3(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d=this,c=$.av.bb().d,b=d.id
b===$&&A.c()
t=d.k3
t===$&&A.c()
s=d.Q
s===$&&A.c()
s-=262
r=b>s?b-s:0
q=$.av.bb().c
s=d.at
s===$&&A.c()
p=d.id+258
o=d.ax
o===$&&A.c()
n=b+t
m=n-1
l=o.length
if(!(m>=0&&m<l))return A.a(o,m)
k=o[m]
if(!(n>=0&&n<l))return A.a(o,n)
j=o[n]
if(d.k3>=$.av.bb().a)c=c>>>2
o=d.k2
o===$&&A.c()
if(q>o)q=o
i=p-258
h=t
g=b
do{A:{b=d.ax
t=a+h
o=b.length
if(!(t>=0&&t<o))return A.a(b,t)
n=!0
if(b[t]===j){--t
if(!(t>=0))return A.a(b,t)
if(b[t]===k){if(!(a>=0&&a<o))return A.a(b,a)
t=b[a]
if(!(g>=0&&g<o))return A.a(b,g)
if(t===b[g]){f=a+1
if(!(f<o))return A.a(b,f)
t=b[f]
n=g+1
if(!(n<o))return A.a(b,n)
n=t!==b[n]
t=n}else{t=n
f=a}}else{t=n
f=a}}else{t=n
f=a}if(t)break A
g+=2;++f
do{++g
if(!(g>=0&&g<o))return A.a(b,g)
t=b[g];++f
if(!(f>=0&&f<o))return A.a(b,f)
n=!1
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
if(t===b[f]){++g
if(!(g<o))return A.a(b,g)
t=b[g];++f
if(!(f<o))return A.a(b,f)
t=t===b[f]&&g<p}else t=n}else t=n}else t=n}else t=n}else t=n}else t=n}else t=n}while(t)
e=258-(p-g)
if(e>h){d.k1=a
if(e>=q){h=e
break}b=d.ax
t=i+e
o=t-1
n=b.length
if(!(o>=0&&o<n))return A.a(b,o)
k=b[o]
if(!(t<n))return A.a(b,t)
j=b[t]
h=e}g=i}b=d.ch
b===$&&A.c()
t=a&s
if(!(t>=0&&t<b.length))return A.a(b,t)
a=b[t]&65535
if(a>r){--c
b=c!==0}else b=!1}while(b)
b=d.k2
if(h<=b)return h
return b},
dg(a,b,c){var t,s,r,q,p,o,n=this
if(c!==0){t=n.a
s=t.c
t=t.d
t===$&&A.c()
t=s>=t}else t=!0
if(t)return 0
r=n.a.e1(c)
q=r.gn(0)
if(q===0)return 0
p=r.e5()
o=p.length
if(q>o)q=o
B.e.aD(a,b,b+q,p)
n.e+=q
n.d=A.h2(p,n.d)
return q},
bC(){var t,s=this,r=s.x
r===$&&A.c()
t=s.f
t===$&&A.c()
s.b.e7(t,r)
t=s.w
t===$&&A.c()
s.w=t+r
r=s.x-r
s.x=r
if(r===0)s.w=0},
d4(a){switch(a){case 0:return new A.a4(0,0,0,0,0)
case 1:return new A.a4(4,4,8,4,1)
case 2:return new A.a4(4,5,16,8,1)
case 3:return new A.a4(4,6,32,32,1)
case 4:return new A.a4(4,4,16,16,2)
case 5:return new A.a4(8,16,32,32,2)
case 6:return new A.a4(8,16,128,128,2)
case 7:return new A.a4(8,32,128,256,2)
case 8:return new A.a4(32,128,258,1024,2)
case 9:return new A.a4(32,258,258,4096,2)}return null}}
A.a4.prototype={}
A.f4.prototype={
d3(a3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1=this,a2=a1.a
a2===$&&A.c()
t=a1.c
t===$&&A.c()
s=t.a
r=t.b
q=t.c
p=t.e
for(t=a3.rx,o=t.$flags|0,n=0;n<=15;++n){o&2&&A.b(t)
t[n]=0}m=a3.ry
l=a3.x1
l===$&&A.c()
if(!(l>=0&&l<573))return A.a(m,l)
k=m[l]*2+1
a2.$flags&2&&A.b(a2)
j=a2.length
if(!(k>=0&&k<j))return A.a(a2,k)
a2[k]=0
for(i=l+1,l=s!=null,k=r.length,h=0;i<573;++i){g=m[i]
f=g*2
e=f+1
if(!(e>=0&&e<j))return A.a(a2,e)
d=a2[e]*2+1
if(!(d<j))return A.a(a2,d)
n=a2[d]+1
if(n>p){++h
n=p}a2.$flags&2&&A.b(a2)
a2[e]=n
d=a1.b
d===$&&A.c()
if(g>d)continue
if(!(n<16))return A.a(t,n)
d=t[n]
o&2&&A.b(t)
t[n]=d+1
if(g>=q){d=g-q
if(!(d>=0&&d<k))return A.a(r,d)
c=r[d]}else c=0
if(!(f>=0&&f<j))return A.a(a2,f)
b=a2[f]
f=a3.aM
f===$&&A.c()
a3.aM=f+b*(n+c)
if(l){f=a3.b5
f===$&&A.c()
if(!(e<s.length))return A.a(s,e)
a3.b5=f+b*(s[e]+c)}}if(h===0)return
n=p-1
do{a=n
for(;;){if(!(a>=0&&a<16))return A.a(t,a)
l=t[a]
if(!(l===0))break;--a}o&2&&A.b(t)
t[a]=l-1
l=a+1
if(!(l<16))return A.a(t,l)
t[l]=t[l]+2
if(!(p<16))return A.a(t,p)
t[p]=t[p]-1
h-=2}while(h>0)
for(n=p;n!==0;--n){if(!(n>=0))return A.a(t,n)
g=t[n]
while(g!==0){--i
if(!(i>=0&&i<573))return A.a(m,i)
a0=m[i]
o=a1.b
o===$&&A.c()
if(a0>o)continue
o=a0*2
l=o+1
if(!(l>=0&&l<j))return A.a(a2,l)
k=a2[l]
if(k!==n){f=a3.aM
f===$&&A.c()
if(!(o>=0&&o<j))return A.a(a2,o)
a3.aM=f+(n-k)*a2[o]
a2.$flags&2&&A.b(a2)
a2[l]=n}--g}}},
bx(a0){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b=this,a=b.a
a===$&&A.c()
t=b.c
t===$&&A.c()
s=t.a
r=t.d
a0.to=0
a0.x1=573
for(t=a.length,q=a0.ry,p=q.$flags|0,o=a0.x2,n=o.$flags|0,m=a.$flags|0,l=0,k=-1;l<r;++l){j=l*2
if(!(j<t))return A.a(a,j)
if(a[j]!==0){j=++a0.to
p&2&&A.b(q)
if(!(j>=0&&j<573))return A.a(q,j)
q[j]=l
n&2&&A.b(o)
if(!(l<573))return A.a(o,l)
o[l]=0
k=l}else{++j
m&2&&A.b(a)
if(!(j<t))return A.a(a,j)
a[j]=0}}for(j=s!=null;i=a0.to,i<2;){++i
a0.to=i
if(k<2){++k
h=k}else h=0
p&2&&A.b(q)
if(!(i>=0))return A.a(q,i)
q[i]=h
i=h*2
m&2&&A.b(a)
if(!(i>=0&&i<t))return A.a(a,i)
a[i]=1
n&2&&A.b(o)
if(!(h>=0))return A.a(o,h)
o[h]=0
g=a0.aM
g===$&&A.c()
a0.aM=g-1
if(j){g=a0.b5
g===$&&A.c();++i
if(!(i<s.length))return A.a(s,i)
a0.b5=g-s[i]}}b.b=k
for(l=B.b.V(i,2);l>=1;--l)a0.bJ(a,l)
h=r
do{l=q[1]
j=a0.to--
if(!(j>=0&&j<573))return A.a(q,j)
j=q[j]
p&2&&A.b(q)
q[1]=j
a0.bJ(a,1)
f=q[1]
j=--a0.x1
if(!(j>=0&&j<573))return A.a(q,j)
q[j]=l;--j
a0.x1=j
if(!(j>=0))return A.a(q,j)
q[j]=f
j=h*2
i=l*2
if(!(i>=0&&i<t))return A.a(a,i)
g=a[i]
e=f*2
if(!(e>=0&&e<t))return A.a(a,e)
d=a[e]
m&2&&A.b(a)
if(!(j<t))return A.a(a,j)
a[j]=g+d
if(!(l>=0&&l<573))return A.a(o,l)
d=o[l]
if(!(f>=0&&f<573))return A.a(o,f)
g=o[f]
j=d>g?d:g
n&2&&A.b(o)
if(!(h<573))return A.a(o,h)
o[h]=j+1;++i;++e
if(!(e<t))return A.a(a,e)
a[e]=h
if(!(i<t))return A.a(a,i)
a[i]=h
c=h+1
q[1]=h
a0.bJ(a,1)
if(a0.to>=2){h=c
continue}else break}while(!0)
t=--a0.x1
p=q[1]
if(!(t>=0&&t<573))return A.a(q,t)
q[t]=p
b.d3(a0)
A.l9(a,k,a0.rx)}}
A.f7.prototype={}
A.cO.prototype={
aK(){return"ByteOrder."+this.b}}
A.d2.prototype={
gn(a){var t=this.b
return t==null?0:t.length-this.c},
cB(a,b){var t=this.b
if(t==null)return A.fI(A.q([],u.t),B.T,null,null)
return A.fI(t,this.a,a,b)},
e5(){var t,s,r,q=this,p=q.b
if(p==null)return new Uint8Array(0)
t=q.gn(0)
s=q.c
r=p.length
if(s+t>r)t=r-s
return J.U(B.e.gB(p),q.b.byteOffset+q.c,t)}}
A.d3.prototype={
e1(a){var t=this,s=t.cB(a,t.c)
t.c=t.c+s.gn(0)
return s}}
A.dd.prototype={
cq(){return J.U(B.e.gB(this.c),this.c.byteOffset,this.b)},
N(a){var t,s,r=this
if(r.b===r.c.length)r.dc()
t=r.c
s=r.b++
t.$flags&2&&A.b(t)
if(!(s>=0&&s<t.length))return A.a(t,s)
t[s]=a},
e7(a,b){var t,s,r,q,p=this
u.L.a(a)
if(b==null)b=a.length
while(t=p.b,s=t+b,r=p.c,q=r.length,s>q)p.c4(s-q)
B.e.aD(r,t,s,a)
p.b+=b},
c4(a){var t,s=this.c,r=s.length,q=r+(a==null?1:a),p=r===0?32768:r*2
if(p<q)p=q
t=new Uint8Array(p)
B.e.aD(t,0,r,s)
this.c=t},
dc(){return this.c4(null)},
gn(a){return this.b}}
A.de.prototype={}
A.dI.prototype={
aK(){return"Channel."+this.b}}
A.y.prototype={
H(){var t=this.b
return++this.a<t.gn(t)},
gL(){return this.b.k(0,this.a)}}
A.af.prototype={
aK(){return"ChannelOrder."+this.b}}
A.bh.prototype={
M(){return new A.bh(new Uint16Array(A.t(this.a)))},
gA(){return B.y},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=A.D(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){return this.gj()},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]}else t=0
return t},
gm(){var t,s=this.a
if(s.length>1){s=s[1]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
gl(){var t,s=this.a
if(s.length>2){s=s[2]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
gt(){var t,s=this.a
if(s.length>3){s=s[3]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){t=A.D(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=A.D(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=A.D(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=A.D(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bi.prototype={
M(){return new A.bi(new Float32Array(A.t(this.a)))},
gA(){return B.r},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t=this.a,s=t.length
if(b<s){t.$flags&2&&A.b(t)
if(!(b>=0))return A.a(t,b)
t[b]=c}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:1},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bj.prototype={
M(){return new A.bj(new Float64Array(A.t(this.a)))},
gA(){return B.t},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t=this.a,s=t.length
if(b<s){t.$flags&2&&A.b(t)
if(!(b>=0))return A.a(t,b)
t[b]=c}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:1},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bk.prototype={
M(){return new A.bk(new Int16Array(A.t(this.a)))},
gA(){return B.w},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=B.a.h(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:0},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){t=B.a.h(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bl.prototype={
M(){return new A.bl(new Int32Array(A.t(this.a)))},
gA(){return B.x},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=B.a.h(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:0},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){A.p(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bm.prototype={
M(){return new A.bm(new Int8Array(A.t(this.a)))},
gA(){return B.v},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=B.a.h(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:0},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){t=B.a.h(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bn.prototype={
M(){var t=this.b
t===$&&A.c()
return new A.bn(this.a,t)},
gA(){return B.o},
gJ(){return null},
aZ(a){var t
if(a<this.a){t=this.b
t===$&&A.c()
t=B.b.aV(t,7-a)&1}else t=0
return t},
b8(a,b){var t
if(a>=this.a)return
a=7-a
t=this.b
t===$&&A.c()
this.b=b!==0?(t|B.b.a8(1,a))>>>0:(t&~(B.b.a8(1,a)&255))>>>0},
k(a,b){return this.aZ(b)},
q(a,b,c){return this.b8(b,c)},
gI(){return this.aZ(0)},
gj(){return this.aZ(0)},
gm(){return this.aZ(1)},
gl(){return this.aZ(2)},
gt(){return this.aZ(3)},
gY(){return A.E(this)},
W(a){this.ab(a.gj(),a.gm(),a.gl(),a.gt())},
ab(a,b,c,d){var t=this
t.b8(0,a)
t.b8(1,b)
t.b8(2,c)
t.b8(3,d)},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
gn(a){return this.a}}
A.bo.prototype={
M(){return new A.bo(new Uint16Array(A.t(this.a)))},
gA(){return B.j},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=B.a.h(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:0},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){t=B.a.h(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.bp.prototype={
M(){var t=this.b
t===$&&A.c()
return new A.bp(this.a,t)},
gA(){return B.p},
gJ(){return null},
b_(a){var t
if(a<this.a){t=this.b
t===$&&A.c()
t=B.b.aV(t,6-(a<<1>>>0))&3}else t=0
return t},
b9(a,b){var t,s,r
if(a>=this.a)return
if(!(a>=0&&a<4))return A.a(B.a6,a)
t=B.a6[a]
s=B.a.h(b)
r=this.b
r===$&&A.c()
this.b=(r&t|B.b.a8(s&3,6-(a<<1>>>0)))>>>0},
k(a,b){return this.b_(b)},
q(a,b,c){return this.b9(b,c)},
gI(){return this.b_(0)},
gj(){return this.b_(0)},
gm(){return this.b_(1)},
gl(){return this.b_(2)},
gt(){return this.b_(3)},
gY(){return A.E(this)},
W(a){this.ab(a.gj(),a.gm(),a.gl(),a.gt())},
ab(a,b,c,d){var t=this
t.b9(0,a)
t.b9(1,b)
t.b9(2,c)
t.b9(3,d)},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
gn(a){return this.a}}
A.bq.prototype={
M(){return new A.bq(new Uint32Array(A.t(this.a)))},
gA(){return B.u},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=B.a.h(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:0},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){t=B.a.h(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.br.prototype={
M(){return new A.br(this.a,new Uint8Array(A.t(this.b)))},
gA(){return B.q},
gJ(){return null},
b0(a){var t,s
if(a<0||a>=this.a)t=0
else{t=this.b
s=t.length
if(a<2){if(0>=s)return A.a(t,0)
t=B.b.aV(t[0],4-(a<<2>>>0))&15}else{if(1>=s)return A.a(t,1)
t=B.b.aV(t[1],4-((a&1)<<2))&15}}return t},
ba(a,b){var t,s,r,q
if(a>=this.a)return
t=B.b.i(B.a.h(b),0,15)
if(a>1){a&=1
s=1}else s=0
if(a===0){r=this.b
if(!(s<r.length))return A.a(r,s)
q=r[s]
r.$flags&2&&A.b(r)
r[s]=(q&15|t<<4)>>>0}else if(a===1){r=this.b
if(!(s<r.length))return A.a(r,s)
q=r[s]
r.$flags&2&&A.b(r)
r[s]=(q&240|t)>>>0}},
k(a,b){return this.b0(b)},
q(a,b,c){return this.ba(b,c)},
gI(){return this.b0(0)},
gj(){return this.b0(0)},
gm(){return this.b0(1)},
gl(){return this.b0(2)},
gt(){return this.b0(3)},
gY(){return A.E(this)},
W(a){this.ab(a.gj(),a.gm(),a.gl(),a.gt())},
ab(a,b,c,d){var t=this
t.ba(0,a)
t.ba(1,b)
t.ba(2,c)
t.ba(3,d)},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
gn(a){return this.a}}
A.aL.prototype={
cF(a,b,c,d){var t,s=this.a
s.$flags&2&&A.b(s)
t=s.length
if(0>=t)return A.a(s,0)
s[0]=a
if(1>=t)return A.a(s,1)
s[1]=b
if(2>=t)return A.a(s,2)
s[2]=c
if(3>=t)return A.a(s,3)
s[3]=d},
M(){return new A.aL(new Uint8Array(A.t(this.a)))},
gA(){return B.h},
gn(a){return this.a.length},
gJ(){return null},
k(a,b){var t=this.a,s=t.length
if(b<s){if(!(b>=0))return A.a(t,b)
t=t[b]}else t=0
return t},
q(a,b,c){var t,s=this.a,r=s.length
if(b<r){t=B.a.h(c)
s.$flags&2&&A.b(s)
if(!(b>=0))return A.a(s,b)
s[b]=t}},
gI(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gj(){var t=this.a,s=t.length
if(s!==0){if(0>=s)return A.a(t,0)
t=t[0]}else t=0
return t},
gm(){var t=this.a
return t.length>1?t[1]:0},
gl(){var t=this.a
return t.length>2?t[2]:0},
gt(){var t=this.a
return t.length>3?t[3]:255},
gY(){return A.E(this)},
W(a){var t=a.gj(),s=this.a,r=s.length
if(r!==0){t=B.a.h(t)
s.$flags&2&&A.b(s)
if(0>=r)return A.a(s,0)
s[0]=t}t=a.gm()
if(r>1){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[1]=t}t=a.gl()
if(r>2){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[2]=t}t=a.gt()
if(r>3){t=B.a.h(t)
s.$flags&2&&A.b(s)
s[3]=t}},
gD(a){return new A.y(this)},
O(a,b){var t,s
if(b==null)return!1
t=!1
if(u.G.b(b))if(b.gn(b)===this.a.length){t=b.gF(b)
s=A.k(this,A.i(this).p("d.E"))
t=t===A.l(s)}return t},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1}
A.cR.prototype={}
A.T.prototype={
aK(){return"Format."+this.b}}
A.cX.prototype={
bj(a){var t=$.j4()
if(!t.b3(a))return"<unknown>"
return t.k(0,a).a},
v(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f=this
for(t=f.a,s=new A.W(t,t.r,t.e,A.i(t).p("W<1>")),r=u.S,q=u.r,p=u.N,o=u.P,n="";s.H();){m=s.d
n+=m+"\n"
l=t.k(0,m)
for(m=l.a,m=new A.W(m,m.r,m.e,A.i(m).p("W<1>"));m.H();){k=m.d
j=l.k(0,k)
n=j==null?n+("\t"+f.bj(k)+"\n"):n+("\t"+f.bj(k)+": "+j.v(0)+"\n")}for(m=l.b.a,k=new A.W(m,m.r,m.e,A.i(m).p("W<1>"));k.H();){i=k.d
n+=i+"\n"
if(!m.b3(i))m.q(0,i,new A.aO(A.aS(r,q),new A.bv(A.aS(p,o))))
h=m.k(0,i)
for(i=h.a,i=new A.W(i,i.r,i.e,A.i(i).p("W<1>"));i.H();){g=i.d
j=h.k(0,g)
n=j==null?n+("\t"+f.bj(g)+"\n"):n+("\t"+f.bj(g)+": "+j.v(0)+"\n")}}}return n.charCodeAt(0)==0?n:n}}
A.cY.prototype={}
A.bv.prototype={
cG(a){a.a.aG(0,new A.et(this))}}
A.et.prototype={
$2(a,b){var t
A.ak(a)
t=A.hE(u.P.a(b))
this.a.a.q(0,a,t)
return t},
$S:7}
A.aO.prototype={
dt(a){a.a.aG(0,new A.eu(this))
a.b.a.aG(0,new A.ev(this))},
k(a,b){var t=this.a.k(0,b)
return t}}
A.eu.prototype={
$2(a,b){var t
A.p(a)
t=u.r.a(b).M()
this.a.a.q(0,a,t)
return t},
$S:16}
A.ev.prototype={
$2(a,b){var t
A.ak(a)
t=A.hE(u.P.a(b))
this.a.b.a.q(0,a,t)
return t},
$S:7}
A.aw.prototype={
aK(){return"IfdValueType."+this.b}}
A.el.prototype={}
A.dk.prototype={
aK(){return"PngFilter."+this.b}}
A.eO.prototype={
aW(a){var t,s,r,q,p,o,n,m,l=this,k=8192,j=a.a
j=j==null?null:j.gaz()
if(!(j===!0&&a.gA()!==B.j))j=a.ga4()<8&&!a.gaN()&&a.gaH()>1
else j=!0
if(j)a=a.dr(B.h)
if(l.w==null){j=A.aU(!0,k)
l.w=j
j.aX(A.q([137,80,78,71,13,10,26,10],u.t))
t=A.aU(!0,k)
t.aA(a.gu())
t.aA(a.gC())
t.N(a.ga4())
if(a.gaN())j=3
else if(a.gaH()===1)j=0
else if(a.gaH()===2)j=4
else j=a.gaH()===3?2:6
t.N(j)
t.N(0)
t.N(0)
t.N(0)
j=l.w
j.toString
l.aE(j,"IHDR",J.U(B.e.gB(t.c),0,t.a))
j=a.c
if(j!=null){t=A.aU(!0,k)
t.aX(new A.bf(j.a))
t.N(0)
t.N(0)
t.aX(j.dq())
j=l.w
j.toString
l.aE(j,"iCCP",J.U(B.e.gB(t.c),0,t.a))}if(a.gaN()){j=l.a
if(j!=null){j=j.a
j===$&&A.c()
l.ce(j)}else{j=a.a
j=j==null?null:j.gJ()
j.toString
l.ce(j)}}if(l.r){t=A.aU(!0,k)
j=l.e
j===$&&A.c()
t.aA(j)
t.aA(l.c)
j=l.w
j.toString
l.aE(j,"acTL",J.U(B.e.gB(t.c),0,t.a))}}s=a.gaN()?1:a.gaH()
r=a.gA()===B.j?2:1
j=a.gu()
q=a.gC()
p=a.gC()
o=new Uint8Array(j*q*s*r+p)
l.cY(0,a,o)
n=B.X.cn(u.L.a(o),l.d)
j=a.d
if(j!=null)for(j=new A.W(j,j.r,j.e,A.i(j).p("W<1>"));j.H();){q=j.d
p=a.d.k(0,q)
p.toString
t=new A.dc(!0,new Uint8Array(8192))
t.aX(B.W.b4(q))
t.N(0)
t.aX(B.W.b4(p))
q=l.w
q.toString
l.aE(q,"tEXt",J.U(B.e.gB(t.c),0,t.a))}if(l.r){t=A.aU(!0,k)
t.aA(l.f)
t.aA(a.gu())
t.aA(a.gC())
t.aA(0)
t.aA(0)
t.cp(a.y)
t.cp(1000)
t.N(1)
t.N(0)
j=l.w
j.toString
l.aE(j,"fcTL",J.U(B.e.gB(t.c),0,t.a));++l.f}if(l.f<=1){j=l.w
j.toString
l.aE(j,"IDAT",n)}else{m=A.aU(!0,k)
m.aA(l.f)
m.aX(n)
j=l.w
j.toString
l.aE(j,"fdAT",J.U(B.e.gB(m.c),0,m.a));++l.f}},
dR(){var t,s=this,r=s.w
if(r==null)return null
s.aE(r,"IEND",A.q([],u.t))
s.f=0
r=s.w
t=J.U(B.e.gB(r.c),0,r.a)
s.w=null
return t},
dD(a,b){var t,s,r,q,p,o=this,n=a.gZ().length
if(n<=1){o.e=1
o.r=!1
o.aW(a)}else{n=a.gZ().length
o.e=n
o.r=n>1
o.c=a.r
if(a.gaN()){t=new A.db(new Int32Array(256))
t.d6(256)
t.dn(a)
o.a=t
for(n=a.gZ(),s=n.length,r=0;r<n.length;n.length===s||(0,A.a0)(n),++r){q=n[r]
if(q!==a){t.c2(q)
t.bZ()
t.c1()
t.bW()}}}for(n=a.gZ(),s=n.length,r=0;r<n.length;n.length===s||(0,A.a0)(n),++r){q=n[r]
p=o.a
if(p!=null)o.aW(p.cr(q))
else o.aW(q)}}n=o.dR()
n.toString
return n},
ce(a){var t,s,r,q=this
if(a.gA()===B.h&&a.b===3&&a.a===256){t=q.w
t.toString
q.aE(t,"PLTE",J.U(a.gB(a),0,null))}else{t=a.a
s=A.aU(!0,t*3)
for(r=0;r<t;++r){s.N(B.a.h(a.an(r)))
s.N(B.a.h(a.am(r)))
s.N(B.a.h(a.al(r)))}t=q.w
t.toString
q.aE(t,"PLTE",J.U(B.e.gB(s.c),0,s.a))}if(a.b===4){t=a.a
s=A.aU(!0,t)
for(r=0;r<t;++r)s.N(B.a.h(a.aC(r)))
t=q.w
t.toString
q.aE(t,"tRNS",J.U(B.e.gB(s.c),0,s.a))}},
aE(a,b,c){u.L.a(c)
a.aA(c.length)
a.aX(new A.bf(b))
a.aX(c)
a.aA(A.h2(c,A.h2(new A.bf(b),0)))},
cY(a,b,c){var t,s,r=this,q=b.gaN()?B.bh:r.b,p=b.gB(0),o=b.a.gak(),n=b.gaN()?1:b.gaH(),m=B.b.G(n*b.ga4()+7,3),l=b.ga4()+7>>>3,k=q.a,j=J.dF(p),i=0,h=0,g=null,f=0
for(;;){t=b.a
t=t==null?null:t.b
if(!(f<(t==null?0:t)))break
s=j.be(p,h,o)
h+=o
switch(k){case 1:i=r.d1(s,l,m,c,i)
break
case 2:i=r.d2(s,g,l,c,i)
break
case 3:i=r.cZ(s,g,l,m,c,i)
break
case 4:i=r.d0(s,g,l,m,c,i)
break
default:i=r.d_(s,l,c,i)
break}++f
g=s}},
cd(a,b,c,d,e){var t,s,r,q;--a
for(t=b.length,s=d.$flags|0;a>=0;e=r){r=e+1
q=c+a
if(!(q<t))return A.a(b,q)
q=b[q]
s&2&&A.b(d)
if(!(e<d.length))return A.a(d,e)
d[e]=q;--a}return e},
d_(a,b,c,d){var t,s,r,q,p=d+1
c.$flags&2&&A.b(c)
t=c.length
if(!(d<t))return A.a(c,d)
c[d]=0
s=a.length
if(b===1)for(d=p,r=0;r<s;++r,d=p){p=d+1
q=a[r]
if(!(d<t))return A.a(c,d)
c[d]=q}else for(d=p,r=0;r<s;r+=b)d=this.cd(b,a,r,c,d)
return d},
d1(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k=e+1
d.$flags&2&&A.b(d)
t=d.length
if(!(e<t))return A.a(d,e)
d[e]=1
for(e=k,s=0;s<c;s+=b)e=this.cd(b,a,s,d,e)
r=a.length
for(q=b-1,p=d.$flags|0,s=c;s<r;s+=b)for(o=q,n=0;n<b;++n,--o,e=k){k=e+1
m=s+o
if(!(m>=0&&m<r))return A.a(a,m)
l=a[m]
m-=c
if(!(m>=0))return A.a(a,m)
m=a[m]
p&2&&A.b(d)
if(!(e>=0&&e<t))return A.a(d,e)
d[e]=l-m&255}return e},
d2(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k,j=e+1
d.$flags&2&&A.b(d)
t=d.length
if(!(e<t))return A.a(d,e)
d[e]=2
s=a.length
for(r=c-1,q=d.$flags|0,p=b!=null,e=j,o=0;o<s;o+=c)for(n=r,m=0;m<c;++m,--n,e=j){if(p){l=o+n
if(!(l>=0&&l<b.length))return A.a(b,l)
k=b[l]}else k=0
j=e+1
l=o+n
if(!(l>=0&&l<s))return A.a(a,l)
l=a[l]
q&2&&A.b(d)
if(!(e>=0&&e<t))return A.a(d,e)
d[e]=l-k&255}return e},
cZ(a,b,c,d,e,f){var t,s,r,q,p,o,n,m,l,k,j,i,h,g=f+1
e.$flags&2&&A.b(e)
t=e.length
if(!(f<t))return A.a(e,f)
e[f]=3
s=a.length
for(r=c-1,q=e.$flags|0,p=b==null,f=g,o=0;o<s;o+=c)for(n=r,m=0;m<c;++m,--n,f=g){l=o+n
if(l<d)k=0
else{j=l-d
if(!(j>=0&&j<s))return A.a(a,j)
k=a[j]}if(p)i=0
else{if(!(l>=0&&l<b.length))return A.a(b,l)
i=b[l]}if(!(l>=0&&l<s))return A.a(a,l)
h=a[l]
g=f+1
q&2&&A.b(e)
if(!(f>=0&&f<t))return A.a(e,f)
e[f]=h-(k+i>>>1)}return f},
dd(a,b,c){var t=a+b-c,s=t>a?t-a:a-t,r=t>b?t-b:b-t,q=t>c?t-c:c-t
if(s<=r&&s<=q)return a
else if(r<=q)return b
return c},
d0(a,b,c,a0,a1,a2){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d=a2+1
a1.$flags&2&&A.b(a1)
t=a1.length
if(!(a2<t))return A.a(a1,a2)
a1[a2]=4
s=a.length
for(r=c-1,q=a1.$flags|0,p=b==null,a2=d,o=0;o<s;o+=c)for(n=r,m=0;m<c;++m,--n,a2=d){l=o+n
k=l<a0
if(k)j=0
else{i=l-a0
if(!(i>=0&&i<s))return A.a(a,i)
j=a[i]}if(p)h=0
else{if(!(l>=0&&l<b.length))return A.a(b,l)
h=b[l]}if(k||p)g=0
else{k=l-a0
if(!(k>=0&&k<b.length))return A.a(b,k)
g=b[k]}if(!(l>=0&&l<s))return A.a(a,l)
f=a[l]
e=this.dd(j,h,g)
d=a2+1
q&2&&A.b(a1)
if(!(a2>=0&&a2<t))return A.a(a1,a2)
a1[a2]=f-e&255}return a2}}
A.es.prototype={
aK(){return"IccProfileCompression."+this.b}}
A.cZ.prototype={
dq(){var t,s=this
if(s.b===B.a1)return s.c
t=B.X.cn(u.L.a(s.c),null)
s.c=t
s.b=B.a1
return t}}
A.eq.prototype={
aK(){return"FrameType."+this.b}}
A.ax.prototype={
gZ(){var t=this.x
return t===$?this.x=A.q([],u.g):t},
cJ(a,b,c,d){var t,s,r,q=this,p=a.gA(),o=a.gaH(),n=a.a
q.bX(d,b,p,o,n==null?null:n.gJ())
p=a.b
if(p!=null)q.b=A.da(p,u.N,u.I)
p=a.d
if(p!=null){o=u.N
q.d=A.da(p,o,o)}B.c.E(q.gZ(),q)
if(!c){t=a.gZ().length
for(p=u.g,s=1;s<t;++s){r=a.x
if(r===$)r=a.x=A.q([],p)
if(!(s<r.length))return A.a(r,s)
q.aW(A.d_(r[s],b,!1,d))}}},
cH(a,b,c){var t,s,r,q,p=this,o=a.b
if(o!=null)p.b=A.da(o,u.N,u.I)
o=a.d
if(o!=null){t=u.N
p.d=A.da(o,t,t)}B.c.E(p.gZ(),p)
if(!b&&a.gZ().length>1){s=a.gZ().length
for(o=u.g,r=1;r<s;++r){q=a.x
if(q===$)q=a.x=A.q([],o)
if(!(r<q.length))return A.a(q,r)
p.aW(A.aP(q[r],!1,!1))}}},
cI(a,b,c,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d=this
B.c.E(d.gZ(),d)
if(a8>4)throw A.j(A.kD("An Image can only have 1-4 channels."))
if(a8===1)a9=B.ay
else if(a8===2)a9=B.ax
else if(a8===3){if(a9!==B.E&&a9!==B.a0)a9=B.E}else if(a8===4)if(a9!==B.Y&&a9!==B.D&&a9!==B.Z&&a9!==B.a_)a9=B.D
d.c_(b4,a5,a0,a1,a6,a8,b0,b1,!1)
t=d.a
if(t==null)return
s=J.j8(t.gB(t))
r=J.U(b,c,null)
if(a1===B.o)b2=B.a.av(b4*a8/8)
else if(a1===B.p){t=B.a.av(b4*a8/4)
b2=t}else{t=b4*a8
if(a1===B.q)t=B.a.av(t/2)
else{q=B.be.k(0,a1)
q.toString
q=t*q
t=q}b2=t}p=d.a.gak()
o=Math.min(b2,p)
for(n=0,m=0,l=0;l<a5;++l,m+=b2,n+=p){k=r.BYTES_PER_ELEMENT
j=A.bI(m,m+o,B.b.X(r.byteLength,k))
B.e.aD(s,n,n+o,J.U(B.e.gB(r),r.byteOffset+m*k,(j-m)*k))}if(a8===3&&a9===B.a0)for(t=d.a,t=t.gD(t);t.H();){i=t.gL()
h=i.gj()
i.sj(i.gl())
i.sl(h)}else{t=a8===4
if(t&&a9===B.Z)for(t=d.a,t=t.gD(t);t.H();){i=t.gL()
h=i.gj()
g=i.gm()
f=i.gl()
i.sj(i.gt())
i.sm(f)
i.sl(g)
i.st(h)}else if(t&&a9===B.a_)for(t=d.a,t=t.gD(t);t.H();){i=t.gL()
h=i.gj()
g=i.gm()
f=i.gl()
i.sj(i.gt())
i.sm(h)
i.sl(g)
i.st(f)}else if(t&&a9===B.Y)for(t=d.a,t=t.gD(t);t.H();){i=t.gL()
h=i.gj()
g=i.gm()
f=i.gl()
e=i.gt()
i.sj(f)
i.sm(g)
i.sl(h)
i.st(e)}}},
aW(a){var t=this
if(a==null)a=A.aP(t,!0,!0)
a.z=t.gZ().length
if(t.gZ().length===0||B.c.gdX(t.gZ())!==a)B.c.E(t.gZ(),a)
return a},
bd(){return this.aW(null)},
c_(a,b,c,d,e,f,g,h,i){var t,s=this
s.c=e
if(c!=null)s.e=A.en(c)
t=!1
if(g==null)if(i)t=s.gA()===B.o||s.gA()===B.p||s.gA()===B.q||s.gA()===B.h||s.gA()===B.j
s.bX(a,b,d,f,t?s.cP(d,h,f):g)},
bX(a,b,c,d,e){var t,s,r=this,q=null
switch(c.a){case 0:if(e==null){t=B.a.av(a*d/8)
s=new A.bw($,t,q,a,b,d)
t=Math.max(t*b,1)
s.d=new Uint8Array(t)
r.a=s}else{t=B.a.av(a/8)
s=new A.bw($,t,e,a,b,1)
t=Math.max(t*b,1)
s.d=new Uint8Array(t)
r.a=s}break
case 1:if(e==null){t=B.a.av(a*(d<<1>>>0)/8)
s=new A.by($,t,q,a,b,d)
t=Math.max(t*b,1)
s.d=new Uint8Array(t)
r.a=s}else{t=B.a.av(a/4)
s=new A.by($,t,e,a,b,1)
t=Math.max(t*b,1)
s.d=new Uint8Array(t)
r.a=s}break
case 2:if(e==null){if(d===2)t=a
else if(d===4)t=a*2
else t=d===3?B.a.av(a*1.5):B.a.av(a/2)
s=new A.bz($,t,q,a,b,d)
t=Math.max(t*b,1)
s.d=new Uint8Array(t)
r.a=s}else{t=B.a.av(a/2)
s=new A.bz($,t,e,a,b,1)
t=Math.max(t*b,1)
s.d=new Uint8Array(t)
r.a=s}break
case 3:if(e==null)r.a=A.hH(a,b,d)
else r.a=new A.ao(new Uint8Array(a*b),e,a,b,1)
break
case 4:t=a*b
if(e==null)r.a=new A.bx(new Uint16Array(t*d),q,a,b,d)
else r.a=new A.bx(new Uint16Array(t),e,a,b,1)
break
case 5:r.a=A.kC(a,b,d)
break
case 6:r.a=new A.c3(new Int8Array(a*b*d),a,b,d)
break
case 7:r.a=new A.c1(new Int16Array(a*b*d),a,b,d)
break
case 8:r.a=new A.c2(new Int32Array(a*b*d),a,b,d)
break
case 9:r.a=A.kA(a,b,d)
break
case 10:r.a=A.kB(a,b,d)
break
case 11:r.a=new A.c0(new Float64Array(a*b*4*d),a,b,d)
break}},
v(a){var t=this
return"Image("+t.gu()+", "+t.gC()+", "+t.gA().b+", "+t.gaH()+")"},
gu(){var t=this.a
t=t==null?null:t.a
return t==null?0:t},
gC(){var t=this.a
t=t==null?null:t.b
return t==null?0:t},
gA(){var t=this.a
t=t==null?null:t.gA()
return t==null?B.h:t},
gD(a){var t=this.a
return t.gD(t)},
gB(a){var t=this.a
t=t==null?null:t.gB(t)
if(t==null)t=B.e.gB(new Uint8Array(0))
return t},
gaH(){var t=this.a
t=t==null?null:t.gJ()
t=t==null?null:t.b
if(t==null){t=this.a
t=t==null?null:t.c}return t==null?0:t},
gaN(){var t=this.a
return(t==null?null:t.gJ())!=null},
ga4(){var t=this.a
t=t==null?null:t.ga4()
return t==null?0:t},
a7(a,b,c,d){var t=this.a
t=t==null?null:t.a7(a,b,c,d)
if(t==null)t=new A.aL(new Uint8Array(0))
return t},
S(a,b,c){var t=this.a
t=t==null?null:t.S(a,b,c)
return t==null?new A.A():t},
aa(a,b){return this.S(a,b,null)},
a_(a,b){if(a<0||a>=this.gu()||b<0||b>=this.gC())return new A.A()
return this.S(a,b,null)},
ct(a,b,c){switch(c.a){case 0:return this.a_(B.a.h(a),B.a.h(b))
case 1:case 3:return this.cu(a,b)
case 2:return this.cs(a,b)}},
cu(a,b){var t,s,r,q,p,o,n=this,m=B.a.h(a),l=m-(a>=0?0:1),k=l+1
m=B.a.h(b)
t=m-(b>=0?0:1)
s=t+1
m=new A.ey(a-l,b-t)
r=n.a_(l,t)
q=s>=n.gC()?r:n.a_(l,s)
p=k>=n.gu()?r:n.a_(k,t)
o=k>=n.gu()||s>=n.gC()?r:n.a_(k,s)
return n.a7(m.$4(r.gj(),p.gj(),q.gj(),o.gj()),m.$4(r.gm(),p.gm(),q.gm(),o.gm()),m.$4(r.gl(),p.gl(),q.gl(),o.gl()),m.$4(r.gt(),p.gt(),q.gt(),o.gt()))},
cs(d1,d2){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,b0,b1,b2,b3,b4,b5,b6,b7,b8,b9,c0,c1,c2,c3,c4,c5=this,c6=B.a.h(d1),c7=c6-(d1>=0?0:1),c8=c7-1,c9=c7+1,d0=c7+2
c6=B.a.h(d2)
t=c6-(d2>=0?0:1)
s=t-1
r=t+1
q=t+2
p=d1-c7
o=d2-t
c6=new A.ex()
n=c5.a_(c7,t)
m=c8<0
l=!m
k=!l||s<0?n:c5.a_(c8,s)
j=m?n:c5.a_(c7,s)
i=s<0
h=i||c9>=c5.gu()?n:c5.a_(c9,s)
g=d0>=c5.gu()||i?n:c5.a_(d0,s)
f=c6.$5(p,k.gj(),j.gj(),h.gj(),g.gj())
e=c6.$5(p,k.gm(),j.gm(),h.gm(),g.gm())
d=c6.$5(p,k.gl(),j.gl(),h.gl(),g.gl())
c=c6.$5(p,k.gt(),j.gt(),h.gt(),g.gt())
b=m?n:c5.a_(c8,t)
a=c9>=c5.gu()?n:c5.a_(c9,t)
a0=d0>=c5.gu()?n:c5.a_(d0,t)
a1=c6.$5(p,b.gj(),n.gj(),a.gj(),a0.gj())
a2=c6.$5(p,b.gm(),n.gm(),a.gm(),a0.gm())
a3=c6.$5(p,b.gl(),n.gl(),a.gl(),a0.gl())
a4=c6.$5(p,b.gt(),n.gt(),a.gt(),a0.gt())
a5=!l||r>=c5.gC()?n:c5.a_(c8,r)
a6=r>=c5.gC()?n:c5.a_(c7,r)
a7=c9>=c5.gu()||r>=c5.gC()?n:c5.a_(c9,r)
a8=d0>=c5.gu()||r>=c5.gC()?n:c5.a_(d0,r)
a9=c6.$5(p,a5.gj(),a6.gj(),a7.gj(),a8.gj())
b0=c6.$5(p,a5.gm(),a6.gm(),a7.gm(),a8.gm())
b1=c6.$5(p,a5.gl(),a6.gl(),a7.gl(),a8.gl())
b2=c6.$5(p,a5.gt(),a6.gt(),a7.gt(),a8.gt())
b3=!l||q>=c5.gC()?n:c5.a_(c8,q)
b4=q>=c5.gC()?n:c5.a_(c7,q)
b5=c9>=c5.gu()||q>=c5.gC()?n:c5.a_(c9,q)
b6=d0>=c5.gu()||q>=c5.gC()?n:c5.a_(d0,q)
b7=c6.$5(p,b3.gj(),b4.gj(),b5.gj(),b6.gj())
b8=c6.$5(p,b3.gm(),b4.gm(),b5.gm(),b6.gm())
b9=c6.$5(p,b3.gl(),b4.gl(),b5.gl(),b6.gl())
c0=c6.$5(p,b3.gt(),b4.gt(),b5.gt(),b6.gt())
c1=c6.$5(o,f,a1,a9,b7)
c2=c6.$5(o,e,a2,b0,b8)
c3=c6.$5(o,d,a3,b1,b9)
c4=c6.$5(o,c,a4,b2,c0)
return c5.a7(B.a.h(c1),B.a.h(c2),B.a.h(c3),B.a.h(c4))},
bk(a,b,c){var t
if(u.k.b(c))if(c.gai().gJ()!=null)if(this.gaN()){t=this.a
if(t!=null)t.a5(a,b,c.gI(),0,0)
return}t=this.a
if(t!=null)t.ao(a,b,c.gj(),c.gm(),c.gl(),c.gt())},
aT(a6,a7){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4=this,a5=null
if(a6==null)a6=a4.gA()
if(a7==null)a7=a4.gaH()
t=B.ag.k(0,a6)
s=!1
if(a6===a4.gA())if(a7===a4.gaH()){r=a4.a
s=(r==null?a5:r.gJ())==null}if(s){q=A.aP(a4,!1,!1)
return q}for(s=a4.gZ(),r=s.length,p=u.N,o=u.S,n=a5,m=0;m<s.length;s.length===r||(0,A.a0)(s),++m,n=e){l=s[m]
k=l.a
j=k==null
i=j?a5:k.a
if(i==null)i=0
k=j?a5:k.b
if(k==null)k=0
j=l.e
j=j==null?a5:A.en(j)
h=l.c
if(h==null)h=a5
else{g=h.a
f=h.b
h=h.c
h=new A.cZ(g,f,new Uint8Array(h.subarray(0,A.iq(0,a5,h.length))))}g=l.w
f=l.r
q=A.fG(a5,j,a6,l.y,g,k,h,f,a7,a5,B.h,i,!1)
k=l.d
q.se2(k!=null?A.da(k,p,p):a5)
if(n!=null){n.aW(q)
e=n}else e=q
k=q.a
d=k==null?a5:k.gJ()
k=q.a
k=k==null?a5:k.gJ()
c=k==null?a5:k.gA()
if(c==null)c=a6
k=l.a
if(d!=null){b=A.aS(o,o)
a=k==null?a5:k.S(0,0,a5)
if(a==null)a=new A.A()
for(k=q.a,k=k.gD(k),a0=a5,a1=0;k.H();){a2=k.gL()
a3=A.mJ(B.a.aF(a.gaj()*255),B.a.aF(a.gae()*255),B.a.aF(a.gag()*255),0)
if(b.b3(a3)){j=b.k(0,a3)
j.toString
a2.sI(j)}else{b.q(0,a3,a1)
a2.sI(a1)
a0=A.iA(a,t,c,a7,a0)
d.aJ(a1,a0.gj(),a0.gm(),a0.gl());++a1}a.H()}}else{a=k==null?a5:k.S(0,0,a5)
if(a==null)a=new A.A()
for(k=q.a,k=k.gD(k);k.H();){A.iA(a,t,a5,a5,k.gL())
a.H()}}}n.toString
return n},
dr(a){return this.aT(a,null)},
ds(a){return this.aT(null,a)},
cP(a,b,c){var t,s=65536
switch(b.a){case 0:return null
case 1:return null
case 2:return null
case 3:t=a===B.j?s:256
return new A.bH(new Uint8Array(t*c),t,c)
case 4:t=a===B.j?s:256
return new A.cp(new Uint16Array(t*c),t,c)
case 5:t=a===B.j?s:256
return new A.bG(new Uint32Array(t*c),t,c)
case 6:t=a===B.j?s:256
return new A.co(new Int8Array(t*c),t,c)
case 7:t=a===B.j?s:256
return new A.cm(new Int16Array(t*c),t,c)
case 8:t=a===B.j?s:256
return new A.cn(new Int32Array(t*c),t,c)
case 9:t=a===B.j?s:256
return new A.cj(new Uint16Array(t*c),t,c)
case 10:t=a===B.j?s:256
return new A.ck(new Float32Array(t*c),t,c)
case 11:t=a===B.j?s:256
return new A.cl(new Float64Array(t*c),t,c)}},
se2(a){this.d=u.w.a(a)}}
A.ey.prototype={
$4(a,b,c,d){var t=this.b
return a+this.a*(b-a+t*(a+d-c-b))+t*(c-a)},
$S:17}
A.ex.prototype={
$5(a,b,c,d,e){var t=-b,s=a*a
return c+0.5*(a*(t+d)+s*(2*b-5*c+4*d-e)+s*a*(t+3*c-3*d+e))},
$S:18}
A.L.prototype={
gJ(){return null}}
A.bZ.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Uint16Array(s.length)
else s=new Uint16Array(A.t(s))
return new A.bZ(s,t.a,t.b,t.c)},
gA(){return B.y},
gB(a){return B.n.gB(this.d)},
ga4(){return 16},
gak(){return this.a*this.c*2},
gD(a){return A.hO(this)},
gn(a){return this.d.byteLength},
gaz(){return!0},
a7(a,b,c,d){var t=new Uint16Array(4),s=new A.bh(t)
t[0]=A.D(a)
t[1]=A.D(b)
t[2]=A.D(c)
t[3]=A.D(d)
t=s
return t},
S(a,b,c){if(c==null||!(c instanceof A.aV)||c.d!==this)c=A.hO(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=A.D(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=A.D(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=A.D(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=A.D(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=A.D(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=A.D(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=A.D(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataFloat16("+this.a+", "+this.b+", "+this.c+")"}}
A.c_.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Float32Array(s.length)
else s=new Float32Array(A.t(s))
return new A.c_(s,t.a,t.b,t.c)},
gA(){return B.r},
gB(a){return B.Q.gB(this.d)},
ga4(){return 32},
gD(a){return A.hP(this)},
gn(a){return this.d.byteLength},
gak(){return this.a*this.c*4},
gaz(){return!0},
a7(a,b,c,d){var t=new Float32Array(4),s=new A.bi(t)
t[0]=a
t[1]=b
t[2]=c
t[3]=d
t=s
return t},
S(a,b,c){if(c==null||!(c instanceof A.aW)||c.d!==this)c=A.hP(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=c
if(r>1){s=q+1
if(!(s<t))return A.a(p,s)
p[s]=d
if(r>2){r=q+2
if(!(r<t))return A.a(p,r)
p[r]=e}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=c
if(r>1){s=q+1
if(!(s<t))return A.a(p,s)
p[s]=d
if(r>2){s=q+2
if(!(s<t))return A.a(p,s)
p[s]=e
if(r>3){r=q+3
if(!(r<t))return A.a(p,r)
p[r]=f}}}},
v(a){return"ImageDataFloat32("+this.a+", "+this.b+", "+this.c+")"}}
A.c0.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Float64Array(s.length)
else s=new Float64Array(A.t(s))
return new A.c0(s,t.a,t.b,t.c)},
gA(){return B.t},
gB(a){return B.ah.gB(this.d)},
gn(a){return this.d.byteLength},
ga4(){return 64},
gD(a){return A.hQ(this)},
gak(){return this.a*this.c*8},
gaz(){return!0},
a7(a,b,c,d){var t=new Float64Array(4),s=new A.bj(t)
t[0]=a
t[1]=b
t[2]=c
t[3]=d
t=s
return t},
S(a,b,c){if(c==null||!(c instanceof A.aX)||c.d!==this)c=A.hQ(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=c
if(r>1){s=q+1
if(!(s<t))return A.a(p,s)
p[s]=d
if(r>2){r=q+2
if(!(r<t))return A.a(p,r)
p[r]=e}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=c
if(r>1){s=q+1
if(!(s<t))return A.a(p,s)
p[s]=d
if(r>2){s=q+2
if(!(s<t))return A.a(p,s)
p[s]=e
if(r>3){r=q+3
if(!(r<t))return A.a(p,r)
p[r]=f}}}},
v(a){return"ImageDataFloat64("+this.a+", "+this.b+", "+this.c+")"}}
A.c1.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Int16Array(s.length)
else s=new Int16Array(A.t(s))
return new A.c1(s,t.a,t.b,t.c)},
gA(){return B.w},
gB(a){return B.ai.gB(this.d)},
gD(a){return A.hR(this)},
gn(a){return this.d.byteLength},
gaz(){return!0},
ga4(){return 16},
gak(){return this.a*this.c*2},
a7(a,b,c,d){var t=B.a.h(a),s=B.a.h(b),r=B.a.h(c),q=B.a.h(d),p=new Int16Array(4),o=new A.bk(p)
p[0]=t
p[1]=s
p[2]=r
p[3]=q
t=o
return t},
S(a,b,c){if(c==null||!(c instanceof A.aY)||c.d!==this)c=A.hR(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=B.a.h(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=B.a.h(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=B.a.h(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataInt16("+this.a+", "+this.b+", "+this.c+")"}}
A.c2.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Int32Array(s.length)
else s=new Int32Array(A.t(s))
return new A.c2(s,t.a,t.b,t.c)},
gA(){return B.x},
gB(a){return B.aj.gB(this.d)},
ga4(){return 32},
gak(){return this.a*this.c*4},
gD(a){return A.hS(this)},
gn(a){return this.d.byteLength},
gaz(){return!0},
a7(a,b,c,d){var t=B.a.h(a),s=B.a.h(b),r=B.a.h(c),q=B.a.h(d),p=new Int32Array(4),o=new A.bl(p)
p[0]=t
p[1]=s
p[2]=r
p[3]=q
t=o
return t},
S(a,b,c){if(c==null||!(c instanceof A.aZ)||c.d!==this)c=A.hS(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=B.a.h(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=B.a.h(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=B.a.h(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataInt32("+this.a+", "+this.b+", "+this.c+")"}}
A.c3.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Int8Array(s.length)
else s=new Int8Array(A.t(s))
return new A.c3(s,t.a,t.b,t.c)},
gA(){return B.v},
gB(a){return B.ak.gB(this.d)},
gak(){return this.a*this.c},
gD(a){return A.hT(this)},
gn(a){return this.d.byteLength},
gaz(){return!0},
ga4(){return 8},
a7(a,b,c,d){var t=B.a.h(a),s=B.a.h(b),r=B.a.h(c),q=B.a.h(d),p=new Int8Array(4),o=new A.bm(p)
p[0]=t
p[1]=s
p[2]=r
p[3]=q
t=o
return t},
S(a,b,c){if(c==null||!(c instanceof A.b_)||c.d!==this)c=A.hT(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*(this.a*r)+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=B.a.h(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*(this.a*r)+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=B.a.h(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=B.a.h(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataInt8("+this.a+", "+this.b+", "+this.c+")"}}
A.bw.prototype={
eb(a,b,c){var t=Math.max(this.e*b,1)
t=new Uint8Array(t)
this.d!==$&&A.h9()
this.d=t},
aw(a){var t,s=this,r=s.d
if(a){r===$&&A.c()
r=new Uint8Array(r.length)}else{r===$&&A.c()
r=new Uint8Array(A.t(r))}t=s.f
t=t==null?null:t.M()
return new A.bw(r,s.e,t,s.a,s.b,s.c)},
gA(){return B.o},
gn(a){var t=this.d
t===$&&A.c()
return t.byteLength},
gT(){var t=this.f
t=t==null?null:t.gT()
return t==null?1:t},
gaz(){return!1},
gB(a){var t=this.d
t===$&&A.c()
return B.e.gB(t)},
ga4(){return 1},
gD(a){return A.eL(this)},
a7(a,b,c,d){var t=new A.bn(4,0)
t.ab(B.a.h(a),B.a.h(b),B.a.h(c),B.a.h(d))
return t},
S(a,b,c){if(c==null||!(c instanceof A.b0)||c.f!==this)c=A.eL(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s=this
if(s.c<1)return
t=s.r;(t==null?s.r=A.eL(s):t).U(a,b)
s.r.b6(c,d,e)},
ao(a,b,c,d,e,f){var t,s=this
if(s.c<1)return
t=s.r;(t==null?s.r=A.eL(s):t).U(a,b)
s.r.ab(c,d,e,f)},
v(a){return"ImageDataUint1("+this.a+", "+this.b+", "+this.c+")"},
gak(){return this.e},
gJ(){return this.f}}
A.bx.prototype={
aw(a){var t,s=this,r=s.d
if(a)r=new Uint16Array(r.length)
else r=new Uint16Array(A.t(r))
t=s.e
t=t==null?null:t.M()
return new A.bx(r,t,s.a,s.b,s.c)},
gA(){return B.j},
gB(a){return B.n.gB(this.d)},
ga4(){return 16},
gT(){var t=this.e
t=t==null?null:t.gT()
return t==null?65535:t},
gak(){return this.a*this.c*2},
gD(a){return A.hU(this)},
gn(a){return this.d.byteLength},
gaz(){return!0},
a7(a,b,c,d){var t=B.a.h(a),s=B.a.h(b),r=B.a.h(c),q=B.a.h(d),p=new Uint16Array(4),o=new A.bo(p)
p[0]=t
p[1]=s
p[2]=r
p[3]=q
t=o
return t},
S(a,b,c){if(c==null||!(c instanceof A.b1)||c.d!==this)c=A.hU(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=B.a.h(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=B.a.h(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=B.a.h(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataUint16("+this.a+", "+this.b+", "+this.c+")"},
gJ(){return this.e}}
A.by.prototype={
ec(a,b,c){var t=Math.max(this.e*b,1)
t=new Uint8Array(t)
this.d!==$&&A.h9()
this.d=t},
aw(a){var t,s=this,r=s.d
if(a){r===$&&A.c()
r=new Uint8Array(r.length)}else{r===$&&A.c()
r=new Uint8Array(A.t(r))}t=s.f
t=t==null?null:t.M()
return new A.by(r,s.e,t,s.a,s.b,s.c)},
gA(){return B.p},
ga4(){return 2},
gB(a){var t=this.d
t===$&&A.c()
return B.e.gB(t)},
gD(a){return A.eM(this)},
gn(a){var t=this.d
t===$&&A.c()
return t.byteLength},
gT(){var t=this.f
t=t==null?null:t.gT()
return t==null?3:t},
gaz(){return!1},
a7(a,b,c,d){var t=new A.bp(4,0)
t.ab(B.a.h(a),B.a.h(b),B.a.h(c),B.a.h(d))
return t},
S(a,b,c){if(c==null||!(c instanceof A.b2)||c.f!==this)c=A.eM(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s=this
if(s.c<1)return
t=s.r;(t==null?s.r=A.eM(s):t).U(a,b)
s.r.b6(c,d,e)},
ao(a,b,c,d,e,f){var t,s=this
if(s.c<1)return
t=s.r;(t==null?s.r=A.eM(s):t).U(a,b)
s.r.ab(c,d,e,f)},
v(a){return"ImageDataUint2("+this.a+", "+this.b+", "+this.c+")"},
gak(){return this.e},
gJ(){return this.f}}
A.c4.prototype={
aw(a){var t=this,s=t.d
if(a)s=new Uint32Array(s.length)
else s=new Uint32Array(A.t(s))
return new A.c4(s,t.a,t.b,t.c)},
gA(){return B.u},
gB(a){return B.R.gB(this.d)},
gak(){return this.a*this.c*4},
ga4(){return 32},
gD(a){return A.hV(this)},
gn(a){return this.d.byteLength},
gaz(){return!0},
a7(a,b,c,d){var t=B.a.h(a),s=B.a.h(b),r=B.a.h(c),q=B.a.h(d),p=new Uint32Array(4),o=new A.bq(p)
p[0]=t
p[1]=s
p[2]=r
p[3]=q
t=o
return t},
S(a,b,c){if(c==null||!(c instanceof A.b3)||c.d!==this)c=A.hV(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=B.a.h(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*this.a*r+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=B.a.h(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=B.a.h(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataUint32("+this.a+", "+this.b+", "+this.c+")"}}
A.bz.prototype={
ed(a,b,c){var t=Math.max(this.e*b,1)
t=new Uint8Array(t)
this.d!==$&&A.h9()
this.d=t},
aw(a){var t,s=this,r=s.d
if(a){r===$&&A.c()
r=new Uint8Array(r.length)}else{r===$&&A.c()
r=new Uint8Array(A.t(r))}t=s.f
t=t==null?null:t.M()
return new A.bz(r,s.e,t,s.a,s.b,s.c)},
gA(){return B.q},
gB(a){var t=this.d
t===$&&A.c()
return B.e.gB(t)},
gD(a){return A.eN(this)},
gn(a){var t=this.d
t===$&&A.c()
return t.byteLength},
gT(){var t=this.f
t=t==null?null:t.gT()
return t==null?15:t},
gaz(){return!1},
ga4(){return 4},
a7(a,b,c,d){var t=B.a.h(a),s=B.a.h(b),r=B.a.h(c),q=B.a.h(d),p=new A.br(4,new Uint8Array(2))
p.ab(t,s,r,q)
t=p
return t},
S(a,b,c){if(c==null||!(c instanceof A.b4)||c.e!==this)c=A.eN(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s=this
if(s.c<1)return
t=s.r;(t==null?s.r=A.eN(s):t).U(a,b)
s.r.b6(c,d,e)},
ao(a,b,c,d,e,f){var t,s=this
if(s.c<1)return
t=s.r;(t==null?s.r=A.eN(s):t).U(a,b)
s.r.ab(c,d,e,f)},
v(a){return"ImageDataUint4("+this.a+", "+this.b+", "+this.c+")"},
gak(){return this.e},
gJ(){return this.f}}
A.ao.prototype={
aw(a){var t,s=this,r=s.d
if(a)r=new Uint8Array(r.length)
else r=new Uint8Array(A.t(r))
t=s.e
t=t==null?null:t.M()
return new A.ao(r,t,s.a,s.b,s.c)},
gA(){return B.h},
gB(a){return B.e.gB(this.d)},
gak(){return this.a*this.c},
ga4(){return 8},
gD(a){return A.hW(this)},
gn(a){return this.d.byteLength},
gT(){var t=this.e
t=t==null?null:t.gT()
return t==null?255:t},
gaz(){return!1},
a7(a,b,c,d){var t=A.jn(B.a.h(B.a.i(a,0,255)),B.a.h(B.a.i(b,0,255)),B.a.h(B.a.i(c,0,255)),B.a.h(B.a.i(d,0,255)))
return t},
S(a,b,c){if(c==null||!(c instanceof A.b5)||c.d!==this)c=A.hW(this)
c.U(a,b)
return c},
a5(a,b,c,d,e){var t,s,r=this.c,q=b*(this.a*r)+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){r=q+2
o=B.a.h(e)
if(!(r<t))return A.a(p,r)
p[r]=o}}},
ao(a,b,c,d,e,f){var t,s,r=this.c,q=b*(this.a*r)+a*r,p=this.d,o=B.a.h(c)
p.$flags&2&&A.b(p)
t=p.length
if(!(q>=0&&q<t))return A.a(p,q)
p[q]=o
if(r>1){o=q+1
s=B.a.h(d)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>2){o=q+2
s=B.a.h(e)
if(!(o<t))return A.a(p,o)
p[o]=s
if(r>3){r=q+3
o=B.a.h(f)
if(!(r<t))return A.a(p,r)
p[r]=o}}}},
v(a){return"ImageDataUint8("+this.a+", "+this.b+", "+this.c+")"},
gJ(){return this.e}}
A.d5.prototype={
aK(){return"Interpolation."+this.b}}
A.a3.prototype={}
A.cj.prototype={
M(){return new A.cj(new Uint16Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.n.gB(this.c)},
gA(){return B.y},
gT(){return 1},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=A.D(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=A.D(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=A.D(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=A.D(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t,s
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
t=t[a]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
return s[t]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]
t=$.K
t=t!=null?t:A.S()
if(!(s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.ck.prototype={
M(){return new A.ck(new Float32Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.Q.gB(this.c)},
gA(){return B.r},
gT(){return 1},
P(a,b,c){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
t.$flags&2&&A.b(t)
if(!(s>=0&&s<t.length))return A.a(t,s)
t[s]=c}},
aJ(a,b,c,d){var t,s,r,q=this.b
a*=q
t=this.c
t.$flags&2&&A.b(t)
s=t.length
if(!(a>=0&&a<s))return A.a(t,a)
t[a]=b
if(q>1){r=a+1
if(!(r<s))return A.a(t,r)
t[r]=c
if(q>2){q=a+2
if(!(q<s))return A.a(t,q)
t[q]=d}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.cl.prototype={
M(){return new A.cl(new Float64Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.ah.gB(this.c)},
gA(){return B.t},
gT(){return 1},
P(a,b,c){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
t.$flags&2&&A.b(t)
if(!(s>=0&&s<t.length))return A.a(t,s)
t[s]=c}},
aJ(a,b,c,d){var t,s,r,q=this.b
a*=q
t=this.c
t.$flags&2&&A.b(t)
s=t.length
if(!(a>=0&&a<s))return A.a(t,a)
t[a]=b
if(q>1){r=a+1
if(!(r<s))return A.a(t,r)
t[r]=c
if(q>2){q=a+2
if(!(q<s))return A.a(t,q)
t[q]=d}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.cm.prototype={
M(){return new A.cm(new Int16Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.ai.gB(this.c)},
gA(){return B.w},
gT(){return 32767},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=B.a.h(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=B.a.h(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=B.a.h(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=B.a.h(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.cn.prototype={
M(){return new A.cn(new Int32Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.aj.gB(this.c)},
gA(){return B.x},
gT(){return 2147483647},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=B.a.h(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=B.a.h(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=B.a.h(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=B.a.h(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.co.prototype={
M(){return new A.co(new Int8Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.ak.gB(this.c)},
gA(){return B.v},
gT(){return 127},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=B.a.h(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=B.a.h(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=B.a.h(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=B.a.h(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.cp.prototype={
M(){return new A.cp(new Uint16Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.n.gB(this.c)},
gA(){return B.j},
gT(){return 65535},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=B.a.h(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=B.a.h(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=B.a.h(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=B.a.h(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.bG.prototype={
M(){return new A.bG(new Uint32Array(A.t(this.c)),this.a,this.b)},
gB(a){return B.R.gB(this.c)},
gA(){return B.u},
gT(){return 4294967295},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=B.a.h(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=B.a.h(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=B.a.h(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=B.a.h(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t
a*=this.b
t=this.c
if(!(a>=0&&a<t.length))return A.a(t,a)
return t[a]},
am(a){var t,s=this.b
if(s<2)return 0
t=this.c
s=a*s+1
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
al(a){var t,s=this.b
if(s<3)return 0
t=this.c
s=a*s+2
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aC(a){var t,s=this.b
if(s<4)return 0
t=this.c
s=a*s+3
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.bH.prototype={
M(){return A.kT(this)},
gB(a){return B.e.gB(this.c)},
gA(){return B.h},
gT(){return 255},
P(a,b,c){var t,s,r=this.b
if(b<r){t=this.c
r=a*r+b
s=B.a.h(c)
t.$flags&2&&A.b(t)
if(!(r>=0&&r<t.length))return A.a(t,r)
t[r]=s}},
aJ(a,b,c,d){var t,s,r,q,p=this.b
a*=p
t=this.c
s=B.a.h(b)
t.$flags&2&&A.b(t)
r=t.length
if(!(a>=0&&a<r))return A.a(t,a)
t[a]=s
if(p>1){s=a+1
q=B.a.h(c)
if(!(s<r))return A.a(t,s)
t[s]=q
if(p>2){p=a+2
s=B.a.h(d)
if(!(p<r))return A.a(t,p)
t[p]=s}}},
af(a,b){var t,s=this.b
if(b<s){t=this.c
s=a*s+b
if(!(s>=0&&s<t.length))return A.a(t,s)
s=t[s]}else s=0
return s},
an(a){var t,s
a*=this.b
t=this.c
s=t.length
if(a>=s)return 0
if(!(a>=0))return A.a(t,a)
return t[a]},
am(a){var t,s,r=this.b
if(r<2)return 0
a*=r
r=this.c
t=r.length
if(a>=t)return 0
s=a+1
if(!(s>=0&&s<t))return A.a(r,s)
return r[s]},
al(a){var t,s,r=this.b
if(r<3)return 0
a*=r
r=this.c
t=r.length
if(a>=t)return 0
s=a+2
if(!(s>=0&&s<t))return A.a(r,s)
return r[s]},
aC(a){var t,s,r=this.b
if(r<4)return 255
a*=r
r=this.c
t=r.length
if(a>=t)return 0
s=a+3
if(!(s>=0&&s<t))return A.a(r,s)
return r[s]},
aS(a,b){return this.P(a,0,b)},
aR(a,b){return this.P(a,1,b)},
aQ(a,b){return this.P(a,2,b)}}
A.aV.prototype={
M(){var t=this
return new A.aV(t.a,t.b,t.c,t.d)},
gA(){return B.y},
gn(a){return this.d.c},
gJ(){return null},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=A.D(c)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=A.D(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s,r=this.d
if(r.c>1){r=r.d
t=this.c+1
s=A.D(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s,r=this.d
if(r.c>2){r=r.d
t=this.c+2
s=A.D(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=$.K
s=s!=null?s:A.S()
if(!(t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
st(a){var t,s,r,q=this.d
if(q.c>3){t=this.gm()
q=q.d
s=this.c+3
r=A.D(t)
q.$flags&2&&A.b(q)
if(!(s>=0&&s<q.length))return A.a(q,s)
q[s]=r}},
gaj(){return this.gj()/1},
gae(){return this.gm()/1},
gag(){return this.gl()/1},
gY(){return A.E(this)},
W(a){var t=this
if(t.d.c>0){t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())}},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.aV){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.aW.prototype={
M(){var t=this
return new A.aW(t.a,t.b,t.c,t.d)},
gn(a){return this.d.c},
gJ(){return null},
gA(){return B.r},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=c}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=1
return s},
st(a){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gaj(){return this.gj()/1},
gae(){return this.gm()/1},
gag(){return this.gl()/1},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.aW){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.aX.prototype={
M(){var t=this
return new A.aX(t.a,t.b,t.c,t.d)},
gn(a){return this.d.c},
gJ(){return null},
gA(){return B.t},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=c}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
st(a){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
s.$flags&2&&A.b(s)
if(!(t>=0&&t<s.length))return A.a(s,t)
s[t]=a}},
gaj(){return this.gj()/1},
gae(){return this.gm()/1},
gag(){return this.gl()/1},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.aX){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.aY.prototype={
M(){var t=this
return new A.aY(t.a,t.b,t.c,t.d)},
gn(a){return this.d.c},
gJ(){return null},
gA(){return B.w},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=B.a.h(c)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s,r=this.d
if(r.c>1){r=r.d
t=this.c+1
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s,r=this.d
if(r.c>2){r=r.d
t=this.c+2
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
st(a){var t,s,r=this.d
if(r.c>3){r=r.d
t=this.c+3
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gaj(){return this.gj()/32767},
gae(){return this.gm()/32767},
gag(){return this.gl()/32767},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.aY){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.aZ.prototype={
M(){var t=this
return new A.aZ(t.a,t.b,t.c,t.d)},
gn(a){return this.d.c},
gJ(){return null},
gA(){return B.x},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=B.a.h(c)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s,r=this.d
if(r.c>1){r=r.d
t=this.c+1
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s,r=this.d
if(r.c>2){r=r.d
t=this.c+2
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
st(a){var t,s,r=this.d
if(r.c>3){r=r.d
t=this.c+3
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gaj(){return this.gj()/2147483647},
gae(){return this.gm()/2147483647},
gag(){return this.gl()/2147483647},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.aZ){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.b_.prototype={
M(){var t=this
return new A.b_(t.a,t.b,t.c,t.d)},
gn(a){return this.d.c},
gJ(){return null},
gA(){return B.v},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=B.a.h(c)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s,r=this.d
if(r.c>1){r=r.d
t=this.c+1
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s,r=this.d
if(r.c>2){r=r.d
t=this.c+2
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
st(a){var t,s,r=this.d
if(r.c>3){r=r.d
t=this.c+3
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gaj(){return this.gj()/127},
gae(){return this.gm()/127},
gag(){return this.gl()/127},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.b_){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.b0.prototype={
M(){var t=this
return new A.b0(t.a,t.b,t.c,t.d,t.e,t.f)},
gn(a){var t=this.f,s=t.f
s=s==null?null:s.b
return s==null?t.c:s},
gJ(){return this.f.f},
gA(){return B.o},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.f
s=b*t.e
r.e=s
t=a*t.c
r.c=s+B.b.G(t,3)
r.d=t&7},
gL(){return this},
H(){var t,s=this,r=++s.a,q=s.f
if(r===q.a){s.a=0
r=++s.b
s.d=0;++s.c
s.e=s.e+q.e
return r<q.b}t=q.c
if(q.f!=null||t===1){if(++s.d>7){s.d=0;++s.c}}else{r*=t
s.d=r&7
s.c=s.e+B.b.G(r,3)}r=s.c
q=q.d
q===$&&A.c()
return r<q.byteLength},
bH(a){var t,s,r=this.c,q=7-(this.d+a)
if(q<0){q+=8;++r}t=this.f.d
t===$&&A.c()
s=t.length
if(r>=s)return 0
if(!(r>=0))return A.a(t,r)
return B.b.aV(t[r],q)&1},
aq(a){var t=this.f,s=t.f
if(s==null)t=t.c>a?this.bH(a):0
else t=s.af(this.bH(0),a)
return t},
a1(a,b){var t,s,r,q,p,o,n=this.f
if(a>=n.c)return
t=this.c
s=7-(this.d+a)
if(s<0){++t
s+=8}r=n.d
r===$&&A.c()
if(!(t>=0&&t<r.length))return A.a(r,t)
q=r[t]
p=B.b.i(B.a.h(b),0,1)
if(!(s>=0&&s<8))return A.a(B.aa,s)
o=B.aa[s]
r=B.b.a8(p,s)
n=n.d
n.$flags&2&&A.b(n)
if(!(t<n.length))return A.a(n,t)
n[t]=(q&o|r)>>>0},
k(a,b){return this.aq(b)},
q(a,b,c){return this.a1(b,c)},
gI(){return this.bH(0)},
sI(a){this.a1(0,a)},
gj(){return this.aq(0)},
sj(a){this.a1(0,a)},
gm(){return this.aq(1)},
sm(a){this.a1(1,a)},
gl(){return this.aq(2)},
sl(a){this.a1(2,a)},
gt(){return this.aq(3)},
st(a){this.a1(3,a)},
gaj(){return this.aq(0)/this.f.gT()},
gae(){return this.aq(1)/this.f.gT()},
gag(){return this.aq(2)/this.f.gT()},
gY(){return A.E(this)},
W(a){var t=this
t.a1(0,a.gj())
t.a1(1,a.gm())
t.a1(2,a.gl())
t.a1(3,a.gt())},
b6(a,b,c){var t=this,s=t.f.c
if(s>0){t.a1(0,a)
if(s>1){t.a1(1,b)
if(s>2)t.a1(2,c)}}},
ab(a,b,c,d){var t=this,s=t.f.c
if(s>0){t.a1(0,a)
if(s>1){t.a1(1,b)
if(s>2){t.a1(2,c)
if(s>3)t.a1(3,d)}}}},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q=this
if(b==null)return!1
if(b instanceof A.b0){t=A.k(q,A.i(q).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=q.f
s=t.f
r=s!=null?s.b:t.c
t=J.N(b)
if(t.gn(b)!==r)return!1
if(q.aq(0)!==t.k(b,0))return!1
if(r>1){if(q.aq(1)!==t.k(b,1))return!1
if(r>2){if(q.aq(2)!==t.k(b,2))return!1
if(r>3)if(q.aq(3)!==t.k(b,3))return!1}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.f}}
A.b1.prototype={
M(){var t=this
return new A.b1(t.a,t.b,t.c,t.d)},
gn(a){var t=this.d,s=t.e
s=s==null?null:s.b
return s==null?t.c:s},
gJ(){return this.d.e},
gA(){return B.j},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c
t+=r.e==null?r.c:1
s.c=t
return t<r.d.length},
aB(a){var t,s=this.d,r=s.e
if(r!=null){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.af(s[t],a)
s=t}else if(a<s.c){s=s.d
r=this.c+a
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
return s},
k(a,b){return this.aB(b)},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=B.a.h(c)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d,r=s.e
if(r==null)if(s.c>0){s=s.d
r=this.c
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
else{s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.an(s[t])
s=t}return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this.d,r=s.e
if(r==null)if(s.c>1){s=s.d
r=this.c+1
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
else{s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.am(s[t])
s=t}return s},
sm(a){var t,s,r=this.d
if(r.c>1){r=r.d
t=this.c+1
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gl(){var t,s=this.d,r=s.e
if(r==null)if(s.c>2){s=s.d
r=this.c+2
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
else{s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.al(s[t])
s=t}return s},
sl(a){var t,s,r=this.d
if(r.c>2){r=r.d
t=this.c+2
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gt(){var t,s=this.d,r=s.e
if(r==null)if(s.c>3){s=s.d
r=this.c+3
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
else{s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.aC(s[t])
s=t}return s},
st(a){var t,s,r=this.d
if(r.c>3){r=r.d
t=this.c+3
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gaj(){return this.gj()/this.d.gT()},
gae(){return this.gm()/this.d.gT()},
gag(){return this.gl()/this.d.gT()},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q=this
if(b==null)return!1
if(b instanceof A.b1){t=A.k(q,A.i(q).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=q.d
s=t.e
r=s!=null?s.b:t.c
t=J.N(b)
if(t.gn(b)!==r)return!1
if(q.aB(0)!==t.k(b,0))return!1
if(r>1){if(q.aB(1)!==t.k(b,1))return!1
if(r>2){if(q.aB(2)!==t.k(b,2))return!1
if(r>3)if(q.aB(3)!==t.k(b,3))return!1}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.b2.prototype={
M(){var t=this
return new A.b2(t.a,t.b,t.c,t.d,t.e,t.f)},
gn(a){var t=this.f,s=t.f
s=s==null?null:s.b
return s==null?t.c:s},
gJ(){return this.f.f},
gA(){return B.p},
gck(){var t=this.f
return t.f!=null?2:t.c<<1>>>0},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r,q=this
q.a=a
q.b=b
t=q.gck()
s=b*q.f.e
q.e=s
r=a*t
q.c=s+B.b.G(r,3)
q.d=r&7},
gL(){return this},
H(){var t=this,s=++t.a,r=t.f
if(s===r.a){t.a=0
s=++t.b
t.d=0;++t.c
t.e=t.e+r.e
return s<r.b}if(r.f!=null||r.c===1){if((t.d+=2)>7){t.d=0;++t.c}}else{s*=t.gck()
t.d=s&7
t.c=t.e+B.b.G(s,3)}s=t.c
r=r.d
r===$&&A.c()
return s<r.length},
bI(a){var t,s=this.c,r=6-(this.d+(a<<1>>>0))
if(r<0){r+=8;++s}t=this.f.d
t===$&&A.c()
if(!(s>=0&&s<t.length))return A.a(t,s)
return B.b.aV(t[s],r)&3},
ar(a){var t=this.f,s=t.f
if(s==null)t=t.c>a?this.bI(a):0
else t=s.af(this.bI(0),a)
return t},
a2(a,b){var t,s,r,q,p,o,n=this.f
if(a>=n.c)return
t=this.c
s=6-(this.d+(a<<1>>>0))
if(s<0){++t
s+=8}r=n.d
r===$&&A.c()
if(!(t>=0&&t<r.length))return A.a(r,t)
q=r[t]
p=B.b.i(B.a.h(b),0,3)
r=B.b.G(s,1)
if(!(r<4))return A.a(B.a5,r)
o=B.a5[r]
r=B.b.a8(p,s)
n=n.d
n.$flags&2&&A.b(n)
if(!(t<n.length))return A.a(n,t)
n[t]=(q&o|r)>>>0},
k(a,b){return this.ar(b)},
q(a,b,c){return this.a2(b,c)},
gI(){return this.bI(0)},
sI(a){this.a2(0,a)},
gj(){return this.ar(0)},
sj(a){this.a2(0,a)},
gm(){return this.ar(1)},
sm(a){this.a2(1,a)},
gl(){return this.ar(2)},
sl(a){this.a2(2,a)},
gt(){return this.ar(3)},
st(a){this.a2(3,a)},
gaj(){return this.ar(0)/this.f.gT()},
gae(){return this.ar(1)/this.f.gT()},
gag(){return this.ar(2)/this.f.gT()},
gY(){return A.E(this)},
W(a){var t=this
t.a2(0,a.gj())
t.a2(1,a.gm())
t.a2(2,a.gl())
t.a2(3,a.gt())},
b6(a,b,c){var t=this,s=t.f.c
if(s>0){t.a2(0,a)
if(s>1){t.a2(1,b)
if(s>2)t.a2(2,c)}}},
ab(a,b,c,d){var t=this,s=t.f.c
if(s>0){t.a2(0,a)
if(s>1){t.a2(1,b)
if(s>2){t.a2(2,c)
if(s>3)t.a2(3,d)}}}},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q=this
if(b==null)return!1
if(b instanceof A.b2){t=A.k(q,A.i(q).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=q.f
s=t.f
r=s!=null?s.b:t.c
t=J.N(b)
if(t.gn(b)!==r)return!1
if(q.ar(0)!==t.k(b,0))return!1
if(r>1){if(q.ar(1)!==t.k(b,1))return!1
if(r>2){if(q.ar(2)!==t.k(b,2))return!1
if(r>3)if(q.ar(3)!==t.k(b,3))return!1}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.f}}
A.b3.prototype={
M(){var t=this
return new A.b3(t.a,t.b,t.c,t.d)},
gn(a){return this.d.c},
gJ(){return null},
gA(){return B.u},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c+r.c
s.c=t
return t<r.d.length},
k(a,b){var t,s=this.d
if(b<s.c){s=s.d
t=this.c+b
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=B.a.h(c)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){return this.gj()},
sI(a){this.sj(a)},
gj(){var t,s=this.d
if(s.c>0){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this.d
if(s.c>1){s=s.d
t=this.c+1
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sm(a){var t,s,r=this.d
if(r.c>1){r=r.d
t=this.c+1
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gl(){var t,s=this.d
if(s.c>2){s=s.d
t=this.c+2
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
sl(a){var t,s,r=this.d
if(r.c>2){r=r.d
t=this.c+2
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gt(){var t,s=this.d
if(s.c>3){s=s.d
t=this.c+3
if(!(t>=0&&t<s.length))return A.a(s,t)
t=s[t]
s=t}else s=0
return s},
st(a){var t,s,r=this.d
if(r.c>3){r=r.d
t=this.c+3
s=B.a.h(a)
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gaj(){return this.gj()/4294967295},
gae(){return this.gm()/4294967295},
gag(){return this.gl()/4294967295},
gY(){return A.E(this)},
W(a){var t=this
t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q,p,o=this
if(b==null)return!1
if(b instanceof A.b3){t=A.k(o,A.i(o).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=J.N(b)
s=o.d
r=s.c
if(t.gn(b)!==r)return!1
s=s.d
q=o.c
p=s.length
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,0))return!1
if(r>1){q=o.c+1
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,1))return!1
if(r>2){q=o.c+2
if(!(q>=0&&q<p))return A.a(s,q)
if(s[q]!==t.k(b,2))return!1
if(r>3){r=o.c+3
if(!(r>=0&&r<p))return A.a(s,r)
if(s[r]!==t.k(b,3))return!1}}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.b4.prototype={
M(){var t=this
return new A.b4(t.a,t.b,t.c,t.d,t.e)},
gn(a){var t=this.e,s=t.f
s=s==null?null:s.b
return s==null?t.c:s},
gJ(){return this.e.f},
gA(){return B.q},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r,q=this
q.a=a
q.b=b
t=q.e
s=t.c*4
r=t.e
if(s===4)t=b*r+B.b.G(a,1)
else if(s===8)t=b*t.a+a
else{t=b*r
t=s===16?t+(a<<1>>>0):t+B.b.G(a*s,3)}q.c=t
t=a*s
q.d=s>7?t&4:t&7},
gL(){return this},
H(){var t,s,r,q=this,p=q.e
if(++q.a===p.a){q.a=0
t=++q.b
q.d=0
q.c=t*p.e
return t<p.b}s=p.c
t=p.f!=null||s===1
r=q.d
if(t){t=r+4
q.d=t
if(t>7){q.d=0;++q.c}}else{t=q.d=r+(s<<2>>>0)
while(t>7){t-=8
q.d=t;++q.c}}t=q.c
p=p.d
p===$&&A.c()
return t<p.length},
bD(a){var t,s=this.c,r=4-(this.d+(a<<2>>>0))
if(r<0){r+=8;++s}t=this.e.d
t===$&&A.c()
if(!(s>=0&&s<t.length))return A.a(t,s)
return B.b.aV(t[s],r)&15},
ap(a){var t=this.e,s=t.f
if(s==null)t=t.c>a?this.bD(a):0
else t=s.af(this.bD(0),a)
return t},
a3(a,b){var t,s,r,q,p,o,n=this.e
if(a>=n.c)return
t=this.c
s=4-(this.d+(a<<2>>>0))
if(s<0){s+=8;++t}r=n.d
r===$&&A.c()
if(!(t>=0&&t<r.length))return A.a(r,t)
q=r[t]
p=B.b.i(B.a.h(b),0,15)
o=s===4?15:240
r=B.b.a8(p,s)
n=n.d
n.$flags&2&&A.b(n)
if(!(t<n.length))return A.a(n,t)
n[t]=(q&o|r)>>>0},
k(a,b){return this.ap(b)},
q(a,b,c){return this.a3(b,c)},
gI(){return this.bD(0)},
sI(a){this.a3(0,a)},
gj(){return this.ap(0)},
sj(a){this.a3(0,a)},
gm(){return this.ap(1)},
sm(a){this.a3(1,a)},
gl(){return this.ap(2)},
sl(a){this.a3(2,a)},
gt(){return this.ap(3)},
st(a){this.a3(3,a)},
gaj(){return this.ap(0)/this.e.gT()},
gae(){return this.ap(1)/this.e.gT()},
gag(){return this.ap(2)/this.e.gT()},
gY(){return A.E(this)},
W(a){var t=this
t.a3(0,a.gj())
t.a3(1,a.gm())
t.a3(2,a.gl())
t.a3(3,a.gt())},
b6(a,b,c){var t=this,s=t.e.c
if(s>0){t.a3(0,a)
if(s>1){t.a3(1,b)
if(s>2)t.a3(2,c)}}},
ab(a,b,c,d){var t=this,s=t.e.c
if(s>0){t.a3(0,a)
if(s>1){t.a3(1,b)
if(s>2){t.a3(2,c)
if(s>3)t.a3(3,d)}}}},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q=this
if(b==null)return!1
if(b instanceof A.b4){t=A.k(q,A.i(q).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){r=q.e.c
t=J.N(b)
if(t.gn(b)!==r)return!1
if(q.ap(0)!==t.k(b,0))return!1
if(r>1){if(q.ap(1)!==t.k(b,1))return!1
if(r>2){if(q.ap(2)!==t.k(b,2))return!1
if(r>3)if(q.ap(3)!==t.k(b,3))return!1}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.e}}
A.b5.prototype={
M(){var t=this
return new A.b5(t.a,t.b,t.c,t.d)},
gn(a){var t=this.d,s=t.e
s=s==null?null:s.b
return s==null?t.c:s},
gJ(){return this.d.e},
gA(){return B.h},
gac(){return this.a},
gad(){return this.b},
U(a,b){var t,s,r=this
r.a=a
r.b=b
t=r.d
s=t.c
r.c=b*t.a*s+a*s},
gL(){return this},
H(){var t,s=this,r=s.d
if(++s.a===r.a){s.a=0
if(++s.b===r.b)return!1}t=s.c
t+=r.e==null?r.c:1
s.c=t
return t<r.d.length},
aB(a){var t,s=this.d,r=s.e
if(r!=null){s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.af(s[t],a)
s=t}else if(a<s.c){s=s.d
r=this.c+a
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
return s},
k(a,b){return this.aB(b)},
q(a,b,c){var t,s,r=this.d
if(b<r.c){r=r.d
t=this.c+b
s=B.a.h(B.a.i(c,0,255))
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gI(){var t=this.d.d,s=this.c
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
sI(a){var t=this.d.d,s=this.c,r=B.a.h(B.a.i(a,0,255))
t.$flags&2&&A.b(t)
if(!(s>=0&&s<t.length))return A.a(t,s)
t[s]=r},
gj(){var t,s=this.d,r=s.e
if(r==null)if(s.c>0){s=s.d
r=this.c
if(!(r>=0&&r<s.length))return A.a(s,r)
r=s[r]
s=r}else s=0
else{s=s.d
t=this.c
if(!(t>=0&&t<s.length))return A.a(s,t)
t=r.an(s[t])
s=t}return s},
sj(a){var t,s,r=this.d
if(r.c>0){r=r.d
t=this.c
s=B.a.h(B.a.i(a,0,255))
r.$flags&2&&A.b(r)
if(!(t>=0&&t<r.length))return A.a(r,t)
r[t]=s}},
gm(){var t,s=this,r=s.d,q=r.e
if(q==null){q=r.c
if(q===2){r=r.d
q=s.c
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else if(q>1){r=r.d
q=s.c+1
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else r=0}else{r=r.d
t=s.c
if(!(t>=0&&t<r.length))return A.a(r,t)
t=q.am(r[t])
r=t}return r},
sm(a){var t,s=this.d,r=s.c
if(r===2){s=s.d
r=this.c
t=B.a.h(B.a.i(a,0,255))
s.$flags&2&&A.b(s)
if(!(r>=0&&r<s.length))return A.a(s,r)
s[r]=t}else if(r>1){s=s.d
r=this.c+1
t=B.a.h(B.a.i(a,0,255))
s.$flags&2&&A.b(s)
if(!(r>=0&&r<s.length))return A.a(s,r)
s[r]=t}},
gl(){var t,s=this,r=s.d,q=r.e
if(q==null){q=r.c
if(q===2){r=r.d
q=s.c
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else if(q>2){r=r.d
q=s.c+2
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else r=0}else{r=r.d
t=s.c
if(!(t>=0&&t<r.length))return A.a(r,t)
t=q.al(r[t])
r=t}return r},
sl(a){var t,s=this.d,r=s.c
if(r===2){s=s.d
r=this.c
t=B.a.h(B.a.i(a,0,255))
s.$flags&2&&A.b(s)
if(!(r>=0&&r<s.length))return A.a(s,r)
s[r]=t}else if(r>2){s=s.d
r=this.c+2
t=B.a.h(B.a.i(a,0,255))
s.$flags&2&&A.b(s)
if(!(r>=0&&r<s.length))return A.a(s,r)
s[r]=t}},
gt(){var t,s=this,r=s.d,q=r.e
if(q==null){q=r.c
if(q===2){r=r.d
q=s.c+1
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else if(q>3){r=r.d
q=s.c+3
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else r=255}else{r=r.d
t=s.c
if(!(t>=0&&t<r.length))return A.a(r,t)
t=q.aC(r[t])
r=t}return r},
st(a){var t,s=this.d,r=s.c
if(r===2){s=s.d
r=this.c+1
t=B.a.h(B.a.i(a,0,255))
s.$flags&2&&A.b(s)
if(!(r>=0&&r<s.length))return A.a(s,r)
s[r]=t}else if(r>3){s=s.d
r=this.c+3
t=B.a.h(B.a.i(a,0,255))
s.$flags&2&&A.b(s)
if(!(r>=0&&r<s.length))return A.a(s,r)
s[r]=t}},
gaj(){return this.gj()/this.d.gT()},
gae(){return this.gm()/this.d.gT()},
gag(){return this.gl()/this.d.gT()},
gY(){return this.d.c===2?this.gj():A.E(this)},
W(a){var t=this
if(t.d.e!=null)t.sI(a.gI())
else{t.sj(a.gj())
t.sm(a.gm())
t.sl(a.gl())
t.st(a.gt())}},
gD(a){return new A.y(this)},
O(a,b){var t,s,r,q=this
if(b==null)return!1
if(b instanceof A.b5){t=A.k(q,A.i(q).p("d.E"))
t=A.l(t)
s=A.k(b,A.i(b).p("d.E"))
return t===A.l(s)}if(u.L.b(b)){t=q.d
s=t.e
r=s!=null?s.b:t.c
t=J.N(b)
if(t.gn(b)!==r)return!1
if(q.aB(0)!==t.k(b,0))return!1
if(r>1){if(q.aB(1)!==t.k(b,1))return!1
if(r>2){if(q.aB(2)!==t.k(b,2))return!1
if(r>3)if(q.aB(3)!==t.k(b,3))return!1}}return!0}return!1},
gF(a){var t=A.k(this,A.i(this).p("d.E"))
return A.l(t)},
$io:1,
$in:1,
gai(){return this.d}}
A.A.prototype={
M(){return new A.A()},
gai(){return $.iJ()},
gac(){return 0},
gad(){return 0},
gn(a){return 0},
gA(){return B.h},
gJ(){return null},
k(a,b){return 0},
q(a,b,c){},
gI(){return 0},
sI(a){},
gj(){return 0},
sj(a){},
gm(){return 0},
sm(a){},
gl(){return 0},
sl(a){},
gt(){return 0},
st(a){},
gaj(){return 0},
gae(){return 0},
gag(){return 0},
gY(){return 0},
W(a){},
gL(){return this},
H(){return!1},
O(a,b){if(b==null)return!1
return b instanceof A.A},
gF(a){return 0},
gD(a){return new A.y(this)},
$io:1,
$in:1}
A.ew.prototype={
v(a){return"ImageException: "+this.a}}
A.db.prototype={
dn(a){var t=this
t.c2(a)
t.bZ()
t.c1()
t.bW()},
d6(a){var t,s,r,q,p,o,n,m=this,l=m.c=Math.max(a,4)
m.f=l-m.d
m.r=l-1
t=B.a.V(l,8)
m.w=t
m.x=t*256
m.Q=new A.bG(new Uint32Array(1024),256,4)
m.a=new A.bH(new Uint8Array(768),256,3)
m.d=3
m.e=2
t=B.a.G(l,3)
m.y=new Int32Array(t)
t=u.i
s=u.o
m.z=s.a(A.aA(l*3,0,!1,t))
m.at=s.a(A.aA(m.c,0,!1,t))
m.ax=s.a(A.aA(m.c,0,!1,t))
B.c.q(m.z,0,0)
B.c.q(m.z,1,0)
B.c.q(m.z,2,0)
B.c.q(m.z,3,255)
B.c.q(m.z,4,255)
B.c.q(m.z,5,255)
r=1/m.c
for(q=0;p=m.d,q<p;++q){B.c.q(m.ax,q,r)
B.c.q(m.at,q,0)}for(o=p*3,q=p;q<m.c;++q,o=n){n=o+1
B.c.q(m.z,o,255*(q-m.d)/m.f)
o=n+1
B.c.q(m.z,n,255*(q-m.d)/m.f)
n=o+1
B.c.q(m.z,o,255*(q-m.d)/m.f)
B.c.q(m.ax,q,r)
B.c.q(m.at,q,0)}},
bW(){var t,s,r,q,p,o,n
for(t=0;t<this.c;++t){s=this.a
s===$&&A.c()
r=this.Q
r===$&&A.c()
q=r.b
if(2<q){p=r.c
o=t*q+2
if(!(o>=0&&o<p.length))return A.a(p,o)
o=p[o]
p=o}else p=0
if(1<q){o=r.c
n=t*q+1
if(!(n>=0&&n<o.length))return A.a(o,n)
n=o[n]
o=n}else o=0
if(0<q){r=r.c
q=t*q
if(!(q>=0&&q<r.length))return A.a(r,q)
q=r[q]
r=q}else r=0
s.aJ(t,Math.abs(p),Math.abs(o),Math.abs(r))}},
d8(a,b,c){var t,s,r,q,p,o,n,m,l,k,j=this.as
if(!(b>=0&&b<256))return A.a(j,b)
t=j[b]
s=t-1
r=this.c
j=this.Q
q=1000
p=-1
for(;;){o=t<r
if(!(o||s>=0))break
if(o){j===$&&A.c()
o=j.b
if(1<o){n=j.c
m=t*o+1
if(!(m>=0&&m<n.length))return A.a(n,m)
m=n[m]
n=m}else n=0
l=n-b
if(l>=q)t=r
else{if(l<0)l=-l
if(0<o){n=j.c
m=t*o
if(!(m>=0&&m<n.length))return A.a(n,m)
m=n[m]
n=m}else n=0
k=n-a
l+=k<0?-k:k
if(l<q){if(2<o){n=j.c
o=t*o+2
if(!(o>=0&&o<n.length))return A.a(n,o)
o=n[o]}else o=0
k=o-c
l+=k<0?-k:k
if(l<q){p=t
q=l}}++t}}if(s>=0){j===$&&A.c()
o=j.b
if(1<o){n=j.c
m=s*o+1
if(!(m>=0&&m<n.length))return A.a(n,m)
m=n[m]
n=m}else n=0
l=b-n
if(l>=q)s=-1
else{if(l<0)l=-l
if(0<o){n=j.c
m=s*o
if(!(m>=0&&m<n.length))return A.a(n,m)
m=n[m]
n=m}else n=0
k=n-a
l+=k<0?-k:k
if(l<q){if(2<o){n=j.c
o=s*o+2
if(!(o>=0&&o<n.length))return A.a(n,o)
o=n[o]}else o=0
k=o-c
l+=k<0?-k:k
if(l<q){p=s
q=l}}--s}}}return p},
bZ(){var t,s,r,q,p,o,n,m=this
for(t=0,s=0;t<m.c;++t){for(r=0;r<3;++r,++s){q=m.z
q===$&&A.c()
if(!(s>=0&&s<q.length))return A.a(q,s)
p=B.b.i(B.a.h(0.5+q[s]),0,255)
q=m.Q
q===$&&A.c()
o=q.b
if(r<o){q=q.c
o=t*o+r
n=B.b.h(p)
q.$flags&2&&A.b(q)
if(!(o>=0&&o<q.length))return A.a(q,o)
q[o]=n}}q=m.Q
q===$&&A.c()
o=q.b
if(3<o){q=q.c
o=t*o+3
n=B.b.h(t)
q.$flags&2&&A.b(q)
if(!(o>=0&&o<q.length))return A.a(q,o)
q[o]=n}}},
c1(){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c=this
for(t=c.c,s=c.Q,r=c.as,q=r.$flags|0,p=0,o=0,n=0;n<t;n=h){s===$&&A.c()
m=s.b
l=1<m
if(l){k=s.c
j=n*m+1
if(!(j>=0&&j<k.length))return A.a(k,j)
i=k[j]}else i=0
for(h=n+1,g=h,f=n;g<t;++g){if(l){k=s.c
j=g*m+1
if(!(j>=0&&j<k.length))return A.a(k,j)
j=k[j]
k=j}else k=0
if(k<i){if(l){k=s.c
j=g*m+1
if(!(j>=0&&j<k.length))return A.a(k,j)
i=k[j]}else i=0
f=g}}if(n!==f){k=0<m
if(k){j=s.c
e=f*m
if(!(e>=0&&e<j.length))return A.a(j,e)
g=j[e]}else g=0
if(k){j=s.c
e=n*m
if(!(e>=0&&e<j.length))return A.a(j,e)
e=j[e]
j=e}else j=0
if(k){d=f*m
e=s.c
j=B.b.h(j)
e.$flags&2&&A.b(e)
if(!(d>=0&&d<e.length))return A.a(e,d)
e[d]=j}if(k){d=n*m
k=s.c
j=B.b.h(g)
k.$flags&2&&A.b(k)
if(!(d>=0&&d<k.length))return A.a(k,d)
k[d]=j}if(l){k=s.c
j=f*m+1
if(!(j>=0&&j<k.length))return A.a(k,j)
g=k[j]}else g=0
if(l){k=s.c
j=n*m+1
if(!(j>=0&&j<k.length))return A.a(k,j)
j=k[j]
k=j}else k=0
if(l){j=s.c
e=f*m+1
k=B.b.h(k)
j.$flags&2&&A.b(j)
if(!(e>=0&&e<j.length))return A.a(j,e)
j[e]=k}if(l){l=s.c
k=n*m+1
j=B.b.h(g)
l.$flags&2&&A.b(l)
if(!(k>=0&&k<l.length))return A.a(l,k)
l[k]=j}l=2<m
if(l){k=s.c
j=f*m+2
if(!(j>=0&&j<k.length))return A.a(k,j)
g=k[j]}else g=0
if(l){k=s.c
j=n*m+2
if(!(j>=0&&j<k.length))return A.a(k,j)
j=k[j]
k=j}else k=0
if(l){j=s.c
e=f*m+2
k=B.b.h(k)
j.$flags&2&&A.b(j)
if(!(e>=0&&e<j.length))return A.a(j,e)
j[e]=k}if(l){l=s.c
k=n*m+2
j=B.b.h(g)
l.$flags&2&&A.b(l)
if(!(k>=0&&k<l.length))return A.a(l,k)
l[k]=j}l=3<m
if(l){k=s.c
j=f*m+3
if(!(j>=0&&j<k.length))return A.a(k,j)
g=k[j]}else g=0
if(l){k=s.c
j=n*m+3
if(!(j>=0&&j<k.length))return A.a(k,j)
j=k[j]
k=j}else k=0
if(l){j=s.c
e=f*m+3
k=B.b.h(k)
j.$flags&2&&A.b(j)
if(!(e>=0&&e<j.length))return A.a(j,e)
j[e]=k}if(l){l=s.c
m=n*m+3
k=B.b.h(g)
l.$flags&2&&A.b(l)
if(!(m>=0&&m<l.length))return A.a(l,m)
l[m]=k}}if(i!==p){q&2&&A.b(r)
if(!(p>=0&&p<256))return A.a(r,p)
r[p]=o+n>>>1
for(g=p+1;g<i;++g){if(!(g<256))return A.a(r,g)
r[g]=n}o=n
p=i}}t=c.r
t.toString
s=B.b.G(o+t,1)
q&2&&A.b(r)
if(!(p>=0&&p<256))return A.a(r,p)
r[p]=s
for(h=p+1;h<256;++h)r[h]=t},
cc(a,b){var t,s,r,q
for(t=this.y,s=a*a,r=0;r<a;++r){t===$&&A.c()
q=B.a.h(b*((s-r*r)*256/s))
t.$flags&2&&A.b(t)
if(!(r<t.length))return A.a(t,r)
t[r]=q}},
c2(a4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2=this,a3=a2.x
a3===$&&A.c()
t=a2.b
s=30+B.b.V(t-1,3)
r=a4.gu()*a4.gC()
q=B.b.X(r,t)
p=Math.max(B.b.V(q,100),1)
if(p===0)p=1
o=B.b.G(a3,8)
if(o<=1)o=0
a2.cc(o,1024)
if(r<1509)n=a2.b=1
else if(B.b.K(r,499)!==0)n=499
else if(B.b.K(r,491)!==0)n=491
else n=B.b.K(r,487)!==0?487:503
m=a4.gu()
l=a4.gC()
for(k=a3,j=1024,i=0,h=0,g=0,f=0;f<q;){a3=a4.a
e=a3==null?null:a3.S(h,g,null)
if(e==null)e=new A.A()
d=e.gj()
c=e.gm()
b=e.gl()
if(f===0){a3=a2.z
a3===$&&A.c()
t=a2.e
t===$&&A.c()
B.c.q(a3,t*3,b)
B.c.q(a2.z,a2.e*3+1,c)
B.c.q(a2.z,a2.e*3+2,d)}a=a2.dj(b,c,d)
if(a<0)a=a2.cN(b,c,d)
if(a>=a2.d){a0=j/1024
e=a*3
a3=a2.z
a3===$&&A.c()
if(!(e>=0&&e<a3.length))return A.a(a3,e)
t=a3[e]
B.c.q(a3,e,t-a0*(t-b))
t=a2.z
a3=e+1
if(!(a3<t.length))return A.a(t,a3)
a1=t[a3]
B.c.q(t,a3,a1-a0*(a1-c))
a1=a2.z
a3=e+2
if(!(a3<a1.length))return A.a(a1,a3)
t=a1[a3]
B.c.q(a1,a3,t-a0*(t-d))
if(o>0)a2.cK(a0,o,a,b,c,d)}i+=n
h+=n
while(h>m){h-=m;++g}while(i>=r){i-=r
g-=l}++f
if(B.b.K(f,p)===0){j-=B.b.X(j,s)
k-=B.b.V(k,30)
o=B.b.G(k,8)
if(o<=1)o=0
a2.cc(o,j)}}},
cK(a,b,c,d,e,f){var t,s,r,q,p,o,n,m,l,k,j,i=this,h=c-b,g=i.d-1
if(h<g)h=g
t=c+b
s=i.c
if(t>s)t=s
r=c+1
q=c-1
p=1
for(;;){o=r<t
if(!(o||q>h))break
n=i.y
n===$&&A.c()
m=p+1
if(!(p<n.length))return A.a(n,p)
l=n[p]
if(o){k=r*3
o=i.z
o===$&&A.c()
if(!(k>=0&&k<o.length))return A.a(o,k)
n=o[k]
B.c.q(o,k,n-l*(n-d)/262144)
n=i.z
o=k+1
if(!(o<n.length))return A.a(n,o)
j=n[o]
B.c.q(n,o,j-l*(j-e)/262144)
j=i.z
o=k+2
if(!(o<j.length))return A.a(j,o)
n=j[o]
B.c.q(j,o,n-l*(n-f)/262144);++r}if(q>h){k=q*3
o=i.z
o===$&&A.c()
if(!(k>=0&&k<o.length))return A.a(o,k)
n=o[k]
B.c.q(o,k,n-l*(n-d)/262144)
n=i.z
o=k+1
if(!(o<n.length))return A.a(n,o)
j=n[o]
B.c.q(n,o,j-l*(j-e)/262144)
j=i.z
o=k+2
if(!(o<j.length))return A.a(j,o)
n=j[o]
B.c.q(j,o,n-l*(n-f)/262144);--q}p=m}},
cN(a,b,c){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f=this,e=1e30
for(t=f.d,s=t*3,r=e,q=r,p=-1,o=-1;t<f.c;++t,s=m){n=f.z
n===$&&A.c()
m=s+1
l=n.length
if(!(s<l))return A.a(n,s)
k=n[s]-a
if(k<0)k=-k
s=m+1
if(!(m<l))return A.a(n,m)
j=n[m]-b
if(j<0)j=-j
m=s+1
if(!(s<l))return A.a(n,s)
i=n[s]-c
if(i<0)i=-i
k=k+j+i
if(k<q){p=t
q=k}n=f.at
n===$&&A.c()
if(!(t<n.length))return A.a(n,t)
h=k-n[t]
if(h<r){o=t
r=h}n=f.ax
n===$&&A.c()
if(!(t<n.length))return A.a(n,t)
l=n[t]
B.c.q(n,t,l-0.0009765625*l)
l=f.at
if(!(t<l.length))return A.a(l,t)
n=l[t]
g=f.ax
if(!(t<g.length))return A.a(g,t)
B.c.q(l,t,n+g[t])}n=f.ax
n===$&&A.c()
if(!(p>=0&&p<n.length))return A.a(n,p)
B.c.q(n,p,n[p]+0.0009765625)
n=f.at
n===$&&A.c()
if(!(p<n.length))return A.a(n,p)
B.c.q(n,p,n[p]-1)
return o},
dj(a,b,c){var t,s,r,q,p,o,n
for(t=this.d,s=this.z,r=0,q=0;r<t;++r){s===$&&A.c()
p=q+1
o=s.length
if(!(q<o))return A.a(s,q)
n=!1
if(s[q]===a){q=p+1
if(!(p<o))return A.a(s,p)
if(s[p]===b){p=q+1
if(!(q<o))return A.a(s,q)
o=s[q]===c
q=p}else o=n}else{o=n
q=p}if(o)return r}return-1}}
A.dc.prototype={
N(a){var t,s,r=this
if(r.a===r.c.length)r.cV()
t=r.c
s=r.a++
t.$flags&2&&A.b(t)
if(!(s>=0&&s<t.length))return A.a(t,s)
t[s]=a&255},
aX(a){var t,s,r,q,p,o=this
u.L.a(a)
t=J.bc(a)
while(s=o.a,r=s+t,q=o.c,p=q.length,r>p)o.bY(r-p)
B.e.aD(q,s,r,a)
o.a+=t},
cp(a){var t=this
if(t.b){t.N(B.b.G(a,8)&255)
t.N(a&255)
return}t.N(a&255)
t.N(B.b.G(a,8)&255)},
aA(a){var t=this
if(t.b){t.N(B.b.G(a,24)&255)
t.N(B.b.G(a,16)&255)
t.N(B.b.G(a,8)&255)
t.N(a&255)
return}t.N(a&255)
t.N(B.b.G(a,8)&255)
t.N(B.b.G(a,16)&255)
t.N(B.b.G(a,24)&255)},
bY(a){var t,s,r,q
if(a!=null)t=a
else{s=this.c.length
t=s===0?8192:s*2}s=this.c
r=s.length
q=new Uint8Array(r+t)
B.e.aD(q,0,r,s)
this.c=q},
cV(){return this.bY(null)},
gn(a){return this.a}}
A.dm.prototype={
cr(a){var t,s,r,q,p,o,n=a.gu(),m=a.gC(),l=this.a
l===$&&A.c()
t=A.fG(null,null,B.h,0,B.F,m,null,0,1,l,B.h,n,!1)
n=t.a
s=n.gD(n)
s.H()
t.z=a.z
t.w=a.w
t.y=a.y
for(n=a.a,n=n.gD(n);n.H();){r=n.gL()
q=s.gL()
p=B.a.h(r.gj())
o=B.a.h(r.gm())
q.q(0,0,this.d8(B.a.h(r.gl()),o,p))
s.H()}return t}}
A.dK.prototype={}
A.d0.prototype={}
A.e6.prototype={
$1(a){var t,s=this.a,r=s[1]
if(!(a<3))return A.a(r,a)
r=r[a]
t=this.b
if(!(t<6))return A.a(s,t)
return s[t][a]*255/Math.max(1,255+(r-255))},
$S:0}
A.ek.prototype={
$2(a,b){var t,s
u.bm.a(b)
t=this.a
s=B.b.K(a,t)
if(s>0)b.$1(a-1)
if(s+1<t)b.$1(a+1)
if(a>=t)b.$1(a-t)
t=a+t
if(t<this.b)b.$1(t)},
$S:19}
A.eh.prototype={
$1(a){var t=this,s=t.a
if(!(a>=0&&a<s.length))return A.a(s,a)
if(s[a]!==0){s=t.b
if(!(a<s.length))return A.a(s,a)
s=s[a]===0}else s=!1
if(s){s=t.b
s.$flags&2&&A.b(s)
if(!(a<s.length))return A.a(s,a)
s[a]=t.c
B.c.E(t.d,a)}},
$S:3}
A.ei.prototype={
$1(a){var t=this,s=t.a
if(!(a>=0&&a<s.length))return A.a(s,a)
if(s[a]===3){s=t.b
if(!(a<s.length))return A.a(s,a)
s=s[a]===0}else s=!1
if(s){s=t.b
s.$flags&2&&A.b(s)
if(!(a<s.length))return A.a(s,a)
s[a]=1
B.c.E(t.c,a)}},
$S:3}
A.ej.prototype={
$1(a){var t,s,r=this,q=r.a
if(!(a>=0&&a<q.length))return A.a(q,a)
if(q[a]===0){t=r.b
if(!(a<t.length))return A.a(t,a)
s=!0
if(t[a]===0){t=r.c
if(!(a<t.length))return A.a(t,a)
if(t[a]!==2){t=r.d
if(!(a<t.length))return A.a(t,a)
t=t[a]>0}else t=s}else t=s}else t=!1
if(t){q.$flags&2&&A.b(q)
q[a]=1
B.c.E(r.e,a)}},
$S:3}
A.eb.prototype={
$1(a){var t
if(a<=0)t=0
else t=a>=1?1:a*a*(3-2*a)
return t},
$S:1}
A.ea.prototype={
$1(a){var t
if(a<=0)t=0
else t=a>=1?1:a*a*(3-2*a)
return t},
$S:1}
A.ee.prototype={
$1(a){return A.p(a)},
$S:0}
A.ef.prototype={
$1(a){return A.p(a)},
$S:0}
A.eg.prototype={
$3(a,b,c){return 0.299*a+0.587*b+0.114*c},
$S:20}
A.ed.prototype={
$1(a){var t=a/255
if(t<0)return J.j5(this.$1(-a))
return t<=0.04045?t/12.92:Math.pow((t+0.055)/1.055,2.4)},
$S:1}
A.ec.prototype={
$1(a){return a<0?-Math.pow(-a,0.3333333333333333):Math.pow(a,0.3333333333333333)},
$S:1}
A.e5.prototype={
$1(a){var t=this.a,s=this.b,r=a+" "+s.gdB()+" \xb7 "
t.a+=r
r=s.b
s.a=r==null?$.eR.$0():r},
$S:21}
A.e2.prototype={
$1(a){var t=this.a.a
return B.a.h(t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gj())},
$S:2}
A.e3.prototype={
$1(a){var t=this.a.a
return B.a.h(t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gm())},
$S:2}
A.e4.prototype={
$1(a){var t=this.a.a
return B.a.h(t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gl())},
$S:2}
A.dP.prototype={
$1(a){var t=this.b,s=this.a.aa(B.b.K(a,t),B.b.X(a,t))
return 0.299*s.gj()+0.587*s.gm()+0.114*s.gl()},
$S:0}
A.dN.prototype={
$1(a){var t=this.a
if(!(a<t.length))return A.a(t,a)
return t[a]===1},
$S:8}
A.dO.prototype={
$1(a){var t=this.a
if(!(a<t.length))return A.a(t,a)
return t[a]!==0},
$S:8}
A.dW.prototype={
$1(a){var t=this.a,s=t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu()))
return 0.299*s.gj()+0.587*s.gm()+0.114*s.gl()},
$S:0}
A.dX.prototype={
$1(a){var t=this.a
return t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gj()},
$S:0}
A.dY.prototype={
$1(a){var t=this.a
return t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gm()},
$S:0}
A.dZ.prototype={
$1(a){var t=this.a
return t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gl()},
$S:0}
A.dQ.prototype={
$1(a){return Math.abs(A.dC(a))>0.001},
$S:5}
A.dR.prototype={
$1(a){return Math.abs(A.dC(a))>0.001},
$S:5}
A.dS.prototype={
$1(a){return Math.abs(A.dC(a))>0.001},
$S:5}
A.dT.prototype={
$1(a){var t=this.a
return B.a.h(t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gj())},
$S:2}
A.dU.prototype={
$1(a){var t=this.a
return B.a.h(t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gm())},
$S:2}
A.dV.prototype={
$1(a){var t=this.a
return B.a.h(t.aa(B.b.K(a,t.gu()),B.b.X(a,t.gu())).gl())},
$S:2}
A.dM.prototype={
$1(a){var t
if(a<=0)t=0
else t=a>=1?1:a*a*(3-2*a)
return t},
$S:1}
A.e9.prototype={
$1(a){var t
if(a<=0)t=0
else t=a>=1?1:a*a*(3-2*a)
return t},
$S:1}
A.e8.prototype={
$0(){return++this.a.a},
$S:4}
A.e_.prototype={
$1(a){var t=this.b
return this.a.aa(B.b.K(a,t),B.b.X(a,t)).gj()},
$S:0}
A.e0.prototype={
$1(a){var t=this.b
return this.a.aa(B.b.K(a,t),B.b.X(a,t)).gm()},
$S:0}
A.e1.prototype={
$1(a){var t=this.b
return this.a.aa(B.b.K(a,t),B.b.X(a,t)).gl()},
$S:0}
A.dL.prototype={
$1(a5){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1=this,a2=a1.a,a3=a5*a2,a4=B.b.K(a5,a1.b)*a2
for(t=a1.c,a2-=t,s=a1.r,r=s.$flags|0,q=a1.w,p=q.$flags|0,o=a1.x,n=o.$flags|0,m=-t,l=a1.d,k=l.length,j=a1.e,i=j.length,h=a1.f,g=h.length,f=t;f<a2;++f){for(e=a3+f,d=m,c=0,b=0,a=0;d<=t;d+=2){a0=e+d
if(!(a0>=0&&a0<k))return A.a(l,a0)
c+=l[a0]
if(!(a0<i))return A.a(j,a0)
b+=j[a0]
if(!(a0<g))return A.a(h,a0)
a+=h[a0]}e=a4+f
r&2&&A.b(s)
if(!(e>=0&&e<s.length))return A.a(s,e)
s[e]=c
p&2&&A.b(q)
if(!(e<q.length))return A.a(q,e)
q[e]=b
n&2&&A.b(o)
if(!(e<o.length))return A.a(o,e)
o[e]=a}},
$S:3}
A.f0.prototype={}
A.di.prototype={
gcl(a){var t=this.at
return t<=0?0:(this.as-this.ax)/t},
gb2(){return this.db>=0.15&&this.cx>0}}
A.fu.prototype={
$1(a){var t=this.a,s=B.a.R((this.b-1)*a)
if(!(s>=0&&s<t.length))return A.a(t,s)
return t[s]},
$S:1}
A.ft.prototype={
$2(a,b){return A.p(a)+A.p(b)},
$S:22}
A.eJ.prototype={}
A.eG.prototype={}
A.eK.prototype={}
A.fk.prototype={
$2(a,b){var t=this.a.k(0,a)
return J.je(t==null?b:t)},
$S:23}
A.fj.prototype={
$2(a,b){var t=this.a.k(0,a)
return A.il(t==null?!1:t)},
$S:24};(function aliases(){var t=J.az.prototype
t.cE=t.v
t=A.w.prototype
t.bR=t.aI})();(function installTearOffs(){var t=hunkHelpers._static_2,s=hunkHelpers._static_0,r=hunkHelpers._instance_0i,q=hunkHelpers.installStaticTearOff
t(J,"lP","hM",25)
s(A,"m1","kV",4)
r(A.dx.prototype,"gn","dZ",14)
q(A,"h5",4,null,["$4"],["m3"],26,0)})();(function inheritance(){var t=hunkHelpers.mixin,s=hunkHelpers.inherit,r=hunkHelpers.inheritMany
s(A.x,null)
r(A.x,[A.fM,J.d4,A.cu,J.bd,A.F,A.w,A.eS,A.d,A.bE,A.cW,A.V,A.aC,A.M,A.bs,A.au,A.eV,A.eH,A.P,A.eD,A.W,A.f_,A.fa,A.aa,A.dy,A.dB,A.cT,A.bg,A.fe,A.fb,A.f1,A.cv,A.f2,A.ep,A.ch,A.eT,A.bK,A.eI,A.bt,A.eo,A.eZ,A.dJ,A.a4,A.f4,A.f7,A.d3,A.de,A.y,A.bv,A.cY,A.aO,A.el,A.cZ,A.a3,A.ew,A.dm,A.dc,A.dK,A.d0,A.f0,A.di,A.eJ,A.eG,A.eK])
r(J.d4,[J.d7,J.c5,J.c7,J.bB,J.bC,J.aQ,J.ay])
r(J.c7,[J.az,J.B,A.aT,A.ce])
r(J.az,[J.dj,J.as,J.ap])
s(J.d6,A.cu)
s(J.ez,J.B)
r(J.aQ,[J.bA,J.c6])
r(A.F,[A.bD,A.cx,A.d8,A.dt,A.dn,A.dw,A.cN,A.ae,A.cy,A.ds,A.bJ,A.cS])
s(A.bL,A.w)
s(A.bf,A.bL)
r(A.d,[A.bW,A.bh,A.bi,A.bj,A.bk,A.bl,A.bm,A.bn,A.bo,A.bp,A.bq,A.br,A.aL,A.ax,A.L,A.aV,A.aW,A.aX,A.aY,A.aZ,A.b_,A.b0,A.b1,A.b2,A.b3,A.b4,A.b5,A.A])
r(A.bW,[A.Y,A.bX,A.aR])
r(A.Y,[A.cw,A.bF,A.dA])
r(A.M,[A.b7,A.aD,A.aE])
r(A.b7,[A.I,A.ai])
r(A.aD,[A.r,A.cD,A.ab])
r(A.aE,[A.bN,A.bO,A.cE])
r(A.bs,[A.bV,A.bu])
r(A.au,[A.cP,A.cQ,A.dr,A.fo,A.fq,A.f3,A.ey,A.ex,A.e6,A.eh,A.ei,A.ej,A.eb,A.ea,A.ee,A.ef,A.eg,A.ed,A.ec,A.e5,A.e2,A.e3,A.e4,A.dP,A.dN,A.dO,A.dW,A.dX,A.dY,A.dZ,A.dQ,A.dR,A.dS,A.dT,A.dU,A.dV,A.dM,A.e9,A.e_,A.e0,A.e1,A.dL,A.fu])
r(A.cP,[A.eP,A.fd,A.fc,A.e8])
s(A.ci,A.cx)
r(A.dr,[A.dp,A.be])
r(A.P,[A.a7,A.dz])
s(A.c8,A.a7)
r(A.cQ,[A.fp,A.eE,A.eF,A.et,A.eu,A.ev,A.ek,A.ft,A.fk,A.fj])
s(A.Q,A.ce)
r(A.Q,[A.cz,A.cB])
s(A.cA,A.cz)
s(A.aB,A.cA)
s(A.cC,A.cB)
s(A.a2,A.cC)
r(A.aB,[A.c9,A.ca])
r(A.a2,[A.cb,A.cc,A.cd,A.cf,A.cg,A.a8])
s(A.cF,A.dw)
r(A.cT,[A.f8,A.eA,A.eY,A.dv])
r(A.bg,[A.bY,A.d9])
s(A.eC,A.f8)
s(A.du,A.bY)
r(A.ae,[A.cs,A.d1])
r(A.bt,[A.df,A.dg,A.dh])
s(A.dx,A.eo)
s(A.fg,A.eZ)
r(A.f1,[A.bM,A.cO,A.dI,A.af,A.T,A.aw,A.dk,A.es,A.eq,A.d5])
s(A.d2,A.d3)
s(A.dd,A.de)
s(A.cR,A.aL)
s(A.cX,A.bv)
s(A.eO,A.el)
r(A.L,[A.bZ,A.c_,A.c0,A.c1,A.c2,A.c3,A.bw,A.bx,A.by,A.c4,A.bz,A.ao])
r(A.a3,[A.cj,A.ck,A.cl,A.cm,A.cn,A.co,A.cp,A.bG,A.bH])
s(A.db,A.dm)
t(A.bL,A.aC)
t(A.cz,A.w)
t(A.cA,A.V)
t(A.cB,A.w)
t(A.cC,A.V)})()
var v={G:typeof self!="undefined"?self:globalThis,typeUniverse:{eC:new Map(),tR:{},eT:{},tPV:{},sEA:[]},mangledGlobalNames:{f:"int",m:"double",h:"num",v:"String",a6:"bool",ch:"Null",u:"List",x:"Object",ag:"Map",H:"JSObject"},mangledNames:{},types:["m(f)","m(m)","f(f)","~(f)","f()","a6(m)","@()","~(v,aO)","a6(f)","@(@)","@(@,v)","@(v)","~(@,@)","~(x?,x?)","er<f>()","f(x?)","~(f,hF)","h(h,h,h,h)","h(h,h,h,h,h)","~(f,~(f))","m(m,m,m)","~(v)","f(f,f)","m(v,m)","a6(v,a6)","f(@,@)","a8(a8,f,f,v)"],interceptorsByTag:null,leafTags:null,arrayRti:Symbol("$ti"),rttc:{"2;":(a,b)=>c=>c instanceof A.I&&a.b(c.a)&&b.b(c.b),"2;note,skin":(a,b)=>c=>c instanceof A.ai&&a.b(c.a)&&b.b(c.b),"3;":(a,b,c)=>d=>d instanceof A.r&&a.b(d.a)&&b.b(d.b)&&c.b(d.c),"3;data,nc,stride":(a,b,c)=>d=>d instanceof A.cD&&a.b(d.a)&&b.b(d.b)&&c.b(d.c),"3;hair,note,skin":(a,b,c)=>d=>d instanceof A.ab&&a.b(d.a)&&b.b(d.b)&&c.b(d.c),"4;":a=>b=>b instanceof A.bN&&A.h8(a,b.a),"4;h,w,x,y":a=>b=>b instanceof A.bO&&A.h8(a,b.a),"5;":a=>b=>b instanceof A.cE&&A.h8(a,b.a)}}
A.ls(v.typeUniverse,JSON.parse('{"ap":"az","dj":"az","as":"az","mS":"aT","d7":{"a6":[],"z":[]},"c5":{"z":[]},"c7":{"H":[]},"az":{"H":[]},"B":{"u":["1"],"H":[],"d":["1"],"O":["1"]},"d6":{"cu":[]},"ez":{"B":["1"],"u":["1"],"H":[],"d":["1"],"O":["1"]},"aQ":{"m":[],"h":[],"an":["h"]},"bA":{"m":[],"f":[],"h":[],"an":["h"],"z":[]},"c6":{"m":[],"h":[],"an":["h"],"z":[]},"ay":{"v":[],"an":["v"],"hN":[],"O":["@"],"z":[]},"bD":{"F":[]},"bf":{"w":["f"],"aC":["f"],"u":["f"],"d":["f"],"w.E":"f","aC.E":"f"},"bW":{"d":["1"]},"Y":{"d":["1"]},"cw":{"Y":["1"],"d":["1"],"Y.E":"1","d.E":"1"},"bF":{"Y":["2"],"d":["2"],"Y.E":"2","d.E":"2"},"bX":{"d":["1"],"d.E":"1"},"bL":{"w":["1"],"aC":["1"],"u":["1"],"d":["1"]},"I":{"b7":[],"M":[]},"ai":{"b7":[],"M":[]},"r":{"aD":[],"M":[]},"cD":{"aD":[],"M":[]},"ab":{"aD":[],"M":[]},"bN":{"aE":[],"M":[]},"bO":{"aE":[],"M":[]},"cE":{"aE":[],"M":[]},"bs":{"ag":["1","2"]},"bV":{"bs":["1","2"],"ag":["1","2"]},"bu":{"bs":["1","2"],"ag":["1","2"]},"ci":{"F":[]},"d8":{"F":[]},"dt":{"F":[]},"au":{"aN":[]},"cP":{"aN":[]},"cQ":{"aN":[]},"dr":{"aN":[]},"dp":{"aN":[]},"be":{"aN":[]},"dn":{"F":[]},"a7":{"P":["1","2"],"fO":["1","2"],"ag":["1","2"],"P.K":"1","P.V":"2"},"aR":{"d":["1"],"d.E":"1"},"c8":{"a7":["1","2"],"P":["1","2"],"fO":["1","2"],"ag":["1","2"],"P.K":"1","P.V":"2"},"b7":{"M":[]},"aD":{"M":[]},"aE":{"M":[]},"a8":{"a2":[],"eX":[],"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"],"z":[],"w.E":"f"},"aT":{"H":[],"z":[]},"ce":{"H":[]},"Q":{"a1":["1"],"H":[],"O":["1"]},"aB":{"w":["m"],"Q":["m"],"u":["m"],"a1":["m"],"H":[],"O":["m"],"d":["m"],"V":["m"]},"a2":{"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"]},"c9":{"aB":[],"fD":[],"w":["m"],"Q":["m"],"u":["m"],"a1":["m"],"H":[],"O":["m"],"d":["m"],"V":["m"],"z":[],"w.E":"m"},"ca":{"aB":[],"fE":[],"w":["m"],"Q":["m"],"u":["m"],"a1":["m"],"H":[],"O":["m"],"d":["m"],"V":["m"],"z":[],"w.E":"m"},"cb":{"a2":[],"fJ":[],"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"],"z":[],"w.E":"f"},"cc":{"a2":[],"fK":[],"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"],"z":[],"w.E":"f"},"cd":{"a2":[],"fL":[],"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"],"z":[],"w.E":"f"},"cf":{"a2":[],"fT":[],"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"],"z":[],"w.E":"f"},"cg":{"a2":[],"fU":[],"w":["f"],"Q":["f"],"u":["f"],"a1":["f"],"H":[],"O":["f"],"d":["f"],"V":["f"],"z":[],"w.E":"f"},"dw":{"F":[]},"cF":{"F":[]},"w":{"u":["1"],"d":["1"]},"P":{"ag":["1","2"]},"dz":{"P":["v","@"],"ag":["v","@"],"P.K":"v","P.V":"@"},"dA":{"Y":["v"],"d":["v"],"Y.E":"v","d.E":"v"},"bY":{"bg":["v","u<f>"]},"d9":{"bg":["x?","v"]},"du":{"bY":[],"bg":["v","u<f>"]},"m":{"h":[],"an":["h"]},"f":{"h":[],"an":["h"]},"u":{"d":["1"]},"h":{"an":["h"]},"v":{"an":["v"],"hN":[]},"cN":{"F":[]},"cx":{"F":[]},"ae":{"F":[]},"cs":{"F":[]},"d1":{"F":[]},"cy":{"F":[]},"ds":{"F":[]},"bJ":{"F":[]},"cS":{"F":[]},"cv":{"F":[]},"d2":{"d3":[]},"dd":{"de":[]},"bh":{"o":[],"d":["h"],"d.E":"h"},"bi":{"o":[],"d":["h"],"d.E":"h"},"bj":{"o":[],"d":["h"],"d.E":"h"},"bk":{"o":[],"d":["h"],"d.E":"h"},"bl":{"o":[],"d":["h"],"d.E":"h"},"bm":{"o":[],"d":["h"],"d.E":"h"},"bn":{"o":[],"d":["h"],"d.E":"h"},"bo":{"o":[],"d":["h"],"d.E":"h"},"bp":{"o":[],"d":["h"],"d.E":"h"},"bq":{"o":[],"d":["h"],"d.E":"h"},"br":{"o":[],"d":["h"],"d.E":"h"},"aL":{"o":[],"d":["h"],"d.E":"h"},"cR":{"o":[],"d":["h"],"d.E":"h"},"cX":{"bv":[]},"ax":{"d":["n"],"d.E":"n"},"L":{"d":["n"]},"bZ":{"L":[],"d":["n"],"d.E":"n"},"c_":{"L":[],"d":["n"],"d.E":"n"},"c0":{"L":[],"d":["n"],"d.E":"n"},"c1":{"L":[],"d":["n"],"d.E":"n"},"c2":{"L":[],"d":["n"],"d.E":"n"},"c3":{"L":[],"d":["n"],"d.E":"n"},"bw":{"L":[],"d":["n"],"d.E":"n"},"bx":{"L":[],"d":["n"],"d.E":"n"},"by":{"L":[],"d":["n"],"d.E":"n"},"c4":{"L":[],"d":["n"],"d.E":"n"},"bz":{"L":[],"d":["n"],"d.E":"n"},"ao":{"L":[],"d":["n"],"d.E":"n"},"cj":{"a3":[]},"ck":{"a3":[]},"cl":{"a3":[]},"cm":{"a3":[]},"cn":{"a3":[]},"co":{"a3":[]},"cp":{"a3":[]},"bG":{"a3":[]},"bH":{"a3":[]},"aV":{"n":[],"o":[],"d":["h"],"d.E":"h"},"aW":{"n":[],"o":[],"d":["h"],"d.E":"h"},"aX":{"n":[],"o":[],"d":["h"],"d.E":"h"},"aY":{"n":[],"o":[],"d":["h"],"d.E":"h"},"aZ":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b_":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b0":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b1":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b2":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b3":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b4":{"n":[],"o":[],"d":["h"],"d.E":"h"},"b5":{"n":[],"o":[],"d":["h"],"d.E":"h"},"A":{"n":[],"o":[],"d":["h"],"d.E":"h"},"db":{"dm":[]},"fL":{"u":["f"],"d":["f"]},"eX":{"u":["f"],"d":["f"]},"fJ":{"u":["f"],"d":["f"]},"fT":{"u":["f"],"d":["f"]},"fK":{"u":["f"],"d":["f"]},"fU":{"u":["f"],"d":["f"]},"fD":{"u":["m"],"d":["m"]},"fE":{"u":["m"],"d":["m"]},"n":{"o":[],"d":["h"]}}'))
A.lr(v.typeUniverse,JSON.parse('{"bW":1,"bL":1,"Q":1,"cT":2}'))
var u=(function rtii(){var t=A.bR
return{G:t("o"),U:t("an<@>"),C:t("F"),Z:t("aN"),D:t("bu<T,f>"),P:t("aO"),r:t("hF"),I:t("L"),l:t("d<m>"),W:t("d<@>"),_:t("d<f>"),g:t("B<ax>"),p:t("B<u<f>>"),s:t("B<v>"),n:t("B<m>"),b:t("B<@>"),t:t("B<f>"),h:t("B<h>"),e:t("O<@>"),T:t("c5"),m:t("H"),M:t("ap"),J:t("a1<@>"),o:t("u<m>"),j:t("u<@>"),L:t("u<f>"),c:t("ag<v,@>"),V:t("bF<f,m>"),Q:t("aB"),E:t("a2"),Y:t("a8"),a:t("ch"),K:t("x"),k:t("n"),O:t("mW"),F:t("+()"),N:t("v"),R:t("z"),d:t("eX"),A:t("as"),y:t("a6"),i:t("m"),q:t("m(f)"),z:t("@"),S:t("f"),f:t("er<ch>?"),B:t("H?"),v:t("u<@>?"),w:t("ag<v,v>?"),X:t("x?"),x:t("v?"),u:t("a6?"),dd:t("m?"),a3:t("f?"),ae:t("h?"),H:t("h"),cQ:t("~(v,@)"),bm:t("~(f)")}})();(function constants(){var t=hunkHelpers.makeConstList
B.az=J.d4.prototype
B.c=J.B.prototype
B.b=J.bA.prototype
B.a=J.aQ.prototype
B.M=J.ay.prototype
B.aB=J.ap.prototype
B.aC=J.c7.prototype
B.Q=A.c9.prototype
B.ah=A.ca.prototype
B.ai=A.cb.prototype
B.aj=A.cc.prototype
B.ak=A.cd.prototype
B.n=A.cf.prototype
B.R=A.cg.prototype
B.e=A.a8.prototype
B.al=J.dj.prototype
B.S=J.as.prototype
B.T=new A.cO(0,"littleEndian")
B.L=new A.cO(1,"bigEndian")
B.am=new A.cW(A.bR("cW<0&>"))
B.U=function getTagFallback(o) {
  var s = Object.prototype.toString.call(o);
  return s.substring(8, s.length - 1);
}
B.an=function() {
  var toStringFunction = Object.prototype.toString;
  function getTag(o) {
    var s = toStringFunction.call(o);
    return s.substring(8, s.length - 1);
  }
  function getUnknownTag(object, tag) {
    if (/^HTML[A-Z].*Element$/.test(tag)) {
      var name = toStringFunction.call(object);
      if (name == "[object Object]") return null;
      return "HTMLElement";
    }
  }
  function getUnknownTagGenericBrowser(object, tag) {
    if (object instanceof HTMLElement) return "HTMLElement";
    return getUnknownTag(object, tag);
  }
  function prototypeForTag(tag) {
    if (typeof window == "undefined") return null;
    if (typeof window[tag] == "undefined") return null;
    var constructor = window[tag];
    if (typeof constructor != "function") return null;
    return constructor.prototype;
  }
  function discriminator(tag) { return null; }
  var isBrowser = typeof HTMLElement == "function";
  return {
    getTag: getTag,
    getUnknownTag: isBrowser ? getUnknownTagGenericBrowser : getUnknownTag,
    prototypeForTag: prototypeForTag,
    discriminator: discriminator };
}
B.as=function(getTagFallback) {
  return function(hooks) {
    if (typeof navigator != "object") return hooks;
    var userAgent = navigator.userAgent;
    if (typeof userAgent != "string") return hooks;
    if (userAgent.indexOf("DumpRenderTree") >= 0) return hooks;
    if (userAgent.indexOf("Chrome") >= 0) {
      function confirm(p) {
        return typeof window == "object" && window[p] && window[p].name == p;
      }
      if (confirm("Window") && confirm("HTMLElement")) return hooks;
    }
    hooks.getTag = getTagFallback;
  };
}
B.ao=function(hooks) {
  if (typeof dartExperimentalFixupGetTag != "function") return hooks;
  hooks.getTag = dartExperimentalFixupGetTag(hooks.getTag);
}
B.ar=function(hooks) {
  if (typeof navigator != "object") return hooks;
  var userAgent = navigator.userAgent;
  if (typeof userAgent != "string") return hooks;
  if (userAgent.indexOf("Firefox") == -1) return hooks;
  var getTag = hooks.getTag;
  var quickMap = {
    "BeforeUnloadEvent": "Event",
    "DataTransfer": "Clipboard",
    "GeoGeolocation": "Geolocation",
    "Location": "!Location",
    "WorkerMessageEvent": "MessageEvent",
    "XMLDocument": "!Document"};
  function getTagFirefox(o) {
    var tag = getTag(o);
    return quickMap[tag] || tag;
  }
  hooks.getTag = getTagFirefox;
}
B.aq=function(hooks) {
  if (typeof navigator != "object") return hooks;
  var userAgent = navigator.userAgent;
  if (typeof userAgent != "string") return hooks;
  if (userAgent.indexOf("Trident/") == -1) return hooks;
  var getTag = hooks.getTag;
  var quickMap = {
    "BeforeUnloadEvent": "Event",
    "DataTransfer": "Clipboard",
    "HTMLDDElement": "HTMLElement",
    "HTMLDTElement": "HTMLElement",
    "HTMLPhraseElement": "HTMLElement",
    "Position": "Geoposition"
  };
  function getTagIE(o) {
    var tag = getTag(o);
    var newTag = quickMap[tag];
    if (newTag) return newTag;
    if (tag == "Object") {
      if (window.DataView && (o instanceof window.DataView)) return "DataView";
    }
    return tag;
  }
  function prototypeForTagIE(tag) {
    var constructor = window[tag];
    if (constructor == null) return null;
    return constructor.prototype;
  }
  hooks.getTag = getTagIE;
  hooks.prototypeForTag = prototypeForTagIE;
}
B.ap=function(hooks) {
  var getTag = hooks.getTag;
  var prototypeForTag = hooks.prototypeForTag;
  function getTagFixed(o) {
    var tag = getTag(o);
    if (tag == "Document") {
      if (!!o.xmlVersion) return "!Document";
      return "!HTMLDocument";
    }
    return tag;
  }
  function prototypeForTagFixed(tag) {
    if (tag == "Document") return null;
    return prototypeForTag(tag);
  }
  hooks.getTag = getTagFixed;
  hooks.prototypeForTag = prototypeForTagFixed;
}
B.V=function(hooks) { return hooks; }

B.at=new A.d9()
B.W=new A.eC()
B.au=new A.eJ()
B.B=new A.eS()
B.av=new A.du()
B.aw=new A.eY()
B.X=new A.fg()
B.D=new A.af(0,"rgba")
B.Y=new A.af(1,"bgra")
B.Z=new A.af(2,"abgr")
B.a_=new A.af(3,"argb")
B.E=new A.af(4,"rgb")
B.a0=new A.af(5,"bgr")
B.ax=new A.af(6,"grayAlpha")
B.ay=new A.af(7,"red")
B.bx=new A.dI(4,"luminance")
B.o=new A.T(0,"uint1")
B.p=new A.T(1,"uint2")
B.r=new A.T(10,"float32")
B.t=new A.T(11,"float64")
B.q=new A.T(2,"uint4")
B.h=new A.T(3,"uint8")
B.j=new A.T(4,"uint16")
B.u=new A.T(5,"uint32")
B.v=new A.T(6,"int8")
B.w=new A.T(7,"int16")
B.x=new A.T(8,"int32")
B.y=new A.T(9,"float16")
B.F=new A.eq(2,"sequence")
B.a1=new A.es(1,"deflate")
B.d=new A.aw(0,"none")
B.i=new A.aw(2,"ascii")
B.f=new A.aw(3,"short")
B.k=new A.aw(4,"long")
B.l=new A.aw(5,"rational")
B.G=new A.aw(7,"undefined")
B.a2=new A.d0(!1,1,1,1,0)
B.aA=new A.d5(0,"nearest")
B.by=new A.d5(1,"linear")
B.aD=new A.eA(null)
B.aG=t([0,1,1,1],u.t)
B.a3=t([178,19,24],u.t)
B.aP=t([1,-1,0,1],u.t)
B.N=t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],u.t)
B.a4=t([232,232,232],u.t)
B.a5=t([252,243,207,63],u.t)
B.aV=t([0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],u.t)
B.aW=t([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],u.t)
B.b1=t([60,0,240,105],u.n)
B.a6=t([63,207,243,252],u.t)
B.b3=t([0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],u.t)
B.H=t([0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29],u.t)
B.aX=t([31,34,38],u.t)
B.aK=t([185,199,201],u.t)
B.aO=t([193,187,30],u.t)
B.b4=t([98,32,30],u.t)
B.aZ=t([35,63,142],u.t)
B.b0=t([53,86,58],u.t)
B.a7=t([B.aX,B.aK,B.aO,B.b4,B.aZ,B.b0],u.p)
B.a8=t([-0.2987,0.5277,0.8432,0.2557,-0.9179,0.6283,-0.4769,0.8349,-0.1043,0.1585,0.809,0.6449,0.2869,-0.1976,-0.9394,0.181,-0.6513,-0.0437,0.3431,0.5731,-0.8422,0.8842,-0.6889,0.3187,-0.3138,-0.1668,-0.7612,0.6737,-0.075,-0.9961,-0.3284,-0.0491,0.6586,0.3915,0.0344,0.2298,-0.6459,0.7607,-0.473,0.1502,0.4383,-0.2386,0.5604,0.9512,-0.917,0.0686,-0.705,0.4305,0.7065,-0.3665,-0.9858,-0.516,0.452,0.1433,0.5678,-0.4589,-0.9663,0.4354,0.9536,0.1233,-0.0706,0.4051,-0.7104,0.7368,-0.7827,0.1087,-0.6342,-0.3885,0.033,-0.2205,0.2107,-0.6376,0.5565,-0.8266,-0.2342,-0.706,-0.4759,0.4979,-0.5746,0.7724,0.6303,-0.2772,-0.9922,-0.5409,0.2518,-0.4471,0.0872,0.6991,-0.601,0.9238,0.1463,-0.5023,0.2479,0.9565,0.5199,0.179,-0.6059,-0.9096,-0.4842,0.7104,-0.2444,0.3773,-0.0418,-0.8872,0.7905,-0.7792,0.1106,-0.4891,0.472,-0.1516,0.7871,-0.56,-0.8315,0.0999,0.3299,0.9389,-0.3133,-0.8701,-0.1751,0.8676,0.2269,-0.2645,-0.7788,-0.5707,0.6415,0.853,0.1614,-0.4598,0.9717,-0.0935,0.619,0.3602,0.7582,-0.8022,0.9932,-0.3128,0.0159,0.3348,0.9311,0.4325,0.0857,0.8916,-0.3363,-0.1223,-0.7778,0.4515,0.9199,-0.1077,0.7451,-0.2298,0.4833,-0.8168,-0.0427,0.5453,-0.9038,0.7411,-0.6581,-0.2147,-0.8085,-0.4364,0.3167,0.8774,-0.1087,0.5248,-0.9834,0.8379,-0.3714,0.3035,-0.5258,0.6371,-0.3275,0.3128,-0.7441,0.622,0.2073,-0.2825,0.9028,0.5263,-0.7289,-0.0344,0.2005,0.7739,-0.6962,0.0501,-0.5951,0.748,-0.1111,0.2733,-0.3626,-0.957,-0.2073,0.3074,0.4579,-0.894,-0.24,-0.7402,-0.5302,-0.1189,0.4076,-0.9814,0.7363,-0.5941,-0.3753,-0.9336,-0.1057,-0.8325,0.581,0.0662,0.2816,-0.4335,0.1497,-0.6718,0.0271,-0.914,0.981,-0.347,0.285,-0.4637,0.3631,-0.3231,0.0051,0.4247,0.7866,0.0784,0.6923,-0.3167,-0.7035,0.1814,-0.5604,0.115,-0.7455,0.9971,-0.1424,0.0496,-0.9761,0.8364,-0.0232,-0.4164,-0.9009,0.3871,-0.093,-0.4774,-0.2215,0.6386,-0.5853,0.3656,0.5868,-0.3748,0.5043,-0.8891,0.4164,0.8901,-0.6928,0.0559,0.6122,-0.5751,-0.3587,0.7319,0.2205,0.8667,0.4877,0.117,0.6606,-0.4574,0.2606,-0.1604,0.6054,0.2039,0.7099,0.306,-0.6811,-0.517,0.8354,-0.8999,0.707,-0.3314,0.623,0.3802,-0.6205,0.1311,0.6723,-0.6957,-0.1311,0.8965,0.5839,-0.9385,-0.5487,-0.1565,-0.7626,-0.0085,0.3856,0.9077,-0.2078,0.6503,-0.0037,0.5072,-0.6293,0.7328,0.4012,-0.18,-0.5814,0.9634,0.0452,0.7475,-0.6571,0.2664,0.79,-0.8281,-0.4061,-0.1433,-0.9321,0.9937,-0.0603,0.1853,-0.5287,-0.2801,0.4764,0.7753,-0.8105,-0.0359,0.1238,-0.6498,-0.4823,-0.0168,-0.9238,-0.3441,-0.6615,-0.0393,0.8437,-0.767,0.0564,-0.6444,-0.4535,-0.2361,0.9155,0.4779,-0.2156,-0.0154,0.5165,-0.791,0.2601,-0.474,0.8325,-0.1785,-0.9311,0.791,0.2098,-0.7963,-0.4125,0.1766,0.3363,0.9863,0.5048,-0.9248,0.6332,-0.4232,-0.853,0.4203,-0.3114,-0.8208,0.2596,-0.4354,-0.7348,0.5961,0.1932,0.3553,-0.7744,-0.326,0.5634,-0.9204,0.1302,0.4598,0.9165,0.0618,0.243,-0.7148,-0.2513,0.7177,-0.7929,0.1258,-0.0916,-0.4408,0.3314,0.9057,-0.981,0.6313,0.3006,-0.201,0.5712,0.9048,0.2127,-0.8637,0.5018,-0.2728,0.9492,0.4388,0.7861,0.0164,-0.977,0.1643,-0.7304,0.3333,-0.5785,0.9433,-0.2523,-0.0398,-0.7563,0.6,0.0066,-0.2864,0.4965,-0.6234,-0.0882,0.8217,-0.2816,-0.6855,-0.3773,0.1101,-0.5976,0.2825,-0.0554,0.7109,-0.4974,0.8628,-0.2122,0.1092,0.9023,-0.3402,-0.9214,-0.2234,0.685,-0.5521,-0.0383,0.8554,-0.3011,-0.0652,-0.6488,0.6576,-0.5043,0.7807,0.3441,-0.4237,0.62,0.956,-0.9375,0.5858,-0.6733,-0.1853,0.4481,-0.328,0.959,-0.83,0.368,-0.5795,-0.2259,0.6845,0.3309,-0.5219,-0.9106,-0.1297,-0.7861,0.3485,-0.3148,0.6034,-0.4046,0.7617,-0.1512,0.1028,-0.9546,0.5433,0.1819,-0.4071,0.409,-0.5414,0.9575,0.1057,0.6967,-0.8393,0.0349,0.6523,0.2449,0.7568,-0.1858,0.9414,-0.6772,0.178,-0.9482,0.3573,0.559,-0.8652,-0.0589,0.4364,-0.6244,0.8442,0.0886,0.4803,0.2337,-0.7343,-0.5155,0.3617,-0.9658,-0.2239,0.4799,-0.854,0.0818,-0.6557,-0.0252,0.2977,-0.556,-0.2996,0.2171,0.8188,-0.5297,0.0393,-0.7026,0.1375,-0.4252,0.728,0.0613,-0.7421,-0.3993,0.1355,0.6254,0.2464,-0.4852,0.6811,-0.6073,0.9956,-0.0466,-0.832,0.4984,-0.493,0.305,0.7231,-0.6063,0.8564,-0.8125,0.262,-0.96,-0.3309,0.3744,-0.4681,0.4422,-0.98,-0.0842,-0.5033,-0.8828,0.4672,-0.3255,0.7885,-0.1556,0.0252,-0.6474,0.7509,-0.5199,0.1419,0.6293,-0.1238,-0.4349,-0.9824,0.9853,-0.156,0.7123,0.5761,0.1116,0.874,-0.3817,-0.1389,0.9033,0.5477,-0.873,-0.1888,0.453,0.726,-0.0784,-0.8188,0.3534,-0.1746,0.5873,0.8076,-0.0716,-0.9712,0.4828,0.9819,-0.1502,0.8085,-0.6586,-0.0247,0.8794,-0.2254,0.1228,-0.9028,0.4208,0.2186,-0.6767,0.8886,-0.349,-0.8418,-0.1482,0.0725,0.6747,-0.2049,-0.0227,0.6181,-0.7016,-0.1316,0.9341,-0.6166,0.5243,0.8662,0.3211,0.0491,-0.7915,0.5419,-0.5546,0.9204,-0.3553,0.2444,-0.2303,0.9463,-0.8403,0.2747,-0.6786,0.3709,-0.3451,0.0706,-0.8794,-0.4037,0.283,-0.7895,0.009,0.3792,-0.5531,0.1893,-0.3949,0.8105,-0.7641,0.1062,-0.4222,0.6435,0.8716,-0.7939,0.2405,-0.5492,-0.2562,0.3177,-0.6259,-0.0164,-0.8193,0.4217,-0.3206,-0.9468,0.4559,-0.7451,0.5624,-0.1336,-0.4676,0.832,-0.2337,0.5863,-0.0642,0.4471,0.9683,-0.3236,-0.6635,0.4916,0.8418,-0.5106,0.2933,0.7182,-0.2567,0.1189,-0.3641,-0.726,-0.2508,0.6933,-0.4139,0.1424,0.3319,-0.7578,0.6493,-0.9243,0.5013,-0.7006,-0.3807,-0.0129,0.5648,0.7421,-0.5927,0.5092,0.8154,-0.094,-0.578,0.662,-0.6703,0.7661,-0.959,-0.2571,0.6147,0.2615,-0.5971,0.9404,-0.9253,0.0032,-0.6518,-0.3636,0.4574,-0.8906,0.6405,0.8867,-0.3265,0.221,0.5722,-0.535,0.2728,0.6928,0.075,-0.4115,0.2581,0.7851,-0.644,0.0369,-0.9805,0.138,-0.7387,-0.5175,0.2117,-0.8711,0.3524,-0.432,-0.7621,0.16,-0.9116,0.0183,-0.7846,0.3592,0.7778,0.223,-0.0432,-0.602,0.9839,-0.9956,-0.0242,-0.2547,0.4237,-0.0818,0.0833,0.704,0.3514,0.8764,-0.2933,-0.8647,0.1839,-0.222,-0.8017,0.4105,0.958,-0.2469,0.22,0.5062,-0.0857,0.9805,-0.8032,0.0139,-0.1492,0.328,0.5409,-0.2576,0.7294,0.0965,0.9692,-0.0452,0.1443,-0.7324,-0.4911,0.7924,-0.8857,-0.2068,0.9009,-0.1175,-0.6322,0.938,-0.8706,-0.3216,0.6142,0.3851,-0.3958,0.6874,0.3255,0.7626,-0.0261,0.577,0.789,0.0945,-0.1131,0.9814,0.5824,-0.3861,0.8813,-0.5053,-0.9419,0.6274,-0.8286,0.4286,-0.1834,0.5668,0.7524,-0.5394,0.8462,-0.6425,-0.4672,-0.1902,-0.9497,-0.5516,0.1385,-0.1121,0.935,0.3138,-0.6752,-0.0071,-0.4803,0.0842,-0.8491,-0.3514,-0.5126,0.0955,0.4374,-0.454,0.6913,-0.7187,-0.4926,0.2156,-0.9941,-0.1951,-0.4828,-0.8178,0.515,-0.1893,0.3836,0.0574,0.6694,0.1604,-0.7739,-0.475,0.347,-0.0388,0.4662,0.1336,-0.7729,-0.1214,0.9302,-0.598,-0.1946,-0.9282,-0.3719,-0.6269,-0.2195,-0.9731,0.3275,-0.3143,-0.5966,0.4222,-0.0799,0.5536,-0.1726,0.0701,0.873,-0.4613,0.1976,-0.7646,-0.3939,0.2361,-0.8447,0.1321,0.9766,0.538,0.2234,0.8027,-0.7162,0.6557,-0.5375,-0.3797,0.7846,0.6298,-0.9976,0.5492,0.8642,0.3216,0.6396,-0.6508,0.8471,-0.9473,-0.2928,0.8945,-0.0911,0.4403,-0.5736,0.6112,0.3455,0.7055,-0.3739,0.8584,-0.9614,-0.0984,-0.6747,-0.3709,0.5336,0.811,-0.9932,0.6498,-0.202,-0.5619,0.8569,0.222,-0.8584,0.5233,0.0696,0.8369,0.4549,0.1658,0.9272,-0.5165,0.5028,0.7133,-0.8589,0.1756,-0.7299,0.2801,-0.6186,-0.3328,0.3241,-0.6982,0.8056,0.0505,0.4911,-0.1717,0.6645,0.3411,-0.3026,-0.7514,-0.051,-0.4159,0.4921,0.0076,-0.9355,0.4603,0.1184,-0.2962,0.2484,-0.1521,-0.6874,-0.0413,-0.7993,0.2,-0.1639,0.3543,0.5922,0.1126,-0.8383,0.8139,-0.0276,0.1746,-0.7201,-0.095,-0.6078,0.2308,0.4623,-0.5131,0.9639,0.2991,0.0037,-0.2552,0.1937,-0.3832,-0.7143,0.6987,-0.0134,-0.4764,-0.2488,0.2786,-0.4325,-0.6757,-0.1116,-0.8247,0.6225,-0.0159,-0.7065,-0.1702,0.0642,0.788,-0.2689,0.6518,0.9678,-0.8877,0.5136,-0.0515,-0.2733,-0.9277,0.9346,-0.6601,-0.0115,-0.9692,-0.5253,0.7519,0.3817,-0.8413,-0.2674,0.2469,0.8852,-0.1673,-0.8227,-0.5985,0.9233,-0.4339,0.4501,0.7128,-0.263,0.7919,-0.43,0.0012,-0.747,-0.5326,0.3026,-0.3382,-0.7773,0.7558,-0.2977,0.9326,0.0774,-0.8374,0.7333,-0.2757,0.5683,-0.8969,-0.6083,0.4315,-0.8139,0.9785,0.5096,0.286,-0.8916,0.7621,0.5829,-0.7797,0.9883,0.3905,0.7201,-0.3045,0.3099,-0.4129,0.2322,0.9038,-0.5468,0.4852,-0.9873,-0.4398,-0.1082,0.1023,0.7836,-0.5702,0.6718,0.3109,-0.4877,0.431,-0.2503,0.8823,0.5976,0.0422,-0.199,0.917,0.6234,-0.6987,-0.5101,0.5849,-0.0408,0.3998,0.6527,-0.8716,0.0418,-0.5277,-0.9267,0.2884,-0.6132,0.4794,0.7534,-0.1922,0.9941,0.5316,-0.4545,0.4198,-0.9062,0.3114,0.557,-0.4095,0.0208,-0.7446,0.1673,-0.0833,0.7988,0.6664,-0.1448,-0.5429,0.0247,-0.3416,-0.1663,0.3729,-0.6039,0.0178,-0.1824,-0.915,0.1082,-0.6151,0.8803,-0.9272,0.5326,-0.8037,-0.3372,-0.0354,0.8422,0.1917,-0.7436,0.4042,-0.3934,-0.8271,0.1648,-0.1204,-0.748,0.7792,0.1868,-0.4295,-0.685,0.2562,-0.9077,-0.5761,0.0974,0.4178,-0.3074,0.1985,0.8198,-0.7485,0.1399,-0.1849,0.3407,0.9546,0.5258,0.0759,0.8926,-0.8657,-0.3919,0.2137,-0.9526,0.0593,-0.1438,0.8413,-0.5458,-0.2137,-0.6791,0.8491,-0.1394,0.3641,0.8911,-0.4779,-0.3304,-0.7192,0.1551,0.3958,-0.9399,0.8618,-0.6781,0.1111,0.8149,-0.3538,0.6479,0.2493,-0.4603,0.5844,0.0339,-0.2484,0.7514,0.1033,0.412,-0.6654,0.3201,0.6156,-0.5399,0.9111,-0.1683,0.7299,0.4974,-0.3675,0.5932,0.0676,-0.8886,0.3924,-0.1048,0.5214,-0.3646,0.7158,-0.0989,-0.8076,0.7358,-0.9507,-0.3836,-0.5629,-0.2894,0.7636,-0.6689,-0.3529,-0.0979,-0.7592,-0.2391,0.6381,-0.0852,0.454,-0.5961,0.6659,-0.6952,0.1844,-0.0349,0.6269,0.1292,-0.8779,0.5067,-0.5556,-0.9736,0.6083,0.326,-0.0149,0.9101,-0.4242,0.643,0.2078,0.5468,-0.4188,-0.9287,0.4432,-0.727,0.893,-0.0867,-0.7934,0.4242,-0.6806,-0.096,-0.4896,0.9976,-0.1897,-0.8525,-0.3543,0.0408,-0.9228,0.2542,-0.6591,0.0232,-0.9839,0.9888,-0.581,-0.3226,0.7255,-0.8154,0.9336,0.1272,0.3358,-0.4882,0.998,-0.2015,0.3197,0.0447,0.8979,0.2591,0.5619,-0.9766,0.1922,0.812,-0.4584,0.3739,0.1575,-0.7206,0.8037,-0.2723,0.3343,-0.3778,0.5106,-0.9829,0.9726,-0.4457,0.284,-0.2821,0.7236,0.1009,-0.181,-0.7871,0.5087,-0.8608,-0.2171,-0.6313,-0.0725,-0.7944,0.9624,-0.1092,0.1761,-0.2454,-0.5424,0.3392,0.8061,-0.3661,0.6689,0.2928,-0.9629,0.5609,0.157,0.6977,-0.0701,0.4564,0.6444,-0.2918,0.872,-0.4813,0.3509,-0.2264,0.2835,-0.0422,0.5507,-0.5346,-0.2278,-0.6611,-0.9595,0.558,0.0085,-0.6161,0.4935,0.6611,-0.8574,-0.158,-0.4838,-0.0271,0.4349,-0.5922,0.5726,-0.937,0.9609,-0.5214,0.0476,-0.9018,0.9043,-0.8081,0.7187,-0.2947,0.3832,-0.6215,0.7841,-0.0188,-0.7177,-0.4027,0.9951,0.2049,-0.5228,0.7089,0.1043,0.8125,0.4545,-0.3006,0.304,-0.5888,0.7407,0.5595,-0.9946,0.0901,-0.1658,-0.8369,0.1634,0.8755,-0.5883,-0.2806,-0.7158,-0.4706,0.9243,-0.6308,0.1492,-0.7407,0.4393,-0.1287,0.6791,-0.7978,0.8252,-0.7099,0.2034,0.8496,0.0379,0.4725,0.7934,-0.3016,0.2259,-0.7651,-0.4515,-0.0877,-0.6796,0.3597,0.9702,-0.7695,0.7045,-0.221,0.1145,-0.0193,-0.3021,0.3031,0.5878,-0.1194,0.1487,0.4359,-0.0564,-0.7138,0.0803,-0.1619,-0.8457,0.5775,0.18,0.43,-0.6347,0.7646,-0.0808,-0.3621,0.3118,-0.979,-0.4965,0.0862,0.5946,-0.8549,0.0242,-0.4081,0.9175,0.4701,-0.6107,0.598,-0.4623,-0.198,0.0276,0.433,0.8242,0.2767,-0.9521,-0.1541,-0.411,0.7348,-0.9048,0.1834,-0.5995,0.0589,0.495,-0.4452,-0.1477,-0.8965,-0.3905,0.2913,-0.0794,-0.8501,0.686,0.8872,0.1297,0.8115,-0.3607,0.5985,0.0921,-0.3197,0.2772,-0.8628,0.8711,-0.6337,0.7143,-0.8335,-0.4168,0.7612,-0.577,0.9482,-0.4505,0.2454,0.8598,0.4955,-0.3612,0.9277,-0.9463,-0.1101,-0.2737,-0.8994,0.4745,-0.7109,0.6059,-0.1678,0.8999,-0.7582,0.7709,-0.1775,0.3973,-0.6894,0.2264,-0.3158,-0.0178,0.9619,-0.9199,0.3143,0.7343,-0.8535,-0.135,0.0794,0.5287,0.7875,0.3402,0.0217,-0.2557,0.5888,0.9062,-0.3499,-0.9536,0.7675,0.3763,0.684,-0.7265,0.9453,-0.5834,-0.4286,0.3475,-0.2615,-0.9746,0.4442,0.2278,-0.9136,-0.5536,0.8295,-0.6713,0.6342,-0.4032,0.3895,-0.1873,0.4618,-0.6821,0.2503,-0.2293,0.095,-0.9189,0.6698,-0.5497,-0.7802,-0.0579,0.3123,-0.4994,0.8066,0.6347,0.2586,0.0628,0.9443,-0.5673,0.1941,-0.0061,-0.3431,0.2371,-0.5189,0.8637,-0.0691,-0.8691,0.7446,-0.7338,0.1389,0.4906,-0.346,-0.6674,0.5893,-0.4437,-0.7529,-0.307,-0.5643,-0.7998,0.979,-0.5082,-0.7045,-0.0686,0.3568,-0.2034,0.1531,-0.5512,0.0808,0.5282,-0.2161,0.156,0.6195,-0.0056,-0.6542,-0.1272,-0.5243,0.7309,-0.2088,-0.0022,0.4989,-0.1414,0.1849,-0.0462,-0.9927,0.1282,0.9092,0.0022,0.5131,-0.7705,0.5751,-0.1458,0.3929,-0.2591,0.7392,0.1214,-0.6825,0.5155,0.0173,-0.6024,-0.3875,-0.8046,-0.2425,0.4027,-0.9072,0.6742,-0.6562,0.5023,-0.9502,-0.2742,0.6562,0.4867,-0.4857,0.3548,-0.1409,-0.5477,0.8579,-0.0505,0.2225,0.9438,0.4002,0.6654,0.1668,-0.054,0.5209,0.2254,0.4193,-0.8745,0.7324,-0.6435,0.9722,-0.8466,-0.3563,-0.0286,-0.9678,0.8383,-0.77,0.4252,0.9751,0.5521,0.0549,-0.7216,0.9331,-0.8237,0.2972,-0.5096,-0.7954,0.9922,0.5614,-0.6147,-0.3548,-0.9023,0.7895,-0.3299,0.8398,-0.6449,0.0354,-0.8618,0.4755,-0.4608,0.8906,-0.2493,-0.7851,0.3578,0.8339,0.5321,-0.0481,0.7387,-0.4007,0.3465,-0.1971,0.9468,0.0432,0.3153,-0.6142,0.1013,-0.2093,0.833,-0.8183,0.6171,0.0877,-0.9849,-0.2874,-0.5946,-0.1067,-0.8974,0.8095,-0.2249,-0.9722,-0.3592,0.875,0.0716,-0.4291,0.2684,-0.0921,0.6361,0.4139,0.7817,-0.6171,0.2611,-0.3079,-0.495,-0.8882,0.2132,-0.4203,0.6308,0.3646,-0.3568,0.5785,0.7968,-0.2474,0.263,-0.4725,0.747,0.3016,-0.0755,-0.599,0.1722,-0.9775,0.2762,-0.3822,0.9868,0.1888,-0.1292,-0.9043,0.2527,0.6884,-0.136,-0.998,0.1248,-0.5263,-0.7504,0.8789,0.0769,-0.8486,-0.4383,0.7114,-0.7768,-0.3734,0.9927,-0.9648,0.2396,-0.3978,0.4149,-0.6977,0.7241,0.3089,0.5526,0.0598,-0.6567,0.2864,-0.4784,0.6151,-0.6913,-0.1927,0.6708,-0.8042,0.5834,-0.2777,-0.7114,0.2342,-0.4667,-0.1487,0.4882,0.7211,0.1306,-0.1995,0.8173,-0.8134,-0.0838,-0.5932,0.1341,-0.8842,0.052,-0.6386,0.4569,-0.1179,-0.7734,-0.2611,0.6894,0.3827,-0.4711,-0.117,0.6996,0.4232,-0.538,-0.7333,0.5389,0.7944,-0.3656,0.0681,-0.4969,0.9795,-0.2884,0.6459,0.2567,-0.1053,-0.5912,0.5897,0.2068,-0.1526,0.4418,-0.0139,0.5702,-0.6391,0.7172,0.0193,-0.2415,0.8847,-0.1233,-0.4369,-0.8261,0.6957,-0.3573,0.9145,0.4398,0.0364,0.8227,0.1878,-0.58,-0.0125,0.4525,-0.5062,0.8725,-0.9101,0.1038,0.9497,-0.8642,-0.0212,-0.6371,0.5697,0.3875,-0.2957,0.2488,0.7035,-0.1937,0.8505,-0.391,0.6215,-0.9492,0.093,0.9209,0.5194,-0.8672,0.0256,0.9365,-0.3055,-0.789,-0.0457,0.7656,-0.244,0.0198,-0.5868,0.389,-0.7534,0.4838,0.198,-0.6454,0.4276,-0.8984,-0.3109,0.4706,0.8046,-0.7089,-0.5433,0.8882,-0.8838,0.2166,-0.1096,0.4711,-0.5267,-0.9209,0.1731,-0.5634,0.4676,0.9858,0.1619,-0.1536,-0.79,-0.5863,-0.1302,-0.8505,0.3807,-0.3094,0.9502,-0.9868,0.1663,-0.0647,0.6796,-0.2332,-0.6943,0.3372,-0.4374,0.8921,-0.9966,0.0203,-0.6664,0.9072,-0.9448,0.4408,-0.7226,-0.0672,0.2151,0.7275,-0.4393,-0.6576,0.201,-0.3895,-0.7079,0.4696,-0.5585,0.5907,0.1609,-0.8808,0.3353,0.6366,-0.958,0.9248,-0.1731,0.749,-0.8593,-0.033,0.767,-0.4413,0.9556,0.1365,-0.8725,-0.0281,0.3226,-0.265,0.7465,-0.4886,-0.3172,-0.7812,0.9287,0.2967,0.6542,-0.7631,-0.0032,-0.2537,-0.9575,0.3861,0.6547,0.2435,0.7499,-0.4261,0.5687,-0.7363,0.2987,-0.1707,0.7998,-0.621,0.4339,-0.4066,0.5502,0.6962,-0.1165,0.2899,-0.3421,0.6728,-0.4979,0.5297,0.0735,-0.4735,0.307,0.9516,-0.5687,-0.2376,0.3866,-0.0549,0.7978,-0.1878,0.6703,0.1219,0.8374,-0.2083,-0.642,0.9321,-0.5013,-0.3407,0.2181,-0.0471,-0.5448,-0.3768,0.6127,-0.264,0.3055,0.0554,-0.6879,-0.2142,0.3846,-0.3485,0.6186,0.1077,-0.7284,0.4144,0.7993,0.0911,0.56,-0.0828,-0.3319,0.8359,0.3436,-0.6381,0.7773,-0.4955,0.0144,-0.2767,-0.9443,0.1253,0.8686,0.0042,-0.4906,0.5473,-0.3578,-0.8579,0.2523,0.0007,-0.831,0.116,-0.5878,-0.7685,0.8002,0.1795,-0.1038,-0.7875,-0.22,0.768,-0.2982,-0.8676,0.5819,-0.7548,0.8735,-0.9145,0.4891,-0.536,0.3221,-0.9233,-0.4105,0.2737,0.4496,-0.1346,0.0691,0.8501,-0.8198,0.5736,0.3495,0.1316,-0.7128,0.915,-0.5507,-0.9634,0.5365,0.6825,-0.5057,0.9189,-0.9785,-0.5819,0.6762,-0.0501,-0.8945,-0.2308,-0.662,-0.4559,-0.8295,0.1072,0.6063,-0.4085,-0.0759,0.5516,-0.7074,0.9526,0.4857,-0.619,-0.2464,-0.9053,0.7548,-0.6933,0.0813,0.6264,0.9687,-0.537,0.7856,-0.2718,0.9214,0.4818,-0.1883,-0.8803,0.4066,0.9824,0.244,-0.6264,0.493,-0.0042,0.1482,-0.1585,0.2635,-0.3387,0.0569,-0.7924,0.9541,-0.0315,-0.7558,0.7587,-0.9902,0.6615,-0.7495,0.4056,-0.2103,-0.64,0.8315,-0.9258,-0.073,0.4554,-0.1648,0.8305,0.1858,-0.0886,-0.8203,0.0457,0.5184,-0.1907,0.2879,-0.3846,0.9756,0.3612,0.2195,0.8769,0.475,-0.1917,-0.9165,0.265,0.8574,-0.8159,0.1741,-0.3685,0.3133,-0.0535,0.6327,0.3978,0.1883,-0.1228,0.3724,-0.242,-0.7197,-0.1028,0.39,-0.9409,0.2274,-0.4198,0.0647,-0.558,0.6425,-0.4144,0.0129,-0.936,0.7138,-0.4256,0.8256,-0.5473,0.5414,-0.6694,0.7744,0.2059,-0.3192,0.5443,0.1702,0.0125,-0.2796,-0.5648,0.1805,-0.4183,0.6952,0.0046,-0.304,0.5189,0.2249,-0.4281,-0.8379,0.3695,-0.3597,-0.6068,0.7289,0.2327,-0.4217,0.8559,-0.8051,0.136,-0.5355,0.5917,-0.999,-0.0369,-0.5678,0.6864,-0.6801,0.0711,-0.3211,0.4183,-0.1243,-0.5482,0.7431,-0.7617,-0.4012,0.9849,-0.8344,-0.4315,0.8623,-0.9609,0.202,0.5238,-0.3617,-0.0046,0.5951,-0.6737,0.7206,0.3001,-0.262,-0.7328,0.8466,0.4227,-0.1013,-0.7675,0.3294,-0.9883,0.9902,-0.0681,-0.452,0.6259,-0.1443,-0.6239,0.4134,-0.4657,0.96,0.556,-0.1155,0.81,-0.9458,0.2957,-0.5121,0.9946,-0.6923,0.6239,0.7543,-0.0305,-0.7392,0.9712,-0.241,0.4628,-0.7182,-0.0779,0.411,0.7226,-0.6967,-0.1248,-0.3509,0.7426,0.1683,0.3714,0.9658,-0.5038,0.6337,-0.978,0.9116,0.517,-0.893,0.1131,-0.1829,-0.6396,0.0388,0.5404,-0.6054,0.6684,-0.4491,0.895,-0.6332,0.7529,-0.7983,-0.1355,0.9385,-0.9687,0.5145,0.158,-0.1868,-0.5341,0.2103,-0.2952,0.6733,0.0149,-0.2664,0.4667,-0.8364,0.3538,-0.9424,0.8779,-0.0955,-0.8852,0.2904,-0.809,0.4452,-0.664,0.1004,0.5902,-0.7807,-0.1219,0.0838,-0.2449,-0.5365,0.1331,0.5033,0.2703,-0.9306,0.0134,-0.5223,0.6205,-0.9487,-0.2518,0.0608,0.8989,0.4476,-0.7465,-0.4173,-0.8823,-0.2459,-0.0584,0.3328,-0.6366,-0.2366,0.0017,0.2752,0.8652,0.5805,0.327,0.8022,-0.2923,0.2532,0.0115,-0.1575,-0.8222,0.1526,0.3563,-0.494,0.2474,-0.3177,0.0281,-0.5829,0.7763,-0.875,0.6117,0.9228,-0.6547,0.4413,-0.4794,0.1541,-0.6996,0.7441,0.0789,-0.5385,0.6879,-0.7021,0.6005,-0.2225,0.031,-0.4447,0.8877,-0.178,-0.3397,0.7973,0.432,-0.8662,0.3338,0.916,-0.8921,-0.1795,-0.5722,0.6596,0.8647,-0.3201,0.1971,0.957,-0.4462,0.3021,-0.8545,0.1394,-0.1966,0.8608,0.0481,0.5355,-0.768,0.8281,0.0896,0.6679,-0.4466,-0.7255,-0.3153,-0.5233,-0.9917,-0.0945,-0.7597,0.4847,-0.896,0.7416,0.4647,-0.2972,-0.0906,0.8159,0.5009,-0.8359,0.6821,-0.0896,0.3324,-0.4486,0.0584,-0.8256,-0.0364,0.7812,-0.8769,0.2938,0.8672,-0.368,-0.1844,0.2576,-0.388,0.1326,0.8535,-0.5907,0.7216,0.2317,-0.895,0.3587,-0.5873,0.1863,-0.4422,0.7221,-0.6303,-0.3377,0.5795,0.8222,-0.3983,0.0994,-0.8012,0.3304,-0.6679,-0.009,0.5179,-0.6225,0.665,-0.4999,0.5966,0.3382,-0.5775,0.7265,-0.389,0.2024,-0.5292,-0.8603,0.41,0.7495,-0.0696,0.4589,0.1736,0.6781,-0.4935,0.9409,-0.3358,0.1209,-0.5306,0.9844,-0.8799,-0.6552,0.1096,-0.4042,0.4129,-0.7084,0.9741,-0.2913,0.5346,0.3607,-0.4305,-0.1634,0.5497,-0.5668,-0.0969,0.4926,-0.7885,0.9663,0.5101,-0.305,-0.0525,0.3949,-0.7568,-0.2762,0.6757,-0.031,0.9399,-0.9853,0.032,0.5126,-0.1106,0.2874,-0.0007,-0.746,0.3885,-0.1018,0.5575,-0.2059,0.706,-0.9033,-0.1453,0.83,-0.3084,-0.0403,-0.9643,-0.7031,-0.1062,0.2654,-0.9316,-0.1321,0.5458,0.9707,-0.1912,0.2122,-0.8129,0.914,-0.6904,-0.2586,0.2845,-0.0076,-0.6464,0.4081,-0.7538,0.5814,0.0427,0.6904,-0.1819,0.8784,-0.5526,0.1429,-0.9087,-0.115,-0.6176,0.8549,0.2239,-0.7377,0.9306,0.073,-0.9331,0.6938,-0.5956,0.0027,-0.9619,0.8012,-0.8408,-0.41,0.9834,0.1155,-0.5311,0.4716,-0.6938,0.6039,-0.2347,-0.7319,0.8388,-0.9292,-0.4799,0.1829,0.7705,-0.9907,-0.4989,0.9258,-0.3851,0.4505,0.1785,-0.7714,0.3636,0.7685,0.2288,0.9961,0.5116,-0.2899,0.896,0.3661,-0.6899,-0.3436,0.0545,-0.5937,0.601,-0.3602,0.0969,0.7822,-0.9263,0.5663,0.8452,-0.1253,0.2293,-0.2352,-0.4266,0.3387,-0.9893,0.5551,-0.3221,0.7949,0.2908,0.6166,0.0984,-0.9741,-0.2435,0.6357,-0.3411,0.3719,-0.2606,0.1414,0.4173,-0.4647,0.3045,-0.641,0.5394,0.2537,-0.157,0.5658,-0.8217,-0.3519,-0.0999,0.2215,0.7573,-0.3827,0.1199,0.4491,0.9746,-0.2322,-0.623,0.474,0.2352,-0.7763,0.0823,-0.6278,0.9018,-0.4579,0.053,-0.6415,-0.2166,-0.4076,0.0891,-0.7968,-0.5004,-0.0183,0.7758,-0.8901,0.3397,0.8603,-0.9429,-0.0442,-0.5683,0.3788,-0.1736,-0.3944,-0.8349,-0.5072,0.7592,-0.9155,0.8984,-0.5712,-0.0623,0.2366,-0.81,-0.1932,-0.4628,-0.7416,0.7553,-0.5018,0.4261,0.0188,-0.851,-0.5238,0.8017,-0.7411,0.8974,-0.1404,0.6571,-0.2527,0.0222,-0.5502,-0.9717,0.8164,0.0471,0.3265,0.851,-0.5145,-0.8432,0.3582,-0.6029,-0.1429,-0.811,0.6772,0.0413,-0.3695,0.8208,-0.0593,0.3939,0.6454,-0.1761,-0.874,0.6029,0.4437,-0.9067,0.6464,-0.6103,0.8134,0.451,-0.2396,0.1448,0.6567,-0.4593,-0.2127,0.4632,0.2508,0.9917,-0.7866,0.664,0.051,0.494,0.3192,-0.0335,0.516,0.1346,0.4291,-0.7211,0.9429,0.0535,0.6669,0.4759,-0.01,0.3368,-0.16,0.9668,-0.663,0.727,0.2147,0.5429,-0.0379,-0.3465,-0.8926,0.1697,-0.7841,0.9184,0.6918,0.4071,-0.285,-0.6327,0.683,-0.9326,-0.2029,0.5385,-0.0291,0.8818,0.5995,-0.433,0.325,-0.7241,0.5707,-0.1941,-0.5595,-0.9453,-0.3162,0.2982,0.7939,-0.3866,-0.0711,0.8833,0.1751,-0.1551,0.2943,-0.9897,0.5971,-0.5805,-0.8002,-0.0667,0.7597,-0.7172,-0.2889,0.537,-0.4642,0.2029,-0.684,0.936,-0.2703,-0.6112,-0.7949,-0.3871,0.7402,-0.2747,-0.4867,0.3236,-0.6249,-0.9389,0.8476,-0.3582,-0.8632,0.1546,0.4872,-0.3744,-0.1326,-0.9702,0.3284,-0.6137,0.7651,0.4344,-0.0764,-0.37,0.1438,-0.7275,-0.0339,0.514,-0.4276,0.1468,0.9629,0.2547,-0.7431,-0.2845,-0.9697,0.2054,-0.0569,0.9194,-0.8867,0.159,0.7011,0.9829,0.0095,-0.7636,0.1536,-0.6127,0.3162,-0.8212,-0.5067,0.5253,-0.707,0.0325,-0.4056,0.8481,0.3094,0.5267,0.1639,-0.5336,0.0437,-0.8896,-0.0974,0.8247,-0.3353,-0.935,0.1067,0.641,0.8681,-0.1136,0.074,0.5643,-0.8496,0.8042,-0.0476,-0.2684,0.219,-0.683,0.6786,-0.5389,-0.0256,-0.8061,0.8193,-0.472,0.999,0.072,0.5766,-0.5009,0.8525,-0.8847,0.3377,-0.4691,0.9375,0.2357,-0.788,-0.0862,-0.5766,-0.3758,0.7118,0.0926,0.496,0.7455,-0.5849,-0.2791,0.3626,-0.4208,-0.7001,0.4379,-0.5194,0.5717,-0.1419,0.9477,-0.2669,0.6635,-0.0017,0.7827,-0.2786,0.937,0.2303,-0.1814,-0.6869,-0.3368,-0.9673,0.8393,0.6161,0.2952,0.7084,-0.5893,0.4188,-0.1199,0.2791,-0.4716,0.369,-0.6503,-0.9604,0.2283,-0.1697,0.4466,-0.4344,0.9585,0.5853,-0.137,0.4017,0.8969,-0.2908,0.5941,0.3651,0.1653,-0.2024,-0.7245,-0.2694,0.2723,-0.6361,0.6484,-0.1365,0.5639,-0.9433,-0.1839,0.7734,0.4154,0.6073,-0.9111,0.37,-0.6659,-0.4745,-0.1267,-0.7988,0.8335,0.0295,0.5306,-0.1375,0.2386,-0.3348,0.7714,-0.9184,0.3758,-0.7153,0.1165,-0.3631,-0.9223,0.4295,-0.5404,-0.812,0.6391,-0.0081,0.9507,0.3665,-0.1341,-0.3924,-0.749,-0.2479,0.1404,0.5673,-0.7368,0.7284,-0.8613,-0.243,0.6068,0.9912,-0.5624,0.6816,-0.725,0.1473,-0.8564,-0.5731,0.0261,-0.9995,0.2552,-0.7358,0.0359,-0.5839,-0.8784,0.5302,0.7079,-0.8559,0.0227,0.4212,-0.2879,0.1053,-0.5824,0.8291,-0.3392,-0.6723,0.1048,-0.2904,0.0056,0.7929,-0.2181,0.9985,0.4369,0.1521,0.6132,-0.5209,-0.9819,0.8144,-0.8149,0.0979,-0.6352,-0.0237,-0.4496,0.5399,0.8447,-0.5897,0.2679,-0.0823,0.7153,0.1194,0.3983,-0.4862,-0.8471,0.0989,-0.62,0.4862,0.9004,-0.0066,-0.9951,0.9673,-0.3915,0.0212,0.8486,0.1717,-0.0608,-0.4017,0.388,-0.3104,0.0071,0.7563,0.2923,0.5175,-0.3729,0.7006,-0.4789,-0.177,0.6513,0.9136,-0.3558,-0.074,0.3778,-0.5204,0.7788,-0.9888,0.9653,-0.7587,0.3954,0.01,0.2669,0.64,-0.852,0.9282,-0.622,0.2625,-0.8071,0.0667,-0.9365,-0.3333,-0.6864,0.2811,-0.0266,0.6469,-0.2596,0.9297,0.4061,0.7074,0.2161,-0.872,-0.2244,0.4593,0.9067,-0.7231,-0.2274,-0.9551,-0.3241,0.7983,0.58,-0.2625,0.7382,-0.8833,0.2244,-0.4701,0.3504,-0.6274,-0.1741,0.4535,-0.5282,-0.704,0.3148,-0.8252,0.0847,0.8896,-0.9438,-0.4901,-0.2381,0.9126,-0.8232,0.1277,0.8657,0.4256,-0.9194,0.2947,0.1287,-0.6728,0.9355,0.1565,-0.3504,-0.0295,0.24,-0.431,0.6713,-0.8339,-0.5453,0.4735,-0.1614,-0.4686,0.4335,-0.1033,-0.409,0.6537,0.3104,0.7963,-0.1692,0.9531,-0.3802,-0.7123,0.3172,-0.5028,-0.9516,-0.3475,-0.1209,0.642,0.054,-0.8173,-0.4247,0.1678,0.5292,0.9775,-0.0637,-0.6645,0.1912,-0.5316,0.3289,-0.0994,-0.6972,0.8007,-0.284,0.6777,0.1223,-0.9057,0.6352,-0.3065,0.5223,0.7783,-0.6298,0.578,-0.1184,0.4842,-0.6991,-0.0789,0.3919,-0.3089,-0.7133,-0.0486,-0.5419,-0.2654,0.7397,-0.4432,-0.8276,-0.1756,0.5228,-0.5726,0.6024,-0.1653,0.8862,-0.0735,-0.3792,0.8203,0.1902,0.7031,-0.9937,0.5585,0.8286,-0.6288,-0.0447,-0.5111,0.5653,-0.9092,0.4457,0.1263,-0.1595,0.5448,0.0374,0.8403,-0.7382,-0.5331,0.3451,0.7602,-0.0105,0.6869,-0.6122,-0.4442,0.2855,0.5053,-0.7856,0.0291,0.9253,-0.4178,0.6103,0.0745,0.4266,-0.7817,0.8838,0.3011,-0.1023,0.9292,-0.9795,-0.2054,-0.451,0.2718,-0.7748,0.1692,0.7094,0.0755,-0.5858,0.7802,0.2332,0.4901,0.8071,-0.7719,0.5746,-0.0374,0.2781,0.6835,-0.728,0.8457,0.1243,-0.9219,-0.6479,0.346,0.0828,-0.9126,-0.6884,-0.011,-0.3123,0.1556,-0.7602,-0.2313,0.5004,-0.8305,0.199,0.011,-0.6,0.8613,-0.8476,0.7304,-0.5902,0.4642,0.2689,0.9893,-0.3245,-0.643,-0.1712,-0.8735,0.4032,0.0462,-0.8354,0.8696,-0.223,0.7016,-0.9639,0.4637,-0.2132,-0.8623,-0.5443,-0.053,-0.348,-0.6606,-0.4403,0.0652,0.2112,0.4271,-0.0051,0.8032,-0.3031,0.9736,-0.4379,-0.8515,0.6376,-0.1468,-0.9512,-0.3856,0.0906,-0.1863,0.3748,-0.9585,0.8706,-0.3788,0.3841,-0.2601,-0.5077,0.4813,-0.2869,0.7192,0.5375,-0.2112,0.9595,0.3421,-0.5717,0.8828,0.3968,0.0466,0.9263,-0.3929,0.7631,-0.2679,0.6601,-0.4418,0.2391,-0.325,-0.0872,-0.8598,-0.2283,0.096,-0.9624,0.4462,0.8935,0.2425,-0.2752,0.6044,-0.1331,-0.5438,0.3675,-0.367,-0.0574,-0.6093,0.2698,0.9995,0.6508,0.2093,0.5438,0.8168,-0.8569,0.6801,-0.5697,-0.7167,0.6278,-0.9013,-0.5653,0.3416,-0.2107,0.4652,0.2015,-0.4618,0.9643,0.5556,-0.6317,0.9013,-0.4833,0.1956,-0.6034,0.0525,-0.8427,0.2659,-0.0613,0.9873,0.1873,-0.8681,-0.5541,0.2821,-0.4476,0.5756,-0.8291,-0.1263,-0.4662,-0.9004,0.2347,-0.6493,0.3783,-0.7475,-0.0774,0.5121,-0.6777,0.9219,0.1409,0.6806,-0.4652,0.7353,-0.1072,0.6093,-0.3988,-0.7372,0.7538,-0.9912,0.8129,0.0935,-0.6947,0.6244,0.1712,0.8266,-0.7573,0.0105,-0.4564,-0.9707,-0.2186,0.3705,-0.072,0.4808,-0.2532,0.9551,-0.1385,0.1458,0.5272,-0.052,-0.9844,0.852,-0.6484,0.0154,-0.7919,0.3065,-0.0965,-0.8813,0.4789,-0.2967,0.602,-0.1497,0.7719,-0.9751,0.6322,-0.7314,-0.4149,0.0305,0.8515,-0.7665,-0.0676,0.7578,0.0799,0.4945,0.7162,-0.283,0.5927,-0.159,0.0867,0.977,-0.8686,0.348,0.0515,-1,0.5741,-0.6532,0.3822,-0.7724,0.2142,-0.5614,-0.0198,0.1453,-0.4921,0.4969,-0.3495,0.2713,0.9614,-0.8911,-0.4808,0.5487,-0.306,0.3988,-0.1306,0.8808,-0.6117,0.1175,-0.7553,0.7915,-0.3973,0.3245,-0.8115,-0.4554,0.8759,-0.6762,0.0672,0.6176,-0.3446,0.4115,0.7167,-0.2943,0.1726,0.6591,-0.0222,-0.7783,0.9487,-0.6908,0.4686,-0.327,-0.5663,0.391,0.7436,-0.1609,0.6015,-0.3426,0.2083,-0.9653,-0.2542,-0.6698,0.2757,-0.5639,0.8545,-0.9756,0.4896,-0.515,-0.3099,0.7504,-0.2044,-0.4002,0.2796,-0.1629,0.9458,-0.3324,0.8183,-0.8979,0.3963,0.9697,-0.1643,-0.6469,-0.0002,-0.7958,-0.2357,0.4608,-0.1463,0.0579,-0.9175,0.6982,-0.7118,0.2498,0.7338,-0.3001,-0.514,0.2313,-0.9556,0.0779,0.7372,0.3993,-0.2581,0.6752,-0.4847,0.2777,-0.8056,-0.114,-0.557,0.8632,-0.7094,-0.4154,0.7665,0.349,0.1018,-0.4569,0.1707,0.9179,0.0081,-0.2498,-0.8388,0.2962,-0.6625,0.4774,0.9121,-0.5184,0.3768,0.9907,-0.7973,0.1267,-0.0208,-0.4271,0.6947,0.2645,-0.0012,-0.6156,0.5512,0.8745,-0.8066,-0.0027,-0.5463,0.0852,0.4999,-0.2405,0.6474,-0.8144,0.3084,0.7377,0.4281,0.6488,-0.5575,0.1961,0.7695,-0.6527,0.9223,0.1507,-0.3705,0.5912,-0.8755,0.4657,0.9082,-0.0203,0.6088,-0.6088,-0.0901,-0.7221,0.1775,-0.8442,0.4584,-0.2,0.9394,0.137,0.4886,-0.8955,-0.1399,0.264,-0.5756,-0.2151,-0.9082,-0.0813,0.6908,-0.8007,0.535,0.1927,0.894,-0.496,0.0882,-0.8818,-0.219,0.0286,0.621,-0.3968,-0.116,0.7729,0.3558,-0.6918,-0.1956,-0.7709,0.8994,-0.8935,0.114,-0.4916,0.4691,0.6625,-0.9297,0.3231,-0.7236,-0.0662,-0.6015,-0.3763,0.0764,-0.9131,-0.4359,-0.1145,0.8276,-0.8452,-0.3455,0.3158,-0.4945,0.5111,-0.032,-0.5551,0.0637,-0.1722,-0.8164,0.3621,-0.2371,0.8589,0.5038,-0.3289,0.9897,-0.0745,0.7641,-0.6098,-0.938,0.6972,-0.4427,0.0266,0.5937,1,-0.8242,0.536,0.8051,0.4159,-0.6405,-0.1507,-0.4227,-0.9404,0.6107,-0.1004,0.831,0.3944,0.7026,-0.6254,-0.8437,0.1824,0.5219,-0.8862,-0.3035,0.9267,0.4447,0.1516,0.5883,-0.138,0.4007,-0.7397,0.1897,-0.2635,0.7797,-0.3841,0.5956,0.8857,0.2571,0.7768,-0.2176,0.9096,0.1512,-0.7426,0.3529,0.03,0.6098,-0.0632,-0.769,-0.2269,-0.9414,0.978,0.3079,-0.4481,0.7148,-0.6835,-0.412,-0.8774,0.2806,-0.5248,-0.9683,0.3797,-0.4051,0.2176,-0.0217,-0.2991,0.2381,-0.6669,0.3753,-0.3812,-0.012,0.1907,-0.5092,-0.286,0.2459,0.8232,0.1136,0.4095,-0.6181,-0.2835,-0.7509,-0.4134,-0.0803,0.2918,0.8701,-0.2327,-0.6596,0.6552,-0.5048,0.0603,-0.9346,-0.369,-0.5321,0.7748,-0.3187,-0.0496,0.8427,-0.6357,-0.0891,0.1629,-0.5116,-0.9726,0.0335,-0.7519,0.3812,-0.5692,0.5546,-0.2698,0.9473,-0.4549,-0.9341,0.746,0.4085,0.8261,0.1946,0.644,-0.6537,0.5424,-0.0545,0.9448,0.2088,0.0315,0.6889,-0.179,0.6137,0.0398,-0.7353,0.5311,0.8408,-0.7758,0.6317,0.8178,-0.9878,-0.2288,0.725,-0.7309,0.9053,-0.9565,0.6249,-0.5658,-0.7822,0.98,-0.03,0.2742,0.77,0.1687,-0.9477,0.5077,-0.4818,0.0168,0.3685,-0.1546,0.2513,0.7197,-0.0769,0.8593,-0.6684,0.2894,-0.9668,0.5541,-0.4388,0.3499,-0.8554,0.9966,0.4125,-0.2855,0.5341,-0.4525,0.663,-0.0325,-0.9531,0.2674,-0.686,0.5331,-0.2039,0.1204,-0.7011,-0.4632,-0.1258,-0.8027,-0.2938,0.1477,-0.9985,-0.2063,0.4681,-0.6005,0.8271,-0.7832,0.1624,-0.2811,0.9087,-0.5609,-0.2098,0.4168,-0.4755,-0.0847,-0.5565,0.135,0.4994,-0.4501,-0.1126,0.367,0.0237,0.5629,-0.1961,-0.3998,0.6581,-0.8696,0.5482,-0.5741,0.9604,-0.2713,-0.7294,0.769,-0.9863,0.9521,-0.6044,-0.7607,0.5082,0.2063,-0.1687,0.4823,0.0383,0.9424,-0.7836,0.705,0.0657,-0.2005,-0.6816,0.7245,-0.1009,0.1966,-0.833,0.8799,-0.3724,0.7314,-0.0926,0.1995,-0.579,0.8891,-0.3118,0.6943,0.3519,0.0403,0.8691,0.4046,-0.4984,0.6532,-0.7661,-0.3343,-0.0628,0.4037,-0.4872,0.7001,-0.8759,0.3426,0.0623,-0.916,0.1595,0.5204,0.8955,0.3182,-0.8398,0.0632,0.6767,-0.665,-0.3524,0.1951,0.7832,0.3446,-0.6845,0.0916,-0.3534,-0.1531,0.0486,0.6855,0.242,0.4784,-0.3294,0.1179,0.5692,-0.4212,-0.2659,-0.8667,0.6899,-0.7524,-0.3338,-0.5917,0.2044,-0.3651,0.599,-0.5272,0.2376,-0.8764,0.9131,-0.6049,-0.1985,0.3206,0.094,-0.5179,0.4613,-0.8789,0.6288,-0.0144,0.2708,-0.9541,-0.559,0.6049,-0.39,-0.8481,0.7485,-0.0095,0.2889,0.579,-0.9302,0.9648,-0.6708,0.2415,-0.1282,-0.3963,0.6674,0.9731,-0.3182,-0.7656,-0.1805,-0.6523,0.7958,-0.2781,0.2694,0.9419,-0.8462,-0.0173,-0.9971,-0.5087,-0.1277,0.9106,0.4427,-0.7543,0.3734,-0.8989,-0.4022,-0.5844,-0.0559,-0.8095,0.8344,0.012,0.3934,0.9878,-0.4696,0.1121,0.7954,-0.1766,0.4486,-0.0598,-0.956,0.8237,0.4769,0.0442,-0.3954,0.4022,0.6078,-0.6742,0.8212,-0.7753,-0.2317,0.9761,-0.3783,-0.7905,0.5057,-0.1624,0.9316,-0.7055,-0.0657,0.241,-0.6195,-0.2708,0.854,-0.453,0.177,-0.2117,0.0002,0.5531,0.8081,-0.7499,-0.0618,-0.6283,0.2996,0.7021,0.0061,-0.4193,0.5463,-0.9121,-0.5136,-0.1473,0.473],u.n)
B.b5=t([1,2,-2,-1,0,1,2,-2,-1,0,1,2],u.t)
B.a9=t([0,0,0,0,0,0,0,0],u.n)
B.O=t([0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],u.t)
B.I=t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],u.t)
B.aE=t([0,0,0],u.t)
B.aT=t([255,255,255],u.t)
B.aS=t([255,255,0],u.t)
B.aR=t([255,0,0],u.t)
B.aF=t([0,0,255],u.t)
B.aH=t([0,255,0],u.t)
B.b6=t([B.aE,B.aT,B.aS,B.aR,B.aF,B.aH],u.p)
B.aa=t([254,253,251,247,239,223,191,127],u.t)
B.J=t([12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],u.t)
B.ab=t([0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],u.t)
B.b_=t([53,58,66],u.t)
B.aN=t([192,197,193],u.t)
B.aL=t([188,175,66],u.t)
B.aJ=t([142,63,52],u.t)
B.aI=t([106,143,185],u.t)
B.b2=t([94,124,86],u.t)
B.ac=t([B.b_,B.aN,B.aL,B.aJ,B.aI,B.b2],u.p)
B.b8=t([0,30,60,120,180,240,280,320],u.n)
B.ad=t([0,0,0,0,0.3,0,0,0],u.n)
B.b9=t([0.14583333333333334,0.10416666666666667,0.0625,0.10416666666666667,0.14583333333333334,0.10416666666666667,0.0625,0.020833333333333332,0.0625,0.10416666666666667,0.0625,0.020833333333333332],u.n)
B.bc=t([0,0,1,1,1,1,1,2,2,2,2,2],u.t)
B.m=t([0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117],u.t)
B.P=t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],u.t)
B.ae=t([0,0,0,0,0.2,0.25,0,0],u.n)
B.aU=t([25,30,33],u.t)
B.aQ=t([239,222,68],u.t)
B.aY=t([33,87,186],u.t)
B.aM=t([18,95,32],u.t)
B.z=t([B.aU,B.a4,B.aQ,B.a3,B.aY,B.aM],u.p)
B.bd=t([0.4375,0.1875,0.3125,0.0625],u.n)
B.bf={mild:0,mid:1,strong:2}
B.bb=t([0,1,2,3,4,5,6,8,9,10,11,12,13,15,16,18,19,21,22,24,25,26,28,30,31,33,35,37,38,40,42,44,45,47,49,50,51,52,53,54,56,57,58,59,60,61,63,64,65,66,68,69,70,71,72,74,75,77,78,79,81,82,84,85,87,88,90,91,93,95,96,98,100,101,103,104,106,108,109,110,111,112,113,113,114,115,116,117,118,118,119,120,121,122,123,124,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,145,146,147,148,149,150,151,153,154,155,156,157,158,160,161,162,163,164,165,167,168,169,170,171,172,174,175,176,177,178,179,180,182,183,184,185,186,187,188,189,189,190,190,191,191,192,193,193,194,194,195,196,197,197,198,199,200,201,201,202,203,204,204,205,206,207,208,209,209,210,211,212,212,213,214,214,215,216,216,217,218,218,219,219,220,220,221,222,222,223,223,224,224,225,225,226,226,227,227,228,228,229,230,230,231,231,232,233,234,234,235,236,236,237,238,239,239,240,240,240,241,241,242,242,243,243,244,244,244,244,244,244,244,244,244,244,244,244],u.t)
B.ba=t([0,1,2,3,4,5,6,8,9,10,11,12,13,15,16,18,19,21,22,23,25,26,28,30,31,33,35,37,39,40,42,44,46,48,49,50,51,53,54,55,56,58,59,60,61,63,64,65,66,68,69,70,71,73,74,75,77,79,80,82,84,85,87,89,91,92,94,96,97,99,101,103,104,106,108,109,111,113,114,115,116,117,118,119,120,121,121,122,123,124,125,126,127,127,128,129,130,131,132,133,133,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,151,152,153,154,155,156,158,159,161,162,164,165,166,168,169,171,172,173,174,175,176,177,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,195,195,196,196,197,198,198,199,199,200,200,201,202,203,203,204,205,206,206,207,208,209,210,210,211,211,212,212,213,213,214,214,215,216,216,217,217,218,218,219,219,220,221,221,222,222,223,223,224,224,224,225,225,226,226,227,227,227,228,228,229,229,230,230,231,231,231,232,233,233,234,235,235,236,237,237,238,239,240,241,242,244,245,247,248,249,251,252,254,255,255,255,255,255,255,255,255,255,255,255,255],u.t)
B.b7=t([0,1,2,4,5,6,7,8,9,11,12,13,15,17,19,22,24,26,28,30,32,34,36,39,41,43,45,47,50,52,54,56,58,60,62,63,65,66,67,68,70,71,72,74,75,77,79,81,83,84,86,88,90,92,94,96,97,99,100,102,103,105,106,108,109,110,112,113,115,117,118,120,121,123,125,126,128,129,131,132,132,133,134,135,136,136,137,138,139,140,141,142,142,143,144,145,146,147,147,148,149,150,152,153,154,155,156,158,159,160,161,162,163,164,166,167,168,169,170,171,172,173,174,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,192,193,194,195,196,197,198,199,199,200,201,202,203,204,205,206,206,207,207,208,208,209,209,210,210,211,211,212,212,213,213,213,214,214,215,215,215,216,216,217,217,218,218,218,219,219,220,220,221,221,221,222,222,223,223,223,224,224,225,225,226,226,226,227,227,227,228,228,228,229,229,229,230,230,231,231,231,232,232,233,233,233,234,234,235,236,236,237,237,238,239,239,240,241,242,243,244,246,247,248,250,251,252,254,255,255,255,255,255,255,255,255,255,255,255,255],u.t)
B.af=new A.bV(B.bf,[B.bb,B.ba,B.b7],A.bR("bV<v,u<f>>"))
B.ag=new A.bu([B.o,1,B.p,3,B.q,15,B.h,255,B.j,65535,B.u,4294967295,B.v,127,B.w,32767,B.x,2147483647,B.y,1,B.r,1,B.t,1],u.D)
B.be=new A.bu([B.o,1,B.p,1,B.q,1,B.h,1,B.j,2,B.u,4,B.v,1,B.w,2,B.x,4,B.y,2,B.r,4,B.t,8],u.D)
B.bg=new A.di(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0)
B.bh=new A.dk(0,"none")
B.bi=new A.dk(4,"paeth")
B.A=new A.I(1,1)
B.bz=new A.r(0,0,0)
B.bA=new A.r(0,0,255)
B.bB=new A.r(0,255,0)
B.bC=new A.r(255,0,0)
B.bD=new A.r(255,255,0)
B.bE=new A.r(255,255,255)
B.bj=A.at("mP")
B.bk=A.at("fD")
B.bl=A.at("fE")
B.bm=A.at("fJ")
B.bn=A.at("fK")
B.bo=A.at("fL")
B.bp=A.at("x")
B.bq=A.at("fT")
B.br=A.at("fU")
B.bs=A.at("eX")
B.bt=new A.dv(!1)
B.bu=new A.dv(!0)
B.K=new A.bM(0,"none")
B.bv=new A.bM(1,"partial")
B.bw=new A.bM(2,"full")
B.C=new A.bM(3,"finish")})();(function staticFields(){$.f5=null
$.a_=A.q([],A.bR("B<x>"))
$.hY=null
$.eQ=0
$.eR=A.m1()
$.hk=null
$.hj=null
$.iF=null
$.ix=null
$.iH=null
$.fm=null
$.fr=null
$.h3=null
$.f6=A.q([],A.bR("B<u<x>?>"))
$.av=A.i4()
$.K=null
$.hC=A.i4()})();(function lazyInitializers(){var t=hunkHelpers.lazyFinal,s=hunkHelpers.lazy
t($,"mQ","ha",()=>A.mq("_$dart_dartClosure"))
t($,"nh","j3",()=>A.q([new J.d6()],A.bR("B<cu>")))
t($,"mY","iM",()=>A.ar(A.eW({
toString:function(){return"$receiver$"}})))
t($,"mZ","iN",()=>A.ar(A.eW({$method$:null,
toString:function(){return"$receiver$"}})))
t($,"n_","iO",()=>A.ar(A.eW(null)))
t($,"n0","iP",()=>A.ar(function(){var $argumentsExpr$="$arguments$"
try{null.$method$($argumentsExpr$)}catch(r){return r.message}}()))
t($,"n3","iS",()=>A.ar(A.eW(void 0)))
t($,"n4","iT",()=>A.ar(function(){var $argumentsExpr$="$arguments$"
try{(void 0).$method$($argumentsExpr$)}catch(r){return r.message}}()))
t($,"n2","iR",()=>A.ar(A.i2(null)))
t($,"n1","iQ",()=>A.ar(function(){try{null.$method$}catch(r){return r.message}}()))
t($,"n6","iV",()=>A.ar(A.i2(void 0)))
t($,"n5","iU",()=>A.ar(function(){try{(void 0).$method$}catch(r){return r.message}}()))
t($,"nc","j0",()=>A.kQ(4096))
t($,"na","iZ",()=>new A.fd().$0())
t($,"nb","j_",()=>new A.fc().$0())
t($,"nf","dH",()=>A.h7(B.bp))
t($,"mX","hc",()=>{A.kW()
return $.eQ})
t($,"ng","j2",()=>new A.x())
t($,"mV","iL",()=>A.lk())
s($,"mU","iK",()=>{$.iL()
return!1})
t($,"n9","iY",()=>A.fW(B.J,B.N,257,286,15))
t($,"n8","iX",()=>A.fW(B.ab,B.I,0,30,15))
t($,"n7","iW",()=>A.fW(null,B.aW,0,19,7))
t($,"nj","j4",()=>{var r=null,q="ISOSpeed"
return A.kK([11,A.e("ProcessingSoftware",B.i,r),254,A.e("SubfileType",B.k,1),255,A.e("OldSubfileType",B.k,1),256,A.e("ImageWidth",B.k,1),257,A.e("ImageLength",B.k,1),258,A.e("BitsPerSample",B.f,1),259,A.e("Compression",B.f,1),262,A.e("PhotometricInterpretation",B.f,1),263,A.e("Thresholding",B.f,1),264,A.e("CellWidth",B.f,1),265,A.e("CellLength",B.f,1),266,A.e("FillOrder",B.f,1),269,A.e("DocumentName",B.i,r),270,A.e("ImageDescription",B.i,r),271,A.e("Make",B.i,r),272,A.e("Model",B.i,r),273,A.e("StripOffsets",B.k,r),274,A.e("Orientation",B.f,1),277,A.e("SamplesPerPixel",B.f,1),278,A.e("RowsPerStrip",B.k,1),279,A.e("StripByteCounts",B.k,1),280,A.e("MinSampleValue",B.f,1),281,A.e("MaxSampleValue",B.f,1),282,A.e("XResolution",B.l,1),283,A.e("YResolution",B.l,1),284,A.e("PlanarConfiguration",B.f,1),285,A.e("PageName",B.i,r),286,A.e("XPosition",B.l,1),287,A.e("YPosition",B.l,1),290,A.e("GrayResponseUnit",B.f,1),291,A.e("GrayResponseCurve",B.d,r),292,A.e("T4Options",B.d,r),293,A.e("T6Options",B.d,r),296,A.e("ResolutionUnit",B.f,1),297,A.e("PageNumber",B.f,2),300,A.e("ColorResponseUnit",B.d,r),301,A.e("TransferFunction",B.f,768),305,A.e("Software",B.i,r),306,A.e("DateTime",B.i,r),315,A.e("Artist",B.i,r),316,A.e("HostComputer",B.i,r),317,A.e("Predictor",B.f,1),318,A.e("WhitePoint",B.l,2),319,A.e("PrimaryChromaticities",B.l,6),320,A.e("ColorMap",B.f,r),321,A.e("HalftoneHints",B.f,2),322,A.e("TileWidth",B.k,1),323,A.e("TileLength",B.k,1),324,A.e("TileOffsets",B.k,r),325,A.e("TileByteCounts",B.d,r),326,A.e("BadFaxLines",B.d,r),327,A.e("CleanFaxData",B.d,r),328,A.e("ConsecutiveBadFaxLines",B.d,r),332,A.e("InkSet",B.d,r),333,A.e("InkNames",B.d,r),334,A.e("NumberofInks",B.d,r),336,A.e("DotRange",B.d,r),337,A.e("TargetPrinter",B.i,r),338,A.e("ExtraSamples",B.d,r),339,A.e("SampleFormat",B.f,1),340,A.e("SMinSampleValue",B.d,r),341,A.e("SMaxSampleValue",B.d,r),342,A.e("TransferRange",B.d,r),343,A.e("ClipPath",B.d,r),512,A.e("JPEGProc",B.d,r),513,A.e("JPEGInterchangeFormat",B.d,r),514,A.e("JPEGInterchangeFormatLength",B.d,r),529,A.e("YCbCrCoefficients",B.l,3),530,A.e("YCbCrSubSampling",B.f,1),531,A.e("YCbCrPositioning",B.f,1),532,A.e("ReferenceBlackWhite",B.l,6),700,A.e("ApplicationNotes",B.f,1),18246,A.e("Rating",B.f,1),33421,A.e("CFARepeatPatternDim",B.d,r),33422,A.e("CFAPattern",B.d,r),33423,A.e("BatteryLevel",B.d,r),33432,A.e("Copyright",B.i,r),33434,A.e("ExposureTime",B.l,1),33437,A.e("FNumber",B.l,r),33723,A.e("IPTC-NAA",B.k,1),34665,A.e("ExifOffset",B.d,r),34675,A.e("InterColorProfile",B.d,r),34850,A.e("ExposureProgram",B.f,1),34852,A.e("SpectralSensitivity",B.i,r),34853,A.e("GPSOffset",B.d,r),34855,A.e(q,B.k,1),34856,A.e("OECF",B.d,r),34864,A.e("SensitivityType",B.f,1),34866,A.e("RecommendedExposureIndex",B.k,1),34867,A.e(q,B.k,1),36864,A.e("ExifVersion",B.G,r),36867,A.e("DateTimeOriginal",B.i,r),36868,A.e("DateTimeDigitized",B.i,r),36880,A.e("OffsetTime",B.i,r),36881,A.e("OffsetTimeOriginal",B.i,r),36882,A.e("OffsetTimeDigitized",B.i,r),37121,A.e("ComponentsConfiguration",B.G,r),37122,A.e("CompressedBitsPerPixel",B.d,r),37377,A.e("ShutterSpeedValue",B.d,r),37378,A.e("ApertureValue",B.d,r),37379,A.e("BrightnessValue",B.d,r),37380,A.e("ExposureBiasValue",B.d,r),37381,A.e("MaxApertureValue",B.d,r),37382,A.e("SubjectDistance",B.d,r),37383,A.e("MeteringMode",B.d,r),37384,A.e("LightSource",B.d,r),37385,A.e("Flash",B.d,r),37386,A.e("FocalLength",B.d,r),37396,A.e("SubjectArea",B.d,r),37500,A.e("MakerNote",B.G,r),37510,A.e("UserComment",B.G,r),37520,A.e("SubSecTime",B.d,r),37521,A.e("SubSecTimeOriginal",B.d,r),37522,A.e("SubSecTimeDigitized",B.d,r),40091,A.e("XPTitle",B.d,r),40092,A.e("XPComment",B.d,r),40093,A.e("XPAuthor",B.d,r),40094,A.e("XPKeywords",B.d,r),40095,A.e("XPSubject",B.d,r),40960,A.e("FlashPixVersion",B.d,r),40961,A.e("ColorSpace",B.f,1),40962,A.e("ExifImageWidth",B.f,1),40963,A.e("ExifImageLength",B.f,1),40964,A.e("RelatedSoundFile",B.d,r),40965,A.e("InteroperabilityOffset",B.d,r),41483,A.e("FlashEnergy",B.d,r),41484,A.e("SpatialFrequencyResponse",B.d,r),41486,A.e("FocalPlaneXResolution",B.d,r),41487,A.e("FocalPlaneYResolution",B.d,r),41488,A.e("FocalPlaneResolutionUnit",B.d,r),41492,A.e("SubjectLocation",B.d,r),41493,A.e("ExposureIndex",B.d,r),41495,A.e("SensingMethod",B.d,r),41728,A.e("FileSource",B.d,r),41729,A.e("SceneType",B.d,r),41730,A.e("CVAPattern",B.d,r),41985,A.e("CustomRendered",B.d,r),41986,A.e("ExposureMode",B.d,r),41987,A.e("WhiteBalance",B.d,r),41988,A.e("DigitalZoomRatio",B.d,r),41989,A.e("FocalLengthIn35mmFilm",B.d,r),41990,A.e("SceneCaptureType",B.d,r),41991,A.e("GainControl",B.d,r),41992,A.e("Contrast",B.d,r),41993,A.e("Saturation",B.d,r),41994,A.e("Sharpness",B.d,r),41995,A.e("DeviceSettingDescription",B.d,r),41996,A.e("SubjectDistanceRange",B.d,r),42016,A.e("ImageUniqueID",B.d,r),42032,A.e("CameraOwnerName",B.i,r),42033,A.e("BodySerialNumber",B.i,r),42034,A.e("LensSpecification",B.d,r),42035,A.e("LensMake",B.i,r),42036,A.e("LensModel",B.i,r),42037,A.e("LensSerialNumber",B.i,r),42240,A.e("Gamma",B.l,1),50341,A.e("PrintIM",B.d,r),59932,A.e("Padding",B.d,r),59933,A.e("OffsetSchema",B.d,r),65e3,A.e("OwnerName",B.i,r),65001,A.e("SerialNumber",B.i,r)],u.S,A.bR("cY"))})
t($,"mT","iJ",()=>A.hH(0,0,0))
t($,"nd","hd",()=>A.kN(1))
t($,"ne","j1",()=>A.l5(B.Q.gB($.hd()),0))
s($,"mR","hb",()=>A.jO(B.a7))})();(function nativeSupport(){!function(){var t=function(a){var n={}
n[a]=1
return Object.keys(hunkHelpers.convertToFastObject(n))[0]}
v.getIsolateTag=function(a){return t("___dart_"+a+v.isolateTag)}
var s="___dart_isolate_tags_"
var r=Object[s]||(Object[s]=Object.create(null))
var q="_ZxYxX"
for(var p=0;;p++){var o=t(q+"_"+p+"_")
if(!(o in r)){r[o]=1
v.isolateTag=o
break}}v.dispatchPropertyName=v.getIsolateTag("dispatch_record")}()
hunkHelpers.setOrUpdateInterceptorsByTag({ArrayBuffer:A.aT,SharedArrayBuffer:A.aT,ArrayBufferView:A.ce,Float32Array:A.c9,Float64Array:A.ca,Int16Array:A.cb,Int32Array:A.cc,Int8Array:A.cd,Uint16Array:A.cf,Uint32Array:A.cg,Uint8Array:A.a8})
hunkHelpers.setOrUpdateLeafTags({ArrayBuffer:true,SharedArrayBuffer:true,ArrayBufferView:false,Float32Array:true,Float64Array:true,Int16Array:true,Int32Array:true,Int8Array:true,Uint16Array:true,Uint32Array:true,Uint8Array:false})
A.Q.$nativeSuperclassTag="ArrayBufferView"
A.cz.$nativeSuperclassTag="ArrayBufferView"
A.cA.$nativeSuperclassTag="ArrayBufferView"
A.aB.$nativeSuperclassTag="ArrayBufferView"
A.cB.$nativeSuperclassTag="ArrayBufferView"
A.cC.$nativeSuperclassTag="ArrayBufferView"
A.a2.$nativeSuperclassTag="ArrayBufferView"})()
Function.prototype.$1=function(a){return this(a)}
Function.prototype.$2=function(a,b){return this(a,b)}
Function.prototype.$0=function(){return this()}
Function.prototype.$3=function(a,b,c){return this(a,b,c)}
Function.prototype.$4=function(a,b,c,d){return this(a,b,c,d)}
Function.prototype.$5=function(a,b,c,d,e){return this(a,b,c,d,e)}
Function.prototype.$6=function(a,b,c,d,e,f){return this(a,b,c,d,e,f)}
Function.prototype.$1$1=function(a){return this(a)}
convertAllToFastObject(w)
convertToFastObject($);(function(a){if(typeof document==="undefined"){a(null)
return}if(typeof document.currentScript!="undefined"){a(document.currentScript)
return}var t=document.scripts
function onLoad(b){for(var r=0;r<t.length;++r){t[r].removeEventListener("load",onLoad,false)}a(b.target)}for(var s=0;s<t.length;++s){t[s].addEventListener("load",onLoad,false)}})(function(a){v.currentScript=a
var t=A.mD
if(typeof dartMainRunner==="function"){dartMainRunner(t,[])}else{t([])}})})()
//# sourceMappingURL=wallie-eink.js.map
